/*
 * @Copyright 2026. Institute for Future Intelligence, Inc.
 *
 * 繁體中文。鍵結構與 en.ts 完全一致。
 *
 * 這不是 zh_cn.ts 的字形轉換：術語採用台灣半導體業界的慣用說法。蝕刻（非刻蝕）、
 * 微影（非光刻）、電漿（非等離子體）、製程（非工藝）、機台（非设备）、模擬
 * （非仿真）、光阻（非光刻胶）。機台資產編號與單位符號一律不翻譯。
 */

export const i18n_zh_tw = {
  translation: {
    mission: {
      whereThePhotonsWent: {
        Title: '光子去哪裡了',
        Briefing: 'EUV-22 慢了四分之一，夜班已經把一次三十小時的收集鏡更換排到了明天。EUV 曝光機丟光的地方有三處，只有一處是收集鏡。在有人打開光源腔之前，先沿著光路走一遍。',
        Debrief: '光根本沒被產生出來。主雷射脈衝打到液滴上時已經晚了，所以電漿只給出約 60% 的合格脈衝能量，之後每一處的功率都下降了同樣的比例。收集鏡在電漿之後：它不可能讓電漿處測到的脈衝能量變低，而正是這一個讀數省下了三十個小時，和一塊本來就在好好工作的收集鏡。',
        objective: {
          timing: '做一次液滴-脈衝時序掃描',
          call: '做出正確的判斷',
        },
      },
      theRulerIsWide: {
        Title: '尺變寬了',
        Briefing: '從週末起，SEM-23 量過的每條線都寬了約一奈米，微影那邊已經調高過一次劑量來把 CD 拉回來。在他們再調一次之前：先弄清楚動的是線，還是儀器。',
        Debrief: '動的是儀器。冷場發射針尖好幾天沒做閃燒處理，能量展寬幾乎成了原來的三倍，而在 500 eV 下這就佔了束斑的大頭——色差模糊與 ΔE 比 E 成正比。束斑變寬，每條邊緣都會被讀得偏外一點。曝光機被調離了目標，去糾正一個本來正確的圖形，這就是量測故障的代價：不是報廢一片晶圓，而是在別處做了一個錯誤的決定。',
        objective: {
          spread: '量測電子槍的能量展寬',
          call: '做出正確的判斷',
        },
      },
      coldPlateWarmQubit: {
        Title: '冷盤是冷的，量子位元是熱的',
        Briefing: 'QDT-24 準時到了 10 mK，上面每個溫度計都正常。裡面這顆晶片上個月在另一台冷凍機裡測得很好，在這裡卻讀得一塌糊塗。會有人提議回溫換晶片。先弄清楚量子位元能「聽到」什麼。',
        Debrief: '驅動線上少了一個 20 dB 的衰減器，於是這條線帶下來的室溫雜訊是應有值的一百倍：量子位元模態裡有八分之一個光子，10 mK 的冷盤上坐著一個 109 mK 的量子位元。晶片沒問題，冷凍機也沒問題。量子位元的溫度不是它鎖在上面的那塊金屬的溫度，而是它線路的溫度，而唯一能讀出這個溫度的溫度計，就是量子位元自己。',
        objective: {
          line: '量測驅動線的插入損耗',
          call: '做出正確的判斷',
        },
      },
      fiftyDegreesHot: {
        Title: '沒人設定的五十度',
        Briefing: 'THRM-04 出來的片電阻偏低，接面也偏深。已經有人要求佈植組去查他們的劑量，他們很不高興。在 IMP-10 為一次劑量稽核搭上一個班之前：劑量偏低不會造成這種現象。',
        Debrief: 'RTP 的高溫計讀數偏低，於是燈被驅動到比螢幕顯示的設定值高五十度。擴散係數服從阿瑞尼斯規律：五十度幾乎讓 Dt 翻倍，摻雜擴散開來，接面變深，片電阻下降。劑量不足會讓片電阻朝相反方向變化，而接面的位置不變。在任何人動手量測之前，誤差的方向就已經指明了是哪台機器。',
        objective: {
          pyrometer: '用校準片核對高溫計',
          call: '做出正確的判斷',
        },
      },
      oxygenClimb: {
        Title: '氧含量的攀升',
        Briefing: '元件工程部門以間隙氧超標為由，退回了最近三根單晶錠的晶圓，而拉晶爐一個月未改動配方。拉速相同、轉速相同、氬氣設定值也相同。找出到底哪裡不一樣。',
        Debrief: '石英坩堝已接近壽命終點。坩堝只要處於高溫就會持續溶入熔體，而一只用舊的坩堝在上個月還管用的同一配方下，會更快地釋放氧。氬氣流量正常，這正好排除了吹掃這條路徑——氧含量升高的另一種可能——而調高氬氣只會把問題再掩蓋一根錠。',
        objective: {
          oxygen: '測量最近一根單晶錠的間隙氧',
          call: '作出判斷，並且判斷正確',
        },
      },
      flatAndSlow: {
        Title: '平坦，但是慢',
        Briefing: '拋光工序每個批次都超出節拍時間，操作員一直靠多拋幾分鐘來湊夠去除量。平坦度仍然合格。沒有人改動過拋光液或下壓力。',
        Debrief: '拋光墊已經鈍化——表面被填塞、不再切削，於是去除率下降，而所有人採用的補救辦法（延長時間）是在用設備壽命換數字。磨料粒徑在規格內，這排除了磨料本身；鈍化的拋光墊和失效的拋光液都會讓去除率下降，但只有其中一個能靠修整解決。',
        objective: {
          rate: '用監控片測量去除率',
          call: '作出判斷，並且判斷正確',
        },
      },
      sharpEnoughToPass: {
        Title: '勉強合格的清晰度',
        Briefing: 'LITH-03 的關鍵尺寸在漂移，最直覺的答案是劑量。在動光源之前請注意：失焦的掃描機所印出的關鍵尺寸誤差，與劑量漂移看起來一模一樣，而兩者需要的修正方向恰好相反。',
        Debrief: '問題出在工件台失焦，而不是光源。離焦不僅損失關鍵尺寸，還會同時損失對比度與 NILS；而劑量誤差只改變線寬、不動邊緣陡度——這正是空間像參數能區分的地方。用劑量去補償，只會保住數字，而下面的製程窗口仍在繼續收窄。',
        objective: {
          focus: '執行聚焦探測',
          call: '作出判斷，並且判斷正確',
        },
      },
      theSlowLeak: {
        Title: '緩慢的洩漏',
        Briefing: 'ETCH-01 抽不到本底真空，上一班把它記為泵老化。換泵要停機四小時，而全廠只有一台備品，所以在動用之前請先確認。',
        Debrief: '是真實洩漏，不是泵老化。兩者都會抬高本底壓力，在真空計上完全一樣；區別在於氣體從哪裡來——洩漏以恆定速率引入大氣，而泵速本身正常。備用泵還在貨架上，這正是先做檢查的價值所在。',
        objective: {
          seal: '執行密封檢查',
          call: '作出判斷，並且判斷正確',
        },
      },
      theCupThatLies: {
        Title: '說謊的法拉第杯',
        Briefing: '佈植批次的方塊電阻偏低，而佈植機聲稱每一次劑量都命中目標。這兩句話必有一句是錯的，而其中一方是在對自己下結論的設備。',
        Debrief: '法拉第杯發生了漂移，設備統計到的離子少於實際佈植量，於是為了湊夠自己的數字而過量佈植。一台自己測量自己的劑量監測器無法發現這一點——只有晶圓能，這正是方塊電阻成為決定性讀數的原因。設備上其餘的檯面讀數全部正常，而它們全都是無辜的。',
        objective: {
          rho: '佈植一片監控片並測量方塊電阻',
          call: '作出判斷，並且判斷正確',
        },
      },
      thePitchThatWalks: {
        Title: '會走位的節距',
        Briefing: 'PAT-21 的平均關鍵尺寸合格，卻在電性測試中失敗，且失敗沿著線條逐條交替出現。這些線條來自同一次曝光，因此套刻不可能是答案。',
        Debrief: '這是節距走位。側牆薄膜偏薄，而在自對準四重成像單元中，側牆厚度就是半節距，因此由一根芯軸衍生出的四條線不再等距。平均值毫髮無損，這正是關鍵尺寸能合格的原因；再怎麼調掃描機也無濟於事：這是一個披著微影投訴外衣的薄膜沉積問題。',
        objective: {
          walk: '逐條測量線條節距',
          call: '作出判斷，並且判斷正確',
        },
      },
      dishingOut: {
        Title: '碟形凹陷',
        Briefing: 'CMP-11 把寬的銅結構拋過頭了，而拋光墊週二才剛換過。最明顯的嫌疑人有不在場證明。',
        Debrief: '拋光液已經老化，其中的緩蝕劑已經耗盡。緩蝕劑的作用是阻止化學成分侵蝕那些拋光墊沒有壓到的銅面，缺了它，寬結構就會凹陷，而窄結構看起來仍然正常——這種輪廓特徵無法靠調整下壓力來糾正。用新墊配舊液，只會更快地拋出同樣的缺陷。',
        objective: {
          inhibitor: '化驗拋光液中的緩蝕劑',
          call: '作出判斷，並且判斷正確',
        },
      },
      voidsInTheVia: {
        Title: '導孔裡的空洞',
        Briefing: 'ECD-12 電鍍厚度達標，但導孔回來時中間帶著一條縫。電流密度、鍍液溫度和接觸電阻的讀數全部正常。',
        Debrief: '有機添加劑已經耗盡。自底向上填充不是靠電流參數實現的，而是靠加速劑與抑制劑決定銅往哪裡長；失去它們的鍍液只會共形沉積，在填滿之前就把導孔夾斷。厚度自始至終都是對的，這正是只有剖面分析才能揭示問題的原因。',
        objective: {
          xsection: '對導孔做剖面分析',
          call: '作出判斷，並且判斷正確',
        },
      },
      theToolThatCriesWolf: {
        Title: '喊狼來了的機台',
        Briefing: 'INSP-13 報出的缺陷太多，工程部門已經開始無視它的缺陷圖。要麼產線這週急劇惡化，要麼惡化的是這台檢測設備。',
        Debrief: '收集光路已經霧化。渾濁鏡片散射出的雜光抬高了探測器所面對的背景，於是設備報出晶圓上並不存在的缺陷；而如此高的虛報率比一台失明的設備危害更大，因為人們會連真實的缺陷圖也不再去看。來料粗糙度正常，這排除了晶圓本身。',
        objective: {
          nuisance: '用已知晶圓驗證虛報率',
          call: '作出判斷，並且判斷正確',
        },
      },
      goodDieCalledBad: {
        Title: '好晶粒被判成壞晶粒',
        Briefing: 'PRB-14 的良率下降了四個百分點，而損失全部集中在晶圓邊緣。探針上週才更換，壽命還綽綽有餘。',
        Debrief: '探針卡失去了平面度。與吸盤不平行的探針卡，一側壓得比另一側重，於是較遠的那一邊始終無法可靠接觸，好的晶粒被判為開路。探針磨損量正常——這正是所有人最先想到的相似故障——換探針只會白白搭上一次換卡，卻什麼都修不好。',
        objective: {
          contact: '測量全片範圍內的接觸電阻',
          call: '作出判斷，並且判斷正確',
        },
      },
      wideKerf: {
        Title: '變寬的切割道',
        Briefing: '封裝端因邊緣崩裂而不斷損失晶粒，而切割工序報告每個批次都在規格內。切割道寬度沒有改動，膠帶也是當前批號。',
        Debrief: '刀片已經超過額定切割次數。磨損的刀片切出更寬的切口、在邊緣造成更多崩裂，而能撐到壓模工序的，是那些原本就沒有裂紋的晶粒。膠帶剝離力正常，這排除了切割過程中晶粒位移——崩裂上升的另一條路徑，也是會讓你去找錯供應商的那一條。',
        objective: {
          kerf: '測量切口寬度',
          call: '作出判斷，並且判斷正確',
        },
      },
      theQuietDispenser: {
        Title: '沉默的點膠機',
        Briefing: 'BOND-16 出來的封裝體在溫度循環中失效，而所有引線的拉力測試都合格。失效發生在晶粒下方，而不是在線弧上。',
        Debrief: '點膠量不足。黏接膠太少會在晶粒底下留下空洞，而空洞既是熱量出不去的地方，也是應力無處釋放的地方——於是產品通過了所有接合測試，卻在第一次溫度循環時失效。拉力與球剪切力都正常，這正是宣告打線機無罪的依據。',
        objective: {
          void: '對晶粒黏著空洞成像',
          call: '作出判斷，並且判斷正確',
        },
      },
      popcorn: {
        Title: '爆米花效應',
        Briefing: 'PKG-17 的產品在客戶端回流焊時開裂，而不是在我們這裡。傳遞壓力正常，模封膠也在有效期內。',
        Debrief: '產品在存放期間吸了潮。封裝在模封膠中的水分在回流溫度下汽化，從內部把封裝體撐裂——這正是它在客戶端失效、卻能通過本廠所有測試的原因。模封空洞正常，同時排除了壓機和模封膠，而這兩項維修都碰不到真正出問題的乾燥包裝流程。',
        objective: {
          popcorn: '執行濕氣敏感度回流試驗',
          call: '作出判斷，並且判斷正確',
        },
      },
      theEarlyFailures: {
        Title: '早期失效',
        Briefing: 'FT-18 在老化後剔除的產品比老化前還多，而測試機今早剛通過量具重複性研究。分選機溫度也在設定值上。',
        Debrief: '問題出在這批產品本身帶有早期失效——那是來自上游的缺陷分布，而不是測試問題。老化本來就是用來篩出它們的；剔除率上升意味著這批貨進廠時就帶著缺陷，答案在上游，不在測試機。量具標準差與分選機溫度都正常，正是這一點把「我們的測試壞了」變成「我們的晶圓壞了」，而這兩句話要找的是不同的人。',
        objective: {
          fallout: '分析老化剔除數據',
          call: '作出判斷，並且判斷正確',
        },
      },
      theValveThatWont: {
        Title: '關不上的閥',
        Briefing: 'GAS-19 的例行安全驗證。氣瓶間運行正常，也沒有任何警報——而這恰恰是值得測試防護裝置的時刻，因為這是唯一能測的時候。',
        Debrief: '過流閥已經卡死在開啟位置。氣體、洗滌塔和排風都沒有任何問題，而且在管路斷裂之前也不會有——可一旦斷裂，唯一應當關閉的裝置卻關不上。一個從不做動作試驗的防護裝置，只是一個你在假設的裝置，而釋放模型正是把這個假設變成一個數字的東西。',
        objective: {
          release: '結合閥門試驗運行釋放模型',
          call: '作出判斷，並且判斷正確',
        },
      },
      leakOrOutgas: {
        Title: '洩漏還是放氣',
        Briefing: 'FAC-06 保不住本底真空，紀錄顯示腔體上週五曾對大氣開放。腔壁上的水和真實洩漏都會造成這個現象。其中一個可以靠烘烤去掉，另一個不行，而單看真空計讀數無法區分。',
        Debrief: '是真實洩漏。區分二者的是壓升的形狀：透過密封件進入的大氣呈線性上升且永不停止，而從腔壁釋出的水氣先上升、隨後隨著表面耗盡而趨於平緩。本底壓力相同，曲線卻是兩條，而烘烤會白費一個班次、什麼也改變不了。',
        objective: {
          rise: '記錄壓升曲線，而不只是那個數字',
          call: '作出判斷，並且判斷正確',
        },
      },
      innocentInstrument: {
        Title: '無辜的儀器',
        Briefing: 'MET-05 把氧化層讀高了 4%，半個廠都想讓它重新校準。在把一台好儀器停機之前：對錯誤假設的可重複測量，看起來和壞掉的儀器一模一樣，只有一種讀數能把它們分開。',
        Debrief: '反射儀是無辜的——變的是薄膜。沉積機漂了，而測量配方還在假設舊材料，於是對錯誤模型的完美擬合可重複地報出了更厚的膜。橢偏儀不假設折射率而是解出它，正是它把\'儀器壞了\'和\'世界變了\'分開——而一次重新校準只會把真正的漂移埋在一個被修正過的謊言下面。',
        objective: {
          ellipsometer: '在橢偏儀上交叉驗證',
          call: '正確地做出判斷',
        },
      },
      atomsToFabs: {
        Title: '從原子到晶圓廠',
        Briefing: '一個批次，走完整條基板產線。在 CZ-07 拉出一根可用的晶體並把晶錠交下去；在 WPR-08 切片；在 CLN-09 做進廠清洗；在 EPI-20 長出合格的元件層，把晶圓交給前段。你做的每個決定都隨流轉卡去到下一台機——包括做錯的那些。',
        Debrief: '從熔體到元件層：這座廠的名字，被你走了一遍。離開 EPI-20 的晶圓在流轉卡上帶著你的熔體摻雜、你的切片、你的清洗和你的磊晶，下游每一台機都要活在你剛定下的預算裡。這就是\'從原子到晶圓廠\'的含義——不是口號，是一個批次的履歷。',
        objective: {
          grow: '在 CZ-07 長出可用的晶錠',
          handCz: '把晶錠交給晶圓製備',
          slice: '在 WPR-08 切片、研磨、拋光',
          clean: '在 CLN-09 做進廠清洗',
          epi: '在 EPI-20 長出合格的元件層',
          handEpi: '把完成的基板交下去',
        },
      },
      holdTheClass: {
        Title: '守住潔淨等級',
        Briefing: '例行認證。證明潔淨間在真正要緊的地方守住了 ISO 等級——在產品上方，而不是牆上的監測器。攜帶式計數器要花一小時；它就是幹這個用的。',
        Debrief: '牆上的監測器鎖在牆所在的地方，而要緊的是敞開產品上方一米的空氣。你花了一小時弄清這個差別。這個習慣，就是這間房。',
        objective: {
          enter: '進入潔淨間並打開 GOWN-00',
          workzone: '在工作區跑一次攜帶式計數器',
        },
      },
      theWallLies: {
        Title: '牆在撒謊',
        Briefing: '經過這間潔淨間的批次缺陷密度在悄悄上升，而牆上的監測器讀數穩穩在等級內。有人錯了。查明是誰，並說出來。',
        Debrief: '無塵服超過了洗滌壽命——這是一個房間通風來不及稀釋就落到晶圓上的源。牆讀的是房間；晶圓讀的是俯身其上的人。',
        objective: {
          workzone: '在產品所在的位置測量',
          call: '正確地做出判斷',
        },
      },
      twoRoomsAway: {
        Title: '故障在兩個房間之外',
        Briefing: '凌晨 02:00。ETCH-01 的選擇比和均勻性超出規格，卡盤溫度偏高，全廠每台蝕刻機都報著同樣的警報。批次在蝕刻工序堆積。蝕刻機本身沒有任何東西壞了。找出壞的是什麼，決定等待期間產線怎麼辦，然後把廠房恢復健康——按這個順序，否則你在錯誤房間裡花的每一小時，產線都要付出代價。',
        Debrief: '故障是地下層的冰水機；蝕刻機只是症狀，隔著兩個房間。通知之後幾小時腔體就回來了——佇列卻沒有。每個在蝕刻前等過的批次都晚到了下一台機台，產線用了一整天的富餘產能去消化。打開「產線」看看你的決定相對另外兩個選項的代價：在這個負荷下按交期丟的交期最少；暫停投片對佇列毫無幫助，還讓被扣住的批次少了餘裕。在製品、產出和週期時間被利特爾法則綁在一起，而一條 95% 負荷的產線到明天還在消化。',
        objective: {
          etch: '去蝕刻機看警報',
          call: '正確上報——問題不在這台機台',
          decide: '決定等待期間產線怎麼辦：打開「產線」並做出選擇',
          descend: '走樓梯下到地下層',
          repair: '恢復冰水供應',
          green: '讓廠房恢復健康',
        },
      },
      theResistClock: {
        Title: '光阻的時鐘',
        Briefing: '同一個夜晚，另一條路線：這個產品的光阻從曝光機到蝕刻機只有八小時的保存期限，而每台蝕刻機三個腔體中的兩個剛剛因溫控失效而停機。從現在起曝光機曝光的每個批次，時鐘都在朝著一個不存在的腔體走。決定曝光機怎麼辦，然後讓廠房恢復健康。',
        Debrief: '時限從來不是跳機的問題。跳機退回的批次在腔體停機前就已曝光，誰也救不了。時限做的事是把蝕刻佇列的每一小時都變成重工，整天、每天——在 95% 負荷下這就是產線的大部分。設閘才讓時限可行：把曝光扣住，直到蝕刻機能及時消化，在唯一一個佇列只花時間的工序上。這是這個廠區裡唯一正確的扣批，而且只因為它是在時鐘開始前扣住的。',
        objective: {
          scanner: '去曝光機看看等著曝光的批次',
          decide: '決定曝光機怎麼辦：打開「產線」的排隊時限並做出選擇',
          call: '在蝕刻機正確上報',
          descend: '走樓梯下到地下層',
          repair: '恢復冰水供應',
          green: '讓廠房恢復健康',
        },
      },
      theSilentTool: {
        Title: '沉默的機台',
        Briefing: 'DEP-02 已經沉積偏厚好幾個小時，它自己的螢幕卻說一切正常，因為它信賴的熱電偶正是壞掉的東西。廠區裡還沒人知道。量測抽檢一部分來訪批次；其中一個會是告訴你答案的批次。決定抽檢力度，找到那台機台，並做出判斷。',
        Debrief: '在抽檢發現之前經過那台機台的每個批次都有風險，這個數字 = 經過機台的產出 × 它在無人察覺下運行的小時數——從良率一側看到的利特爾法則。加大抽檢能縮短這段時間，代價是量測機台的佇列，而全廠每個批次都在那個佇列裡。抽檢率是一個決定：工廠更願意承擔哪一種代價，「產線」把兩種價格都擺出來。',
        objective: {
          metrology: '去量測——只有它能看見這件事',
          decide: '決定抽檢率：打開「產線」的失控事件並做出選擇',
          call: '正確判斷沉積機台',
        },
      },
      theDueChamber: {
        Title: '到期的腔體',
        Briefing: 'ETCH-01 的 C 腔體今晚到了保養期：計畫內四小時，在瓶頸上，在一個已經落後的班次裡。值班領班寧願讓它跑完這週。看看機台，然後決定——並準備好說出繼續跑的代價。',
        Debrief: '計畫內保養只花它的小時數。延後是拿磨損的腔體下注，而「產線」說這注每週都輸：腔體會壞，計畫外維修花兩倍時間，落在沒人選擇的時刻，在那台一小時就是全廠一小時的機台上。領班說今晚四小時很痛，沒錯。他錯的是週四八小時的代價。',
        objective: {
          etch: '去蝕刻機',
          decide: '決定保養：打開「產線」的保養並做出選擇',
        },
      },
      theStopwatch: {
        Title: '碼表',
        Briefing: '同樣的人數下潔淨間讀數變髒，開門事件後恢復明顯變慢。天花板過濾器上個月剛換過。診斷它——並準備好為你信任的那個讀數辯護。',
        Debrief: '恢復時間只由換氣次數決定，別的什麼都動不了它，所以過濾器乾淨而恢復緩慢，問題在大樓，不在房間。抓住它的儀器是一塊碼表。維修不在這一層——但那是另一張工單。',
        objective: {
          recovery: '給恢復計時',
          call: '正確地通報',
        },
      },
      firstShift: {
        Title: '工作台上的第一個班',
        Briefing: '檢查站的缺陷密度在經過 CLN-09 的所有批次上翻了一倍。工作台沒有報警，看起來一如往常。你的第一次診斷：先掙來一個讀數，再下結論。',
        Debrief: '一種化學失效、另一種正常——這是槽液耗盡的特徵，而透明液體從來不會看起來耗盡。你為陪測晶圓付了錢，它把錢還給了你。',
        objective: {
          visit: '在 CLN-09 接班',
          reading: '至少掙來一個讀數',
          call: '正確地做出判斷',
        },
      },
      invisibleFault: {
        Title: '看不見的故障',
        Briefing: '一個產品的閘氧完整性在下滑，誰也找不到缺陷。顆粒計數完美。不管這是什麼，便宜的測量看不見它。',
        Debrief: '一個單層的銅對樓裡所有光學檢查機都是隱形的，它坐在看似完美的晶圓上進了爐子。那個昂貴的破壞性測量之所以存在，正是因為這種故障存在。',
        objective: {
          metals: '下單表面金屬測量',
          call: '正確地做出判斷',
        },
      },
      shipsAnyway: {
        Title: '照樣出貨',
        Briefing: '沒有任何針對 EPI-20 的報告。每一站都在規格內。這張工單存在，是因為認證數據看起來稍稍偏離趨勢，而樓上有人相信你的判斷勝過規格限。',
        Debrief: '廠區裡最難的一個班：一台壞了的機台在出合格晶圓。沒有任何東西強迫你剛才的判斷——這正是它值得做的原因。',
        objective: {
          reading: '在 EPI-20 掙來一個讀數',
          call: '照樣正確地做出判斷',
        },
      },
      notThisTool: {
        Title: '不在這台機',
        Briefing: 'CLN-09 在同一次訪問裡顆粒和金屬都超標，而兩個槽今早都剛配的。在下單八小時的台面維修之前：問題真的在這個工作台嗎？',
        Debrief: '兩種化學同時失效是任何單一槽都造不出的特徵——晶圓看到的最後一道水是大樓的水。你拒絕下單的那個維修會花八小時，什麼也修不好。',
        objective: {
          phone: '致電廠務查詢公用系統面板',
          call: '正確地通報',
        },
      },
      takeTheStairs: {
        Title: '走樓梯下去',
        Briefing: '通報已經完成：沖洗迴路讀 11 MΩ·cm，嫌疑是拋光混床。現在你是這個故事的廠務一側。下去，把大樓恢復健康。',
        Debrief: '混床在幾乎整個壽命裡穩住 18.2，然後在最後幾個百分點內崩潰——這正是水廠按處理量再生、絕不按表針再生的原因。面板綠了；樓上的工作台下一批就恢復。',
        objective: {
          descend: '走 FAC-06 後面的樓梯下去',
          repair: '再生拋光混床',
          green: '讓大樓恢復健康',
        },
      },
      oneEventTwoSymptoms: {
        Title: '一個事件，兩種症狀',
        Briefing: '相隔一小時的兩起投訴：ALD 生長又快又不均勻，爐管氧化層偏厚。兩台機、兩個製程組、兩張工單。先都去看過，再相信任何一個。',
        Debrief: '乾燥氣總管裡的水毀掉 ALD，因為水是它的共反應物；又透過完全不同的機制讓爐氧變厚。兩種症狀除了病因毫無共同點——而在你在兩台機之間走過之前，兩個組沒有任何理由對表。',
        objective: {
          ald: '去看 ALD 機台',
          furnace: '去看爐管',
          call: '在任一台正確地通報',
        },
      },
      wrongRepair: {
        Title: '讓大樓恢復健康',
        Briefing: '廠務層有什麼東西病了。工單只說了這一句。下面的每次維修不管對錯都照收工時——儀表就是你避免付兩次錢的辦法。',
        Debrief: '在你花掉一個小時之前，儀表就排除了無辜的設備：廠務層大部分是好的，這件事本身就是診斷的大部分。如果你先修了健康的設備，收工報告會精確展示那份確定的代價。',
        objective: {
          descend: '下去讀儀表',
          repair: '修真正生病的那台設備',
          green: '讓大樓恢復健康',
        },
      },
    },
    orders: {
      Button: '工單',
      Title: '工單',
      BoardNote:
        '一份任務說明、一棟處於某種狀態的大樓，以及對證據的期待。接受工單會佈置好世界；' +
        '你做的每件事都會記入日誌，證據齊了工單就完成。沒有評分——收工報告只展示你的確定' +
        '花了多少代價。',
      TrackRoom: '這間房',
      TrackTool: '眼前的機台',
      TrackBuilding: '這棟大樓',
      TrackCapstone: '整條產線',
      ClassLink: '課堂連結',
      LinkCopied: '已複製連結',
      Accept: '接受',
      Again: '再來一次',
      Abandon: '放棄',
      Active: '進行中',
      Completed: '已完成',
      Done: '工單完成',
      Cost: '花了什麼',
      TotalHours: '機台總工時',
    },
    subfab: {
      mau: {
        Title: '新風機組 MAU-1',
        Intro: '室外空氣進，潔淨室空氣出。除濕就是冷卻到露點再再熱；冬天靠蒸汽加濕；壓力是扣除排風之後剩下的。',
        Readings: '機組讀數',
        WeatherSummer: '夏季設計日',
        WeatherWinter: '冬季設計日',
        WeatherMild: '溫和天氣',
        Reset: '重設',
        KnobOutsideC: '室外空氣溫度',
        KnobOutsideRh: '室外空氣濕度',
        KnobSupplyC: '送風溫度設定',
        KnobSupplyRh: '送風濕度設定',
        KnobFanPct: '送風機，設計值的 %',
        KnobExhaustPct: '製程排風，設計值的 %',
        Flow: '送風 / 排風',
        Moisture: '含濕量 進 / 出',
        DewPoint: '送風露點',
        CoilLeaving: '冷卻盤管出風溫度',
        Dehumidifying: '除濕中',
        Cooling: '冷卻盤管',
        Heating: '預熱 + 再熱盤管',
        Steam: '加濕器蒸汽',
        FanPower: '風機功率',
        Power: '功率（冰水機按 COP 折算）',
        Pressure: '潔淨室壓力',
        WarnFreeze: '冰水盤管被要求達到接近冰點的露點：結霜風險。',
        WarnCooling: '冷卻盤管超出額定能力；送風會偏熱偏濕。',
        WarnHeating: '熱水盤管超出額定能力；送風會偏冷。',
        WarnSteam: '加濕器超出額定能力；潔淨室會變乾。',
        WarnPressureLow: '潔淨室正壓喪失：走廊空氣正從縫隙倒灌進來。',
        WarnPressureHigh: '壓力過高：門會頂著閉門器，FFU 靜壓箱會被頂起。',
        Note: '銘牌：12 000 m³/h，製冷 240 kW，供熱 130 kW，蒸汽 110 kg/h。樓上還沒有任何設備感知這台機組；這些數字是焓濕計算，不是故障模型。',
      },
      BoardTitle: '廠務層公用系統',
      SkidNote:
        '這是大樓這一側的故事。在這裡做的維修是真實的：無論對錯工時照收，只有真正生病的' +
        '那台設備能換回任何東西。',
      RepairCleared:
        '維修完成，迴路重新認證。公用系統面板重新變綠——上樓看看各台設備恢復吧。',
      RepairWasted:
        '修好了，重新認證了……而樓上的症狀紋絲不動。這台設備本來是健康的；工時已經花掉了。',
      RepairIdle: '這台設備沒有任何問題。預防性維護，已記錄並計費。',
      BeltsSlipping: '帶載打滑',
      BeltsTight: '張緊良好',
      reading: {
        headerLeakUp: '總管漏率',
        headerAdder: '各腔體附加壓力',
        pcwSupply: '供水溫度相對額定值',
        gasMoisture: '乾燥器出口總管水分',
        upwLoop: '迴路電阻率（25 °C 補償）',
        ahuFlow: '送風量相對設計值',
        ahuBelts: '傳動皮帶檢查',
        forelineMET05: '前級壓力，MET-05',
        forelineINSP13: '前級壓力，INSP-13',
        forelinePRB14: '前級壓力，PRB-14',
        trayCMP11: '雙套管托盤，CMP-11 管線',
        trayECD12: '雙套管托盤，ECD-12 管線',
        chemInterlock: '輸送連鎖',
        mauFlow: '新風送風量 / 設計值',
        mauFilterDp: '初效濾網壓降',
        roomPressure: '潔淨室相對大氣壓力',
      },
      PumpsPulling: '全部正常抽氣',
      TrayDry: '乾燥',
      TraysDry: '托盤乾燥',
      InterlockShut: '已關停——{{tag}} 輸送停止',
      InterlockOpen: '開放，所有管線正常輸送',
      Tight: '密封良好',
    },
    name: {
      SimFab: 'SimFab',
      Institute: '未來智能研究所',
      Tagline: 'SimFab — 從原子到晶圓廠',
    },

    language: {
      Language: '語言',
      Change: '切換語言',
    },

    splash: {
      Eyebrow: '從原子到晶圓廠',
      Headline: '你正站在<em>更衣氣閘室</em>前。',
      Sub:
        '歡迎！你的任務是運行走道裡的機台：打開一台機台，設定製程，請站上的技術員' +
        '解釋正在發生的事，分析資料，產生報告。你也可以按工單來做。',
      KeyWalk: '<span>行走 · <kbd>Shift</kbd> 奔跑</span>',
      KeyLook: '<span>環視 · 或用 <kbd>←</kbd><kbd>→</kbd> 轉身</span>',
      KeyOpen: '<span>開啟機台</span>',
      KeyAsk: '<span>助理替你把實驗跑出來</span>',
      CapLook: '右鍵拖曳',
      CapOpen: '點擊',
      CapAsk: '提問',
      KeyFind: '<span>按名稱尋找任何機台並跳轉過去</span>',
      EnterFab: '進入 {{fab}}',
      CapTap: '點按',
      CapDrag: '拖曳',
      KeyWalkTouch: '<span>廠區裡的任意機台——你會走到它面前</span>',
      KeyLookTouch: '<span>環視四周</span>',
      KeyOpenTouch: '<span>開啟面前的機台</span>',
    },

    vehicle: {
      Hoist: '天車（OHT）',
      Robot: '移動機器人',
      Carrying: '載有批次 {{lot}}，晶圓盒 {{carrier}}',
      BoundFor: '前往 {{tool}} 的 {{port}} 號裝載埠',
      BoundEnd: '沿車道返回',
      Cruising: '以 {{speed}} m/s 行駛中',
      Holding: '在前車後方等待',
      Transferring: '正在裝載埠交接晶圓盒',
      Moving: '以 {{speed}} m/s 移動中',
      Delivering: '正在裝載埠交付',
      Yielding: '已停車——安全區域內有人',
      Dismiss: '按 <kbd>Esc</kbd> 或點擊地面關閉',
      DismissTouch: '點按地面關閉',
    },
    talk: {
      Title: '正在與 {{name}} 交談',
      Placeholder: '問{{name}}一個問題…',
      Send: '送出',
      Close: '結束對話',
      Stop: '停止',
      Stopped: '已停止',
      Thinking: '…',
      Local: '本機回覆——無法連線託管模型',
      VoiceOn: '朗讀回覆',
      VoiceOff: '停止朗讀回覆',
      MicStart: '說出你的問題',
      MicStop: '停止聆聽',
      Listening: '正在聆聽…',
      MicWhere: '語音輸入由瀏覽器處理，音訊可能會傳送到其語音服務。',
      MicDenied: '無法使用麥克風。請在瀏覽器中允許後再說話。',
      predict: {
        Waiting: '在結果出來之前：',
        Placeholder: '說說你認為會往哪個方向變…',
        Skip: '直接看結果',
        SkipTitle: '不作判斷，直接顯示結果',
      },
      knock: {
        Wants: '{{name}} 想跟你說句話',
        Listen: '去聽聽',
        Dismiss: '暫不',
        OutOfSpec: '關於 {{tag}} 剛跑出規格的那片',
        WrongCall: '關於 {{tag}} 的故障判斷',
        Stalled: '關於你手上這張工單',
      },
      experiment: {
        Running: '這就跑給你看…',
        Progress: '第 {{done}} / {{total}} 個條件',
        Unavailable: '我從這裡構不到機台——到它前面按 E，在那裡問。',
        Failed: '這次運行沒有跑完。機台沒有被動過。',
        LockedOut: '{{tag}} 掛了保養鎖定牌——檢查項簽字之前，它上面什麼都不能跑',
      },
      line: {
        ChambersDown: '製程冷卻水正在變熱，全廠每台蝕刻機三個腔體中的兩個因此停機——每台蝕刻機只剩一個腔體在承擔全部蝕刻。全廠區的批次都在蝕刻前堆積。',
        Scenario: {
          chiller: '冰水機跳機',
          qtime: '排隊時限',
          excursion: '失控事件',
          pm: '到期腔體',
        },
        Decided: {
          chiller: {
            reroute: '讓所有批次排隊等剩下的腔體，先到先做',
            hold: '腔體恢復前暫停投片',
            'by-date': '蝕刻按交期排程',
          },
          qtime: {
            run: '讓曝光機照常運行',
            gate: '在曝光機前設閘，直到蝕刻機能及時蝕刻',
          },
          excursion: {
            '0.05': '抽檢 5% 的量測來訪',
            '0.1': '抽檢 10% 的量測來訪',
            '0.25': '抽檢 25% 的量測來訪',
            '0.5': '抽檢 50% 的量測來訪',
          },
          pm: {
            now: '現在保養腔體',
            defer: '讓腔體跑完這週',
          },
        },
      },
      demo: {
        // The controls a scene puts under itself in a conversation, where
        // its panel would have wired them to a recipe (app/talk/demoScenes.tsx).
        knob: {
          RingWear: '聚焦環磨損',
          IonEnergy: '離子平均能量',
          Downflow: '下降氣流速度',
          Tilt: '束流相對晶軸的傾斜',
        },
        Show: '再放一次',
        Loading: '正在調出…',
        Failed: '這個在這裡放不出來。',
        'crystal-lattice': {
          Title: '矽晶體到底是什麼',
          About: '矽原子按金剛石結構排列，在真實分子動力學下振動。',
          Watch: '每個原子都在振動，卻沒有一個離開位置。固體就是這樣：把它們固定住的只有彼此。',
          Try: '把「晶體溫度」往 1600 K 拉，看振動越來越大，再拉回來。沒有一個原子會離開自己的位置。',
        },
        bands: {
          Title: '矽為什麼是半導體',
          About: '矽的能帶結構，以及決定其餘一切的那道禁帶。',
          Watch: '看滿帶和空帶之間的那道間隙。太寬就不導電，太窄就關不斷。',
          Try: '這裡沒有可調的東西——能帶只解一次。沿著下方座標軸逐點看垂直方向的間隙，找出它最窄的位置。',
        },
        carriers: {
          Title: '摻雜矽裡的載流子從哪來',
          About: '凍析區、非本質區、本質區：一個摻雜濃度到底給你多少載流子。',
          Watch: '拖動摻雜滑桿，看載流子數怎麼不跟著走。在低溫那一端，大多數摻雜原子還攥著自己的電子沒放。',
          Try: '把摻雜滑桿從一頭拉到另一頭，看三個區依次經過：凍析區、非本質區，最後是矽本身接管的本質區。',
        },
        'si-surface': {
          Title: '矽表面，以及它為什麼會反應',
          About: '(100) 面的重構，以及這條線上每道製程所依靠的懸掛鍵。',
          Watch: '看最上面一層怎麼兩兩配對。那些傾斜的二聚體就是懸掛鍵——這條線上每道製程都在跟它們反應。',
          Try: '先讓它穩定下來，再把溫度滑桿往上推，看那些二聚體照樣保持傾斜——重構不是加熱能抹掉的。',
        },
        'diffusion-hop': {
          Title: '原子在固體裡怎麼移動',
          About: '一個自間隙原子在矽中一次次跳躍，溫度越來越高，畫出它的阿瑞尼士直線。',
          Watch: '盯著那個標出來的原子跟鄰居換位——一次跳躍就是一次擴散事件。把爐溫調高，跳得更勤；而完美晶體一次也不跳。',
          Try: '把「爐溫」拉到 1600 K 左右再按一次 Run——跳躍會快上好幾倍。然後切到「完美晶體（對照）」，看它無論多熱都停在零。',
        },
        'film-growth': {
          Title: '薄膜是怎麼一個原子一個原子長起來的',
          About: '氣相原子落到熱晶圓上並留下來，以及它們畫出的成長曲線。',
          Watch: '原子不斷落上來，有的留下有的又跑掉。旁邊那條曲線就是膜在變厚，它拐彎的地方就是來和走打平的地方。',
          Try: '把「晶圓溫度」往下拉再跑一次：晶圓越冷，落上來的留得越多，曲線也就更接近整份氣相裝料。',
        },
        tunnelling: {
          Title: '電子穿隧只有幾個原子厚的閘極氧化層',
          About: '一個電子波包撞上由幾層原子構成的閘極氧化層：大部分以條紋的形式彈回來，一個微弱的副本穿隧過去，放大後你能看見它。',
          Watch: '看波包一邊前進一邊變寬，然後堆在原子前形成明亮的條紋——那是入射波和反射波在交疊。牆的另一側，放大之後，一個微弱的副本穿過了一堵它沒有足夠能量翻越的牆。這就是穿隧。',
          Try: '把「氧化層厚度」拉到 0.6 nm——兩層原子——看牆後面那部分變亮，放大倍數標籤會告訴你亮了多少。再按「氧化層作為平板」，把原子換成它們平均而成的光滑位障，看穿過去的比例幾乎一樣。 按「三維 · 體積」，同一堵牆會變成一層層的小球，在工作執行緒上幾秒算完。',
        },
        'plasma-emission': {
          Title: '為什麼輝光能告訴你薄膜已經蝕完',
          About: '蝕刻機的終點偵測是一台對著電漿的光譜儀。每條譜線都是一個原子在兩個能階間跌落，由分布尾端的電子點亮。',
          Watch: '看兩條曲線：矽蝕穿時 SiF 譜帶熄滅，同一刻氟線上升，因為再沒有什麼在消耗氟。',
          Try: '把 T_e 從 3 eV 拉到 2 eV，看氬的 750 nm 線塌下去，而 440 nm 譜帶幾乎不動：13.5 eV 的閾值對 2.9 eV 的閾值。',
        },
        'dopant-atom': {
          Title: '摻雜原子就是一個氫原子——直到它們太多了',
          About: '磷原子多出來的那個電子繞著它運動，像氫原子一樣，只是被晶體按比例改了：軌道 2.4 nm，束縛能幾十 meV。由薛丁格方程式解出，不是畫上去的。',
          Watch: '看左圖帶陰影的軌道和穿過它的三條線——波耳半徑、平均半徑，以及到下一個摻雜原子的一半距離。右圖裡，束縛能隨摻雜濃度下降，在莫特轉變處歸零。',
          Try: '把「摻雜濃度」拉到 10¹⁸ 以上，看那條一半距離的線穿進軌道，同時遮蔽把軌道撐大——然後束縛態消失，電子自由了。切換到砷化鎵，看模型表現最好的情形。',
        },
        'photon-counting': {
          Title: '一幅影像是由什麼構成的',
          About: '把空間像當作被計數的光子交付——每個像素一次卜瓦松抽樣——再經光阻模糊並顯影。印出邊緣的粗糙度是量出來的，不是假定的。',
          Watch: '看中間那幅圖：20 mJ/cm² 的 EUV 下，影像是一片顆粒，每像素約 100 個光子，右邊顯影出的邊緣在游走。虛線是同一幅影像若由 ArF 光子構成的情形，平滑 √14 倍。',
          Try: '把「劑量」拉到 2 mJ/cm²，看粗糙度依 1/√劑量 上升；切到「EUV 的影像，ArF 的光子」，同一條邊緣就變平滑。在 0.5 mJ/cm² 下把光阻作用距離縮到 2 nm，缺陷列就出現了。',
        },
        'channel-quantisation': {
          Title: '臨界電壓為何不在公式所說之處',
          About: '閘極把能帶壓彎成一奈米寬的井，這麼窄的井只允許離散的能階。通道電荷離開了氧化層，而探針卡量到的就是這個差別。',
          Watch: '看左圖的陰影形狀：通道裡的每個電子在氧化層處為零，在一奈米深處達到峰值。右圖中，兩條電容都搆不到氧化層電容；實線的量子電容更低，因為每一伏帶來的電荷落得離氧化層更遠幾埃。',
          Try: '把「閘極電壓」調高，看能階下沉、形狀向氧化層擠壓——更近，卻永遠不貼上去。把「氧化層厚度」減到 1 nm，兩條電容曲線的差距會變大：氧化層只有十來埃時，幾埃的間距就更要緊。',
        },
        'raman-strain': {
          Title: '拉曼儀盯著移動的那條譜線',
          About: '由真實的 Stillinger–Weber 力常數算出矽的聲子，以及拉曼光譜儀用來讀取應變的區心光學模。',
          Watch: '看六支色散：三支聲學支從零出發，三支光學支在 593 cm⁻¹ 附近；旁邊的拉曼譜線標出了實測的 520——模型偏高，並且如實說明。',
          Try: '把「雙軸應變」拖到 −1%，譜線上移並分裂成一個單態和一個雙態；推到 +1% 則下移。切換到 Ge，一切都往下掉：更重的原子架在更軟的鍵上。',
        },
        'quantum-well': {
          Title: '幾個奈米的合金對一個電洞意味著什麼',
          About: '夾在矽之間的一薄層矽鍺，對電洞而言就是一個盒子，而生長的厚度就是盒寬。允許的能階由所生長的剖面解出，不是畫上去的。',
          Watch: '看位能井內那一架虛線能階，以及落在最低一階上的陰影曲線——它顯示那個電洞真正所在之處。每一階都是這層材料所允許的一個能量；在它們之間，電洞無處可取。',
          Try: '把「生長厚度」從 8 nm 往下拉，看每一階都往上爬；再看最上面那一階觸到壁而消失——原本容納四階的井變成三階，再變成兩階。把「鍺組成」調高使井變深，它們又會回來。',
        },
        'resist-absorption': {
          Title: '光阻為什麼只響應某一種顏色的光',
          About: '計算得到的共軛分子吸收帶，並標出曝光所用的各條波長。把鏈拉長，吸收帶便沿光譜移動，依次越過每一條譜線。',
          Watch: '看哪幾條標線變成琥珀色。分子只響應其吸收帶所覆蓋的譜線；而吸收帶會移動，是因為 π 電子處在一個盒子裡，盒長即共軛長度——鏈越長能階越密，吸收的光也越紅。',
          Try: '把「共軛長度」從 1 個雙鍵拉到 11 個。到 4 個時吸收帶正落在 365 nm 的 i 線上；到 6 個就已越過它落到 g 線，i 線隨之熄滅。這裡無論怎麼調都落不到 193 nm 的 ArF 上，這正是 193 nm 需要另一族分子的原因。',
        },
        chemisorption: {
          Title: '前驅體與晶圓逐鍵反應',
          About: '反應性力場下矽烷落在矽晶圓上：一個 Si-H 鍵在懸鍵處斷裂，生成一個 Si-Si 鍵，這個矽便併入薄膜。畫出的鍵棒來自鍵級，而非腳本。',
          Watch: '看一個分子飄下來貼到表面，隨後把一個氫交給它——兩者之間的鍵棒消失，通向晶圓的新鍵棒出現。綠色曲線數的是已併入薄膜的矽，藍色數的是留在表面的氫，正是它擋住了下一個分子。',
          Try: '按下「矽基自由基（SiH₃，電漿 CVD）」，再把「晶圓溫度」拉到 600 K：自由基能附著，而完整的矽烷不能——這正是電漿 CVD 可以低幾百克耳文運行的原因。然後按「氫終止」，看生長如何等待氫先離開。',
        },
        'electron-diffraction': {
          Title: '電子波穿過雙縫',
          About: '高斯電子波包遇到雙縫或一排原子，盒子邊緣按角度記錄到達的一切。各束落在 sin θ = mλ/p 所指的位置，一旦波長超過間距便消失。',
          Watch: '看波包一邊前進一邊展寬，在狹縫處分開，作為分離的光束離去。圖就是螢幕：每個峰都落在一條虛線上，而那些虛線是由間距預測的繞射級。峰不是誰畫上去的——是波形成的。',
          Try: '把「電子能量」拉向 4 eV，看外側各級先張開、再隨波長超過間距而消失。按「一排原子，間距 0.5 nm」換成更細的靶，那裡要看到任何結構都需要短得多的波長。',
        },
        'light-absorption': {
          Title: '矽晶圓為什麼對紅光透明',
          About: '由緊束縛能帶算出的基板光吸收：整個布里淵區內從滿帶到空帶的每一次躍遷。厚度擬合預設使用的折射率正是從這裡來的。',
          Watch: '看曲線從零抬起的位置。矽在 3 eV 附近，即其直接能隙，遠高於通常引用的 1.1 eV——單個光子無法提供間接躍遷所需的動量。琥珀色標線是反射儀的掃描範圍，幾乎整段都落在透明區。',
          Try: '按「Ge」，再按「GaAs」。兩者的吸收起點都低得多，把整個可見掃描範圍吞掉；所以它們都做不成窗口，也所以薄膜之下的晶圓才是厚度擬合所需要的那個透明體。',
        },
        'doped-lattice': {
          Title: '摻雜原子，落在它的晶格裡',
          About: '硼佔據一個矽原子位，在真實的分子動力學下振動——這才是「p 型」的真面目。',
          Watch: '帶光暈的原子是佔據矽位的硼。這個替位本身就是摻雜——不是晶圓的某種屬性，而是一個坐錯位置的原子，重複很多次。看圖：輕的硼明顯比周圍的矽振動得更快。',
          Try: '把「摻雜濃度（已誇大）」上下拖動，再按「高亮摻雜原子」取消光暈，看看真實比例。真實摻雜是百萬分之幾——在 216 個原子裡根本看不見，所以這個視圖作了弊。',
        },
        channelling: {
          Title: '為什麼離子植入要傾斜七度',
          About: '離子植入真正到達的深度，以及決定它的那點傾斜。',
          AxisDepth: '進入晶圓的深度（nm）',
          AxisIons: '停下來的離子數',
          LabelQualified: '傾斜 7°（已認證）',
          LabelLive: '目前傾斜',
          Status: '臨界角 ψ₁ = {{a}}° · 溝道化束流 {{b}}% · 最深的 1% 達到 {{c}} nm',
          Tracing: '正在追蹤 3,000 個離子…',
          Watch: '虛線是通過認證的 7° 配方。傾斜為零時，四分之一的束流找到敞開的原子列一穿而過——劑量相同、能量相同，深度卻翻了一倍。',
          Try: '把「束流相對晶軸的傾斜」從 0 拖到 12°，看那條深拖尾在哪裡消失。它在 2° 和 4° 幾乎毫髮無損，然後驟然塌縮——塌縮的那個角度，正是圖下方標出的 ψ₁。',
        },
        sheath: {
          Title: '晶圓邊緣上方的電漿鞘',
          About: '把亂走的離子變成垂直束流的那段壓降，以及磨損的聚焦環怎麼把它帶歪。',
          Watch: '晶圓上方那條亮帶就是壓降。等勢線就是離子走的路——在晶圓上方是平的，到磨損的聚焦環那裡就彎了。',
          Try: '把「聚焦環磨損」從 0 拉到 100%，看晶圓邊緣上方的等勢線怎麼從平的變成彎的。彎的那一段，就是離子不再垂直入射的地方。',
        },
        'trench-arde': {
          Title: '窄溝槽為什麼蝕刻得慢',
          About: '同一團電漿下四條不同寬度的溝槽，窄的那幾條被餓著。',
          Watch: '四條溝槽，同一團電漿。看蝕刻劑怎麼到得了寬溝的底，卻始終到不了窄溝的底。',
          Try: '把「離子平均能量」從 93 eV 往上拉，看窄溝不但沒變好反而更糟：離子越硬，表面消耗蝕刻劑就越快，快過窄孔能送進去的速度。',
        },
        'thermal-budget': {
          Title: '熱對摻雜剖面做了什麼',
          About: '一個流程讓摻雜劑移動多遠，即 D(T) 對時間的積分：兩片相同的佈植，其中一片在 900 °C 流程中經歷十分鐘 1200 °C 尖峰。',
          Watch: '兩片晶圓，佈植了同樣的硼。左邊那片在過程中間被加熱到 1200 °C 十分鐘；右邊那片全程保持 900 °C。看看左邊的硼擴散得遠多少。',
          Try: '',
        },
        'drive-in': {
          Title: '一次完整的驅入退火',
          About: '硼在爐中被推進矽裡，溫度和剖面隨著運行一起變化。',
          Watch: '硼往矽裡推進。看擴散前緣一路往下走，右邊的曲線隨著各個探針先後感受到它而依次抬起來。',
          Try: '用畫布下面的爐溫設定：一百度的作用遠大於把時間加倍，從探針曲線抬起來的快慢就看得出來。',
        },
        'line-chiller': {
          Title: '產線：冰水機跳機對整個廠區做了什麼',
          About: '把廠房看成排隊系統：蝕刻機三個腔體停了兩個、停機六小時，值班的三種應對，每一種都逐批次與同一週無故障的情形比較。',
          Watch: '藍線是沒人做決定時的情形。看腔體停機時蝕刻在製批次猛增，再看腔體恢復之後產線還要付出多久的代價。然後看表格：同一次故障，三個決定，各自在交期上的代價。',
          Try: '把負荷切到 95%，看同樣的六小時跳機要用幾天才能消化。再把通知時間切到 08:00，看在錯誤機台上耗掉的六小時值多少。',
        },
        'bay-airflow': {
          Title: '一個 bay 裡的層流下降氣流',
          About: '把顆粒往下帶走的層流空氣，以及站在裡面的人對它做了什麼。',
          Watch: '看空氣筆直往下走，到地面再往兩側散開。它帶著的東西也就跟著走了——除非有人正站在中間擋著。',
          Try: '把「下降氣流速度」往 0.10 m/s 拉，看那根筆直的氣柱怎麼散掉。這就是「把顆粒掃走的氣流」和「任它亂飄的氣流」之間的差別。',
        },
      },
      cast: {
        sarah: { Name: '陳怡君', Short: '怡君', Role: '蝕刻技術員', Post: '04 號工作區 ETCH-01 的操作螢幕前' },
        jake: { Name: '林志偉', Short: '志偉', Role: '微影技術員', Post: '05 號工作區 LITH-03 塗佈顯影軌道的操作螢幕前' },
        emily: { Name: '黃淑芬', Short: '淑芬', Role: 'CMP 技術員', Post: '08 號工作區 CMP-11 的操作螢幕前' },
        nicole: { Name: '吳雅婷', Short: '雅婷', Role: '離子植入技術員', Post: '03 號工作區 IMP-10 的操作螢幕前' },
        tom: { Name: '張家豪', Short: '家豪', Role: '維護技術員', Post: '02 號工作區 THRM-04 打開的面板內，站在腳凳上' },
        owen: { Name: '鄭文彬', Short: '文彬', Role: '磊晶技術員', Post: '02 號工作區 EPI-20 的操作螢幕前' },
        grace: { Name: '林佳穎', Short: '佳穎', Role: '晶圓測試技術員', Post: '09 號工作區 PRB-14 的操作螢幕前' },
        laura: { Name: '蔡宜芳', Short: '宜芳', Role: '量測技術員', Post: '07 號工作區 MET-05 的操作螢幕前' },
        ryan: { Name: '許志豪', Short: '志豪', Role: '沉積技術員', Post: '04 號工作區 DEP-02 的操作螢幕前' },
        hannah: { Name: '周欣怡', Short: '欣怡', Role: 'EUV 曝光機技術員', Post: '06 號工作區 EUV-22 的操作螢幕前' },
        brian: { Name: '賴冠宇', Short: '冠宇', Role: 'CD-SEM 量測技術員', Post: '06 號工作區 SEM-23 的操作螢幕前' },
        claire: { Name: '謝佩君', Short: '佩君', Role: '低溫技術員', Post: '12 號工作區 QDT-24 的操作螢幕前' },
        kevin: { Name: '王建宏', Short: '建宏', Role: '值班主管', Post: '主走道上，正在巡視廠房' },
        marcus: { Name: '李俊傑', Short: '俊傑', Role: '蝕刻設備技術員', Post: '04 號工作區後方維護通道內 ETCH-01 的背面，一塊後面板已拆下' },
        rachel: { Name: '陳雅琪', Short: '雅琪', Role: '沉積設備技術員', Post: '04 號工作區後方維護通道內 DEP-02 的輔助機櫃旁' },
        dave: { Name: '劉建志', Short: '建志', Role: '廠務電工', Post: '08 號工作區後方維護通道內的 MCC 配電盤前' },
        megan: { Name: '楊佩珊', Short: '佩珊', Role: '廠務技術員', Post: 'ETCH-01 這一排後方的維護通道走道上，正在巡檢' },
      },
      floor: {
        Walking: '在主走道上，與 {{bay}} 號工作區（{{tags}}）齊平，正朝{{toward}}走',
        TowardGas: '東邊的氣體站',
        TowardGowning: '西邊的更衣站',
        AtTool: '{{bay}} 號工作區的 {{tag}}',
        Down: '{{tag}} 正在進行預防性維護，已停機',
        LayoutBallroom:
          '大開間式廠房：同樣的機台立於同一開放地面，沒有隔牆。兩排機台面向主走道，每排身後各有一排同型機台（如 ETCH-01 身後的 ETCH-02）面向外側走道，無人值守、不能開啟，問題請找第一排。泵、冰水機、射頻電源和氣櫃都在地下層。更衣站在西端，氣體站在東端；工作區從更衣站旁的 01 號起編號，在任何走道上都相同。',
        Layout:
          '這裡是 Fab A。工作區加維修通道式廠房：機台正面嵌在單一主走道兩側的隔牆內，隔牆後是維修通道；有架空搬運環線和地面機器人運送晶圓盒，西端是更衣站，東端是氣體站。工作區沿主走道編號，01 號最靠近更衣站。',
      },
      local: {
        Greeting: '你好，我是{{name}}，現在在{{post}}。想了解什麼？',
        Doing: '我在 {{tag}}，機台{{state}}。螢幕顯示 {{headline}}（{{caption}}）。',
        DoingNoTool: '我正在工作區之間走動，沿主走道往前。',
        About: '{{tag}} 是一台{{name}}，做的是{{process}}。{{blurb}}',
        Screen: '現在讀數是 {{headline}}——{{caption}}。{{rows}}',
        Order: '目前開啟的工單是「{{title}}」：{{total}} 個目標已完成 {{done}} 個。',
        NoOrder: '現在沒有開啟的工單。',
        Down: '{{tag}} 停機做 PM：面板已拆下，掛了上鎖掛籤，晶舟已降到升降機上。檢查簽核後就恢復運轉。',
        Showing: '這個我在這裡跑不了，不過可以放出來給你看：{{title}}。',
        CantSay: '這個我在這裡說不了。到 {{tag}} 前按 E，問機台自己的助手——它能把實驗跑出來。',
        CantSayNoTool: '這個我在這裡說不了。機台自己的面板能把實驗跑出來——到機台前按 E。',
        NotHuman: '我不是真人——你在跟模擬器說話。現在也沒有任何 AI 模型在回答；這些話是模擬器裡預設的固定台詞。',
        States: { idle: '閒置', running: '運轉中', alarm: '警報中' },
      },
    },
    hud: {
      OpenLive: '點擊機台，或按 <kbd>E</kbd> 開啟',
      OpenPending: '點擊或按 <kbd>E</kbd> 查看站點範圍——尚未模擬',
      OpenLiveTouch: '點按機台即可開啟',
      OpenPendingTouch: '點按查看站點範圍——尚未模擬',
      Idle: '待機',
      Open: '開啟',
      Running: '執行中 {{speed}}x',
      Rate: '速率',
      NonUniformity: '不均勻度',
      Cleared: '已清除',
      Time: 't',
    },

    panel: {
      Close: 'Esc — 回到廠區',
      Failed: '這個面板繪製失敗（{{message}}）。按 Esc 回到廠區。',
    },

    hmi: {
      Status: '狀態',
      Idle: '待機',
      LastStep: '上一道製程',
      Down: '停機',
      PmInProgress: '預防保養中',
    },

    xr: {
      EnterVr: '進入 VR',
      ExitVr: '離開 VR',
      Unavailable: 'VR 無法使用',
      ViewInVr: 'VR',
      ViewInVrTitle: '用手機 VR 眼鏡盒觀看',
      HolderHint: '輕點置中 · 長按離開',
      NoMotion: '這支手機沒有回報朝向。',
      MotionDenied: '動作權限遭拒。請在瀏覽器的本站設定中開啟。',
    },

    routes: {
      Button: '流程',
      ButtonTitle: '晶圓走過廠區的順序',
    },

    line: {
      DecideLabelQtime: '你在曝光機前的決定',
      DecideLabelExcursion: '你的決定：量測來訪抽檢多少',
      DecideLabelPm: '你對到期腔體的決定',
      ProductsLabel: '產品',
      ProductsOne: '一種',
      ProductsTwo: '兩種 —— 30% 雙重圖形',
      ChartCtTitleMix: '改道策略下各產品的週期時間（虛線：無故障）',
      ProductsThree: '三種 —— 25% EUV，3% 量子位元晶片',
      ProductEuv: 'EUV 產品',
      ProductQuantum: '量子位元晶片',
      NewToolsTitle: '曝光機、CD-SEM 和冷凍機群，與瓶頸並排來看',
      ColTool: '設備',
      ColInBuilding: '全廠台數',
      ColUtilisation: '忙碌率',
      ColDown: '停機率',
      ColWait: '平均等待',
      NewToolsNote: '四分之一的投片是先進產品：EUV-22 印它的閘極和最下面四層金屬，SEM-23 在 ETCH-01 蝕刻之前把每一次曝光都量一遍。百分之三是量子位元晶片，它們走完八道製程就離開前段，然後在冷凍機裡待兩天。把最後一欄和第三欄對著看。冷凍機群只用了大約一半的產能，遠低於蝕刻機，它的批次卻等得最久，差了一個數量級：批次等的是一台冷凍機空出來，而一台冷凍機一忙就是兩天。等待時間取決於排在你前面的那件工作要做多久，而不只是設備有多忙。曝光機是另一課：全廠只有一台，每八小時就有一小時停機，而批次沒有別處可去。冰水機跳機會同時停掉三族水冷設備：每三個蝕刻腔中的兩個、那台曝光機，以及每一台冷凍機。',
      ProductA: '單次圖形',
      ProductB: '雙重圖形',
      ChartCtTitleProducts: '改道策略下各產品的週期時間',
      TabQtime: '排隊時限',
      TabExcursion: '失控事件',
      TabPm: '保養',
      QtimeRun: '放任不管',
      QtimeGate: '在曝光機前設閘',
      QtimeNote: '同一次跳機，但製程路線上的光阻有保存期限：離開曝光機後八小時內沒有蝕刻的批次要去膠、重新曝光。每個已曝光卻卡在停機腔體後面的批次，時鐘都在走。兩種做法：放任不管，或在曝光機前設閘——目標蝕刻機以現有可用腔體無法在時限內蝕刻的批次就不曝光，讓批次在時鐘開始前等待。',
      QtimeChartTitle: '跳機以來退回曝光機的批次',
      ColReworks: '退回的批次',
      ColReworksControl: '無故障情形',
      ColReworkHours: '損失的曝光機小時',
      QtimeFinding: '先看「無故障」一欄：只要蝕刻佇列的等待超過時限，排隊時限本身就是一台重工機器——85% 時每天幾個批次，95% 時是大多數。設閘是讓時限可行的關鍵——它把曝光扣在曝光機前（那裡的佇列只花時間），直到蝕刻機能及時消化——85% 時代價是幾個交期，95% 時沒有代價。跳機本身增加的很少：它退回的批次是腔體停機時已經曝光的那些，任何策略都救不了。這是唯一一種扣住批次是對的情形，而且只因為它是在時鐘開始前扣住的。',
      ExcursionNote: '這次沒有跳機。凌晨兩點，一台沉積機台悄悄失控並繼續運行。廠區裡沒有任何提示。量測機台抽檢一部分來訪批次；抽到一個經過了壞機台的批次，才會發現。在此之前經過該機台的每個批次都已暴露。按六週不同運氣取平均，因為一次發現就是一次抽籤。',
      ExcursionChartTitle: '抽檢率買到的與付出的',
      ExcursionChartX: '被抽檢的量測來訪比例',
      ExcursionChartY: '批次 · 等待 × 10 小時',
      ExcursionSeriesExposed: '暴露批次，均值',
      ExcursionSeriesWait: 'MET-05 等待，× 10 小時',
      ColRate: '抽檢比例',
      ColDetect: '發現用時',
      ColExposed: '暴露批次，均值',
      ColExposedWorst: '最差一週',
      ColInspections: '每天抽檢數',
      ColMetWait: 'MET-05 等待',
      ColMetUtil: 'MET-05 忙碌',
      ExcursionFinding: '暴露批次數 = 經過壞機台的產出 × 發現前的小時數——這是從良率一側看到的利特爾法則。抽檢力度加十倍，發現時間減半，風險批次減半，但量測機台被填滿：佇列隨抽檢率增長，全廠每個批次都要在週期時間上付出代價。抽檢率是一個決定：工廠更願意承擔哪一種代價。',
      PmNow: '現在保養',
      PmDefer: '繼續運行',
      PmNote: '一台蝕刻機的一個腔體在凌晨兩點到了保養期。現在做：今晚計畫內的四小時。或者繼續跑：一個磨損的腔體終究會壞，壞的時候，計畫外維修要花兩倍時間，在沒人選擇的時刻。延後是一場賭博，所以兩種做法都按八週不同運氣評判，並與既不保養也不磨損的同樣八週比較。',
      ColChamberDown: '腔體停機，週均',
      ColBeyondControl: '超出兩者皆無的一週',
      ColWorstWeek: '最差一週',
      ColFailed: '保養前就壞了',
      ColDelayLotHours: '淨延誤批次小時',
      PmFinding: '計畫內保養只花它的 {{pm}} 小時。磨損的腔體壽命縮到 {{worn}} 小時，每次都在一週內壞掉，計畫外維修花了 {{repair}} 小時，而表中的維修時間是 {{mttr}} 小時——計畫內保養的兩倍，在沒人選擇的時刻，發生在瓶頸上。瓶頸的一小時就是全廠的一小時：最後兩欄裡每一個延誤批次小時都是這個差值沿產線傳下去的結果。',
      DecideLabel: '腔體停機期間，你的決定',
      Undecided: '尚未決定。工單需要一個決定；下面的數字不受影響。',
      Decided: '你選擇了：{{policy}}。已記入日誌。',
      Button: '產線',
      ButtonTitle: '把整座廠看成一條產線：批次、排隊，以及地下層的一次故障對它們意味著什麼',
      Title: '產線 —— 凌晨 02:00 的冰水機跳機',
      Intro: '十個工作區，一條製程路線，每台機台前都有佇列。凌晨兩點，地下層的一台冰水機跳機：製程冷卻水變熱，每台蝕刻機三個腔體中的兩個失去溫控。第三個腔體照常運行。批次仍在不斷到達。你正在值班。',
      Bottleneck: '瓶頸：{{tag}} —— {{n}} 台蝕刻機，每台三個腔體，每天約 {{starts}} 片晶圓投片',
      LoadLabel: '產線負荷',
      Load85: '85% —— 健康的產線',
      Load95: '95% —— 滿載的產線',
      CallLabel: '通知廠務部門',
      CallPrompt: '立即通知 —— 腔體 6 小時後恢復',
      CallLate: '08:00 才通知 —— 腔體 12 小時後恢復',
      ViewLabel: '檢視',
      TabScenario: '冰水機跳機',
      TabCurve: '運轉曲線',
      Running: '正在運行產線……',
      PolicyReroute: '改道',
      PolicyRerouteNote: '所有批次排隊等剩下的那個腔體，先到先做。沒人做決定時就是這樣。',
      PolicyHold: '暫停投片',
      PolicyHoldNote: '腔體恢復前不再投新批次。',
      PolicyByDate: '按交期',
      PolicyByDateNote: '蝕刻機下一個做離交期最近的批次，不論是否急件。',
      Control: '無故障',
      ControlNote: '同一週，冰水機正常運行。',
      ChartWipTitle: '蝕刻在製批次超出無故障情形的部分',
      ChartWipY: '批次',
      ChartX: '跳機後的小時數',
      ChartCtTitle: '逐日完工批次的週期時間',
      ChartCtY: '小時',
      MarkTrip: '跳機',
      MarkRestore: '恢復',
      CostTitle: '這次故障的代價，對比同一週無故障的情形',
      ColPolicy: '策略',
      ColPeak: '蝕刻在製峰值',
      ColDrain: '佇列恢復正常',
      ColDelayed: '被延誤的批次',
      ColMeanDelay: '平均延誤',
      ColDates: '丟失的交期',
      ColHot: '丟失的急件批次',
      ColChamberHours: '損失的腔體小時',
      DrainNever: '兩週內未恢復',
      HoursAfter: '恢復後 {{h}} 小時',
      Hours: '{{h}} 小時',
      CostNote: '在跳機後的兩週內逐批次與對照組比較：批次完工晚於無故障情形即算延誤，對照組能如期而這裡沒有即算丟失交期。腔體停機 {{h}} 小時。',
      LittleTitle: '穩態產線上的利特爾法則',
      LittleLine: '跳機前：產線內 {{wip}} 個批次 = {{thr}} 批次/小時 × {{ct}} 小時週期時間（比值 {{ratio}}）。在製品、產出和週期時間不可能各自獨立變化。',
      FindingsTitle: '產線告訴我們什麼',
      FindingDrain: '腔體幾小時就回來了，佇列卻沒有。每個在蝕刻前等過的批次都晚到了下一台機台，後面的批次又晚到了它們的機台，產線只能用富餘產能——扣除已有到達之後剩下的那部分——去消化。85% 時還有富餘；95% 時幾乎沒有，同樣的六小時要用幾天才能消化。',
      FindingByDate: '蝕刻按交期排程在兩種負荷下丟的交期都最少，因為「離交期最近」接近「最老的先做」，而這會把批次推出再入式產線，而不是再繞一圈。它的代價只在 95% 時顯現：急件批次不再插隊，而佇列已經很長，於是大多數急件失約。85% 時正確的規則，正是 95% 時丟掉急件批次的規則。',
      FindingHold: '暫停投片對蝕刻毫無影響。接下來六小時會堆在那裡的批次早已在廠內；你沒投的那些批次離蝕刻還有八天。暫停做到的只是讓被扣住的批次少了六小時的餘裕。',
      CurveNote: '健康產線（無故障）的週期時間隨負荷的變化。產線半空時平坦、接近純製程時間，八十幾開始上翹，九十幾陡升。85% 和 95% 下的冰水機跳機是從內部看到的這條曲線上的兩個點：斜率就是佇列一旦形成要多久才能消化。',
      CurveTitle: '週期時間隨負荷的變化',
      CurveX: '瓶頸負荷',
      CurveY: '× 製程時間',
      CurveSeries: '健康產線',
      CurveHere: '目前產線',
      ColLoad: '負荷',
      ColCt: '週期時間',
      ColCtRaw: '× 純製程時間',
      ColWip: '產線在製批次',
    },
    finder: {
      Button: '尋找機台',
      Placeholder: '輸入資產編號、機台名或製程名……',
      Hint: '<kbd>↑</kbd><kbd>↓</kbd> 選擇 · <kbd>Enter</kbd> 前往 · <kbd>Esc</kbd> 關閉',
      Empty: '沒有符合「{{q}}」的機台。',
    },
    place: {
      subfab: {
        Name: '地下設備層（子廠房）',
        Where: '設備層，FAC-06 後方樓梯',
      },
    },
    zone: {
      entry: '入口與規範',
      substrate: '基板——從矽到晶圓',
      frontend: '前段——把元件做出來',
      metrology: '量測與公用設施',
      interconnect: '平坦化與內連線',
      sort: '檢測與分類',
      assembly: '組裝、封裝與測試',
      quantum: '量子元件——同一座廠，另一種產品',
      support: '次廠房與化學品供應',
    },

    station: {

      etch: {
        Name: '電感耦合電漿蝕刻機',
        Process: '電漿蝕刻',
        Blurb: '多晶矽閘極蝕刻。完整模擬：反應器傳輸、鞘層物理、表面動力學。',
      },
      deposition: {
        Name: 'ALD / CVD 沉積叢集機台',
        Process: '薄膜沉積',
        Blurb:
          '以 ALD 成長 Al2O3。完整模擬：前驅物傳輸、受位點限制的表面化學、飽和行為與溫度視窗。',
      },
      litho: {
        Name: '浸潤式掃描機與塗佈顯影軌道機',
        Process: '微影',
        Blurb:
          '曝光劑量與焦距決定關鍵尺寸。完整模擬：由繞射級次合成的空間影像、光阻化學、' +
          '製程視窗與光子統計。',
      },
      patterning: {
        Name: '自對準四重圖案化單元',
        Process: '多重圖案化',
        Blurb:
          '先印粗的，再切兩次，最終節距取決於一層膜的厚度，而不是掃描機分辨得出的任何東西。' +
          '完整模擬：側壁幾何、節距行走，以及為什麼一個漂亮的平均值會掩蓋一個已經壞掉的圖案。',
      },
      thermal: {
        Name: '立式爐管與快速熱處理',
        Process: '熱製程',
        Blurb:
          '氧化、摻雜擴散與活化。完整模擬：Deal-Grove 氧化成長、菲克擴散，以及作為共用帳戶的熱預算。',
      },
      metrology: {
        Name: '橢圓偏光儀與反射儀',
        Process: '量測與統計製程管制',
        Blurb: '漂移偵測與管制圖。完整模擬：反射率擬合、量具能力，以及扣留批次或停機的判斷。',
      },
      facilities: {
        Name: '氣體輸送與廢氣處理',
        Process: '廠務與安全',
        Blurb:
          '真空、氣體輸送與廢氣處理。完整模擬：流導、抽真空過程，以及區分漏氣與腔體吸濕的升壓率測試。',
      },
      gowning: {
        Name: '更衣氣密室與規範區',
        Process: '無塵室規範',
        Blurb: '在你換好無塵衣之前，你就是這棟樓裡最大的粒子來源。範圍已界定，尚未模擬。',
      },
      crystal: {
        Name: '柴氏長晶爐',
        Process: '晶體成長',
        Blurb: '多晶矽與一顆晶種長成單晶矽晶棒。範圍已界定，尚未模擬。',
      },
      waferprep: {
        Name: '切片、研磨與拋光線',
        Process: '晶圓製備',
        Blurb: '晶棒變成晶圓，平整度以微米計。範圍已界定，尚未模擬。',
      },
      epi: {
        Name: '減壓磊晶反應器',
        Process: '矽磊晶',
        Blurb:
          '生長元件真正棲身的那一層。完全模擬:Grove 串聯的兩個生長阻力、來自晶體爐所摻基板的自摻雜,以及約束配方的滑移與霧狀缺陷。',
      },
      clean: {
        Name: 'RCA 濕式清洗槽',
        Process: '表面前處理',
        Blurb: '廠裡跑得最多、也最不起眼的製程。範圍已界定，尚未模擬。',
      },
      implant: {
        Name: '高束流離子植入機',
        Process: '離子植入',
        Blurb: '廠裡唯一一台會數自己原子的機台。範圍已界定，尚未模擬。',
      },
      cmp: {
        Name: '化學機械研磨機',
        Process: '平坦化',
        Blurb: '正是平坦度讓多層金屬內連線成為可能。範圍已界定，尚未模擬。',
      },
      plating: {
        Name: '銅電鍍槽',
        Process: '內連線',
        Blurb: '銅是鍍上去而不是蝕刻出來的，靠三種添加劑才能填滿。範圍已界定，尚未模擬。',
      },
      inspection: {
        Name: '圖形晶圓光學檢測與複檢',
        Process: '缺陷檢測',
        Blurb: '靈敏度與誤報率之爭，以及一個缺陷特徵的代價。範圍已界定，尚未模擬。',
      },
      probe: {
        Name: '晶圓針測與分類',
        Process: '晶圓測試',
        Blurb: '晶圓在這裡變成裸晶，良率在這裡變成一個數字。範圍已界定，尚未模擬。',
      },
      dicing: {
        Name: '背面研磨與切割',
        Process: '晶圓薄化與切割',
        Blurb: '薄到能夠堆疊，脆到不容忽視。範圍已界定，尚未模擬。',
      },
      bonding: {
        Name: '黏晶與打線機',
        Process: '組裝',
        Blurb: '壓力、超音波功率與時間——一個由曲面構成的製程視窗。範圍已界定，尚未模擬。',
      },
      packaging: {
        Name: '封膠、底部填充與先進封裝',
        Process: '封裝',
        Blurb: '好裸晶在這裡因為力學問題變成壞產品。範圍已界定，尚未模擬。',
      },
      finaltest: {
        Name: '終測與燒機',
        Process: '最終測試',
        Blurb: '測到什麼程度算夠，是算出來的，不是憑喜好定的。範圍已界定，尚未模擬。',
      },
      euv: {
        Name: 'EUV 曝光機（錫光源）',
        Process: 'EUV 微影',
        Blurb:
          '現代晶圓廠最重要的設備，從頭到尾都是量子物理。完整模擬：以薛丁格方程式求解錫離子的游離能、產生 13.5 nm 光的電漿、以傳遞矩陣計算的鉬/矽反射鏡，以及在光阻裡印出粗糙邊緣的光電子級聯。',
      },
      ebeam: {
        Name: 'CD-SEM 與電子束檢測',
        Process: '電子束量測',
        Blurb:
          '量測光學解析不了的東西。完整模擬：以 THRM-04 的穿隧引擎計算電子槍的 Fowler-Nordheim 場發射、繞射與像差所允許的束斑，以及一條由蒙地卡羅產生、邊緣要靠機台判定的線掃描訊號。',
      },
      quantum: {
        Name: '低溫量子元件測試站',
        Process: '量子位元特性量測',
        Blurb:
          '同一座廠、同一批設備，做的是另一種產品。完整模擬：以傳遞矩陣計算約瑟夫森接面的氧化層、精確求解 transmon 漢米爾頓量、頻率碰撞良率，以及 EPI-20 成長的矽量子井中的能谷分裂。',
      },
      gas: {
        Name: '氣瓶間與化學品輸送',
        Process: '氣體與化學品管理',
        Blurb: '矽甲烷、砷化氫、氫氟酸。在這個站點上出錯，代價不是報廢那麼簡單。範圍已界定，尚未模擬。',
      },
    },

    assistant: {
      // Suggestion chips, keyed by intent id. The English example stays
      // in the intent as the source of record and is what actually routes.
      topic: {
        'ion-enhanced etching': '離子增強蝕刻',
        'sheath and ion energy': '鞘層與離子能量',
        'ion energy distribution': '離子能量分佈',
      },
      example: {
        'etch-qual': '這台蝕刻機通過認定可以跑產品了嗎？',
        'cmp-qual': '這台拋光機通過認定可以跑產品了嗎？',
        'litho-qual': '這台掃描機通過認定可以曝產品了嗎？',
        'thermal-qual': '這台爐子通過認定可以跑產品了嗎？',
        selectivity: '我能不能直接把偏壓調高來達到速率目標？',
        'cmp-overpolish': '過拋該跑多少？',
        'cmp-speeds': '為什麼拋光盤和載具要同速旋轉？',
        'cmp-density': '為什麼銲墊會下凹而密集陣列不會？',
        'dep-saturation': '我的劑量真的飽和了嗎？',
        'dep-window': '這該在什麼溫度下跑？',
        'dep-purge': '能縮短吹淨換產能嗎？',
        'dep-conformality': '為什麼我溝槽底部的膜更薄？',
        'dep-uniformity': '為什麼我的膜邊緣更厚？',
        'fac-conductance': '抽氣慢——需要換台更大的泵嗎？',
        'fac-leak': '本底壓力偏高——是漏氣還是放氣？',
        'edge-fast': '為什麼我的晶圓邊緣蝕得更快？',
        loading: '同一份配方為什麼在另一種產品上跑得更快？',
        sheath: '到底是什麼決定了晶圓處的離子能量？',
        endpoint: '怎麼知道蝕刻什麼時候蝕完？',
        'what-if': '把壓力調高會怎樣？',
        diagnose: '什麼都沒動——蝕刻為什麼變慢了？',
        'litho-dose-focus': 'CD 偏了——是劑量還是焦距？',
        'litho-window': '這個圖形有可用的製程窗口嗎？',
        'litho-stochastics': '完全相同的曝光為什麼印出來不一樣？',
        'metro-trust': '這個膜厚讀數能信嗎？',
        'metro-capability': '這台量具夠格幹這活嗎？',
        'metro-signal': '管制圖報警了——是真的嗎？',
        'thermal-budget': '沒人動過植入——接面為什麼移了？',
        'thermal-oxide': '氧化層為什麼不長了？',
        'thermal-junction': '怎麼把接面做淺而不犧牲片電阻？',
        'thermal-lateral': '推進退火只是把摻雜原子往下推嗎？',
        'bond-window': '銲接窗口在哪裡，兩端各會發生什麼？',
        'bond-wires': '同一份銲線配方，為什麼線更多的元件良率更差？',
        'bond-imc': '介金屬化合物隨時間對銲點做了什麼？',
        'clean-longer': '把 SC-1 跑久點晶圓就更乾淨嗎？',
        'clean-queue': 'HF 之後晶圓等多久有關係嗎？',
        'clean-metals': 'SC-2 槽到底是幹什麼用的？',
        'gown-monitor': '監測點說在潔淨等級內——我的晶圓乾淨嗎？',
        'gown-garments': '好好穿無塵衣真能量出差別嗎？',
        'gown-recovery': '擾動之後這個區要多久恢復？',
        'cz-segregation': '晶棒兩端的電阻率為什麼不一樣？',
        'cz-voronkov': '這根晶體最快能拉多快？',
        'cz-oxygen': '晶圓裡的氧是從哪來的？',
        'dice-thin': '晶圓能磨多薄才不至於開始碎？',
        'dice-chipping': '能切快一點而不崩到裸晶嗎？',
        'dice-wheel': '更細的磨輪划得來嗎？',
        'euv-dose': '提高劑量要花掉多少每小時晶圓數？',
        'euv-power': '光源功率翻倍，曝光機能快多少？',
        'sem-landing': '為什麼不把 CD-SEM 的著陸能量調高來得到更銳利的影像？',
        'sem-current': '更大的束流會讓 CD 量測重複得更好嗎？',
        'cryo-attenuation': '驅動線需要多少衰減？',
        'cryo-frequency': '為什麼量子位元做在 5 GHz 而不是 1 GHz？',
        'epi-hotter': '為什麼再升溫也不再加快生長？',
        'epi-bake': '能縮短 H2 烘烤省點週期嗎？',
        'epi-faster': '能直接加大 TCS 讓磊晶長快點嗎？',
        'ft-guardband': '保護帶的代價是什麼？',
        'ft-burnin': '預燒值得花那些時間嗎？',
        'ft-coverage': '測試時間到底要多久才算夠？',
        'gas-purge': '吹掃幾個循環才能安全開箱？',
        'gas-detector': '偵測器報警來得及讓我撤出去嗎？',
        'gas-abatement': '排放口出去的到底是什麼？',
        'imp-channelling': '我的接面為什麼比表裡查的深？',
        'imp-damage': '劑量到多少植入會把矽打成非晶？',
        'imp-profile': '怎麼把接面做得更淺？',
        'insp-threshold': '要不要調低閾值多抓些缺陷？',
        'insp-limit': '殺死那顆裸晶的缺陷我們為什麼沒看見？',
        'insp-coverage': '需要掃完整片晶圓嗎？',
        'pkg-popcorn': '一顆好裸晶為什麼在迴銲時壞了？',
        'pkg-warpage': '封裝為什麼翹曲，什麼時候才要緊？',
        'pkg-mould': '模後固化到底在幹什麼？',
        'saqp-walk': '為什麼我的間隔一寬一窄交替？',
        'saqp-pitch': '最終節距到底由什麼決定？',
        'saqp-collapse': '這份配方為什麼塌了？',
        'ecd-fill': '我的溝槽裡為什麼有空洞？',
        'ecd-terminal': '為什麼晶圓邊緣的銅更厚？',
        'ecd-rate': '要鍍多久才能到我要的厚度？',
        'prb-area': '晶粒面積大了良率為什麼差這麼多？',
        'prb-clustering': '卜瓦松良率模型為什麼低估我這條線？',
        'prb-signature': '這些損失是晶圓的還是探針卡的？',
        'wpr-kerf': '晶棒裡有多少最後變成了晶圓？',
        'wpr-damage': '要去掉多少矽才能把鋸傷除乾淨？',
        'wpr-flatness': '什麼會讓晶圓弓彎，為什麼要緊？',
      },
      Who: '探究助理',
      OffThread: '實驗在主執行緒之外執行，因此你仍然可以在廠內自由走動。',
      InlineThread: '實驗在主執行緒內執行，執行期間畫面可能會短暫卡頓。',
      Placeholder: '就你看到的現象提問……（按 Enter 送出）',
      Run: '執行實驗',
      Designing: '正在設計實驗……',
      RunningCondition: '正在執行第 {{done}} / {{total}} 組條件 — {{label}}',
      Promise:
        '我給出的每一句結論，都是用真實跑出來的數字拼出來的。如果無法把你的問題變成一個實驗，' +
        '我會直說，而不是編一個出來。',
      Hypothesis: '假設',
      Design: '實驗設計',
      Measured: '實測',
      Findings: '發現',
      CanInvestigate: '我可以研究的問題',
      ConditionsRun: '已執行的條件',
      Condition: '條件',
      Descend: '↓ 下探到微觀尺度 — {{topic}}',
      NextQuestion: '你的下一個問題',
      NoMatch: '沒有相符的實驗',
      CannotRun:
        '我還沒辦法把「{{question}}」變成一個我會跑的實驗，所以我不會去猜一個答案。我說的每一句話都' +
        '來自真實跑過的模擬，而這個問題我沒有可跑的東西。在這台機台上，我能調查的是這些：',
      NoMatchFollowUp: '可以從上面挑一個，或者改用你在晶圓上看到的現象來重新提問。',

      NearestMatch: '沒有完全相符 — 最接近的實驗',
      NearestLead:
        '我沒辦法完全按你問的方式跑「{{question}}」。在這台機台上，我會跑的最接近的是' +
        '「{{example}}」——{{summary}}這和你的問題並不相同，所以在採信結果之前，先判斷它是否真的' +
        '回答了你。',
      RunNearest: '就跑這個',
      NearestFollowUp: '如果這不是你的意思，用你在晶圓上看到的現象再說一遍，我重新找。',
    },

    auth: {
      Title: '登入後即可使用助理',
      Why:
        '登入的作用是為這次工作階段署名——記錄你提出的問題、它們變成的實驗，以及下次可以接著' +
        '做的工作。廠內其餘部分不需要帳號：機台、晶圓與求解器對每一個站在廠區裡的人都開放。',
      Google: '使用 Google 繼續',
      Guest: '以訪客身分繼續',
      SignIn: '登入',
      AsMe: '實名登入',
      Anonymously: '匿名登入',
      MenuWhy: '帳號的作用，是讓你的工作能延續到下一次。',
      GuestScope: '匿名——僅限本瀏覽器',
      ConfirmGuestTitle: '確定匿名登入嗎？',
      ConfirmGuestBody:
        '匿名帳號在登出的那一刻就消失，且無法恢復——在它名下保存的一切都會一併失去。它也不' +
        '存在於任何其他瀏覽器或電腦上。請只在這台電腦上、只為一次使用而選擇它。',
      ConfirmSignOutTitle: '確定登出這個匿名帳號嗎？',
      ConfirmSignOutBody: '登出後此帳號無法恢復，在它名下保存的工作都會遺失。實名登入才能讓工作長久保留。',
      Yes: '是',
      No: '否',
      GuestNote:
        '訪客帳號不帶姓名與電子郵件。它的用法和已登入帳號完全一樣，有效期取決於這個瀏覽器保留多久。',
      Checking: '正在確認目前登入的使用者……',
      Retry: '重試',
      SignedInAs: '已登入：{{name}}',
      SignedInAsGuest: '已以訪客身分登入',
      SignOut: '登出',
      GuestName: '訪客',
      SignedIn: '已登入',
      ErrNetwork: '沒有網路。登入需要連線——廠區與求解器不需要。',
      ErrNotEnabled: '此登入方式尚未在這個專案中啟用。',
      ErrDomain: '{{host}} 未獲授權用於登入。請將它加入 Firebase 的授權網域清單。',
      ErrTooMany: '這台機器嘗試次數過多。請等一分鐘後再試。',
      ErrPopupBlocked: '瀏覽器攔截了登入視窗。請為本網站允許彈出視窗，或改走訪客入口。',
      ErrUnavailable: '登入無法使用——應用程式無法連線 Firebase。',
    },

    recipe: {
      // Preset display labels. Code-like ones keep their code everywhere.
      presetLabel: {
        // Etch (ETCH-01) recipe codes: rendered without a namespace.
        baseline: 'BASELINE-SI-01',
        lowPressure: '低氣壓 欠飽和',
        highPressure: '高氣壓 擴散受限',
        highBias: '高偏壓 各向異性',
        smallOpenArea: '低負載產品',
        starvedFlow: '低流量異常',
        facilities: {
          vacNominal: '健康腔體',
          vacThrottled: '流導受限',
          vacLeak: '真實洩漏',
          vacDirty: '潮濕腔體',
          vacBiggerPump: '更大的幫浦，同一根管',
        },
        ale: {
          baseline: '基準-ALE-矽',
          tooEnergetic: '離子能量過高',
          tooGentle: '離子能量過低',
          starvedDose: '劑量低於飽和',
          noPurge: '無吹淨',
          highAspect: '高深寬比',
          nitride: '氮化物',
        },
        bonding: {
          baseline: '基準-金鋁銲接',
          coldBond: '銲接不足',
          overDriven: '過度施壓',
          longCure: '延長固化',
          highPinCount: '高接腳數',
        },
        dicing: {
          baseline: '基準-200UM',
          thinStack: '堆疊薄化',
          noRelief: '不做應力釋放',
          fastFeed: '快速進給',
          narrowStreet: '窄切割道',
        },
        packaging: {
          baseline: '基準-BGA',
          thinMould: '薄模封蓋',
          bigBody: '大封裝體',
          floorLifeBlown: '乾燥包裝外放置',
          hotReflow: '高溫迴銲',
        },
        finaltest: {
          baseline: '基準-商規',
          noBurnIn: '不做預燒',
          automotive: '車規',
          noGuardBand: '無保護帶',
          shortTest: '短測試',
        },
        clean: {
          baseline: '基準-RCA',
          noHf: '不做 HF 收尾',
          queueBlown: '排隊超時',
          aggressive: '激進 SC-1',
          shortClean: '短清洗',
        },
        gowning: {
          baseline: '基準-ISO5-潔淨區',
          noHood: '沒戴頭罩',
          wrongOrder: '穿衣順序錯誤',
          crowded: '人員擁擠',
          straightThrough: '逕直穿過氣閘',
          lowFlow: '換氣減少',
          longExposure: '晶圓敞置',
        },
        cmp: {
          baseline: '基準-銅鑲嵌',
          underPolished: '無過拋',
          overPolished: '重度過拋',
          mismatchedSpeeds: '轉速失配',
          hardPress: '高下壓力',
        },
        crystal: {
          baseline: '基準-CZ300-硼',
          perfectSilicon: '完美矽',
          antimony: '銻基板',
          pulledTooFast: '提拉過快',
          tightSpec: '窄電阻率規格',
          magneticCz: '磁控直拉',
        },
        epi: {
          epiDevice: '元件層',
          epiSlow: '動力學探針',
          epiThin: '薄層快長',
        },
        gas: {
          baseline: '基準-砷化氫面板',
          lazyPurge: '偷懶吹掃',
          silaneRelease: '矽甲烷洩漏',
          chlorinePool: '氯氣，偵測器在天花板',
          dilutedArsine: '稀釋砷化氫',
          slowDetector: '響應遲緩的偵測器',
          ammoniaHabit: '氨——壞習慣',
        },
        implant: {
          baseline: '基準-硼源汲',
          zeroTilt: '零傾角',
          shallow: '淺接面延伸',
          deepWell: '深阱',
          hotImplant: '熱植入',
        },
        patterning: {
          baseline: '基準-SAQP-40',
          pitchWalk: '節距漂移',
          overTrimmed: '芯軸過度修整',
          thickSpacer: '側壁過厚',
          doubleOnly: 'SADP（一遍）',
          aggressive: '激進——32 nm 節距',
        },
        plating: {
          baseline: '基準-銅鑲嵌',
          noAccelerator: '無加速劑',
          noSuppressor: '無抑制劑',
          thinSeed: '薄種子層',
          hotPlate: '高電流',
          overPlated: '過度電鍍',
          highAspect: '高深寬比',
        },
        inspection: {
          baseline: '基準-暗場',
          hotScan: '熱掃描',
          coldScan: '冷掃描',
          shortWave: '更短波長',
          sampled: '抽樣掃描',
        },
        probe: {
          baseline: '基準-分選',
          bigDie: '大裸晶',
          poissonForecast: '卜瓦松預測',
          heavyCluster: '重度成簇',
          wideEdge: '寬邊緣排除',
        },
        thermalBaseline: '閘極氧化 + RTA',
        thermalWetField: '濕法場氧',
        thermalFurnaceAnneal: '爐管退火',
        thermalShallowJunction: '淺接面',
        thermalArsenicSd: '砷源汲',
        waferprep: {
          baseline: '基準-300MM',
          thinWire: '細鋸線',
          singleSided: '單面拋光',
          shortEtch: '短蝕刻',
          shortPolish: '短拋光',
          coarseSaw: '粗鋸',
          thinWafer: '薄晶圓',
        },
      },
      knob: {
        bedLoadFraction: '混床已用壽命',
        uvIntensity: 'UV 氧化燈輸出',
        pouTempC: '取樣溫度',
        inletTocPpb: 'RO 來水 TOC',
        modifySeconds: '氯吸附劑量',
        modifyPressureMtorr: '改質步壓力',
        purgeSeconds: '吹淨',
        ionEnergyEv: '離子能量',
        removeSeconds: '移除步時間',
        ionFlux: '離子通量',
        forceGf: '銲接壓力',
        ultrasonicMw: '超音波功率',
        bondMs: '銲接時間',
        stageTempC: '載台溫度',
        cureMinutes: '環氧固化時間',
        cureTempC: '固化溫度',
        wiresPerDie: '每顆裸晶打線數',
        targetThicknessUm: '晶圓目標厚度',
        finalGrit: '精磨輪粒度',
        feedRateMmS: '切割進給速度',
        streetWidthUm: '切割道寬度',
        diePerWafer: '每片晶圓裸晶數',
        mouldThicknessUm: '模封蓋厚',
        substrateThicknessUm: '基板厚度',
        mouldTempC: '模封溫度',
        postCureMinutes: '模後固化',
        floorLifeHours: '迴銲前廠內壽命',
        humidityPct: '環境濕度',
        reflowPeakC: '迴銲峰值溫度',
        bodySizeMm: '封裝體尺寸',
        useTempC: '規定使用溫度',
        burnInTempC: '預燒溫度',
        burnInHours: '預燒時長',
        hotTestC: '高溫測試',
        coldTestC: '低溫測試',
        guardBandFraction: '保護帶',
        testSeconds: '單顆測試時間',
        lotSize: '批量',
        sc1Minutes: 'SC-1 時間',
        sc1TempC: 'SC-1 溫度',
        megasonicW: '兆聲功率',
        sc2Minutes: 'SC-2 時間',
        hfSeconds: 'HF 浸蝕時間',
        hfDilution: 'HF 稀釋比',
        queueMinutes: 'HF 後等待時間',
        incomingParticlesCm2: '來料顆粒',
        incomingMetal: '來料金屬沾汙',
        occupants: '區內人數',
        activity: '活動強度',
        airChangesPerHour: '換氣次數',
        filterCoverage: '濾網覆蓋率',
        filterEfficiency: '濾網效率',
        bayVolumeM3: '房間容積',
        downflowMs: '下吹流速',
        airlockMinutes: '氣閘停留時間',
        waferExposureMinutes: '晶圓暴露時間',
        particleSizeUm: '規定粒徑',
        downForceKPa: '下壓力',
        platenRpm: '拋光盤轉速',
        carrierRpm: '載具轉速',
        slurryFlowMlMin: '研磨液流量',
        overpolishPct: '過拋量',
        overburdenNm: '來料餘量厚度',
        incomingStepNm: '來料台階高度',
        meltDopingCm3: '熔體摻雜',
        chargeKg: '裝料量',
        diameterMm: '晶棒直徑',
        pullRateMmMin: '提拉速率',
        gradientKCm: '軸向溫度梯度',
        crucibleRpm: '坩堝轉速',
        crystalRpm: '晶體轉速',
        magneticFieldT: '磁場強度',
        resistivityTolerance: '電阻率容差',
        targetResistivity: '目標電阻率',
        cylinderPercent: '鋼瓶濃度',
        purgeCycles: '吹淨循環數',
        purgeRatio: '單循環稀釋比',
        leakRateSccm: '洩漏率',
        detectorThreshold: '警報閾值',
        detectorResponseS: '偵測器響應時間',
        energyKeV: '植入能量',
        dose: '植入劑量',
        tiltDeg: '傾角',
        twistDeg: '扭轉角',
        beamCurrentMa: '束流',
        waferTempC: '晶圓溫度',
        mandrelPitchNm: '芯軸節距',
        mandrelCdNm: '芯軸線寬（微影後）',
        mandrelTrimNm: '芯軸修整量',
        spacer1Nm: '側壁 1 厚度',
        spacer2Nm: '側壁 2 厚度',
        spacerOveretch: '側壁過蝕量',
        currentDensityMaCm2: '電流密度',
        seconds: '電鍍時間',
        seedThicknessNm: '種子層厚度',
        trenchWidthNm: '溝槽寬度',
        trenchDepthNm: '溝槽深度',
        suppressor: '抑制劑',
        accelerator: '加速劑',
        leveler: '整平劑',
        copperGL: '硫酸銅濃度',
        acidGL: '酸濃度',
        wavelengthNm: '波長',
        thresholdSigma: '檢測閾值',
        pixelNm: '像素尺寸',
        scanCoverage: '晶圓掃描覆蓋率',
        reviewSample: 'SEM 複檢抽樣',
        designRuleNm: '設計規則',
        incomingDensityCm2: '來料缺陷密度',
        dieAreaCm2: '裸晶面積',
        edgeExclusionMm: '邊緣排除區',
        clusterAlpha: '缺陷聚集度',
        touchdownsPerClean: '兩次清針間觸點數',
        parametricGuardBand: '參數保護帶',
        wireDiameterUm: '銲線線徑',
        sawGrit: '鋸切粒度',
        lapGrit: '研磨粒度',
        lapRemovalUm: '單面研磨去除量',
        etchRemovalUm: '單面蝕刻去除量',
        polishPressureKPa: '拋光壓力',
        polishRpm: '拋光轉速',
        polishMinutes: '拋光時間',
        ingotLengthMm: '晶棒可用長度',
        bakeMinutes: 'H2 烘烤時間',
        epiTempC: '生長溫度',
        tcsTorr: 'TCS 分壓',
        epiMinutes: '生長時間',
        epiDopingCm3: '磊晶層摻雜',
        h2Slm: '氫氣載氣',
        pressureMtorr: '腔體壓力',
        sourcePowerW: '源射頻功率',
        biasPowerW: '偏壓射頻功率',
        flowSccm: '總氣體流量',
        cf4Fraction: 'CF4 比例',
        wafertempC: '晶圓溫度',
        openAreaFraction: '開口率',

        // 微影。
        doseMjCm2: '曝光劑量',
        focusNm: '離焦量',
        pitchNm: '節距',
        pebBlurNm: 'PEB 擴散長度',
        resistContrast: '光阻對比度',
        developThreshold: '顯影閾值',

        // 熱處理製程。
        oxideTempC: '氧化溫度',
        oxideMinutes: '氧化時間',
        implantDose: '植入劑量',
        implantKeV: '植入能量',
        annealTempC: '退火溫度',
        annealSeconds: '退火時間',

        // 廠務。
        volumeL: '腔體容積',
        pumpSpeedLs: '幫浦抽速',
        lineDiameterCm: '管路直徑',
        lineLengthCm: '管路長度',
        leakThroughput: '漏氣流量',
        outgassingInitial: 't=0 時的釋氣量',
        outgassingTau: '釋氣衰減時間',
      },
      preset: {
        facilities: {
          vacNominal: '短粗管線，密封良好。流導不是限制，也沒有洩漏。',
          vacThrottled: '同一台幫浦接在 5 公分粗、兩米長的管線後面。腔體永遠看不到幫浦的抽速。',
          vacLeak: '已抽了一整夜的腔體上有一道被夾住的門封，腔壁已乾，只剩洩漏。本底壓力卡住不動，壓升曲線永遠不彎。注意釋氣很低：今早才打開過的腔體是沒法檢漏的。',
          vacDirty: '開蓋暴露大氣後帶著潮氣重新裝好。釋氣很重，但最終能抽走。',
          vacBiggerPump: '在受限管線上換三倍大的幫浦——昂貴的錯誤答案。',
        },
        ale: {
          baseline:
            '認證的 ALE：氯劑量飽和，氬離子 28 eV——窗口正中。每循環約 0.3 nm，比同一腔體裡的 RIE 配方慢兩個數量級。',
          tooEnergetic:
            '把能量提到 60 eV 來提速。已越過基板濺射閾值，未改質的矽也在被連續移除。更快了，但不再是 ALE——協同度數字會比蝕刻輪廓更早說明這一點。',
          tooGentle:
            '12 eV。低於改質層的閾值，氯吸附上去了，卻什麼也下不來。腔體看起來一切正常。',
          starvedDose:
            '氯只給半秒。覆蓋不完整，於是每循環蝕刻量取決於劑量到達晶圓各處的多少——而這正是當初改用 ALE 想擺脫的均勻性問題。',
          noPurge:
            '兩個半循環重疊，部分蝕刻變成連續進行。仍在蝕，但已不是逐層蝕。',
          highAspect:
            '同一配方用在 50:1 的結構上。移除半步沒問題——離子是定向的——但中性劑量必須到達底部，在這個深寬比下它到不了。',
          nitride:
            '同一配方，另一種膜。氯化學並不通用——氮化物更難改質，每循環蝕刻量下降，配方需要重新認證。',
        },
        bonding: {
          baseline:
            '認證的熱超音波金球銲接，鋁銲墊。',
          coldBond:
            '超音波功率減半。氧化層活了下來，於是介面的大部分從未真正銲上。',
          overDriven:
            '功率和壓力一起加大，把銲點硬壓出來。銲上了，然後繼續往矽裡壓。',
          longCure:
            '200 C 下固化四小時以求保險。介金屬化合物全程在長，而且之後也不會變薄回去。',
          highPinCount:
            '一顆裸晶上 480 根線。看起來很漂亮的單線良率，取到 480 次方就不漂亮了。',
        },
        dicing: {
          baseline:
            '認證流程：細磨輪、應力釋放、適中進給的刀片切割。',
          thinStack:
            '為堆疊封裝薄化到 50 um。下游的每一步都因此更脆。',
          noRelief:
            '磨完直接切。每片省 45 秒，把研磨損傷留在片內——這是一個強度問題，要到模壓機那裡才有人看見。',
          fastFeed:
            '為產能把進給翻倍。崩邊隨它的平方根增長。',
          narrowStreet:
            '切割道縮到 40 um 好多排裸晶。鋸縫和崩邊可沒跟著變小。',
        },
        packaging: {
          baseline:
            '認證的打線 BGA：模封與基板應力平衡，乾燥包裝，標準迴銲。',
          thinMould:
            '為限高槽位把模封蓋減到 250 um。疊層嚴重失衡，隨之翹曲。',
          bigBody:
            '40 mm 的封裝體。翹曲隨跨度的平方增長，所以這不是一個小改動。',
          floorLifeBlown:
            '迴銲前在 70% 濕度的廠內放了三週。袋子上印的時鐘不是裝飾。',
          hotReflow:
            '峰值推到 268 C 保證潤濕。所有與吸濕相關的問題都會加重。',
        },
        finaltest: {
          baseline:
            '125 C 預燒 48 小時，高低溫測試，10% 保護帶。',
          noBurnIn:
            '為產能整個跳過。便宜、快，而且每一顆早夭品都會發到客戶手裡。',
          automotive:
            '150 C 下 168 小時，寬保護帶。在這裡漏檢就是召回，寧枉勿縱反而便宜。',
          noGuardBand:
            '量在限內就出貨。良率最高，而每一次漏檢都是一次退貨。',
          shortTest:
            '為產能把測試時間砍到一秒。涵蓋率跟著掉。',
        },
        clean: {
          baseline:
            '完整 RCA，短 HF 收尾，20 分鐘內進爐。',
          noHf:
            '把化學氧化層留在片上。放在想要它的沉積之前是對的；放在閘極氧化層之前是錯的。',
          queueBlown:
            'HF 收尾之後，晶圓擱了四個小時。自然氧化層長回來了，這次清洗等於白做。',
          aggressive:
            '80 C 三十分鐘，兆聲開滿。顆粒幾乎清零，換來一個粗糙度可以量出來的表面。',
          shortClean:
            '為產能只做兩分鐘 SC-1。大部分顆粒還在。',
        },
        gowning: {
          baseline:
            '四個人，全套無塵衣，每小時 500 次換氣。規範照本執行，也是下游每台機台預設的數字。',
          noHood:
            '少穿一件。丟掉的不是五分之一的防護——是頭罩貢獻的整個倍數，因為無塵衣的作用是相乘的。',
          wrongOrder:
            '每件都穿了，順序全不對。衣服是齊的，但在穿的過程中已經被汙染了。',
          crowded:
            '裝機進來十二個人。發塵量隨人數線性增長，而通風什麼都沒變。',
          straightThrough:
            '不停留。氣閘存在的意義就是吹掉新無塵衣正在脫落的東西；逕直走過去等於跳過它唯一的作用。',
          lowFlow:
            '為省電把風速降到 150 ACH。濃度等於產生除以通風，所以這和把人數增至三倍效果完全一樣。',
          longExposure:
            '一批晶圓在檯面上敞開放了半小時。濃度沒變，完全在等級之內；只是晶圓收集了三十分鐘而不是兩分鐘。',
        },
        cmp: {
          baseline:
            '認證的銅拋光：盤與載具轉速匹配，20% 過拋。',
          underPolished:
            '端點訊號一動就停。在完美均勻的機台上勉強撐得住；在任何真實機台上，拋得慢的地方仍有金屬把線路橋接起來——那是短路，也就是一顆死晶。',
          overPolished:
            '把過拋翻倍以確保清乾淨。每條寬線都因此下凹。',
          mismatchedSpeeds:
            '載具轉速只有盤的一半。相對速度在晶圓上不再均勻，出現一個壓力修正消不掉的徑向特徵。',
          hardPress:
            '為產能把壓力加到 40 kPa。更快，而每一種缺陷機制都隨它同步放大。',
        },
        crystal: {
          baseline:
            '硼摻雜，150 kg，300 mm。以 1.0 mm/min 對著 30 K/cm 的梯度提拉——Voronkov 窗口的空位一側，量產矽大多住在這裡。',
          perfectSilicon:
            '把拉速降到正好坐在 Voronkov 比值上：空位和自間隙原子誰也不佔優。犧牲的是生長速度、也就是錢，這是閘極氧化層客戶付錢買的東西。',
          antimony:
            '重摻 n+ 基板。k = 0.023，熔體富集近四十倍，晶棒大部分搆不著任何窄電阻率窗口。這是偏析最殘酷的樣子。',
          pulledTooFast:
            '梯度不變，拉到每分鐘兩毫米半。越過潛熱上限：介面保持不了平面，晶體失去單晶結構。',
          tightSpec:
            '同一根晶體，容差收緊到百分之五。生長什麼都沒變，而晶棒的大部分賣不出去了——規格就是良率。',
          magneticCz:
            '0.3 T 磁場壓制熔體對流，到達介面的坩堝氧大幅減少。低氧矽——同時也失去了內吸雜這條退路。',
        },
        epi: {
          epiDevice:
            '生產點：深入傳輸平台區，鼓泡器決定速率，燈的誤差被原諒。在 CZ-07 長出的任何基板上長四微米輕摻矽。',
          epiSlow:
            '降到 950 °C 後表面反應成為瓶頸，生長速率就是一支溫度計——這是把氣路問題和溫度問題分開的那個配方。',
          epiThin:
            'TCS 開滿，一分鐘不到長一微米。有意貼著噴濺極限跑——盯著顆粒數。',
        },
        gas: {
          baseline:
            '砷化氫面板，開箱前十個循環、每循環十比一。認證規程，以及它背後的算術。',
          lazyPurge:
            '同樣十個循環，但每次只抽到一半壓力。十個 0.5 的循環是一千倍；十個 0.1 的循環是一百億倍。同樣的規程，同樣的時間，差七個數量級。',
          silaneRelease:
            '純矽甲烷漏進氣瓶間。自燃氣體，所以火是眼前的問題；如果沒點著，要緊的才是暴露限值。',
          chlorinePool:
            '氯氣密度是空氣的兩倍，會在地面積聚。下面這個完全混勻的數字偏樂觀，而裝在天花板上的偵測器量錯了地方。',
          dilutedArsine:
            '1% 砷化氫氫氣稀釋——通常就是這麼買的。少吹兩個數量級，最後的暴露限值一分不少。',
          slowDetector:
            '警報點設在暴露限值兩倍、響應兩分鐘的偵測器。它會報警。這個工具要問的是：報得來得及嗎。',
          ammoniaHabit:
            '氨在遠低於限值時你就聞到了，於是它教會你鼻子是個偵測器。砷化氫在任何危險濃度下都沒有氣味警告。',
        },
        implant: {
          baseline:
            '源汲極硼植入：30 keV，3 × 10¹⁵，七度傾角避開通道效應。',
          zeroTilt:
            '正對通道打下去。峰值落在該落的地方，而相當一部分劑量鑽到了三倍深的地方。',
          shallow:
            '5 keV 的 BF2。分子重、能量低、非常淺——每個離子造成的損傷也大得多。',
          deepWell:
            '200 keV 的磷。夠深，也不可避免地瀰散——離散度是射程的 38%。',
          hotImplant:
            '晶圓保持 300 C，晶格邊植入邊自修復。留給後面退火的損傷更少，也就是熱預算花得更少。',
        },
        patterning: {
          baseline:
            '160 nm 芯軸節距兩次減半到 40 nm——任何 193 nm 掃描機都解析不了的節距。修整量已調到兩種間隔正好相等。',
          pitchWalk:
            '芯軸修整偏了 4 nm——該是 10 修成了 14。平均節距仍然正好 40 nm，平均間隔仍然正好 20 nm，CD-SEM ' +
            '的所有彙總數字都在目標上。而每隔一條線就長錯了地方。',
          overTrimmed:
            '修到沒了。側壁還沒沉積芯軸就已消失，沒有可依附的側壁。',
          thickSpacer:
            '160 nm 節距上沉 30 nm 的 ALD。側壁相接，圖形連成一整塊——這是幾何，不是製程。',
          doubleOnly:
            '第一遍就停：80 nm 節距，只有一種漂移方式而不是兩種。密度減半，能出錯的地方也少得多。',
          aggressive:
            '128 nm 芯軸節距配 16 nm 側壁，做 32 nm 的最終節距。處處更緊，修整窗口隨之收窄。',
        },
        plating: {
          baseline:
            '認證鍍液，20 mA/cm² 一分鐘，填 60 nm 溝槽。自底向上填滿，留下餘量交給 CMP-11 去除。',
          noAccelerator:
            '去掉加速劑就沒有 CEAC 正回饋：溝槽變成保形沉積，槽口先合攏，結構裡留下空洞。這個添加劑不是錦上添花。',
          noSuppressor:
            '沒有什麼再壓制平場和槽口，增益塌向一，側壁贏下這場賽跑。',
          thinSeed:
            '10 nm 種子層給溝槽騰了地方——也讓片電阻翻了四倍，端子效應把晶圓中心餓著了。',
          hotPlate:
            '50 mA/cm² 把週期時間砍半。越過極限電流後鍍液供銅不及，鍍層燒焦。',
          overPlated:
            '鍍三分鐘而不是一分鐘。溝槽早就滿了；之後長的全是餘量，而每一奈米餘量都是 CMP-11 的下凹時間。',
          highAspect:
            '20 nm 寬、300 深的溝槽。超填充在這裡反而更強——底面積收縮更猛——但側壁要合攏的距離也近得多。',
        },
        inspection: {
          baseline:
            '認證的量產掃描：355 nm 暗場，4 sigma，全片。',
          hotScan:
            '閾值降到 2 sigma，什麼都要找出來。確實找到更多——也把複檢佇列埋進了表面粗糙度裡。',
          coldScan:
            '閾值提到 9 sigma，報告乾淨。報告是乾淨了；晶圓沒有。',
          shortWave:
            '266 nm 換下 355 nm。靈敏度隨波長的三分之二次冪變化，所以這是 20% 的收益，不是 25%。',
          sampled:
            '為產能只掃五分之一的晶圓。一切按比例縮水，包括信心。',
        },
        probe: {
          baseline:
            '認證分選：0.59 cm² 裸晶，3 mm 邊緣排除，負二項分布 alpha 3。',
          bigDie:
            '同一條線上 2 cm² 的裸晶。良率隨面積指數下降，這就是為什麼裸晶尺寸是設計者做的最貴的決定。',
          poissonForecast:
            '同一片晶圓改用卜瓦松預測。系統性偏悲觀，因為真實缺陷成簇，而成簇的缺陷把自己浪費在本來就死了的裸晶上。',
          heavyCluster:
            '一道刮傷或一次不當搬運：alpha 降到 0.8。缺陷數沒變，良率反而更好。',
          wideEdge:
            '排除 8 mm 以避開邊緣失效。順帶也扔掉了好裸晶。',
        },
        waferprep: {
          baseline:
            '認證產線：120 µm 線鋸，雙面研磨與拋光，成品 775 µm。晶棒仍有五分之一以磨漿的形式離開。',
          thinWire:
            '70 µm 細線省鋸縫。確實省了——它也會游走，因為同樣張力下更細的線切得更鬆。片數更多，平整度更差。',
          singleSided:
            '只加工正面。製程時間省一半，晶圓卻會弓彎，因為背面損傷應力再沒有東西平衡它。',
          shortEtch:
            '化學蝕刻砍到一微米。它是唯一只除損傷、不添損傷的一步，砍掉它就把研磨損傷留在了晶圓裡——而後面的拋光搆不到那麼深。',
          shortPolish:
            '拋光砍到兩分鐘。損傷早就除淨了——受損的是表面光潔度，而一片起霧的晶圓是掃描機對不上焦的晶圓。',
          coarseSaw:
            '#250 的線鋸切得更快，留下的損傷深過研磨所能觸及。後面的工步是按更細的鋸配的，現在對不上了。',
          thinWafer:
            '成品 400 µm，為堆疊元件準備。每根晶棒出更多片，用少得多的矽扛同樣的弓彎。',
        },
        baseline:
          '已驗證的視窗中心配方：204 nm/min，不均勻度 4.3%，選擇比 3.7:1。從這裡開始。',
        lowPressure:
          '壓力降到 6 mTorr：116 nm/min，不均勻度 10.9%。腔體裡可用來產生氟的氣體太少，' +
          '需求超過供給（Da 1.15），最先接觸氣體的邊緣因此快了 19%。',
        highPressure:
          '壓力升到 90 mTorr：201 nm/min，不均勻度 8.6%。氟很充足（Da 0.20），但擴散係數隨 1/p 變化，' +
          '來不及送到晶圓中心。又是邊緣偏快，13%——原因相反，特徵相同。',
        highBias:
          '偏壓加到 350 W：227 nm/min，但不均勻度 20%，選擇比掉到 1.3:1。多出來的需求把蝕刻推進了' +
          '傳輸受限區（Da 1.22）。這是追速率最不該走的路。',
        smallOpenArea:
          '開口率只有 4%：308 nm/min，配方沒動卻快了一半，因為爭奪同一批氟的矽少了很多。' +
          '均勻性基於同樣的原因改善到 1.8%。這就是負載效應，也是同一份配方換個產品就會漂移的原因。',
        starvedFlow:
          '質量流量控制器從 200 sccm 降到 20：崩到 72 nm/min，不均勻度 28%，78% 的進氣被解離，' +
          'Da 超過 2。氟的總量由 MFC 放進來多少決定，此時它已經成了限制條件。',

        // 微影。
        lithoBaseline: '在 180 nm 節距下調劑量到目標尺寸，最佳焦距。對比度 0.97，NILS 7.1，LER 2.4 nm。',
        lithoDefocused: '離焦 90 nm。對比度跌到 0.42，線寬嚴重偏離目標。',
        lithoUnderdosed: '20 mJ/cm²。線印得太寬——光少，去掉的光阻就少。',
        lithoTightPitch: '已經超出常規照明能好好應付的範圍：對比度 0.57，視窗隨之收窄。',
        lithoEuvFine: '把光源也換成 EUV。印得出來，但只靠一小部分光子。',

        // 熱處理製程。
        thermalBaseline: '1000 °C 乾氧閘極氧化，再用 30 s 快速退火活化一次淺硼植入。',
        thermalWetField: '1050 °C 水氣通兩小時。厚得多，也快得多——代價是花掉大量熱預算。',
        thermalFurnaceAnneal: '同一次植入，但改成爐管退火 30 分鐘，而不是 RTP 裡的 30 秒。',
        thermalShallowJunction: '低能量植入配上短促的高溫尖峰退火——這是做淺接面的現代配方。',
        thermalArsenicSd: '用砷代替硼。原子重得多，所以幾乎不動——而這正是重點。',

        // 廠務：真空系統組態。
        vacNominal: '短而粗的管路，密封良好。流導不是瓶頸，也沒有漏。',
        vacThrottled: '同一台幫浦，接在 5 cm 粗、兩公尺長的管路後面。腔體根本感受不到幫浦的抽速。',
        vacLeak:
          '腔門密封圈被夾傷，而這台腔已經抽了一整夜，所以腔壁是乾的，剩下的只有漏。' +
          '基礎壓力卡住不動，升壓率曲線永遠不彎。注意釋氣量很低：今天早上剛開過的腔，是查不了漏的。',
        vacDirty: '開腔見了大氣，回裝時還帶著潮氣。釋氣很重，但最終還是能抽掉。',
        vacBiggerPump: '在那條被卡住的管路上換一台三倍大的幫浦——這是又貴又錯的答案。',
      },
    },

    chamber: {
      maint: {
        chamberClean: {
          Label: '腔體清洗與預處理',
          Detail:
            '濕式清洗、重新組裝，再跑預處理片。重置腔壁狀態，連帶解決沉積物造成的匹配器失調。' +
            '代價是數小時的機台可用時間。',
        },
        pumpService: {
          Label: '維護幫浦組',
          Detail: '恢復基礎真空度與升壓率。機台停機一個班次。',
        },
        replaceFocusRing: {
          Label: '更換聚焦環',
          Detail: '恢復邊緣電場整形。通常在排定的清洗中一併完成。',
        },
        matchTune: {
          Label: '重新調諧射頻匹配器',
          Detail:
            '不開腔就能恢復輸入功率——但若根因是沉積物，很快就會再次漂移。這是治標不治本。',
        },
      },
    },

    tool: {
      hmi: {
        Qubit: '量子位元',
        WafersPerHour: '片/小時',
        Yield: '良率',
        WorkZone: '工作區',
        Wires: '每顆線數',
        Welded: '焊合面積',
        WarpUm: 'µm 翹曲',
        Usable: '可用長度',
        Uniformity: '不均勻性',
        Thickness: '厚度',
        Surface: '表面',
        Stack: '排氣口',
        Species: '佈植離子',
        Screened: '篩除率',
        Repeatability: '重複性',
        Removal: '去除率',
        Regime: '控制區',
        Recovery: '自淨時間',
        Purge: '吹掃',
        PumpSpeed: '抽速',
        PitchWalk: '節距漂移',
        PctYield: '% 良率',
        OxideCapped: '氧化層封蓋',
        Overkill: '誤殺率',
        Nuisance: '誤報率',
        NmProbe: 'nm 探針',
        NmPitch: 'nm 節距',
        NmOxide: 'nm 氧化層',
        Moisture: '含濕量',
        LotHere: '批次在機',
        Landing: '著陸能量',
        HfLast: 'HF-last',
        Growth: '生長時間',
        GoodWafers: '合格晶圓',
        GoodDie: '合格晶粒',
        Gain: '由下而上增益',
        EscapesPpm: 'ppm 漏放',
        Dose: '劑量',
        Cycles: '循環數',
        Contrast: '對比度',
        Channelled: '通道比例',
        Capture: '捕獲率',
        Budget: '熱預算',
        Bow: '彎曲度',
        AcrossDie: '晶粒內起伏',
      },
      history: {
        word: {
          map_clustered: '晶圓圖呈團簇分布',
          map_radial: '晶圓圖呈徑向分布',
          map_centre: '晶圓圖呈中心失效',
          map_edge: '晶圓圖呈邊緣失效',
          map_uniform: '晶圓圖呈均勻分布',
          attach_void: '黏晶空洞',
          intermetallic: '介金屬化合物',
          cratered_pad: '焊墊彈坑',
          lifted_ball: '焊球脫起',
          trench_filled: '溝槽填滿',
          trench_seam: '溝槽有縫隙',
          trench_void: '溝槽有空洞',
          lattice_damaged_but_crystalline: '晶格受損但仍為晶態',
          layer_amorphised: '表層已非晶化',
          transport_limited: '輸送控制',
          transition_limited: '過渡區',
          reaction_limited: '反應控制',
          interstitial_rich: '富間隙原子',
          perfect: '完美晶體',
          vacancy_rich: '富空位',
          arsenic: '砷',
          antimony: '銻',
          phosphorus: '磷',
          boron: '硼',
        },
        EtchedCleared: '，晶圓 {{pct}}% 已蝕穿至停止層',
        Etched: '蝕刻 {{s}} s，速率 {{rate}} nm/min，不均勻性 {{nu}}%，側壁 {{angle}}°：膜內 CD {{cd}} nm',
        LithoFailed: '——部分曝光場未成像',
        LithoExposedEuv: '以 13.5 nm 曝光，{{dose}} mJ/cm²，節距 {{pitch}} nm：CD {{cd}} nm，LER {{ler}} nm ' +
          '3σ，場內變化 {{range}} nm',
        LithoExposed: '以 193 nm 曝光，{{dose}} mJ/cm²，節距 {{pitch}} nm：CD {{cd}} nm，LER {{ler}} nm ' +
          '3σ，場內變化 {{range}} nm',
        Cooled: '冷卻至 10 mK：接面 R·A {{ra}} Ω·µm²，E_J {{ej}} GHz，電容 {{cap}} fF，transmon f₀₁ ' +
          '{{f01}} GHz',
        SemMeasured: '顯影後 CD {{cd}} nm，節距 {{pitch}} nm，著陸能量 {{ev}} eV，探針 {{probe}} nm',
        EuvExposedPlain: '以 13.5 nm 曝光',
        EuvExposed: '以 {{dose}} mJ/cm² 曝光，節距 {{pitch}} nm：CD {{cd}} nm，LER {{ler}} nm 3σ，隨機失效 ' +
          '{{failures}} 處',
        Tested: '在 {{temp}} °C 下預燒 {{hours}} h 並測試：出貨 {{shipped}}，誤殺良品 {{overkill}}，漏放不良品 ' +
          '{{escaped}}',
        MouldedCracked: '（{{pct}}% 因減薄損傷開裂）',
        MouldedPopcorned: '，爆米花開裂',
        Moulded: '模封並迴焊：翹曲 {{um}} µm，進 {{die}} 顆晶粒，出 {{packages}} 個封裝',
        BondedFailure: '（{{mode}}）',
        Bonded: '每顆 {{wires}} 條線，剪力 {{gf}} gf，焊合 {{welded}}%——進 {{before}} 顆，出 {{after}} 顆',
        DicedChipping: '，崩邊越過切割道',
        Diced: '減薄至 {{um}} µm 並切割：{{die}} 顆晶粒，{{mpa}} MPa，m = {{m}}',
        SaqpWalk: '——平均間距 {{nm}} nm，每隔一條線就錯位',
        Saqp: 'SAQP {{mult}}×：節距 {{from}} → {{to}} nm，線寬 {{cd}} nm，節距漂移 {{walk}} nm',
        SaqpCollapsed: 'SAQP 坍塌：{{reason}}',
        Sorted: '已分選：良率 {{yield}}%，探測 {{probed}} 顆中 {{good}} 顆合格，{{signature}}',
        Scanned: '以 {{nm}} nm 掃描：回報 {{density}}/cm²（誤報 {{nuisance}}%），捕獲真實缺陷的 {{capture}}%',
        RcaOxideCapped: '，氧化層封蓋',
        RcaHfLast: '，HF-last，排隊 {{min}} min（效益已回吐 {{pct}}%）',
        Rca: 'RCA 清洗：去除 {{pct}}% 顆粒，剩餘 {{left}}/cm²',
        Exposure: '在 ISO {{iso}} 工作區敞開 {{min}} min（{{zone}}/m³，房間讀數 {{room}}/m³）：+{{adders}} ' +
          '顆粒/cm²',
        PlatedOverburden: '，過鍍層 {{over}} nm，留給 CMP-11 的台階 {{step}} nm，不均勻性 {{nu}}%',
        PlatedVoid: '（空洞 {{pct}}%）',
        Plated: '電鍍 {{nm}} nm，增益 {{gain}}×：{{fill}}',
        PolishedWorst: '，最差處為 {{region}}（碟形凹陷 {{dishing}} nm，侵蝕 {{erosion}} nm）',
        PolishedBridging: '，金屬仍在橋接',
        Polished: '拋光 {{s}} s，晶粒內起伏 {{nm}} nm',
        AldParasitic: '，其中 {{pct}}% 為寄生 CVD',
        Ald: '{{cycles}} 個 ALD 循環，{{nm}} nm，不均勻性 {{nu}}%',
        AnnealOxide: '，生長氧化層 {{nm}} nm',
        AnnealFresh: '（新片應為 {{xj}} nm）',
        Anneal: '退火循環：xj {{xj}} nm',
        ImplantChannelled: '，{{pct}}% 發生通道效應，深達 {{nm}} nm',
        Implant: '{{species}}，{{kev}} keV，{{dose}}/nm²：Rp {{rp}} nm，{{lattice}}',
        EpiSpitting: '，帶入氣相顆粒',
        EpiSlip: '，邊緣出現滑移',
        EpiSeam: '，{{um}} µm 自摻雜過渡區',
        Epi: '磊晶層：{{um}} µm，摻雜 {{doping}}/nm³，{{regime}}',
        Sliced: '切片、研磨、蝕刻並拋光：{{um}} µm，TTV {{ttv}} µm，彎曲 {{bow}} µm，殘餘損傷 {{damage}} ' +
          'µm（{{mpa}} MPa）。該晶錠得到 {{good}} 片合格晶圓。',
        IngotStructureLost: '——結構已喪失',
        Ingot: '晶錠已生長：{{mm}} mm 摻{{dopant}}矽，籽晶端 {{rho}} Ω·cm，氧 {{oxygen}}/nm³，{{regime}}',
        StockBlank: '庫存空白片——鋸上沒有來自 CZ-07 的晶錠。',
        BareWafer: '拋光裸片，無薄膜',
      },
      quantum: {
        Dd3Note: '這個面板上面的每一個數字都把兩個量子點當作排在一條線上。其實不是：電子是從閘極之間的縫隙裡穿過去的，而縫隙是有寬度的。所以這裡把一個電子放在三維位能場的左量子點裡然後鬆手，對整個波積分薛丁格方程，用的就是 ' +
          'THRM-04 的穿隧體積和 MET-05 ' +
          '的繞射所用的同一個傳播器。沒有任何東西告訴它該穿得多快。圖表數的是波有多少還在左邊，耦合強度從第一次折返讀出：h/4t。把擠壓保持為零，灰色虛線（二能階，用一維求解器的 ' +
          't）就壓在藍線下面——兩個除了位能場之外毫無共同之處的計算，得到了一致的結果。現在把縫隙擠窄。縫隙越窄，橫向上把電子束縛得越緊，這要付出零點能，電子在穿過時必須湊夠這份能量：它就是換了名字的位障高度，每單位擠壓相當於半個 ' +
          'ħω₀。橙色曲線正是把這一項加到一維位障上，它與波的真實行為相差不到十分之一。位障閘比圖紙窄幾個奈米，對量子位元速度的影響比它的電壓還大，這讓 t ' +
          '成了一個微影參數。量子井按它真實的十奈米畫出；在網格上它厚了 2.2 ' +
          '倍，因為矽中的電子沿生長方向重五倍，換一個變數就能把兩種質量放進同一個網格。一個電子，一個能谷，沒有自旋，沒有雜訊，沒有弛豫。',
        Dd3KnobDetuning: '失諧',
        Dd3KnobPinchValue: '縫隙內 ħω = {{hw}} meV',
        Dd3KnobPinch: '閘極把縫隙擠窄多少',
        Dd3KnobBarrier: '位障閘',
        Dd3Idle: '按「執行」：電子在左量子點被釋放，並在工作執行緒上傳播，每次執行十到二十秒。',
        Dd3Status: '{{ps}} / {{run}} ps · {{left}} % 在左量子點 · Σ|ψ|² = {{norm}}',
        Dd3TileNoPinch: '縫隙與量子點一樣寬：無需修正',
        Dd3TileAdiabaticNote: '位障增加 {{mev}} meV：縫隙以 ħω = {{hw}} meV 束縛電子',
        Dd3TileAdiabatic: '計入縫隙的零點能',
        Dd3Tile1dNote: '應在 {{ps}} ps 內穿越',
        Dd3Tile1d: '一維求解器，同樣的閘極',
        Dd3TileWaiting: '在電子第一次折返時讀取',
        Dd3TileMeasuredNote: '第一次折返在 {{ps}} ps，{{pct}} % 到了另一側',
        Dd3TileMeasured: '穿隧耦合，由執行結果測得',
        Dd3Crossed: '第一次折返',
        Dd3ChartY: 'P(左)',
        Dd3ChartX: '時間 (ps)',
        Dd3ChartTitle: '電子處於左量子點的機率',
        Dd3LineAdiabatic: '二能階，把縫隙的零點能加到位障上',
        Dd3Line1d: '二能階，用一維求解器的 t',
        Dd3Measured: '三維傳播',
        Dd3About: '這裡展示了什麼，模型又略去了什麼',
        SectionDd3: '三維傳播下的穿越——以及縫隙變窄的代價（薛丁格方程，分裂 Cayley 步進）',
        NextFrequency: 'EPI-20 量子井裡的自旋量子位元靠磁場而不是約瑟夫森接面來劈裂，約每特斯拉 28 GHz。多大的磁場能讓它在這台冷凍機裡和 5 GHz 的 ' +
          'transmon 一樣「冷」？你預計最先出問題的會是什麼？',
        TitleFrequency: '|1⟩ 佈居隨量子位元頻率的變化',
        LabelP1High: '最高頻率下處於 |1⟩',
        LabelP1Low: '最低頻率下處於 |1⟩',
        HypFrequency: '當兩能階之間的間隔遠大於周圍的熱能時，二能階系統就處在基態：要緊的是 hf 比 kT，而不是 T ' +
          '本身。如果是這樣，同一台冷凍機、同一套線路，應該讓低頻量子位元混得很厲害，而高頻的很乾淨，兩者之間冷凍機上什麼都沒變。',
        AskedFrequency: '量子位元的頻率如何決定冷凍機夠不夠冷？',
        SumFrequency: '量子位元頻率對熱佈居：冷不冷看的是 hf 對 kT，而不是多少毫開。',
        NextAttenuation: '上個月測得很好的一顆晶片，今天在 |1⟩ 的讀數是百分之十，而冷凍機上所有溫度計都正常。在有人提議回溫之前，趁冷凍機還冷著，你會先量什麼？',
        TitleAttenuation: '量子位元溫度隨線路衰減的變化',
        LabelPlate: '冷盤始終為',
        LabelQubitCold: '衰減最多時的量子位元',
        LabelQubitWarm: '衰減最少時的量子位元',
        HypAttenuation: '傳送驅動脈衝的同軸線同時也帶著室溫雜訊，在量子位元的模態裡約有一千個光子。每 10 dB ' +
          '的低溫衰減會去掉其中的十分之九。如果量子位元是和它「聽到」的東西熱平衡，而不是和它所在的冷盤熱平衡，那麼每加一個衰減器它的溫度都應該下降，直到只剩冷盤自身的輻射——而冷盤上的溫度計應該紋絲不動。',
        AskedAttenuation: '量子位元的驅動線需要多少衰減？',
        SumAttenuation: '驅動線衰減對量子位元溫度：室溫雜訊，每 10 dB 減為十分之一。',
        knob: {
          circulation: '氦-3 循環量',
          attenuationDb: '驅動線衰減',
        },
        AssistantBlurb: '問問驅動線需要多少衰減，或者為什麼量子位元要做在 5 GHz。每個回答都是用這份配方把冷凍機跑一遍。',
        AssistantLead: 'QDT-24 探究助手',
        TileExcitedNote: '針對上面設計的 {{f}} GHz 量子位元',
        TileExcited: '無驅動時處於 |1⟩ 的比例',
        TileQubitNote: '其模態中有 {{n}} 個熱光子',
        TileQubit: '量子位元溫度',
        TilePlateNote: '從 4 K 到基礎溫度需 {{h}} h',
        TilePlate: '混合室冷盤',
        SectionTool: '本班次的冷凍機：冷盤有多冷，量子位元有多冷',
        fault: {
          missingAttenuator: {
            Evidence: [
              '無驅動時量子位元在 |1⟩ 的讀數是百分之十，而限值是百分之一，同時冷盤讀數為 10 mK。',
              '流量、4 K 級和真空罐壓力都正常：冷凍機是健康的。',
              '網路分析儀在一條規格為 60 dB 的線上只測到 40 dB。',
            ],
            Truth: '重做線路時，驅動線混合室一端的 20 dB ' +
              '衰減器被漏裝了。現在這條線放過的室溫雜訊是應有值的一百倍：量子位元模態裡有八分之一個光子，而不是千分之一個，這相當於 10 mK 的冷盤上坐著一個 ' +
              '109 mK ' +
              '的量子位元。每十次量測就有一次從錯誤的初態開始。所有溫度計都是對的。量子位元的溫度不是它鎖在上面的那塊金屬的溫度，而是它能「聽到」的東西的溫度。',
            Complaint: '冷凍機狀態完美：10 mK，準時到達。量子位元卻不行。讀出保真度很差而 T1 看上去正常，而且上個月這顆晶片在另一台冷凍機裡測得很好。',
            Label: '驅動線上少了一個衰減器',
          },
          canLeak: {
            Evidence: [
              '真空罐壓力是合格值的八倍。',
              '蒸餾室流量正常，說明致冷功率完好；4 K 級正常，說明多出來的熱量不是沿支撐件傳下來的。',
              '測漏儀在真空罐法蘭處測到了氦。',
            ],
            Truth: '真空罐上的一處銦密封漏了，本該是真空的空間裡有了氦氣。氣體會導熱：它把熱量從 4 K ' +
              '壁直接帶到冷盤，是合格漏熱的八倍，冷盤就停在根號八倍的基礎溫度上。這是最貴的一種——必須把冷凍機升到室溫才能打開——也正因為如此，要先把那兩個便宜的相似故障排除掉。',
            Complaint: '這次降溫冷盤卡在 28 mK 不動了。流量正常，4 K 級也正常。',
            Label: '真空罐裡進了氦氣',
          },
          warmCompressor: {
            Evidence: [
              '4 K 級讀數為 5.2 K。冷阱堵塞和真空罐漏氣都不會讓 4 K 級變熱。',
              '蒸餾室流量和真空罐壓力都正常。',
              '壓縮機進水 31 °C，限值是 25 °C。',
            ],
            Truth: '驅動脈管的壓縮機拿到的冷卻水有 31 °C，正在降載運轉，於是 4 K 級停在了 5.2 ' +
              'K。所有更冷的部件都掛在這一級上，而沿支撐件和線纜傳下來的熱量大致與它溫度的平方成正比：漏熱是原來的 2.6 倍，基礎溫度就是原來的根號 2.6 ' +
              '倍。下午更糟，是因為大樓的冷卻水，而不是冷凍機。',
            Complaint: '一週內基礎溫度從 10 mK 慢慢爬到了 16 mK，而且下午更糟。循環量完全是設定值。',
            Label: '脈管壓縮機運轉偏熱',
          },
          pluggedTrap: {
            Evidence: [
              '蒸餾室流量只有設定值的 20%。真空罐漏氣只會增加熱量，不會減少流量。',
              '真空罐壓力和 4 K 級都正常。',
              '冷阱兩端壓降是正常值的五倍。',
            ],
            Truth: '用來淨化回流氦-3 的液氮冷阱被凍住的空氣堵滿了，把循環量卡到了設定值的五分之一。致冷功率與循環量乘以 T ' +
              '的平方成正比，所以五分之一的流量在同樣的漏熱下只能維持根號五倍的溫度：22 ' +
              'mK。冷凍機內部什麼問題也沒有。要修的地方在氣體處理櫃上，一個下午就夠，而且不用回溫。',
            Complaint: '冷盤降不到 22 mK 以下。上一次降溫它到了 10。有人說是真空罐漏了，想回溫把所有密封都重做一遍。',
            Label: '冷阱正在堵塞',
          },
          cryoHealthy: {
            Evidence: [
              '冷盤在 10 mK，量子位元在 |1⟩ 的讀數是八分之一個百分點。',
              '所有台面讀數都正常。',
            ],
            Truth: '沒有任何問題。正確的判斷是開始量測。',
            Complaint: '例行降溫。冷盤一夜之間到了基礎溫度。',
            Label: '一切正常',
          },
        },
        reading: {
          lineInsertionLoss: {
            Label: '用網路分析儀測驅動線插入損耗 (2.0 h)',
          },
          leakCheck: {
            Limit: '無訊號',
            Label: '冷凍機低溫狀態下對真空罐做氦測漏 (3.0 h)',
          },
          compressorWater: {
            Limit: '進水 < 25 °C',
            Label: '脈管壓縮機處的冷卻水 (30 min)',
          },
          trapPressure: {
            Label: '液氮冷阱兩端壓降 (30 min)',
          },
          qubitPopulation: {
            Label: '無驅動時量子位元在 |1⟩ 的佈居',
          },
          canPressure: {
            Label: '真空罐壓力',
          },
          fourKelvin: {
            Label: '4 K 級溫度',
          },
          stillFlow: {
            Label: '蒸餾室的氦-3 流量',
          },
        },
        aspect: {
          wiring: {
            Action: '回溫、打開冷凍機，把驅動線上缺的衰減器裝回去',
            Label: '微波線路',
          },
          vacuum: {
            Action: '回溫、找到漏點、重做銦密封，再重新降溫',
            Label: '真空罐',
          },
          pulseTube: {
            Action: '恢復壓縮機的冷卻水，讓 4 K 級恢復',
            Label: '脈管致冷機及其壓縮機',
          },
          circulation: {
            Action: '給液氮冷阱回溫並抽空，然後把循環量恢復上去',
            Label: '氦-3 循環',
          },
        },
        SecondaryLabel: '量子位元在 |1⟩ 的佈居',
        ToolLabel: 'QDT-24 低溫量子元件測試',
        GuardWafer: '這批還是整片晶圓。請先在 DICE-15 切割：冷凍機放的是樣品座上的晶片，它的冷盤比晶圓還小。',
        GuardPackaged: '這些元件已經模封成封裝了。量子位元晶片是裸片進冷凍機的，用打線接合到樣品座上。',
        CoolLot: '降溫到 10 mK 並量測量子位元特性',
        NoteNoLot: '冷凍機裡沒有晶片。把完工的量子晶片帶到這裡來降溫並量測。',
        SectionSpin: 'EPI-20 量子井裡的自旋量子位元：能谷分裂（緊束縛）',
        SectionTransmon: 'Transmon：求解漢米爾頓量（Sturm 二分法）',
        DriveRabiTitle: '共振驅動：布居數來回擺盪',
        DriveRabiX: '時間 (ns)',
        DriveRabiY: '布居數',
        DriveP0: '|0⟩',
        DriveP1: '|1⟩',
        DriveP2: '|2⟩（洩漏）',
        DriveLeakTitle: 'π 脈衝太短就會洩漏出量子位元',
        DriveLeakX: '閘時間 (ns)',
        DriveLeakY: '留在 |2⟩ 及以上的布居數（log₁₀）',
        DriveLeakSeries: '校準 π 脈衝後的洩漏',
        DriveSpeedLimit: '1/|α| = {{nsec}} ns',
        DriveThisGate: '目前的閘',
        DriveRamseyTitle: 'Ramsey：被電荷雜訊帶走的相位',
        DriveRamseyX: '兩個 π/2 脈衝之間的等待時間 ({{unit}})',
        DriveRamseyY: '第二個脈衝後處於 |0⟩ 的機率',
        DriveFringe: '條紋',
        DriveEnvelope: '包絡',
        DriveT2: 'T₂*',
        DriveStatF01: '量子位元頻率 f₀₁',
        DriveStatRatio: 'E_J/E_C = {{ratio}}',
        DriveStatAlpha: '非諧性 α',
        DriveStatLimit: '速度極限 1/|α| = {{nsec}} ns',
        DriveStatRabi: 'Rabi 頻率',
        DriveStatPi: '方形 π 脈衝需要 {{nsec}} ns',
        DriveStatLeak: '{{nsec}} ns π 脈衝後的洩漏',
        DriveStatP1: 'P(|1⟩) = {{p}}',
        DriveFrameRwa: '旋轉波近似',
        DriveFrameLab: '實驗室座標系，保留反旋轉項',
        DriveStatT2: '電荷雜訊決定的 T₂*',
        DriveStatAsymptotic: 'E_J/E_C 已超出電荷基所能分辨的範圍；此處 f₀₁ 的擺幅取 Koch 的漸近式，電荷雜訊不再限制這個量子位元',
        DriveStatSigma: '偏置電荷雜訊 σ = {{sigma}} e',
        DriveTransmon: 'Transmon（E_J 來自約瑟夫森接面）',
        DriveBox: '庫柏對盒（E_J = E_C）',
        DriveShowLeak: '洩漏與閘時間',
        DriveShowRamsey: 'Ramsey 條紋',
        DriveKnobCap: '並聯電容',
        DriveKnobCapValue: '{{ff}} fF · E_C = {{ec}} MHz',
        DriveKnobAmp: '驅動振幅',
        DriveKnobGate: 'π 脈衝閘時間',
        DriveKnobSigma: '偏置電荷雜訊 σ',
        DriveKnobSigmaValue: '{{sigma}} e',
        SectionDrive: '驅動下的 transmon：Rabi、洩漏與去相位（薛丁格方程式，RK4）',
        DriveNote: '把上面的能譜拿來做點事。微波訊號耦合到超導島上的電荷，而在能階本身的基底中，電荷算符只連接相鄰能階，所以頻率為 f₀₁ 的訊號會讓量子位元以左圖的 Rabi 頻率在 |0⟩ 和 |1⟩ 之間來回擺盪。麻煩在於 |2⟩：它離等間距下一階的位置只差非諧性 α，而短於幾個 1/|α| 的脈衝頻寬足以把它激發出來。洩漏曲線是在每個時長下校準過的 π 脈衝——這是每一台超導量子處理器都繞不開的速度極限。切換到 Ramsey 看的是另一只時鐘：基板中的雜散電荷會漂移，能階對它的依賴使 f₀₁ 隨之漂移，一批量測就會在 T₂* 內失去相位。切換到庫柏對盒，相位在幾奈秒內就消失了；而在面板預設參數下，transmon 隨雜訊滑桿不同能保持幾十到幾百微秒，約為它的兩萬倍，這正是它存在的理由。四個求解出的能階在旋轉波近似成立時按該近似驅動，不成立時（庫柏對盒，或相對量子位元頻率很強的脈衝）則在實驗室座標系中計算，保留反旋轉項。雜訊以準靜態處理，能量弛豫、1/f 雜訊頻譜以及 DRAG 之類的脈衝整形都沒有包括在內。',
        SectionChargeQubit: '一個電子，兩個量子點：運動中的電荷量子位元（薛丁格方程式，么正步進）',
        ChargeQubitNote: '上一節止於一個數字：幾十微電子伏特的穿隧耦合 t。這一節告訴你那個數字究竟是什麼。把電子放進左邊的量子點再放手，它不會待著不動——它會在 h/(4t)（這裡約五十皮秒）內越到右邊的點，然後再回來，如此往復不休，因為這個模型裡沒有任何東西能讓它停下。\n\n左邊畫的是 |c_L φ_L + c_R φ_R|²，也就是交換耦合求解器早已算出的兩個軌域，其振幅是一步步積分出來的，而不是照搬教科書公式——那個公式只用來在測試中核對結果。把兩點傾斜一下，會同時發生兩件事：越過去的比例按 4t²/(4t² + ε²) 變小，而越過去的那部分反而更快。\n\n斜坡切換展示的是真實邏輯閘的驅動方式——讓失諧掃過零點，掃得慢電子就沿反交叉進入另一個點，掃得快則逕直穿過，其機率由藍道–齊納公式給出。\n\n最後一個旋鈕說明了電荷量子位元為何只是教學裝置而非產品：雜散電荷會推動失諧，頻率隨之漂移，振盪在幾奈秒內就模糊殆盡——只有幾百次往返，而 transmon 能做到幾十萬次。在零失諧處，頻率對雜訊只有二階依賴，這正是所謂的甜蜜點。模型只有兩個能階與準靜態雜訊：沒有能谷、沒有聲子、沒有弛豫，電子也從未被測量。',
        CqDensityTitle: '電子在哪裡：橫跨兩個量子點的 |ψ|²',
        CqDensityX: '沿量子點連線的位置（nm）',
        CqDensityY: '能量（meV）',
        CqPotential: '閘極位能',
        CqDensitySeries: '電子密度 |ψ|²',
        CqTraceTitle: '電子來回擺盪：P(左) 隨時間變化',
        CqTraceX: '時間（ns）',
        CqTraceY: '電子位於左側量子點的機率',
        CqTraceSeries: 'P(左)，積分所得',
        CqEnvelopeSeries: '電荷雜訊留下的可見度',
        CqNow: '此刻',
        CqRampTitle: '掃過反交叉的失諧斜坡',
        CqRampX: 'log₁₀ 掃描速率（µeV/ns）',
        CqRampY: '電子留在原量子點的機率',
        CqRampSeries: '積分所得',
        CqRampFormula: '藍道–齊納公式',
        CqRampHere: '此斜坡',
        CqCrossover: '轉折點',
        CqToggleOscillation: '讓它來回擺盪',
        CqToggleRamp: '掃過反交叉',
        Cq3dCrossing: '穿越所需',
        Cq3dSweep: '掃描歷時',
        Dot3dInLeft: '在左量子點',
        Dot3dInRight: '在右量子點',
        CqAbout: '這裡展示了什麼，模型又省略了什麼',
        CqBenchKnobs: '旋鈕',
        CqBenchReadouts: '讀數',
        Dot3dAbout: '關於這幅圖',
        Dot3dScaleTailsShort: '尾部（對數）',
        Dot3dScaleDensityShort: '密度（線性）',
        Dot3dAnimCaption: '一個電子，在元件之中。這團雲是兩個量子點軌域按電子不斷變化的振幅相加的結果，|c_L φ_L + c_R φ_R|²，干涉也包含在內——所以它是從一個點流向另一個點，而不是兩團雲互換亮度。沿兩點方向的形狀是解出來的；垂直於該方向以及穿過 10 nm 量子井的部分是假設的基態。',
        CqStatCrossover: '臨界掃描速率',
        CqStatCrossoverNote: '2πt²/ħ：比它慢的斜坡把電子帶過去，比它快的則把電子留在原地',
        CqStatStays: '這次斜坡留在原地的比例',
        CqStatStaysNote: '藍道–齊納公式給出 {{formula}}%',
        YieldShort: '{{y}}% 的晶片沒有頻率碰撞 · 每個量子位元落在目標約 {{sigma}} MHz 以內',
        CqRampAveraged: '遠離交叉點時，兩條能支之間的拍頻快得一幀畫面無法顯示，那裡畫的是拍頻的平均；在交叉點附近，畫的就是拍頻本身。',
        CqStatT: '穿隧耦合 t',
        CqStatTNote: '與交換耦合小節在同一設計上讀到的 {{freq}} 相同',
        CqStatPeriod: '一次往返',
        CqStatPeriodNote: '把電子送到隔壁需 {{half}}：半個週期',
        CqStatAmplitude: '有多少真正越過去',
        CqStatAmplitudeNote: 'ε = {{eps}} µeV 時的 4t²/(4t² + ε²)',
        CqStatT2: '同調時間 T₂*',
        CqStatT2Note: '振盪模糊之前可往返 {{periods}} 次',
        CqStatT2Coherent: '無雜訊：完全同調',
        CqStatT2CoherentNote: '把電荷雜訊調上去：這正是電荷量子位元唯一挺不過去的東西',
        CqSlowdown: '放慢 {{factor}} 倍：這裡的一秒相當於冷凍機中的 {{nsec}} ns',
        CqRun: '執行',
        CqPause: '暫停',
        CqReset: '回到左側量子點',
        CqKnobBarrier: '位障閘極',
        CqKnobDetuning: '兩點之間的失諧',
        CqKnobNoise: '作用在失諧上的電荷雜訊',
        CqNoiseNone: '無',
        CqKnobRate: '掃描速率',
        CqKnobRateValue: '{{rate}} µeV/ns · {{stays}}% 留在原處',
        ExchOff: '關閉',
        ExchPotentialTitle: '兩個量子點，一個電子：局域軌域',
        ExchPotentialX: '沿量子點連線的位置 (nm)',
        ExchPotentialY: '能量 (meV)',
        ExchPotentialSeries: '閘極位能',
        ExchLeft: '左量子點 |φ_L|²',
        ExchRight: '右量子點 |φ_R|²',
        ExchJTitleBarrier: '交換能 J 隨位障閘的變化',
        ExchJTitleDetuning: '交換能 J 隨失諧的變化',
        ExchJXBarrier: '位障閘高度 (meV)',
        ExchJXDetuning: '失諧 ε (meV)',
        ExchJY: 'log₁₀ J (µeV)',
        ExchJSeries: 'J，Hubbard 模型',
        ExchJHere: '目前設計',
        ExchJGate: '10 ns √SWAP',
        ExchStatT: '穿隧耦合 t',
        ExchStatTNote: '局域軌域之間的非對角元素；鞍點比量子點底部高 {{saddle}} meV',
        ExchStatU: '共用一個量子點的代價 U',
        ExchStatUNote: '兩個電子同處一個 {{size}} nm 量子點時的庫侖能',
        ExchStatJ: '交換能 J',
        ExchStatJNote: '{{mhz}} MHz；弱穿隧公式 4t²U/(U² − ε²) 給出 {{formula}}',
        ExchStatGate: '√SWAP 閘時間',
        ExchStatGateNote: 'h/(4J)：交換相位轉過四分之一圈',
        ExchStatMerged: '電子已不再被侷限在兩個量子點中——把基態能階降到鞍點以下，或升高位障',
        ExchStatTilted: '傾斜已把兩個軌域都拉進同一個量子點——隔壁沒有電子可以交換；把失諧調回零附近',
        ExchSweepBarrier: 'J 隨位障閘',
        ExchSweepDetuning: 'J 隨失諧',
        ExchKnobBarrier: '位障閘',
        ExchKnobDetuning: '兩個量子點之間的失諧',
        ExchKnobSep: '量子點間距（半個節距）',
        ExchKnobHw: '量子點侷限能 ħω₀',
        SectionExchange: '兩個自旋量子位元及其之間的閘：交換耦合（薛丁格方程，Hubbard 模型）',
        ExchangeNote: '一個量子點容納一個量子位元，而電腦需要兩個量子位元彼此交互作用。在矽中，這種交互作用就是交換作用，不需要任何人為它佈線。相鄰量子點中的兩個電子可以短暫共用一個量子點來降低能量，但包立原理只允許自旋相反時這樣做，因此單態比三重態低一個能量 J；讓 J 保持開啟 h/(4J) 的時間，兩個自旋就完成一個 √SWAP 閘。這裡的每一步都是解出來的：雙量子點位能中的單電子給出局域軌域之間的穿隧耦合 t，對左軌域的庫侖積分給出共用一個量子點的代價 U，雙電子 Hubbard 模型給出 J，在弱穿隧時 J 為 4t²U/(U² − ε²)。升高位障閘，t 按指數下降，J 隨其平方下降：一個閘上十毫電子伏特的變化可使 J 改變近五個數量級，晶片正是這樣開關一個閘的。模型沿量子點連線為一維，以量子點尺寸軟化庫侖核，不含能谷、自旋軌道耦合或電荷雜訊。',
        Dot3dT: '穿隧耦合 t',
        Dot3dJ: '交換 J',
        Dot3dGate: '√SWAP',
        Dot3dCaption: '沿兩個量子點的方向：求解所得。橫跨量子點及穿過 10 nm 量子井的方向：假定為基態。每個量子點上方是一個柱塞閘極，兩者之間是位障閘極——顏色越暖表示位障越高。白色處是兩個軌域互相重疊的地方。',
        Dot3dScaleTails: '顯示尾部（對數，四個數量級）',
        Dot3dScaleDensity: '真實密度（線性）',
        SectionJunction: '約瑟夫森接面：一奈米的氧化層（傳遞矩陣、Landauer 公式）',
        SpinNote: '矽導帶的最低能量位於動量空間的六個點上；應變量子井只留下其中兩個——即兩個能谷——而且幾乎等高。這裡的原子鏈是最小的、能有兩個能谷的模型——每個原子面一個格點，躍遷參數選成讓能帶最低點落在矽的位置——所以陡峭的 ' +
          'Si/SiGe 台階能把兩個能谷分開幾百 ' +
          'µeV。當成長溫度偏高、鍺擴散把這個台階抹開半個奈米時，平滑模型裡的分裂就崩塌了；但合金是逐個原子隨機的，電子碰到的隨機鍺又會碰巧把能谷分開。一座晶圓廠的自旋量子位元良率，就是那些在這場抽獎中贏得足夠多、使自旋在工作磁場下不跑進上能谷的量子點所佔的比例。',
        KnobB: '磁場',
        KnobDot: '量子點半徑',
        KnobField: '閘極電場',
        KnobGe: '位障中的鍺含量',
        KnobWell: '矽量子井厚度',
        KnobInterface: '界面寬度（EPI-20 成長）',
        DotNext: '換一個量子點看看',
        DotSmooth: '平滑合金，無無序',
        DotAlloy: '真實量子點：隨機合金',
        StatThermalNote: '能谷分裂必須是它的許多倍，否則上能谷會被佔據',
        StatThermal: '100 mK 下的熱能',
        StatHotSpotNote: '自旋分裂等於能谷分裂、自旋弛豫最快的地方——要遠離它',
        StatHotSpot: '熱點',
        StatQubitNote: '在 {{b}} T：塞曼分裂 {{ez}} µeV',
        StatQubit: '自旋量子位元頻率',
        StatWaferNote: '的量子點超過 100 µeV；中位數 {{median}}，10-90%：{{lo}}-{{hi}} µeV',
        StatWafer: '五十個量子點中',
        StatThisDotNote: '所畫量子點的能谷分裂；無無序時為 {{smooth}} µeV',
        StatThisDot: '這個量子點',
        LevelsHot: '熱點',
        LevelsHere: '工作磁場',
        LevelsY: '能量 (µeV)',
        LevelsX: '磁場 (T)',
        LevelsTitle: '自旋與能谷能階隨磁場的變化',
        LevelValley1Up: '上能谷，自旋向上',
        LevelValley1Down: '上能谷，自旋向下',
        LevelValley0Up: '下能谷，自旋向上',
        LevelValley0Down: '下能谷，自旋向下',
        ValleyTarget: '100 µeV',
        ValleyHere: '目前成長',
        ValleyBand: '10% 和 90% 分位的量子點',
        ValleyMedian: '真實合金，中位數量子點',
        ValleySmooth: '平滑合金（無無序）',
        ValleyY: 'log₁₀ 能谷分裂 (µeV)',
        ValleyX: 'Si/SiGe 界面寬度 (nm)',
        ValleyTitle: '能谷分裂與界面寬度的關係',
        WellDensity: '電子',
        WellSmooth: '平滑分布',
        WellAlloy: '這個量子點的合金',
        WellY: '導帶底 (meV)',
        WellX: '膜層中的高度 (nm)',
        WellTitle: '逐個原子面看量子井，以及電子在哪裡',
        YieldNote: '在這個離散下，上面的量子位元落在目標頻率約 {{sigma}} MHz 以內（一個標準差）。當兩個相鄰位元中任一個落在對方 0-1 或 1-2 ' +
          '躍遷線 {{window}} MHz 以內時就發生碰撞，此時雙位元閘會驅動錯誤的躍遷——只有 {{y}}% ' +
          '的晶片完全沒有碰撞。在室溫下量測每個接面，再用雷射退火微調，是晶圓廠壓低離散的一種做法。',
        KnobSpread: '整片晶圓上的接面電阻離散',
        TransmonNote: '這個電路的漢米爾頓量是 4E_C(n − n_g)² − E_J cos φ，其中 n 數的是穿過接面的庫柏對，φ ' +
          '是相位差，二者像位置和動量一樣共軛。寫在庫柏對數的基底裡，它是一個三對角矩陣，它的本徵值就是能階階梯。把電容縮小到 E_J 接近 ' +
          'E_C，能帶就會隨每一個雜散電荷擺動；把電容做大，能帶按指數變平，而非諧性——第一級和第二級台階之間的差，正是它讓脈衝只驅動量子位元——只按冪次縮小。這個取捨就是 ' +
          'transmon。',
        KnobNg: '偏置電荷',
        KnobEj: '約瑟夫森能 E_J / h',
        KnobCapValue: '{{ff}} fF · E_C/h {{ec}} MHz',
        KnobCap: '並聯電容',
        StatShiftNote: '多 0.01 nm 的 AlOx 會讓這個量子位元偏移多少',
        StatShift: '十分之一埃的氧化層',
        StatDispersionNote: 'Koch 等人的漸近公式：{{koch}}',
        StatDispersion: 'f₀₁ 的電荷色散',
        StatRatioNote: '大於約 20 是 transmon；接近 1 則是庫柏對盒',
        StatRatio: 'E_J / E_C',
        StatAnharmNote: '約為 −E_C，即 −{{ec}} MHz：正因如此脈衝才能只驅動 0→1',
        StatAnharm: '非諧性',
        StatF01Note: '教科書公式 √(8E_J E_C) − E_C 給出 {{asym}} GHz',
        StatF01: '量子位元頻率 f₀₁',
        YieldHere: '目前製程',
        YieldSeries: '對晶片做蒙地卡羅',
        YieldY: '無頻率碰撞的晶片 (%)',
        YieldX: '接面電阻離散，一個標準差 (%)',
        YieldTitle: '無頻率碰撞的晶片，{{n}} 個量子位元排成一鏈',
        BandsHere: 'n_g',
        BandsY: '高於基態平均值的能量 / h (GHz)',
        BandsX: '偏置電荷 n_g（庫柏對）',
        BandsTitle: '能階階梯與島上雜散電荷的關係',
        PotentialExcited: '|1⟩',
        PotentialGround: '|0⟩',
        PotentialSeries: '約瑟夫森位能',
        PotentialY: '能量 / h (GHz)',
        PotentialX: '接面兩端的相位 φ (rad)',
        PotentialTitle: '量子擺：−E_J cos φ 及其兩個最低能態',
        JunctionNote: '這個接面是在兩次鋁蒸鍍之間往蒸鍍腔裡通幾分鐘氧氣長出來的，留下的是一奈米左右的非晶 AlOx。電子靠穿隧穿過它，所以電阻隨厚度指數成長——這正是 ' +
          'THRM-04 閘氧化層的那一課，只是目標反過來：這裡晶圓廠需要的是精確數量的穿隧，而不是完全沒有。電阻在室溫下逐個接面量測，因為 ' +
          'Ambegaokar 和 Baratoff 證明了：晶片一旦變冷，它就確定了臨界電流。位障高度和質量是擬合真實接面得到的；曲線有多陡與它們無關。',
        KnobMass: '氧化層中的有效質量',
        KnobBarrier: '位障高度',
        KnobArea: '接面面積',
        KnobOxide: '氧化層厚度',
        StatEjNote: 'E_J/h——下面的 transmon 就建立在它上面',
        StatEj: '約瑟夫森能',
        StatIcNote: 'Ambegaokar-Baratoff：鋁進入超導態後 I_c R_n = πΔ/2e',
        StatIc: '臨界電流',
        StatRnNote: '{{a}} µm² 的接面，在室溫下量得',
        StatRn: '正常態電阻',
        StatRaNote: '氧化層每厚一埃，×{{f}}',
        StatRa: 'R·A',
        RaBand: '量子位元接面',
        RaHere: '目前氧化層',
        RaSeries: 'Landauer 公式，經由傳遞矩陣',
        RaY: 'log₁₀ R·A (Ω·µm²)',
        RaX: 'AlOx 厚度 (nm)',
        RaTitle: '電阻與氧化層厚度的關係',
        JunctionWave: '電子波穿過氧化層：只剩 {{f}}',
        JunctionAl: 'Al',
      },
      ebeam: {
        NextCurrent: '量具研究沒通過，而單幀影像看上去很清晰。在電流、幀數和機器下面的地面這三者裡，你會先查哪一個？什麼讀數能告訴你不是另外兩個？',
        TitlePrecisionCurrent: '重複性和束斑隨探針電流的變化',
        LabelSpotThere: '該電流下的束斑',
        LabelAtCurrent: '對應電流',
        LabelBestPrecision: '最佳重複性',
        HypCurrent: '邊緣是在由計數電子構成的輪廓裡定位的，所以它的離散應該與電流的平方根成反比。但電流來自亮度固定的源：想要更多，就得把針尖上更大的一塊成像到晶圓上。如果兩者都成立，重複性一開始應該改善得很快，然後停下來——要麼因為束斑變大，要麼因為有些雜訊電流壓不下去。',
        AskedCurrent: '更大的束流能讓 CD 重複得更好嗎？',
        SumCurrent: '探針電流對重複性：計數雜訊一路下降，直到只剩下電流碰不到的那部分雜訊。',
        NextLanding: '上面的產額部分顯示了光阻在哪裡不再充電。如果最銳利的束斑在 2000 eV，而電荷中性點在 500 附近，你會放棄哪一個？選錯了影像會是什麼樣子？',
        TitleSpotEnergy: '束斑尺寸隨著陸能量的變化',
        LabelChromaticShare: '低能端的色差模糊',
        LabelSpotHigh: '最高能量下的束斑',
        LabelSpotLow: '最低能量下的束斑',
        HypLanding: '有兩種模糊取決於束能量。繞射與電子波長成正比，而波長與能量的平方根成反比。色差模糊與電子槍的能量展寬除以能量成正比，下降得更快。如果兩者都對，束斑應該隨著束變硬而穩定縮小，其中色差那一份最先塌下去。',
        AskedLanding: '著陸能量對束斑有什麼影響？',
        SumLanding: '著陸能量對束斑尺寸：束越硬，繞射和色差模糊都越小。',
        knob: {
          alphaMrad: '會聚半角',
          frames: '平均幀數',
          currentPa: '探針電流',
          landingEv: '著陸能量',
        },
        AssistantBlurb: '問問著陸能量對束斑有什麼影響，或者更大的束流能不能讓 CD 重複得更好。每個回答都是用這份配方把鏡筒跑一遍。',
        AssistantLead: 'SEM-23 探究助手',
        TileSignalNote: '電流 × 幀數 × 偵測器，相對合格值',
        TileSignal: '每次量測的訊號',
        TilePrecisionNote: '同一條線，反覆量測',
        TilePrecision: '重複性',
        TileSpotNote: '繞射 {{d}} nm，色差 {{c}} nm',
        TileSpot: '晶圓上的束斑',
        SectionTool: '本班次的 CD-SEM：看得多細，重複得多好',
        fault: {
          tiredScintillator: {
            Evidence: [
              '參考樣品上的偵測器訊號只有合格值的 25%。',
              '雜訊在每一幀之內，而不在幀與幀之間：對位離散正常。',
              '束斑尺寸和影像功率譜都正常。',
            ],
            Truth: '閃爍體被電子轟擊了多年，發光量只剩原來的四分之一。每個像素計到的電子少了，每個像素的雜訊就大了，而在有雜訊的輪廓裡找到的邊緣會游走：精度與訊號的平方根成反比，所以四分之一的訊號就是兩倍的離散。束斑不受影響。多平均幾幀確實能補回來，代價是光阻要吃四倍的劑量，而它在電子束下會收縮。',
            Complaint: '一個月來重複性慢慢超出了限值。影像看上去有顆粒感，操作員開始多平均幾幀來得到一張乾淨的圖，結果產能減半。',
            Label: '偵測器閃爍體老化',
          },
          groundedMount: {
            Evidence: [
              '幀間對位離散是限值的三倍，而單幀束斑正常。',
              '偵測器訊號正常，所以不是計數雜訊。',
              '加速度計顯示機架在跟著地面動。',
            ],
            Truth: '一個氣浮支座掉了壓，機架落在了限位塊上，於是鏡筒現在跟著地面一起動：束與晶圓之間有 1.2 nm rms ' +
              '的相對運動。單幀裡幾乎看不出來，因為一幀很快。它出現在幀與幀之間：每一幀落在稍微不同的位置，平均後的邊緣就跟著游走。SEM-23 ' +
              '的操作台與基座分開放置，防的正是這個。',
            Complaint: '量具研究沒通過：同一條線量十次，離散是應有值的三倍。單張影像看上去卻非常清晰。',
            Label: '隔振支座沒有浮起',
          },
          stigmatorDrift: {
            Evidence: [
              '影像功率譜呈橢圓形。色差模糊是圓的。',
              '發射雜訊正常，給針尖做閃燒處理也毫無變化。',
              '過焦時，模糊被拉長並轉過九十度。',
            ],
            Truth: '消像散器漂了，束斑裡有 3.5 nm ' +
              '的像散。它看上去像是槍的問題，因為兩者都讓影像發軟、線條變寬；但它不是槍的問題，因為這種模糊有方向：焦點以下束斑朝一個方向拉長，焦點以上朝另一個方向拉長。順著拉長方向的線條看上去仍然很銳利，所以一個操作員說機器沒問題，下一個卻說有問題。',
            Complaint: '影像發軟，線條讀數偏寬。今天早上給電子槍做了閃燒處理，一點用也沒有。',
            Label: '像散未校正',
          },
          gassyTip: {
            Evidence: [
              '發射電流雜訊隨模糊一起升高。像散不會讓電子槍閃爍。',
              '模糊是圓的：功率譜沒有被拉長。',
              '離焦系列測得展寬 0.7 eV。',
            ],
            Truth: '冷場發射針尖已經好幾天沒做閃燒處理了。吸附在上面的氣體一塊一塊地改變功函數，能量展寬從 0.25 eV 漲到了 0.7 eV。在 500 eV ' +
              '著陸能量下，這個展寬就佔了束斑的大頭：色差模糊與 ΔE/E 成正比，所以低電壓鏡筒恰恰最怕它。線並沒有變寬，變寬的是尺。',
            Complaint: '從週末起影像就發軟，每條線都寬了約一奈米。微影那邊已經調高過一次劑量，想把 CD 拉回目標。',
            Label: '槍尖吸附了氣體',
          },
          semHealthy: {
            Evidence: [
              '束斑和重複性都正常。',
              '所有台面讀數都在限值內。',
            ],
            Truth: '沒有任何問題。正確的判斷是繼續量測。',
            Complaint: '例行班次。每日標樣的量測值正常。',
            Label: '一切正常',
          },
        },
        reading: {
          grainCheck: {
            Label: '平坦樣品單幀內的雜訊 (30 min)',
          },
          accelerometer: {
            Limit: '隔振有效',
            Label: '鏡筒機架與地面的加速度計對比 (1.5 h)',
          },
          throughFocus: {
            Limit: '圓形',
            Label: '碳上金標樣的過焦系列 (1.0 h)',
          },
          energySpread: {
            Label: '由色差離焦系列測得的能量展寬 (2.0 h)',
          },
          detectorSignal: {
            Label: '參考樣品上的偵測器訊號',
          },
          frameJitter: {
            Label: '幀間對位離散',
          },
          fftEllipticity: {
            Label: '影像功率譜的橢圓度',
          },
          emissionNoise: {
            Label: '發射電流雜訊',
          },
        },
        aspect: {
          detector: {
            Action: '更換閃爍體並重新設定光電倍增管增益',
            Label: '二次電子偵測器',
          },
          isolation: {
            Action: '讓氣浮支座重新浮起並調平，找出是什麼碰到了機架',
            Label: '隔振系統',
          },
          column: {
            Action: '重新對中鏡筒，並在碳上金標樣上消除像散',
            Label: '鏡筒對中與消像散器',
          },
          gun: {
            Action: '對針尖做閃燒處理趕走吸附氣體，並等待發射穩定',
            Label: '場發射電子槍',
          },
        },
        SecondaryLabel: '重複性',
        ToolLabel: 'SEM-23 CD-SEM 與電子束檢測',
        GuardEtched: '這個圖形已經蝕刻進薄膜了。顯影後檢查是在蝕刻之前看的一眼，那時印壞了還能去膠重工。',
        GuardNoPattern: '這批晶圓上沒有圖形。請先在 EUV-22 或 LITH-03 曝光：CD-SEM 量的是圖形，而這片晶圓上沒有。',
        MeasureLot: '量測圖形並放行去蝕刻',
        NoteNoLot: '載台上沒有批次。把曝過光的晶圓帶到這裡來量測。',
        SectionInspection: '電子束檢測：看得更細，覆蓋更少',
        SectionLinescan: '量測一條線（蒙地卡羅）',
        WaveNote: 'MET-05 的模擬箱讓幾電子伏特的電子穿過相距一奈米的狹縫，電子束按波長決定的角度散開。上面的電子光學柱工作在 {{e}} eV，波長是 ' +
          '{{pm}} pm，而透鏡只接受幾個毫弧度——所以聚焦的束斑被展寬 0.54 λ/α，也就是幾奈米，原因和狹縫把電子束散開完全一樣。下面就是 ' +
          'MET-05 自己的求解器。',
        SectionWave: '繞射項背後的波（MET-05 的模擬箱）',
        SectionProbe: '束斑：繞射與像差之爭',
        YieldBalance: 'σ = 1：離開的與到達的一樣多',
        YieldLandingMark: '著陸 {{e}}',
        YieldChartTitle: '每個著陸電子從樣品中帶出了什麼',
        YieldChartX: '著陸能量，log₁₀ eV（2 = 100 eV，3 = 1 keV）',
        YieldChartY: '每個入射電子對應的出射電子數',
        YieldSeriesDelta: 'δ 二次電子（< 50 eV）',
        YieldSeriesEta: 'η 背向散射電子（≥ 50 eV）',
        YieldSeriesTotal: 'σ = δ + η',
        YieldChargeBalanced: '平衡：絕緣體在這裡保持不動',
        YieldChargePositive: '帶正電：離開的電子多於著陸的電子',
        YieldChargePending: '掃描中……束流還沒有到達這個能量',
        YieldChargeNegative: '帶負電：電子在表面堆積',
        YieldStatMax: '二次電子最多處',
        YieldStatMaxNote: '著陸能量為 {{e}}',
        YieldStatCross: 'σ 穿過 1 的位置',
        YieldStatCrossNote: 'E₁ 與 E₂：絕緣體可以成像而不帶電的著陸能量',
        YieldStatLanding: '在 {{e}}',
        YieldProgress: '掃描中… {{pct}}%（每個能量 {{n}} 個束流電子）',
        YieldDone: '{{n}} 個束流電子，用時 {{s}} s',
        YieldIdle: '按「執行」，讓電子束打到薄膜上。',
        YieldMaterial: '電子束下的樣品',
        YieldCar: '化學放大光阻',
        YieldMor: '金屬氧化物光阻',
        YieldSi: '矽',
        YieldPause: '暫停',
        YieldResume: '繼續',
        YieldRun: '執行掃描',
        YieldKnobLanding: '要檢查的著陸能量',
        SectionYield: '影像為什麼有對比——二次電子產額與著陸能量（蒙地卡羅）',
        YieldNote: 'SEM 拍下的每一幅影像，都由離開樣品的電子構成，而這些電子分兩類。背向散射電子是在固體內部轉向後高速返回的束流電子；二次電子是被電子束撞出的慢電子，只有產生在距表面幾奈米以內的那些才能逸出。這裡的掃描用上方線掃描所用的同一個蒙地卡羅級聯，把束流電子打到一塊厚而平的薄膜上，並統計這兩類電子。δ 與 η 從 100 eV 起才分開畫：在此之下，直接彈回的束流電子能量已低於 50 eV 的界限，所以那裡只畫兩者之和。看 δ 先上升，在幾百 eV 處達到峰值，然後隨著更快的電子束把能量沉積到太深、任何二次電子都到不了表面的地方而下降。總產額 σ = δ + η 大於一時，表面失去電荷；小於一時，表面獲得電荷。絕緣的光阻只有在兩個交叉點上才保持不動，而上面的那個 E₂，正是 CD-SEM 以幾百伏著陸的原因。未包含：電荷沒有回饋到電子束上，薄膜是平的，模型中的矽峰值偏低、背向散射偏多，與實測的矽不同。',
        SectionGun: '電子槍：從針尖穿隧出來的電子（THRM-04 的傳遞矩陣）',
        KnobSnr: '所需訊雜比',
        KnobContrast: '缺陷對比度',
        KnobPixel: '像素尺寸',
        InspNote: '電子束能看到任何光學機台都標不出來的開路接觸孔或埋藏的空洞，因為它不依賴於光在比波長小得多的東西上的散射。但只有當缺陷從計數雜訊中凸顯出來時才看得見，這就確定了每個像素需要的電子數。像素越小，束斑就要越小，束斑越小承載的電流越少，而超過一百奈安培電子束就會自己把自己弄模糊。所以電子束檢測只去設計或光學掃描認為值得花時間的少數地方。',
        StatWaferTimeNote: 'INSP-13 掃一片只要 {{min}} 分鐘，但看不到 {{nm}} nm 以下',
        Hours: '{{h}} 小時',
        Years: '{{y}} 年',
        StatWaferTime: '整片晶圓',
        StatRate: '每小時面積',
        StatDwellNote: '不低於 {{min}} ns——偵測器需要穩定時間',
        StatDwell: '每像素駐留時間',
        StatInspCurrentNote: '{{probe}} nm 束斑能承載的電流，上限 {{cap}} nA',
        StatInspCurrent: '束流',
        StatElectronsPxNote: '以訊雜比 {{snr}} 看到對比度 {{c}}% 的缺陷',
        StatElectronsPx: '每個像素需要的電子數',
        InspWafer: '每小時一整片晶圓',
        InspHere: '目前像素',
        InspOptical: 'INSP-13 光學掃描（最小能看到 {{nm}} nm）',
        InspEbeam: '電子束',
        InspY: 'log₁₀ 每小時 mm²',
        InspX: '像素尺寸 (nm)',
        InspTitle: '每小時檢測面積與像素尺寸的關係',
        ScanNote: 'CD-SEM ' +
          '從來看不到「寬度」。電子束逐點掃過時，它數的是從樣品逃逸出來的慢電子；靠近側壁時電子既能從頂面也能從側壁逃出，所以邊緣發亮。它報出的數字，是訊號在「間隙基線到峰值」之間某個選定比例處的穿越點——移動閾值，同一條線就量得更寬或更窄；側壁傾斜，答案就在頂部寬度和底部寬度之間移動。這個偏差要對照截面來校準。校準不掉的是計數：平均更多幀，重複量測的離散按平方根縮小，而每多一個電子，被量的光阻就會多收縮一點。',
        KnobSidewall: '側壁偏離垂直的角度',
        KnobHeight: '光阻高度',
        KnobLineCd: '線條底部寬度',
        KnobFrames: '平均幀數',
        KnobThreshold: '邊緣閾值',
        ScanRepeat: '重複四十次',
        ScanAgain: '再量一次',
        ScanRun: '掃描線條',
        ScanStale: '樣品或電子束變了——按「掃描線條」重新量測。',
        ScanStatus: '用上面電子光學柱的 {{probe}} nm 束斑、{{e}} eV 掃描。',
        ScanProgress: '正在掃描線條……{{pct}}%',
        StatPrecisionNote: '平均 {{mean}} nm',
        StatPrecision: '精密度，重複 40 次',
        StatDoseNote: '{{pa}} pA，每像素 {{dwell}} ns，{{frames}} 幀，平均 {{lines}} 條掃描線',
        StatDose: '每像素電子數',
        StatBiasNote: '機台要對照截面校準掉的部分',
        StatBias: '相對半高處線寬的偏差',
        StatCdNote: '閾值 {{threshold}}%；真實線寬頂部 {{top}} nm，底部 {{bottom}} nm',
        StatCd: '量得線寬',
        SignalCd: '邊緣 · {{cd}} nm',
        SignalMeasured: '實測，{{frames}} 幀',
        SignalExpected: '期望值（蒙地卡羅）',
        SignalY: '每個入射電子的二次電子數',
        SignalX: '束斑位置 (nm)',
        SignalTitle: '橫跨線條的二次電子訊號',
        ScanSilicon: '矽',
        ScanResist: '光阻',
        KnobAlpha: '會聚半角',
        KnobCurrent: '束流',
        KnobLanding: '著陸能量',
        ProbeNote: '把透鏡開大，繞射模糊就會縮小——電子是波，更寬的錐角聚得更細——但離軸遠的光線焦點偏短，能量不同的電子聚焦在不同深度，這兩者都隨角度增大。最佳束斑在它們交叉的地方。在幾百電子伏特時通常是色差項佔上風，所以上一節電子槍的能量展寬決定了解析度；要更大的電流會放大光源的像，用解析度換訊號。',
        StatGunUsedNote: '能量展寬 {{spread}} eV，來自上面的電子槍',
        GunSchottky: '蕭特基',
        GunCold: '冷場發射',
        StatGunUsed: '電子槍',
        StatBestNote: '在 {{a}} mrad',
        StatBest: '最佳可達',
        StatProbeNote: '繞射 {{d}}，色差 {{c}}，球差 {{s}}，源像 {{i}} nm',
        StatProbe: '此角度下的束斑',
        StatLambdaNote: '在 {{e}} eV——遠小於一個原子，卻仍然限制著束斑',
        StatLambda: '電子波長',
        ProbeHere: '設定',
        ProbeBest: '最佳角',
        ProbeSpherical: '球差',
        ProbeChromatic: '色差，來自電子槍的能量展寬',
        ProbeDiffraction: '繞射，0.54 λ/α',
        ProbeTotal: '束斑',
        ProbeY: '包含一半電流的直徑 (nm)',
        ProbeX: '會聚半角 (mrad)',
        ProbeTitle: '束斑尺寸與會聚角的關係',
        GunNote: '在每奈米幾伏特的電場下，鎢針尖外面的真空變成一道不到一奈米寬的位障，電子穿隧過去——這就是 Fowler-Nordheim 穿隧，和 THRM-04 ' +
          '的閘氧化層被偏壓推過能帶偏移時進入的是同一個區間。電流來自同一個傳遞矩陣，只是把氧化層換成了真空，再對金屬中的電子積分；沒有人告訴它 ' +
          'Murphy-Good ' +
          '方程式，它卻落在了方程式上。把針尖加熱並鍍膜以降低功函數，同樣的計算就變成蕭特基發射體：電子翻越被電場拉低的位障。它更穩定，能量展寬也更大——下一節會把這變成更大的束斑。',
        KnobField: '針尖處的引出電場',
        EmitterSchottky: '蕭特基，ZrO/W，1800 K',
        EmitterCold: '冷場發射，W，300 K',
        KnobEmitter: '發射體',
        StatBrightnessNote: 'A/(m²·sr·V)——一個小而準直的束斑能攜帶多少電流',
        StatBrightness: '約化亮度',
        StatTopNote: '高於費米能階，已被電場和鏡像電荷拉低',
        StatTop: '位障頂',
        StatSpreadNote: '出射電子的半高全寬——決定下面的色差模糊',
        StatSpread: '能量展寬',
        StatJNote: '{{r}} nm 針尖發出 {{i}} µA',
        StatJ: '電流密度',
        FnSeries: '穿隧處是一條直線',
        FnY: 'ln(J / F²)',
        FnX: '1 / 電場 (nm/V)',
        FnTitle: 'Fowler-Nordheim 圖',
        JfHere: '目前電場',
        JfMg: 'Murphy-Good 方程式',
        JfTmm: '傳遞矩陣（THRM-04 引擎）',
        JfY: 'log₁₀ 電流密度 (A/m²)',
        JfX: '針尖處電場 (V/nm)',
        JfTitle: '電流密度與電場的關係',
        GunWidth: '要穿隧 {{w}} nm',
        GunX: '進入真空的距離 (nm)',
        GunOut: '出射',
        GunMetal: '針尖',
      },
      euv: {
        NextPower: '這週機器慢了四分之一，而光源已經滿功率。你會先把功率計放在電漿和晶圓之間的哪個位置？每個讀數又能排除什麼？',
        TitlePowerWph: '每小時晶圓數隨光源功率的變化',
        LabelMirrorHeat: '進入鏡子的熱量',
        LabelWphHigh: '最高功率下的產出',
        LabelWphLow: '最低功率下的產出',
        HypPower: '曝光時間等於劑量除以晶圓處的功率，所以光源翻倍應該讓它減半。但晶圓還要花時間裝載、對準和步進，這些時間裡根本沒有光。如果這份固定開銷是真的，產出的增長就應該比功率慢，並趨向一個任何光源都抬不高的上限。',
        AskedPower: '光源功率能換來多少產出？',
        SumPower: '光源功率對產出：收益遞減，代價是鏡子上的熱。',
        NextDose: '金屬氧化物光阻對到達它的光子的吸收是原來的三倍。你會把這份好處花在更低的劑量上，還是更平滑的邊緣上？廠裡誰會替哪一邊說話？',
        AxisWph: '每小時晶圓數',
        TitleDoseWph: '每小時晶圓數隨劑量的變化',
        AxisLer: 'LER 3σ (nm)',
        TitleDoseTrade: '粗糙度和產出隨劑量的變化',
        LabelWphLost: '讓出的產出',
        LabelLerHigh: '最高劑量下的粗糙度',
        LabelLerLow: '最低劑量下的粗糙度',
        HypDose: '邊緣之所以粗糙，是因為它是由數得清的光子畫出來的，而計數雜訊與計數的平方根成反比。如果事情就這麼簡單，劑量翻兩番應該讓粗糙度大約減半——而曝光要用固定的光束給出這份劑量，時間就要四倍。',
        AskedDose: '劑量換來什麼，又花掉什麼？',
        SumDose: '劑量用產出換平滑的邊緣：散粒雜訊對曝光時間。',
        knob: {
          sourceW: '中間焦點處的光源功率',
          doseMjCm2: '曝光劑量',
        },
        AssistantBlurb: '問問劑量要花多少每小時晶圓數，或者更高的光源功率到底能換來什麼。每個回答都是用這份配方把從電漿到晶圓的整條鏈跑一遍。',
        AssistantLead: 'EUV-22 探究助手',
        TileIfNote: '其中 {{heat}} W 最終用來加熱了鏡子',
        TileIf: '中間焦點功率',
        TileLerNote: '實際給出的劑量為 {{dose}} mJ/cm²',
        TileLer: '線邊緣粗糙度',
        TileWphNote: '到達晶圓的功率 {{w}} W',
        TileWph: '產出',
        SectionTool: '本班次的曝光機：光子進，晶圓出',
        fault: {
          doseSensorOverReads: {
            Evidence: [
              '監控片粗糙度超限，而整條光路上的功率都正常。任何光損失都不會造成這種情況。',
              '產出高於額定值。這台機器上其他任何故障都只會讓它變慢。',
              '工件台上的參考光電二極體讀到的只有劑量感測器回報值的 80%。',
            ],
            Truth: '狹縫能量感測器漂了，它回報的劑量比實際給出的多五分之一，於是機器每次曝光都提前結束。配方要 40 mJ/cm²，晶圓只拿到 ' +
              '32。粗糙度就是光子散粒雜訊，與劑量的平方根成反比，所以邊緣粗糙了約十分之一，而機器變快也正是出於同一個原因。好消息和壞消息是同一個故障。',
            Complaint: '沒人抱怨這台機器。它的產出比額定值高了百分之十，班長把這寫進週報當作好消息。SEM-23 卻把最近三批都標記為邊緣粗糙。',
            Label: '劑量感測器讀數偏高',
          },
          carbonOnOptics: {
            Evidence: [
              '中間焦點功率達標；晶圓處功率相對它低了四分之一。損失在曝光機內部。',
              '逐鏡檢查讀到 68%，本應是 70%。',
              '電漿處的脈衝能量正常。',
            ],
            Truth: '每面投影鏡都因為光束自己從殘餘碳氫化合物裡裂解出的碳而損失了兩個點的反射率。兩個點聽起來不算什麼。但從中間焦點到晶圓有十一次反射，0.68 ' +
              '的十一次方只有 0.70 的十一次方的四分之三。多層膜沒有任何餘量可讓。',
            Complaint: '產出下降了約六分之一。中間焦點處的光源功率完全達標，所以光源組已經關閉了他們的工單。',
            Label: '投影鏡上長碳',
          },
          tinOnCollector: {
            Evidence: [
              '電漿處的脈衝能量正常，而中間焦點功率低了 40%。損失發生在這兩者之間，而兩者之間只有收集鏡。',
              '晶圓處功率與中間焦點功率成比例：投影光學系統把收到的光都傳了下去。',
              '遠場成像顯示收集鏡只有乾淨時的 60%。',
            ],
            Truth: '錫屑在收集鏡上越積越多，現在它的反射率只有乾淨時的約 ' +
              '60%。光源組說得對：電漿發出的光一點不少。光是丟在它遇到的第一面鏡子上的，而那正是整台機器裡唯一一面直接對著每秒五萬次錫爆炸的鏡子。',
            Complaint: '產出已經連續下滑三週，現在低了約四分之一。光源組說他們的脈衝能量穩如磐石。',
            Label: '收集鏡上有錫',
          },
          dropletTimingDrift: {
            Evidence: [
              '電漿處的脈衝能量降到了合格值的 60%。髒的收集鏡做不到這一點：它在電漿之後。',
              '中間焦點功率下降了同樣的比例，所以在收集鏡上沒有額外損失。',
              '時序掃描發現主脈衝滯後。',
            ],
            Truth: '主脈衝到得晚了，預脈衝壓扁的液滴已經漂出焦點，所以每一發只產生應有帶內光的約 ' +
              '60%。光是在電漿處就缺了——它根本沒被產生出來——而收集鏡對收到的光反射得很好。換收集鏡要花三十小時，卻什麼也改變不了。',
            Complaint: '自從更換液滴產生器噴嘴後，產出下降了約四分之一。夜班認為收集鏡終於被錫糊滿了，想預約更換。',
            Label: '雷射脈衝沒打中液滴',
          },
          euvHealthy: {
            Evidence: [
              '電漿、中間焦點和晶圓處的功率都正常。',
              '監控片上的粗糙度正常。',
            ],
            Truth: '沒有任何問題。正確的判斷是繼續曝光。',
            Complaint: '例行班次。產出符合計畫，監控片在規格內。',
            Label: '一切正常',
          },
        },
        reading: {
          doseCrossCheck: {
            Label: '用工件台上的參考光電二極體核對劑量 (2.0 h)',
          },
          opticsTransmission: {
            Label: '開機檢修時逐鏡穿透率檢查 (6.0 h)',
          },
          collectorImage: {
            Label: '收集鏡遠場成像 (2.0 h)',
          },
          dropletTiming: {
            Limit: '命中',
            Label: '光源液滴-脈衝時序掃描 (1.5 h)',
          },
          lerMonitor: {
            Label: '監控片上的線邊緣粗糙度',
          },
          waferPower: {
            Label: '晶圓處功率與中間焦點功率之比',
          },
          ifPower: {
            Label: '中間焦點功率',
          },
          plasmaEnergy: {
            Label: '電漿處的帶內脈衝能量',
          },
        },
        aspect: {
          doseControl: {
            Action: '用參考光電二極體重新校準狹縫能量感測器',
            Label: '劑量感測器',
          },
          optics: {
            Action: '對投影鏡執行原位氫自由基清洗',
            Label: '投影光學系統',
          },
          collector: {
            Action: '換上一塊乾淨的收集鏡，把這塊送去除錫',
            Label: '收集鏡',
          },
          source: {
            Action: '重新校準預脈衝和主脈衝與液滴的時序，並重新對準液滴流',
            Label: '液滴產生器與雷射時序',
          },
        },
        SecondaryLabel: '線邊緣粗糙度',
        ToolLabel: 'EUV-22 錫光源 EUV 曝光機',
        GuardNoPrint: '還沒有印出任何圖形。先讓上面的列印部分算完，這樣批次才會按有人看過的配方曝光。',
        NoteWouldExpose: '這個批次將以 {{dose}} mJ/cm² 曝光，邊緣粗糙度 {{ler}} nm 3σ。',
        ExposeLot: '曝光晶圓並送往 CD-SEM',
        NoteNoLot: '吸盤上沒有批次。把塗好光阻的晶圓帶到這裡來曝光。',
        SectionPrint: '用數得清的光來印圖',
        SectionCascade: '一個光子，一簇電子（蒙地卡羅）',
        SectionThroughput: '從光源的瓦數到每小時晶圓數',
        AbsorbCar: '聚合物 CAR',
        AbsorbCarF: '含氟 CAR',
        AbsorbMorSn: '錫氧 MOR',
        AbsorbMorHf: '鉿氧 MOR',
        AbsorbSi: '矽（基板）',
        AbsorbBar: '{{el}}：以 {{mass}}% 的質量貢獻 {{share}}% 的 μ',
        AbsorbElementsTitle: '誰在吸收：依元素分解的 μ',
        AbsorbElementsX: '膜中的元素',
        AbsorbElementsY: 'μ 的分量（每 µm）',
        AbsorbWithout: '不加該原子',
        AbsorbCurveTitle: '膜吸收了多少光',
        AbsorbCurveX: '膜厚（nm）',
        AbsorbCurveY: '吸收（%）',
        AbsorbShort: 'μ = {{mu}} 每 µm · 吸收了 {{pct}}% 的光子',
        AbsorbHelp: '完整的光子收支',
        AbsorbStatus: 'μ = 每 µm {{mu}} · 衰減長度 {{length}} nm · 每 nm² {{incident}} 個光子中吸收 {{absorbed}} 個（{{pct}}%）· 頂部 5 nm 得到的是底部 5 nm 的 {{ratio}} 倍',
        AbsorbGain: '依質量加入 {{pct}}% 的 {{el}}，在密度不變時 μ 提高到 {{factor}} 倍。金屬氧化物光阻還同時帶來了更高的密度。',
        AbsorbResist: '光阻',
        AbsorbThickness: '膜厚',
        AbsorbDose: '劑量',
        AbsorbAdd: '加入一種原子',
        AbsorbAddNone: '不加',
        AbsorbAddFraction: '其質量分率',
        SectionAbsorb: '光阻留住多少光子——逐個原子的吸收（光電截面）',
        AbsorbNote: '上面的級聯從一個被吸收的光子開始，下面的印製在數光子，但劑量把光子送到的是膜表面，而不是膜內。在 92 eV，吸收就是光電效應，別無其他，因此膜的衰減是對其原子的加總：μ = ρ Σ wᵢ(μ/ρ)ᵢ，每種元素的截面由其內層電子決定。依原子計，錫的吸收約為碳的三十倍，氧約為三倍半，氫幾乎為零。依質量計差距小得多，所以把聚合物質量的十分之一換成錫，吸收只增加約六分之一；金屬氧化物光阻靠的是含量與密度兩者兼得。看長條圖：在聚合物中氧的吸收超過其質量占比，在錫簇中錫承擔了大部分 μ。35 nm 的聚合物膜大約每七個光子留住一個，而更暗、更厚的膜頂部得到的劑量多於底部，於是印出傾斜的側壁。截面取自 Henke 表在 91.84 eV 處的數值，錫與鉿分別處在 4d 與 4f 共振上，最不確定；被吸收的光子接下來做什麼，是級聯部分的事。',
        SectionMirror: '反射鏡：四十對鉬和矽（傳遞矩陣）',
        SectionSource: '光源：在 13.5 nm 發光的錫離子',
        PrintNote: '每平方奈米得到的光子數是圍繞空間像所要求值的卜瓦松隨機數，每個光子把它的酸拋出幾奈米遠，烘烤把它們模糊，酸夠多的地方光阻被顯影掉。這裡沒有人告訴模型粗糙度與劑量的平方根成反比——是計數本身做到了這一點。提高劑量，邊緣變平滑而線條變細；為了產能降低劑量，邊緣就會變粗糙，直到越過一個懸崖，某處的間隙被橋接或線條斷開。更長的酸擴散能掩蓋雜訊，但也一起模糊了影像。額定劑量是光阻化學家手裡的旋鈕：它決定半節距線條在哪個劑量下印出來。',
        PrintSweep: '掃描劑量',
        PrintAgain: '再曝一片晶圓',
        Na055: '高 NA 0.55',
        Na033: 'NA 0.33',
        KnobSizeDose: '光阻額定劑量',
        KnobDiffusion: '烘烤中的酸擴散',
        KnobPitch: '線條節距',
        KnobPrintDose: '劑量',
        PrintScale: '沿線方向 {{w}} nm · 橫向 {{h}} nm',
        PrintWorking: '正在逐個光子曝光……',
        StatNilsNote: '空間像對比度 {{contrast}}%',
        StatNils: '影像對數斜率',
        StatFailuresNote: '{{rows}} 列線條中斷線 {{breaks}} 列、橋接 {{bridges}} 列',
        StatFailures: '隨機失效',
        StatLerNote: '沿邊緣的 3σ；線寬粗糙度 {{lwr}} nm',
        StatLer: '線邊緣粗糙度',
        StatCdNote: '目標 {{half}} nm，即半個節距',
        StatCd: '印出的線寬',
        StatPhotonsNote: '其中 {{abs}} 個被光阻吸收',
        StatPhotons: '每 nm² 光子數',
        SweepHere: '目前曝光',
        SweepFail: '斷線或橋接的列數 ÷ 20',
        SweepLer: '線邊緣粗糙度',
        SweepY: 'LER 3σ (nm) · 失效列數 ÷ 20',
        SweepX: '劑量 (mJ/cm²)',
        SweepTitle: '粗糙度與失效隨劑量的變化（每個劑量換用對應額定的光阻）',
        CascadeNote: '一個 92 eV ' +
          '的光子被一個原子吸收，原子射出一個帶走大部分能量的光電子。這個電子再撞出別的電子，每次游離花掉大約十電子伏特，直到沒有一個快到還能游離；慢電子停下的地方，光酸產生劑可以把它們捕獲並釋放出酸。所以圖形並不寫在光落下的地方，而是寫在它周圍幾奈米的範圍裡，而且每個光子產生多少酸本身就是隨機的。金屬氧化物光阻的吸收強四倍——又是錫的 ' +
          '4d 電子，和光源裡發光的是同一批——而且它的膜更緻密，電子停得更早。',
        CascadeFire: '再吸收七個光子',
        ResistMor: '金屬氧化物光阻（錫）',
        ResistCar: '化學放大光阻（聚合物）',
        KnobResist: '光阻',
        StatAbsorbedNote: '到達 {{t}} nm 光阻的光子中',
        StatAbsorbed: '膜層吸收',
        StatBlurNote: '相對光子落點的橫向均方根距離',
        StatBlur: '電子模糊',
        StatElectronsNote: '光電子以及它釋放出的每個二次電子',
        StatElectrons: '每個光子的電子',
        StatEventsNote: '{{blank}}% 的光子一個都沒產生',
        StatEvents: '每個光子的酸',
        HistSeries: '1500 個光子',
        HistY: '光子比例',
        HistX: '一個光子引發的化學事件數',
        HistTitle: '每個被吸收光子產生的酸',
        CascadeEvent: '化學事件',
        CascadeAcid: '生成的酸',
        CascadeSecondary: '二次電子',
        CascadePhotoelectron: '光電子',
        CascadePhoton: '被吸收的光子',
        CascadeSubstrate: '底層',
        KnobMirrors: '光源之後的反射鏡數',
        KnobMirrorR: '每面反射鏡的反射率',
        KnobDose: '光阻劑量',
        KnobSource: '中間焦點處的光源功率',
        WphNote: '每一環都是相乘。十幾次 70% 的反射只剩不到 2%，整形出均勻的狹縫又去掉一半，所以光源處的 250 W ' +
          '到晶圓上只有兩瓦半左右。把光阻所需劑量減半，機台產出幾乎翻倍——這就是光阻化學家和光源工程師在爭同一件事的原因，也是下一節要展示降低劑量代價的原因。',
        StatWph: '產能',
        StatExposureNote: '另加每片 {{overhead}} s 不是曝光的時間：換片、對準、步進',
        StatExposure: '每片晶圓的曝光時間',
        StatWaferNote: '而反射鏡一路吸收了 {{heat}} W',
        StatWafer: '到達晶圓的功率',
        StatTransmissionNote: '{{n}} 次反射，照明系統在整形狹縫時只保留 {{keep}}%',
        StatTransmission: '光學系統穿透率',
        WphHere: '目前配方',
        WphSeries: '光源 {{w}} W',
        WphY: '每小時晶圓數',
        WphX: '劑量 (mJ/cm²)',
        WphTitle: '每小時晶圓數與光阻所需劑量的關係',
        MirrorNote: '任何材料對 13.5 nm ' +
          '光的折射都只差幾個百分點，所以單一表面反射不了多少。把一種重金屬和一種輕的間隔層交替疊起來，每對厚半個波長，八十個界面上微弱的反射就會同相疊加。內部的駐波把暗的波節放在鉬裡——正是光會被吸收的地方。粗糙的界面讓反射鏡賴以反射的台階變得模糊；光本身從真空裡裂解出來的碳則在表面上吸收。一台曝光機裡這樣的反射連著有十幾次，所以一面鏡子損失一個百分點，就要損失十二次。',
        KnobAngle: '入射角',
        KnobCarbon: '鏡面上沉積的碳',
        KnobRough: '界面粗糙度',
        KnobPairs: '膜對數',
        KnobGamma: '鉬佔週期的比例',
        KnobPeriod: '週期',
        MirrorSolving: '正在求解膜系……',
        StatBestNote: '目前設定：{{now}} nm',
        StatBest: '13.5 nm 的最佳週期',
        StatChainNote: '連續 {{n}} 次反射，在 13.5 nm',
        StatChain: '穿過整台曝光機',
        StatFwhmNote: '峰值一半處的全寬',
        StatFwhm: '頻寬',
        StatRNote: '峰值 {{peak}}%，位於 {{at}} nm',
        StatR: '13.5 nm 處的反射率',
        PairsHere: '目前膜系',
        PairsSeries: '反射率',
        PairsY: '13.5 nm 處的反射率 (%)',
        PairsX: 'Mo/Si 膜對數',
        PairsTitle: '再多加膜對也沒用',
        MirrorEdge: 'Si L 吸收邊',
        MirrorChain: '經過整條反射鏡鏈之後，×20',
        MirrorSeries: '目前膜系',
        MirrorY: '反射率 (%)',
        MirrorX: '波長 (nm)',
        MirrorTitle: '單面反射鏡隨波長的變化',
        FieldX: '距表面的深度 (nm)',
        FieldTitle: '反射鏡頂部內部的 |E|²',
        SourceNote: '這條階梯是算出來的：每一級都是該離子薛丁格方程式的自洽解，凡是 NIST ' +
          '有資料的地方都與之吻合。電荷態分布也是在它上面算出來的——電子碰撞游離與復合之間的平衡。離子在哪裡發光則是量出來的，不是算出來的：單電子計算把 ' +
          '4d→4f 躍遷放在 17 nm 附近，是 4d 與 4f 電子之間的交換作用——一種多電子效應——把 Sn⁸⁺ 到 Sn¹³⁺ 的光一起拉到了 ' +
          '13.5 nm。正是這種疊加，讓錫電漿在關鍵頻寬裡比黑體強五十倍。',
        LaserSolid: '固態雷射，1 µm',
        LaserCo2: 'CO₂，10.6 µm',
        KnobLaser: '驅動雷射',
        KnobTeValue: '{{ev}} eV · {{kk}} 千 K',
        KnobTe: '電子溫度',
        StatCeNote: '雷射能量中進入帶內的比例，在真實光源上量得',
        StatCe: '量產轉換效率',
        StatPhotonNote: '光是從 Sn¹⁰⁺ 再剝一個電子就要 {{ev}} eV——是一個離子發回的光子能量的兩倍多',
        StatPhoton: '一個光子',
        StatBlackNote: '同一頻寬裡——所以要譜線光源，所以要錫',
        StatBlack: '黑體只能放進',
        StatInBandNote: '這些離子的發射中落在 13.5 nm ± 1% 以內的部分',
        StatInBand: '帶內',
        StatMeanNote: '最多的離子是 Sn{{q}}+',
        StatMean: '平均電荷',
        ScanHere: '目前電漿',
        ScanSolid: '1 µm 雷射，10²¹ 電子/cm³',
        ScanCo2: 'CO₂ 雷射，10¹⁹ 電子/cm³',
        ScanY: '帶內光的比例 (%)',
        ScanX: '電子溫度 (eV)',
        ScanTitle: '雷射應該把電漿打到什麼溫度',
        SpectrumBand: '2% 頻寬',
        SpectrumBlack: '同溫度的黑體',
        SpectrumTin: '此溫度下的錫離子',
        SpectrumY: '發射功率，峰值 = 1',
        SpectrumX: '波長 (nm)',
        SpectrumTitle: '發射出來的光',
        ChargeBand: '這些離子在帶內發光',
        ChargeSeries: '離子',
        ChargeY: '佔錫的比例',
        ChargeX: '電荷態 q（錫離子 Sn q+）',
        ChargeTitle: '{{te}} eV 的電漿裡有哪些離子',
        LadderPhoton: '一個 13.5 nm 光子',
        LadderNist: '實測值（NIST）',
        LadderSolved: '求解值（Hartree-Fock-Slater）',
        LadderY: '游離能 (eV)',
        LadderX: '被游離離子的電荷態 q',
        LadderTitle: '階梯：再剝掉一個電子要多少能量',
      },
      panel: {
        HelpMore: '瞭解更多',
        AboutSim: '這裡展示了什麼，模型又省略了什麼',
        BenchKnobs: '旋鈕',
        BenchReadouts: '讀數',
        BenchRun: '執行',
        DownForPm: '在廠區裡，這台設備正因預防性維護而上鎖掛牌：外殼已拆下，裡面有一名技術員，所以它的螢幕和工作區看板都顯示停機。你在這裡操作的是它的合格製程，也就是維護結束後它要恢復運轉的那套製程。從這個面板運行的批次，就是按那套製程跑的，和摘牌之後一樣。',
        ValueOnTarget: '在目標上',
        SolverHeadMeasured: '實測',
        SolverHeadClosedForm: '解析式',
        SolverHeadSolved: '數值解',
        LabelClosed: '解析解',
        LabelSolved: '數值解',
        TravelCard: '流轉卡',
        ThermalBudgetLine: '熱預算：相當於 1000 °C 下 {{min}} 分鐘，共 {{steps}} 個高溫工步——足以讓硼移動約 {{nm}} nm',
        SectionStoredRecipes: '已存配方',
        SectionWafer: '晶圓',
        SectionLot: '批次',
        SectionProcessState: '製程狀態',
        SectionRecipe: '配方',
        SectionShift: '班次',
      },
      cleanroom: {
        NextThoseAddersBecomeCln09: '這些增量會變成 CLN-09 的來料顆粒數，再變成 INSP-13 的缺陷密度，再變成 PRB-14 ' +
          '的良率數字。沿產線追蹤其中一個，看看晶圓盒敞開一分鐘折合多少裸晶。',
        AxisXAirChangesPerHour: '每小時換氣次數',
        TitleRecoveryTimeAgainstAirChanges: '恢復時間隨換氣次數的變化',
        LabelDepositionVelocity: '沉降速度',
        NoteAfterFilterLoading: '濾網積塵之後',
        LabelEffectiveAch: '有效換氣次數',
        LabelRecovery: '恢復',
        HypSteadyStateConcentrationShouldGo: '穩態濃度應等於產生量除以通風量，所以換氣次數加倍應使濃度大約減半——絕對收益逐步遞減。恢復時間應以同樣方式下降。如果是這樣，通風就是一根價格陡漲的槓桿，而且只要房間裡有人，它就有一個跌不破的下限。',
        AskedWhatDoesVentilationBuyAnd: '通風買到了什麼？一次擾動的影響會持續多久？',
        SumAirChangesRecoveryTimeAnd: '換氣次數、恢復時間，以及敞開晶圓盒上的暴露時鐘。',
        NextEveryNumberHereIsPer: '這裡的每個數字都是按每分鐘暴露計的。問我暴露時間本身值多少——它是這張單子裡唯一由機台排程而不是由人控制的變數。',
        LabelWrongOrder: '順序錯誤',
        LabelStreetClothes: '便服',
        LabelPenetrationGowned: '穿透率，全套穿戴',
        HypEachGarmentIsAFilter: '每件潔淨服都是一個過濾器，串聯的過濾器是相乘而不是相加——所以整套組合應遠好於任何單件，而去掉一件的代價應遠大於那件看上去單獨貢獻的量。順序重要也是同一個道理：在更髒的一件之後穿上的衣服，還沒開始工作就已被污染。',
        AskedHowMuchDoesTheGowning: '更衣規程實際買到了多少？',
        SumGarmentPenetrationAsAProduct: '潔淨服穿透率是一個乘積，以及為什麼穿戴順序是一條規則。',
        NextTheDownflowCarriesParticlesFrom: '下行氣流把顆粒從人站的位置帶向他下方和下游的一切。既然如此，裝載埠敞開時你該站在走道的哪裡——牆上的監測器能告訴你你站錯了嗎？',
        LabelRoomAverageTheMonitor: '全室平均（監測器）',
        LabelWorkZone: '工作區',
        AxisYParticlesM: '顆粒/m³',
        AxisXPeopleInTheBay: '區間內人數',
        TitleRoomAverageAndWorkZone: '全室平均與工作區濃度隨人數的變化',
        LabelZoneRoom: '工作區 / 全室',
        LabelWaferSees: '晶圓感受到',
        LabelMonitorReads: '監測器讀數',
        HypACeilingMonitorMeasuresA: '天花板監測器測的是全室平均，而平均假定污染源均勻分佈在房間裡。站在機台前的人不是均勻分佈的——他是距離敞開產品一米的點源。如果這一點重要，工作區濃度就應明顯高於全室平均，而且每多一個人差距就該拉大。',
        AskedIsTheNumberOnThe: '牆上的數字是晶圓感受到的數字嗎？',
        SumRoomAverageAgainstWorkZone: '全室平均對工作區，以及為什麼牆上的監測器可以既正確又沒用。',
      },
      intents: {
        NextHoldingIsTheEasyHalf: '扣住是簡單的那一半。已經放在裝載口的那批貨現在怎麼辦？在你把它判為報廢而不是等待之前，還需要知道什麼？',
        NextAQualPassesOnTheDay: '資格認定只對做它的那一天有效。下一批要看到什麼，你才會認定這次只是運氣好而不是機台真的健康？在你相信任何一種結論之前，又想看多少片？',
        LabelBenchReadings: '檯面讀值',
        LabelNonUniformity: '不均勻度',
        LabelMonitorRate: '監控片速率',
        VerdictWithAWatchItem: '放行，但有一項要盯著',
        VerdictHeld: '扣住',
        VerdictQualified: '已認定',
        LabelVerdict: '判定',
        HypAQualificationIsADecision: '資格認定是一個決定，不是一段解釋。只要監控片落在規格視窗內，而且檯面上每一項讀值都在各自限值內，機台就放行；任何一項不合格就扣住。再用標稱腔體跑一次、用已認定配方跑一次，就足以指出是哪一邊的責任，不必做完整診斷。',
        AskedIsThisToolFitToRun: '這台機台現在能不能跑產品，如果不能該怎麼辦？',
        SumRunTheMonitorWafer: '跑一片監控片，把檯面讀值逐項對照限值，然後做出放行判斷。',
        LabelAsFound: '發現時狀態',
        LabelNoEffect: '無效果',
        AxisYRecovered: '找回比例 %',
        AxisXCandidateRanked: '候選項（按排名）',
        TitleHowMuchEachSingleRepair: '每項單獨修復各能找回多少',
        LabelDeviationAsFound: '發現時的偏差',
        LabelSeparation: '區分度',
        LabelNextBest: '次佳候選',
        LabelMostLikelyCause: '最可能的原因',
        HypIfASingleChamberAspect: '如果罪魁是腔體的某一項，那麼把恰好那一項——且只有那一項——恢復到標稱值就應能找回結果，而恢復其他任何一項都不行。如果沒有任何單項恢復有效，原因就不在腔體。',
        AskedTheRecipeHasNotChanged: '配方沒變，結果卻變了。腔體裡是什麼動了？',
        SumIsolateAChamberFaultBy: '每次只恢復一個嫌疑項，以此隔離腔體故障。',
        AxisYNonUniformity: '非均勻性 %',
        LabelBestUniformity: '最佳均勻性',
        LabelRateChange: '速率變化',
        LabelAtYourSetting: '你的設定下',
        SumSweepAnySingleRecipeKnob: '掃描配方中任意一個旋鈕，同時看到所有後果。',
        LabelHeavyLoad: '重負載',
        TitleRadialRateTheSpreadThat: '徑向速率——決定過蝕刻窗口的分散',
        LabelMeanRate: '平均速率',
        LabelNuHeavyLoad: '重負載 NU',
        LabelNuAsRunning: '當前 NU',
        HypOpticalEmissionFromTheEtch: '蝕刻產物的光學發射在薄膜清除時下降，所以曲線標出了終點。但晶圓不是一下子全部清乾淨的——它在由均勻性決定的窗口內逐漸清除——所以所需的過蝕刻，以及期間損失的氧化層，都應隨非均勻性放大。',
        AskedHowIsTheEndOf: '蝕刻的終點是怎麼偵測的？需要多少過蝕刻？',
        SumEndpointDetectionOveretchAndWhat: '終點偵測、過蝕刻，以及非均勻性在下游的代價。',
        NextTheSheathIsThinnerThan: '在這個氣壓下鞘層比離子平均自由程還薄，所以離子不經碰撞穿過鞘層，以窄能量帶到達。氣壓升到一定程度，這就不再成立。當離子開始以各種角度到達時，剖面會怎樣？',
        AxisXSourcePowerW: '源功率 (W)',
        TitleEtchRateVersusSourcePower: '固定偏壓下蝕刻速率隨源功率的變化',
        NoteImprovesWithSofterIons: '離子更柔和時反而改善',
        LabelRate2001600W: '速率，200 -> 1600 W',
        NoteScale: '尺度',
        DesignSourcePowerSwept200To: '源功率從 200 掃到 1600 W，偏壓功率恆定。在每個點求解放電，得到電漿密度、波姆通量、由功率平衡得到的鞘層電壓，以及由 Child ' +
          '定律得到的鞘層厚度。',
        HypTheBiasSupplyDeliversA: '偏壓電源向穿越鞘層的離子輸送固定的瓦數。因此每個離子的能量就是瓦數除以離子電流。如果這是對的，提高源功率——製造更多離子——應讓每個離子的能量更低，儘管偏壓設定從未動過。',
        AskedWhereDoesIonBombardmentEnergy: '離子轟擊的能量從哪裡來？哪個旋鈕控制它？',
        NextBiasRaisesIonEnergySource: '偏壓提高的是離子能量。源功率提高的是離子數量。如果你需要更高速率又不想丟選擇比，該伸手去動哪一個——把源功率調高時，鞘層又會對離子能量做什麼？',
        AxisXBiasPowerW: '偏壓功率 (W)',
        TitleRateAndSelectivityBothRespond: '速率和選擇比都響應偏壓——方向相反',
        LabelProfileAt200W: '200 W 時的剖面',
        LabelProfileAt0W: '0 W 時的剖面',
        LabelSelectivityAt500W: '500 W 時選擇比',
        LabelRateAt500W: '500 W 時速率',
        LabelOutOfReach: '無法企及',
        DesignBiasSweptFrom0To: '偏壓從 0 掃到 500 W，源功率、氣壓和流量固定。測量蝕刻速率、Si:SiO2 選擇比、側壁角度，以及相應的離子能量。',
        HypBiasPowerSetsIonEnergy: '偏壓功率決定離子能量，不決定離子數量。矽有自發的氟反應通道和很低的離子閾值；氧化物兩樣都沒有。所以提高偏壓應讓兩者都變快，但相對而言氧化物快得更多——也就是說，速率是拿選擇比買來的。',
        SumTradeRateAgainstSelectivityAnd: '在速率與選擇比、氧化層擊穿之間做取捨。',
        LabelLoadTheLowLoadProduct: '載入低負載產品',
        NextARecipeQualifiedOnA: '一個在開口率 15% 產品上認證過的配方，現在要跑開口率 65% ' +
          '的產品。你是重新定時，還是重新認證配方？問我：每種選擇在晶圓邊緣的氧化層損失上各要付出什麼。',
        TitleRadialProfileAtEachLoad: '各負載下的徑向分佈',
        LabelMeanRateL305: '平均速率',
        AxisXOpenAreaFraction: '開口面積比',
        TitleEtchRateVersusOpenArea: '蝕刻速率隨開口率的變化',
        LabelNuAtHeavyLoad: '重負載下的 NU',
        LabelLoadingRatio: '負載比',
        LabelRateAt90Open: '開口率 90% 時速率',
        LabelRateAt4Open: '開口率 4% 時速率',
        HypEveryExposedSquareMillimetreOf: '每一平方毫米裸露的矽都在爭奪同一份有限的氟供應。如果確實如此，速率應隨開口率上升而下降，同時晶圓的均勻性應變差——因為更重的負載把蝕刻推向輸運控制。',
        AskedWhyDoesAnIdenticalRecipe: '為什麼完全相同的配方在不同產品上給出不同的蝕刻速率？',
        LabelLoadARecipeThatRuns: '載入一個邊緣偏快的配方（開口率 90%）',
        LabelAsRunning: '當前狀態',
        AxisYFAtomsM3: 'F 原子 m⁻³',
        TitleEtchantDensityAtTheSurface: '表面蝕刻劑密度——速率背後的供應',
        AxisXRR0Centre: 'r / R (0 = 中心)',
        TitleEtchRateAcrossTheWafer: '沿晶圓半徑的蝕刻速率',
        LabelBestCondition: '最佳條件',
        LabelSignature: '特徵',
        HypAFastEdgeMeansThe: '邊緣快意味著晶圓邊緣比中心得到更充足的蝕刻劑供應。如果這是對的，任何提高供需比的做法——更多氣體、更小偏壓、更快擴散——都應把分佈拉平。如果全都無效，原因就根本不在供應。',
        AskedWhyDoesTheEtchRate: '為什麼蝕刻速率從中心到邊緣有傾斜？這裡的原因是什麼？',
        SumDiagnoseACentreToEdge: '診斷中心到邊緣的特徵，找出是哪種機制造成的。',
      },
      metro: {
        NextYouHaveOneAlarmAnd: '你手上有一次報警和一個被扣住的批次。扣批要花錢，把壞品發出去也要花錢。你接下來會測什麼來做決定？還要多少次額外讀數，答案才不再是拋硬幣？',
        LabelNoisyGauge: '偏吵的量具',
        LabelStepAt30: '第 30 批處的階躍',
        TitleTheDriftingRunMeasuredAnd: '漂移中的運行——實測值，以及背後的真相',
        LabelCpkNoisyGauge: 'Cpk，量具偏吵',
        LabelStepCaughtAfter: '階躍在此之後被抓住',
        LabelDriftCaughtAtLot: '漂移在此批次被抓住',
        NoteIn60LotsOfA: '來自從未移動過的製程的 60 個批次',
        LabelFalseAlarmsStable: '誤報警，穩定製程',
        HypControlRulesFireOnWhatever: '管制規則只對擺在它面前的東西報警，而擺在它面前的是製程加量具。所以完全穩定的製程也會產生報警；真正的漂移應先觸發連串規則、後觸發三西格瑪規則；更吵的量具會毀掉能力指數，而製程本身絲毫未變。',
        AskedTheChartFiredIsThe: '管制圖報警了。是製程在動，還是噪聲？',
        SumSeparateARealProcessDrift: '把真實的製程漂移與測量噪聲、與運氣區分開。',
        NextIfTheGaugeIsNot: '如果量具能力不足，你可以對多次讀數取平均來壓低它的噪聲。這要付出什麼代價？到什麼程度不如乾脆買台更好的機台？',
        LabelTightProcess: '嚴苛製程',
        LabelLooseProcess: '寬鬆製程',
        LabelThisProcess: '當前製程',
        NoteRepeatability: '重複性',
        DesignTwentyFiveRepeatMeasurementsOf: '對同一片不變的晶圓重複測量二十五次，再把這一重複性與三種不同的製程波動做比較。',
        HypAGaugeHasOneRepeatability: '量具有一個固定的重複性，但能力不是量具的屬性。它是測量分散與總分散之比。所以同一台機台，對寬鬆的製程應判為有能力，對嚴苛的製程應判為沒能力——而機台本身什麼都沒變。',
        AskedIsThisMeasurementToolCapable: '這台測量機台有能力看清它所監控的製程嗎？',
        SumCompareMeasurementSpreadWithProcess: '把測量分散與製程分散做比較——能力是一個比值。',
        NextIfTheResidualCannotTell: '如果殘差不能告訴你模型錯了，什麼能？想想第二種獨立的測量必須對什麼敏感，才能抓住這個問題。',
        LabelRecipeIndex: '配方折射率',
        LabelCorrectIndex: '正確折射率',
        TitleMeasuredSpectrumAndTheFitted: '實測光譜與擬合模型',
        LabelResidualRecipe: '殘差，配方模型',
        LabelResidualCorrect: '殘差，正確模型',
        LabelRecipeModel: '配方模型',
        LabelCorrectModel: '正確模型',
        HypTheToolMeasuresReflectedLight: '機台測的是反射光，不是厚度。它找的是模型光譜與所見最匹配的那個薄膜厚度。模型對，答案就該對；模型的折射率錯了，擬合仍會收斂，仍會報出一個自信的數字，但它是錯的——而殘差幾乎不會抱怨。',
        AskedTheToolReportedAThickness: '機台報出了一個厚度。它是對的嗎？',
        SumShowThatAMeasurementIs: '說明一次測量其實是一次模型擬合，因此可以精確地錯。',
      },
      dep: {
        TitleThicknessAcrossTheRadiusUnder: '各條件下沿半徑的厚度分佈',
        LabelBestCondition: '最佳條件',
        LabelParasitic: '寄生',
        LabelAsRunning: '當前狀態',
        HypAProperlySaturatedProperlyPurged: '飽和充分、吹掃充分的 ALD ' +
          '薄膜應幾乎完全均勻，因為無論流過多少氣體，每個位點都恰好接收一個分子。所以非均勻性意味著生長在某處跟隨了氣體輸送——要麼劑量從未飽和，要麼寄生 ' +
          'CVD 在 ALD 之上額外鍍膜。兩者的解決辦法不同，分別測試就能區分它們。',
        AskedIsThisThicknessMapA: '這張厚度分佈圖是劑量問題還是吹掃問題？',
        SumDecideWhetherAThicknessMap: '判斷一張厚度分佈圖是劑量問題還是吹掃問題。',
        TitleFlatWaferGrowthOverThe: '同一掃描範圍內平坦晶圓的生長——紋絲不動',
        LabelStepCoverage: '階梯覆蓋率',
        AxisYCoverageAtTheBottom: '底部覆蓋率 %',
        TitleStepCoverageVersusDoseExposure: '階梯覆蓋率隨劑量的變化——曝置才是槓桿',
        NoteAlreadySaturatedUpTop: '頂部早已飽和',
        LabelFlatGrowthUnchanged: '平面生長不變',
        LabelOnAFlatWafer: '平坦晶圓上',
        HypInsideADeepFeatureThe: '在深結構內部，前驅物靠在壁間反彈前進，每次反彈都是它在到達底部之前發生反應的機會。如果限制保形性的正是這一點，那麼解決辦法就是曝置——更長的劑量——它應能改善底部，而對平坦晶圓的生長毫無影響，因為平坦表面早已飽和。',
        SumShowWhyConformalityIsA: '說明為什麼保形性是劑量問題，而不是化學問題。',
        NextThePurgeHasToClear: '吹掃必須清空腔體，而腔體按駐留時間清空。如果提高載氣流量，能不能進一步縮短吹掃——還會改變什麼？',
        LabelCycleTime: '循環時間',
        AxisYSecondsPerCycle: '每循環秒數',
        TitleCycleTimeVersusPurgeTime: '循環時間隨吹掃時間的變化——你買到的產能',
        AxisXPurgeMs: '吹掃 (ms)',
        TitleParasiticCvdVersusPurgeTime: '寄生 CVD 隨吹掃時間的變化',
        LabelCycleTimeSaved: '節省的循環時間',
        LabelShortestSafePurge: '最短安全吹掃',
        LabelResidenceTime: '駐留時間',
        HypPurgingEmptiesTheChamberExponentially: '吹掃按氣體駐留時間以指數方式清空腔體。共反應物到達時仍殘留的前驅物會在氣相中直接反應，而不是等待空位——那就是 ' +
          'CVD。所以短吹掃應該買到循環時間，代價是寄生生長和均勻性，而不是生長速率。',
        AskedHowShortCanThePurge: '吹掃最短能到多短，製程才不至於不再是 ALD？',
        SumTradeCycleTimeAgainstParasitic: '在循環時間與寄生 CVD 和均勻性之間做取捨。',
        NextBothEndsOfTheWindow: '窗口的兩端都比中間長得更快。如果有人只給你看一個厚度數字，並告訴你機台溫度偏高，你如何把它與溫度偏低區分開？',
        LabelGrowthHere: '此處生長量',
        LabelParasiticHere: '此處寄生生長',
        LabelYourSetpoint: '你的設定點',
        HypAdsorptionNeedsHeatToComplete: '吸附需要熱量才能完成，但熱量過多會讓前驅物自行脫附或分解。如果這是對的，中間會有一個區間，生長平坦且基本全是自限制的，而兩端的寄生生長各因不同的原因上升。',
        AskedWhereIsTheTemperatureBand: '這個製程保持 ALD 特性的溫度區間在哪裡？',
        SumMapTheAldWindowAnd: '描繪 ALD 窗口，找出生長在哪裡不再自限制。',
        NextASaturatedDoseOnA: '在平坦晶圓上已飽和的劑量，仍可能讓深結構的底部得不到前驅物，因為前驅物必須在反應之前先到達底部。你的產品深寬比是多少？這個劑量在它的底部還飽和嗎？',
        AxisYNonUniformity: '非均勻性 %',
        TitleNonUniformityFollowsSaturation: '非均勻性跟隨飽和程度',
        AxisXDoseMs: '劑量 (ms)',
        LabelUniformityAtYourDose: '你的劑量下的均勻性',
        LabelDoseNeeded: '所需劑量',
        LabelSaturatedGrowth: '飽和生長量',
        LabelSelfLimiting: '自限制',
        HypIfTheSurfaceSaturatesGrowth: '如果表面會飽和，每循環生長量會隨劑量上升然後走平，拐點之後的一切都完全相同。如果它繼續上升，表面就不是限制因素，這個製程就是披著 ALD 配方外衣的 ' +
          'CVD。',
        AskedDoesGrowthStopRespondingTo: '生長會不會不再隨劑量變化——這個製程真的是自限制的嗎？',
        NextDoseCost: '延長劑量脈衝能修好溝槽，但也會拉長你全部 {{cycles}} 個循環中的每一個。算一算這在運行時間上的代價，再決定提高前驅物分壓是否能更便宜地買到同樣的暴露量。',
        SumSweepDoseTimeAndFind: '掃描劑量時間，找出生長在哪裡不再響應。',
      },
      config: {
        LabelDeepseek: 'DeepSeek',
      },
      route: {
        step: { wellDriveIn: '阱區推進', gateOxidation: '閘極氧化', spacerDensify: '側牆緻密化', spikeAnneal: '尖峰退火' },
        stepPurpose: {
          'a-day-per-cooldown-the-test-is-the-bottleneck': '每次降溫要一天：測試就是瓶頸',
          'aluminium-wire-which-goes-superconducting-with-the-chip': '用鋁線，它會和晶片一起進入超導態',
          'a-fridge-takes-a-chip-not-a-wafer': '冷凍機放的是晶片，不是晶圓',
          'area-sets-the-frequency-and-ten-percent-wide-is-a-collision': '面積決定頻率，寬百分之十就會發生頻率碰撞',
          'a-nanometre-of-aluminium-oxide-counted-in-cycles': '一奈米的氧化鋁，按循環數來數',
          'transfer-it-into-the-superconducting-film': '把圖形轉移到超導薄膜裡',
          'capacitor-pads-resonators-and-the-junction-leads': '電容極板、共振器和接面的引線',
          'a-lossy-surface-is-a-lossy-qubit': '表面有損耗，量子位元就有損耗',
          'bin-it-and-decide-what-escapes': '分檔，並決定什麼會漏出去',
          'and-the-die-is-under-183-mpa-for-the-rest-of-its-life': '裸晶此後終生承受 183 MPa',
          'onto-a-substrate': '裝到基板上',
          'and-the-wafer-stops-being-a-wafer': '晶圓從此不再是晶圓',
          'the-first-honest-yield-number-anyone-has-had': '所有人拿到的第一個真實良率數字',
          'last-look-before-the-wafer-is-cut-up': '晶圓被切開前的最後一眼',
          'a-defect-free-doped-to-order-layer-over-the-bulk': '在體矽之上按需摻雜、無缺陷的一層',
          'before-it-is-allowed-into-the-front-end': '進入前段產線之前的一道關',
          'one-crystal-becomes-a-thousand-wafers': '一根晶體變成上千片晶圓',
          '72-hours-for-one-ingot-and-one-ingot-is-1000-wafers': '一根晶棒要 72 小時，而一根晶棒約合 1000 片晶圓',
          'the-next-layer-prints-on-this-surface': '下一層就印在這個表面上',
          'slurry-is-a-defect-if-it-is-left-on': '漿料留在上面就是缺陷',
          'take-off-everything-above-the-trench': '把溝槽以上的一切磨掉',
          'bottom-up-fill-and-an-overburden-for-cmp': '自底向上填充，並留給 CMP 一層餘量',
          'copper-poisons-silicon-so-it-is-fenced-in': '銅會毒化矽，所以要把它圈起來',
          'polymer-off-before-anything-is-deposited-on-it': '去掉聚合物，然後才能在上面沉積',
          'ash-the-resist-off-before-anything-is-deposited': '在沉積任何東西之前先把光阻灰化去除',
          'and-the-wire-that-sits-on-top-of-the-via': '以及騎在通孔上方的那條導線',
          'down-to-the-layer-below': '一直打到下一層',
          'where-the-wires-go': '導線要走的地方',
          'the-insulator-the-trenches-go-into': '溝槽所在的絕緣層',
          'because-everything-after-this-assumes-it-worked': '因為後面的一切都假定這一步成功了',
          'activate-the-dopant-and-move-it-as-little-as-possible': '活化摻雜並儘量少讓它移動',
          'self-aligned-to-the-gate-that-was-just-etched': '與剛蝕出的閘自對準',
          'the-gate-electrode': '閘電極',
          'the-thinnest-most-consequential-film-in-the-device': '元件中最薄、影響最深遠的一層膜',
          'deep-and-expensive-in-budget': '很深，而且很耗熱預算',
          'the-tub-the-device-sits-in': '元件棲身的那口阱',
          'a-furnace-drives-contamination-in-it-does-not-remove-it': '爐管會把污染往裡驅入，而不是去除它',
          'print-one-line-in-four': '每四條線曝印一條',
          'four-lines-where-there-was-one': '一條線變成四條',
          'anisotropic-again': '再來一次非等向性蝕刻',
          'the-first-spacers-are-now-the-mandrels': '第一層側壁現在成了芯軸',
          'two-lines-where-there-was-one': '一條線變成兩條',
          'anisotropic-clears-the-horizontals': '非等向性：清掉水平面',
          'ald-this-thickness-sets-the-half-pitch': 'ALD——這層厚度決定半節距',
          'the-knob-that-centres-the-pattern': '把圖形置中的那個旋鈕',
          'the-only-exposure-in-the-whole-module': '整個模組唯一的一次曝光',
          'transfer-that-too': '再把這些也轉移下去',
          'print-the-lines-in-between': '在中間曝印另一半線條',
          'transfer-it': '把它轉移下去',
          'print-every-other-line': '曝印每隔一條的線條',
          'transfer-resist-into-the-film': '把光阻圖形轉移進薄膜',
          'print-the-pattern-directly-at-13-5-nm': '以 13.5 nm 直接曝印圖形',
          'print-the-pattern-directly': '直接曝印圖形',
        },
        stepLabel: {
          'cool-down-and-characterise': '降溫並特性量測',
          'wire-bond-to-the-sample-holder': '打線接合到樣品座',
          'dice-into-chips': '切割成晶片',
          'measure-every-junction': '量測每一個接面',
          'grow-the-tunnel-barrier': '生長穿隧位障',
          'etch-the-circuit': '蝕刻電路',
          'expose-the-circuit': '曝光電路圖形',
          'substrate-clean': '基板清洗',
          'final-test-and-burn-in': '終測與預燒',
          'mould-and-cure': '封膠與固化',
          'die-attach-and-wire-bond': '黏晶與打線',
          'grind-and-dice': '減薄與切割',
          'wafer-sort': '晶圓測試分選',
          'final-inspection': '最終檢查',
          'epitaxial-device-layer': '磊晶元件層',
          'incoming-clean': '來料清洗',
          'slice-lap-etch-polish': '切片、研磨、蝕刻、拋光',
          'crystal-growth': '晶體生長',
          'thickness-and-dishing-check': '厚度與碟形凹陷檢查',
          'post-cmp-clean': 'CMP 後清洗',
          'copper-cmp': '銅 CMP',
          'copper-plate': '銅電鍍',
          'barrier-and-seed': '阻障層與種子層',
          'post-etch-clean': '蝕刻後清洗',
          'resist-strip': '去光阻',
          'trench-etch': '溝槽蝕刻',
          'via-etch': '通孔蝕刻',
          'trench-lithography': '溝槽微影',
          'dielectric-deposition': '介電沉積',
          'post-gate-metrology': '閘後量測',
          'spike-anneal': '尖峰退火',
          'source-drain-implant': '源極/汲極注入',
          'polysilicon-deposition': '多晶矽沉積',
          'gate-oxidation': '閘氧化',
          'well-drive-in': '阱推進',
          'well-implant': '阱注入',
          'pre-gate-clean': '閘前清洗',
          'pull-the-first-spacers': '拔除第一道側壁',
          'spacer-2-etch': '蝕刻第二層側壁',
          'deposit-spacer-2': '沉積第二層側壁',
          'pull-the-mandrel': '拔除芯軸',
          'spacer-1-etch': '蝕刻第一層側壁',
          'deposit-spacer-1': '沉積第一層側壁',
          'trim-the-mandrel': '修整芯軸',
          'print-the-mandrel': '曝印芯軸',
          'etch-population-4': '蝕刻，第 4 組',
          'etch-population-3': '蝕刻，第 3 組',
          'etch-population-2': '蝕刻，第 2 組',
          'etch-population-1': '蝕刻，第 1 組',
          'expose-population-4': '曝光，第 4 組',
          'expose-population-3': '曝光，第 3 組',
          'expose-population-2': '曝光，第 2 組',
          'expose-population-1': '曝光，第 1 組',
          'etch-second-population': '蝕刻，第二組線條',
          'expose-second-population': '曝光，第二組線條',
          'etch-first-population': '蝕刻，第一組線條',
          'expose-first-population': '曝光，第一組線條',
          'pattern-transfer-etch': '圖形轉移蝕刻',
          expose: '曝光',
        },
        NoteTakeTheCall: '四個候選原因，其中之一是：真的就只是某一台機台。站點警報是免費的，逐層曲線不是——這正是要做的決定：花一個半小時的機台時間去看趨勢，還是憑一份怎麼看都是綠色的彙總直接下結論。',
        FaultIntro: '本模擬器中其他所有故障都是機台故障：某個腔體出了問題，而且腔體自己會報出來。這三個不是。在每一個案例裡，每一次過站都在各自的規格之內，而產品卻超出了自己的規格——所以沒有壞讀數可找，沒有警報可回應，也沒有機台可修。要練的本事是別再盯著機台看，這也是最難教的習慣，因為一個好技術員的全部直覺都在喊：去查機台。',
        AxisChlorineDoseS: '氯劑量 (s)',
        AxisEpcNm: 'EPC (nm)',
        NoteTheSameInstrumentDep02: '與 DEP-02 上 ALD ' +
          '用的是同一件儀器，同一個測試：真正自限制的半循環會先上升然後走平。曲線一直往上爬，就說明更多前驅物仍在去除更多材料。注意僅憑這條曲線並不能證明 ' +
          'ALE——能量過高的配方也會飽和。協同度那個數字才是把它們區分開的測試。',
        NoteBelowSaturationDoseNow: '低於飽和——現在是劑量決定速率',
        NoteSaturated: '已飽和',
        ValueSputtering: '濺射',
        ValueStarved: '欠飽和',
        ValueInWindow: '在窗口內',
        NotePartOfThisEtchIs: '這次蝕刻有一部分是連續進行的',
        NoteNeitherHalfEtchesAlone: '兩個半反應都不單獨蝕刻——這才是 ALE',
        LabelEtchRate: '蝕刻速率',
        LabelSelectivity: '選擇比',
        LabelRegime: '工作區',
        LabelSynergy: '協同度',
        mat: {
          'silicon-oxide': '氧化物',
          'silicon-nitride': '氮化物',
          silicon: '矽',
        },
        SectionFilm: '薄膜',
        SecondaryLabel: '最後一層的 CD 分散',
        ToolLabel: '製程路線——每台機台，按順序',
        fault: {
          justOneTool: {
            Evidence: [
              '有一個站點超出規格，而真正的流程故障從不出現這種情況。',
              '分層圖走平，接面深在目標上，沒有觸發任何管制規則。',
              '變化是突然的、有明確日期的——流程故障是慢慢到來的。',
            ],
            Truth: '這不是流程故障。CMP-11 ' +
              '正在為去除速率警報——一個普普通通的單站問題，配一個普普通通的診斷，它自己的班次報告二十分鐘就會點出名字。大多數良率波動就是一台機台的事，一個學會條件反射式抄起流程工具的學生，學到的是這堂課錯誤的那一半。先讀站點警報；它們是免費的。',
            Complaint: '良率從週二起掉了五個點。良率工程師開了流程覆盤，想談逐層累積。',
            Label: '就是一台機台的事，流程是干擾項',
          },
          sequenceDrift: {
            Evidence: [
              '管制圖規則觸發了，卻沒有任何一個點越限。',
              '黃金晶圓直接量出了累計偏移。',
              'CMP 分層圖走平，接面深在目標上。',
            ],
            Truth: '有一台機台每層漂約 0.18。十一層就是 ' +
              '1.8——單側規格的六成——而沒有一個讀數越出過管制界限，因為漂移相對判限很小、相對批間散布卻很大。居中的製程連續八點落在中心線同一側是 1/128 ' +
              '的事件，這就是這條規則存在的原因，也是只有跨訪問的管制圖才有它的原因。',
            Complaint: '參數良率每週滑一點，沒有人指得出是哪一批出的錯。什麼都沒警報。',
            Label: '十一次量測全部合格，而有什麼在動',
          },
          budgetSpent: {
            Evidence: [
              '沒有任何一次退火超過它自己的限值。',
              '接面剖切超過 78 nm。',
              'CMP 的分層圖走平，沒有觸發任何管制圖規則。',
            ],
            Truth: '為了解決一個電阻率投訴，阱推進從 300 秒延長到了 880 秒。它仍是一次合法的退火——單步限值是 900 ' +
              '秒——但它花掉了流程末尾尖峰退火所依賴的預算。接面深隨總量的平方根變化，所以流程裡最後一步被之前的每一步約束著，而這本帳沒有人管。',
            Complaint: '整個產品的參數分級都挪了位。每個爐管步驟都在自己的窗口內，THRM-04 每次診斷都乾淨。',
            Label: '接面太深，而沒有一次退火超時',
          },
          stackAccumulation: {
            Evidence: [
              'CMP 後台階高度按限值原文十層全過。',
              '對層號作圖後，它爬升並停在高處，而不是走平。',
              '沒有站點警報，接面深也在目標上。',
            ],
            Truth: 'CMP-11 的墊修整器磨損了，平坦化效率從 0.90 掉到 0.55。每次拋光留下的台階仍低於 80 nm ' +
              '的單次限值——但它向上傳遞的形貌比以前多，十層複利下來是 70 nm。雙方說的都是實話。單次限值從來不是從焦深預算推出來的，80 nm ' +
              '和掃描機真正需要的 55 nm 之間的縫隙，就是故障藏身的地方。',
            Complaint: '微影在每一批的第 8 層金屬上報廢，怪焦距。CMP 說自己十層全部合格，還有數據為證。',
            Label: '第 8 層金屬印不出來，而 CMP-11 每一層都合格',
          },
          routeHealthy: {
            Evidence: [
              '每一次單站檢查都通過，沒有站點在警報。',
              '分層圖走平，接面深在目標上。',
            ],
            Truth: '什麼問題都沒有。正確的判定就是繼續跑。',
            Complaint: '良率例會。產線按預測在跑。',
            Label: '一切正常',
          },
        },
        NoteSCycleTheRieRecipe: '{{a}} 秒/循環——隔壁的 RIE 配方約跑 200',
        NoteEvAgainstAEvWindow: '{{a}} eV，窗口為 {{b}}–{{c}} eV',
        NoteNmOverCycles: '{{b}} 個循環共 {{a}} nm',
        NoteSameChamberSameGasesSame: '同一個腔體、同樣的氣體、同樣的電源。讓它成為 ALE ' +
          '的，是化學和離子在時間上被分開了，而且離子能量被壓到它自己什麼都蝕不動的程度。比上面那份配方慢兩個數量級，而當出錯不可接受時，最後兩奈米就是這麼去除的。',
        SectionEnergyWindowIsTheRemoval: '能量窗口——移除半步是否自我侷限？',
        NoteTheModifiedLayerHasA: '改質層的濺射閾值低於其下的材料，兩個閾值之間有一條帶：改質層能被移除而基板不會。低於這條帶什麼都去不掉；高於它就是在濺射，製程就不再是任何意義上的原子級。跑在窗口之上，是配方名叫 ' +
          'ALE 而實際不是的最常見方式。',
        SectionSaturationCurveIsTheDose: '飽和曲線——劑量半步是否自我侷限？',
        SectionStoredAleRecipes: '已存 ALE 配方',
        KnobWafers: '{{n}}k 片',
        flow: {
          'quantum-chip': {
            Purpose: '八道製程，一個一奈米厚的接面，以及一次要在 10 mK 下花一整天的測試。',
            Name: 'Transmon 測試晶片',
          },
          'product-saqp': {
            Purpose: '從矽料到分級成品，內連線迴圈每層金屬跑一遍。',
            Name: '完整產品流程——SAQP',
          },
          'back-end': {
            Purpose: '一片完工晶圓變成分好級的成品。',
            Name: '組裝與測試',
          },
          'gate-saqp': {
            Purpose: '阱、閘極氧化層、多晶矽、圖形化，以及隨後的源汲極。',
            Name: '閘極層——SAQP',
          },
          substrate: {
            Purpose: '多晶矽和一顆籽晶變成一片拋光晶圓。',
            Name: '基板',
          },
          'metal-layer': {
            Purpose: '蝕刻介電層，填入銅，再把多餘的磨掉。',
            Name: '鑲嵌金屬層',
          },
          le4: {
            Purpose: '四張光罩，才到 SAQP 用一張就搆到的節距。',
            Name: 'LE⁴ 四重圖形化',
          },
          saqp: {
            step7: {
              Label: '拔除第一道側壁',
            },
            step6: {
              Label: '蝕刻第二層側壁',
            },
            step5: {
              Label: '沉積第二層側壁',
            },
            step4: {
              Label: '拔除芯軸',
            },
            step3: {
              Label: '蝕刻第一層側壁',
            },
            step2: {
              Label: '沉積第一層側壁',
            },
            step1: {
              Label: '修整芯軸',
            },
            step0: {
              Label: '曝印芯軸',
            },
            Purpose: '一張光罩、八步操作，最終節距由一層薄膜的厚度決定。',
            Name: 'SAQP',
          },
          lele: {
            Purpose: '兩張光罩、四步操作。兩次曝光間的疊對誤差會變成 CD 誤差。',
            Name: 'LELE 雙重圖形化',
          },
          'single-euv': {
            Purpose: '一張光罩、兩步操作，達到別人要八步才搆到的節距。',
            Name: '單次曝光，EUV',
          },
          'single-duv': {
            Purpose: '一張光罩、兩步操作，以及 36 nm 半節距處的硬極限。',
            Name: '單次曝光，193i',
          },
        },
        LabelGateOxide: '閘極氧化',
        LabelWellDriveIn: '阱推進',
        TextTheThreeMechanisms: '三種機制，逐一拆解',
        TextTakeTheCall: '來做這個判定',
        TextHowYouWouldSeeIt: '怎樣才能看見它',
        TextTheFault: '故障所在',
        TextWhatTheProductSays: '產品怎麼說',
        TextWhatTheToolSays: '機台怎麼說',
        TextMostExpensive: '花費最多',
        TextMostVisited: '到訪最多',
        TextShowWhatWasActuallyWrong: '看看究竟是哪裡壞了',
        TextRouteFaults: '流程級故障',
        TextComparePatterning: '圖形化方案對比',
        LabelEtchPerCycle: '每循環蝕刻量',
        LabelSurfaceCoverage: '表面覆蓋率',
        NoteTheMaskThresholdIsFar: '光罩的閾值遠高於改質層',
        SectionAleRecipe: 'ALE 配方',
        case: {
          'slow-drift': {
            HowToSeeIt: '西電規則。居中的製程連續八點落在中心線同一側是 1/128 的事件，所以這不是巧合。沒有任何點越限；「模式」本身才是訊號，而只有跨訪問的管制圖才有模式。',
            ProductSays: '參數良率在下滑，卻沒有人指得出是哪一批開始出的錯。',
            ToolSays: '每個讀數都在規格和管制界限之內。沒有報過一次警。',
            Truth: '一只質量流量控制器每層漂移約合 0.4 nm。十一層下來就是 4 nm 的偏移——每一次單看都在規格內，而製程已經不再居中。',
            Label: '十一次量測全部合格，而機台是壞的',
          },
          'thermal-account': {
            HowToSeeIt: '沿流程把熱預算加總，而不是逐步對照各自的限值。流程裡最後一次退火被之前的每一次退火約束著，而這本帳沒有人管。',
            ProductSays: '閘極模組結束時接面深超出規格。',
            ToolSays: '每個爐管步驟都在自己的時間和溫度窗口內。THRM-04 每次診斷都是乾淨的。',
            Truth: '為了解決一個電阻率投訴，阱推進被延長了。它單獨看仍是一次合法的退火。但它花掉了流程末尾尖峰退火所依賴的預算，最後出來的接面深超了 30%。',
            Label: '接面太深，而沒有一次退火超時',
          },
          'planarisation-drift': {
            HowToSeeIt: '把 CMP 後極差對「層號」作圖，而不是對規格作圖。健康的疊層會收斂成一條平線；這一組一路爬升不停，因為公比變小的幾何級數會收斂在更高的地方。',
            ProductSays: '到第 8 層金屬時，掃描機上的 CD 散布已超出焦深預算，微影組在怪掃描機。',
            ToolSays: '每一層的每次 CMP 都在自己的規格內。去除速率、均勻性、拋後極差全部正常。',
            Truth:
              '拋光墊修整器磨損了，平坦化效率從 0.90 掉到 0.55。每次拋光仍然去除配方要求的量，仍然把台階留在 45 nm ' +
              '的單次限值以內——但它向上傳遞的形貌比以前多，而十層這樣傳下來是會複利的。',
            Label: '第 8 層金屬印不出來，而 CMP-11 每一層都合格',
          },
        },
        AsideDrift:
          '十一層累計漂移 {{total}}——單側規格的六成，花掉時沒有一個讀數越出窗口。居中的製程連續八點落在中心線同一側的機率約為 ' +
          '1/128，所以它是一條規則，不是一種直覺。',
        AsidePlanarisation:
          '健康的疊層收斂在 {{healthy}} nm，這一組收斂在 {{worn}} nm。兩者都是幾何級數——R(n+1) = ' +
          '(R(n)+F)(1−η)——收斂點是 F(1−η)/η，由效率決定，跟任何單獨一次拋光無關。單次限值寫成 {{visit}} ' +
          'nm，只是因為機台能守住這個數；焦深預算真正需要的是 {{route}} nm。故障就住在這兩個數字的縫隙裡，而這道縫才是真正的缺陷。',
        VerdictNoRule: '未觸發任何規則',
        VerdictNoReadingOut: '沒有任何讀數超出規格或管制界限',
        VerdictJunction: '接面深 {{junction}} nm，限值 {{limit}} nm',
        VerdictAnnealsOk: '每次退火都在各自窗口內',
        VerdictCdSpread: 'CD 散布 {{spread}} nm，預算 {{budget}} nm',
        VerdictInSpecAll: '10 層全部合格',
        LabelSpike: '尖峰退火',
        LabelDensify: '緻密化',
        LimitRouteNeeds: '流程真正需要的 {{limit}} {{unit}}',
        LimitPerVisit: '單次限值 {{limit}} {{unit}}',
        LimitControl: '管制界限',
        LimitSpec: '規格線',
        StepListMore: '……還有 {{more}} 步，多數是金屬層的又一輪',
        StepListHead: '操作步 — 共 {{total}} 步，顯示第 1 至 {{shown}} 步',
        TileGoodDieNote: '{{gross}} 顆中合格 {{good}} 顆',
        TilePerGoodDie: '每合格裸晶',
        TileDieYieldNote: '按 {{area}} cm² 裸晶',
        TileDieYield: '裸晶良率',
        TileLineYieldNote: '存活下來的整片晶圓',
        TileLineYield: '線良率',
        TileThermalNote: '折合 1000 °C 下的秒數',
        TileThermal: '熱預算',
        TileDefectsNote: '每碰一次都有代價',
        TileDefects: '新增缺陷',
        TileLithoNote: '的成本，出自 {{steps}} 步中的 {{masks}} 步',
        TileLithoShare: '微影占比',
        TileCostNote: '為光罩成本',
        PerWaferSuffix: '/片',
        TileCost: '成本',
        TileMasksNote: '每張都是一塊光罩，買一次',
        TileOperationsNote: '晶圓要停這麼多次',
        TileOperations: '操作步數',
        ThPerGoodDie: '$/合格裸晶',
        ThYield: '綜合良率',
        ThLitho: '微影占比',
        ThPerWafer: '$/片',
        ThMasks: '光罩',
        ThSteps: '步數',
        ThRoute: '流程',
        CompareIntro:
          '把圖形放上晶圓的五種方法。後三種達到的節距是任何單次 193 nm ' +
          '曝光都解析不了的，它們靠拿光罩換操作步數來實現——光罩買一次，工步卻每片晶圓都要付。改一改下面的裸晶面積或生產量，排名就會變，這才是真正的答案：沒有最好的流程，只有對某個產品最好的流程。',
        KnobVolume: '生產量',
        KnobDieArea: '裸晶面積',
        group: {
          quantum: '量子元件',
          product: '產品',
          layers: '層模組',
          patterning: '圖形化模組',
        },
        SideNote: '晶圓廠不是一排機台。它是一個迴圈，每做一層就跑一圈，而產品就是晶圓繞這個圈的次序。',
        reading: {
          goldenWafer: {
            Label: '在黃金晶圓上複測最近 11 層（6.0 小時）',
          },
          junction: {
            Label: '接面剖切——破壞性（4.0 小時）',
          },
          layerTrend: {
            Limit: '走平，且低於 55 nm',
            Label: 'CMP 後極差對層號作圖（1.5 小時）',
          },
          stationAlarms: {
            ValueNone: '無',
            ValueCmp: 'CMP-11 去除速率偏低',
            Limit: '無',
            Label: '當前超規格的站點',
          },
          spcRules: {
            ValueNone: '無',
            Limit: '無',
            Label: '層序中觸發的管制圖規則',
          },
          thermalTotal: {
            Limit: '無單步超過 900 秒',
            Label: '本流程已花熱預算',
          },
          cmpVisits: {
            Value: '{{b}} 層中 {{a}} 層在 {{c}} nm 之內',
            Limit: '10 層全部',
            Label: '每層 CMP 後台階高度',
          },
        },
        aspect: {
          singleStation: {
            Action: '去警報的那台機台跑它自己的班次報告——這不是流程問題',
            Label: '單一站點，按常規診斷處理',
          },
          toolDrift: {
            Action: '從分層圖上找出漂移的機台並重新對中',
            Label: '某台機台在層序中漂移',
          },
          thermalBudget: {
            Action: '把阱推進退回 300 秒，另想辦法達到電阻率目標',
            Label: '最後一次退火前已花掉的熱預算',
          },
          planarisation: {
            Action: '修銳 CMP-11 的墊修整器，並把單次台階限值改由焦深預算推導，而不是看機台能撐多少',
            Label: '金屬疊層上的逐層累積',
          },
        },
      },
      etch: {
        GuardNotRun: '腔體還沒有運行。請先在上面啟動製程：批次記下的是電漿實際做了什麼，而不是配方要求了什麼。',
        GuardEtched: '這個圖形已經在薄膜裡了。要再曝光一次，才有新的東西可轉移。',
        GuardNoPattern: '這批晶圓上沒有圖形。蝕刻機是把光阻圖形轉移到下面的薄膜裡：請先在 LITH-03 或 EUV-22 曝光。',
        TransferLot: '轉移圖形並把批次送去清洗',
        NoteNoLot: '裝載腔裡沒有批次。帶一片有圖形的晶圓來，把圖形轉移到薄膜裡。',
        SecondaryLabel: '非均勻性',
        ToolLabel: 'ETCH-01 · ICP 多晶矽蝕刻',
        SectionAtomicLayerMode: '原子層模式——同一個腔體，換一種跑法',
        SectionSheath: '離子的方向從哪來——晶圓邊緣的鞘層（電場）',
        SheathNote:
          '一張穿過晶圓邊緣的剖面：頂部是作為平坦邊界的電漿，底部是晶圓和它的聚焦環，兩者之間就是鞘層——' +
          '而這正是畫面所呈現的東西。明暗就是電位，電漿一側亮、晶圓一側暗；黃線是它的等勢線；' +
          '箭頭是離子的去向——沿著電場往下走，而在平坦表面之上，這就意味著' +
          '筆直向下。電漿蝕刻之所以能切出垂直側壁，全部原因就在這裡：不是離子會瞄準，是電場替它瞄準了。' +
          '現在看聚焦環。全新時，它的頂面與晶圓齊平，電場平直地掠過邊緣，所以最外圈的晶片看到的與中心' +
          '完全相同。讓腔體繼續運行，環被逐漸蝕刻掉：等勢線在更低的表面上方下陷，於是在同一高度上，環上方' +
          '的電位高於晶圓上方，晶圓邊緣正上方的電場便多出一個由環指向晶圓的橫向分量。兩件事同時發生——' +
          '邊緣的離子向內傾斜，落在晶圓裸露的稜角上，最外圈的晶片因此蝕出傾斜的側壁；而原本鋪散在環上的' +
          '電場線，現在像匯聚到避雷針那樣匯聚到那個稜角上，邊緣挨打更重、跑得更快。這就是「環磨損」故障裡' +
          '那張邊緣偏快的分布圖，被看見了。把偏壓調高，每一支箭頭都變長，卻沒有一支轉向：這是拉普拉斯的' +
          '場，而拉普拉斯是線性的，所以傾斜屬於幾何，只有換新環才治得了。',
        SheathCaveat:
          '誠實的邊界。真實的鞘層是一層幾毫米厚的空間電荷區，其邊界就是電漿本身；這裡則是固定平板下的' +
          '一段導電間隙。形狀——平面之上是平的、台階之上會彎——是一樣的，而那個彎正是這一節要講的。' +
          '這裡沒有「執行」可按，也沒有時鐘：這個場裡不含時間，所以只要旋鈕一動，求解器立刻把它安頓好；' +
          '在這裡變化的是環，而不是分鐘。環緊貼晶圓，' +
          '真實的環則隔著零點幾毫米；而且它被固定在晶圓電位上：真實的環透過自身電容與射頻耦合，隨著變薄而' +
          '改變，甚至可能把環上方的鞘層往相反方向推——這正是現代腔體要給聚焦環單獨加射頻來操縱傾斜的原因。' +
          '在這裡，唯一會動的只有幾何。',
        SheathTilt: '晶圓邊緣離子向內傾斜',
        SheathTiltTitle: '離子到達的方向，沿晶圓分布',
        SheathTiltX: '沿晶圓的位置（mm）—— 邊緣在右側',
        SheathTiltY: '偏離垂直的傾角（°，向內為正）',
        SheathTiltSeries: '離子入射角',
        SheathTiltStatus: '邊緣 {{a}}°，晶圓中部 {{b}}° · 彎曲這條線的是聚焦環，偏壓不會讓它移動',
        SheathEdgeFlux: '邊緣 / 中心電流',
        SheathWear: '環磨損',
        SheathDirected: '漂移/擴散',
        SectionTrench: '自由基進入溝槽——窄圖形為何蝕得慢（深寬比相關蝕刻）',
        TrenchNote:
          '上面那張晶圓圖是一種「供不應求」——晶圓上每一處開口都在搶同一份供給，也就是負載效應。這裡是同一種' +
          '供不應求，只是尺度小了一千倍。同一片電漿下的四條溝槽，寬度從 90 nm 到 720 nm，深度都是' +
          '900 nm，因此深寬比分別是 10、5、2.5 和 1.25。自由基自上方擴散進來，凡是遇到矽就被消耗：槽底，' +
          '以及一路下去的每一面側壁。按執行，然後在圖上讀那四個槽底。10:1 溝槽的底部所見，只是 1.25:1 ' +
          '所見的一小部分——同一片電漿、同一時刻——所以它蝕得更慢，而同時帶有這兩種圖形的佈局，總是寬的' +
          '那條先到底。這就是深寬比相關蝕刻，也叫 RIE 遲滯，也正是蝕刻時間要按最窄圖形來定、其餘一律過蝕的' +
          '原因。現在讓表面消耗得更猛：把晶圓加熱，或者把偏壓調高讓離子打得更狠。窄溝槽餓得更厲害，遲滯' +
          '反而更嚴重。那個在速率上取勝的激進配方，輸掉了圖形之間的均勻性。',
        TrenchCaveat:
          '這裡被標定的是表面：活化能取的就是本面板自己的氟對矽的數值，離子增強也遵循本面板「閾值以上按平方根' +
          '增長」的規律，所以每一個方向性都是面板的。輸運則是用連續擴散來代替 100 nm 溝槽在 20 mTorr 下真正' +
          '經歷的分子流，而速率常數是特意選來讓最窄的溝槽在合格配方下呈現明顯的飢餓狀態。所以四個槽底的先後' +
          '順序、以及它們對旋鈕的響應，都是掙來的；那些百分比不是可以拿回機台去引用的數字，時間軸也不是——' +
          '真實的溝槽在微秒量級就填滿了。',
        TrenchWide: '1.25:1 槽底',
        TrenchNarrow: '10:1 槽底',
        TrenchLag: '遲滯',
        reading: {
          houseutilities: {
            Limit: '總管不漏，PCW 在供應溫度，乾燥氣 < 50 ppm',
            Label: '會同廠務檢查公用設施 (2 h)',
          },
          seasoning: {
            Label: '腔壁掛片 / OES 預處理檢查 (1 h)',
          },
          sealcheck: {
            Label: '本腔體氦氣測漏 (6 h)',
          },
          ringgauge: {
            Label: '聚焦環厚度量規 (30 min)',
          },
          base: {
            Label: '基礎真空度',
          },
          leak: {
            Label: '升壓率',
          },
          power: {
            Label: '實際輸入源功率',
          },
          pump: {
            Label: '幫浦運轉時數',
          },
          rf: {
            Label: '聚焦環射頻時數',
          },
          flowverify: {
            Label: '流量驗證，升壓率法 (45 min)',
          },
          tempverify: {
            Label: '儀器化晶圓，吸盤溫度 (2 h)',
          },
        },
        aspect: {
          power: {
            Label: '射頻匹配 / 輸入功率',
            Action: '重新調諧匹配器',
          },
          flow: {
            Label: '供氣系統（MFC）',
            Action: '校正或更換 MFC',
          },
          vacuum: {
            Label: '真空完整性（洩漏 / 幫浦）',
            Action: '查漏並維護幫浦組',
          },
          walls: {
            Label: '腔壁狀態',
            Action: '腔體清洗與預處理',
          },
          chuck: {
            Label: '靜電吸盤溫控',
            Action: '維護冰水機',
          },
          ring: {
            Label: '聚焦環',
            Action: '更換聚焦環',
          },
          house: {
            Label: '問題不在這台機台——通報廠務',
            Action: '停止在這台機台上排查，交由廠務處理',
          },
        },
        fault: {
          none: {
            Label: '無故障——腔體健康',
            Complaint: '機台已驗證，運轉在規格之內。',
            Truth: '一切正常。',
            Evidence: [
              '所有腔體讀數都落在標稱值上。',
            ],
          },
          mfcDrift: {
            Label: '質量流量控制器供氣不足',
            Complaint: '蝕刻速率偏低，晶圓均勻性變差。沒有人改過配方。',
            Truth: 'CF4 質量流量控制器顯示的是設定值，實際只放過去約 42%。氟的總量由真正進入腔體的氣體決定，而不是由顯示器上的數字決定。',
            Evidence: [
              '流量驗證（升壓率法）與 MFC 回讀值不一致。',
              '實際輸入射頻功率正常，排除匹配器問題。',
              '升壓率正常，排除洩漏。',
              '做一次腔體清洗也解決不了。',
            ],
          },
          chamberLeak: {
            Label: '真空洩漏',
            Complaint: '速率下降，選擇比也變得反常。上次保養之後開始的。',
            Truth: '重新組裝時門封被夾到了。空氣正在漏入，氧在氣相中奪走氟，因此即使流量與功率都正確，蝕刻劑也到不了晶圓。',
            Evidence: [
              '升壓率遠高於 1 mTorr/min 的限值——這是決定性的測試。',
              '基礎真空度同樣偏高。',
              '流量驗證與實際輸入功率都正常。',
            ],
          },
          matchDetuned: {
            Label: '射頻匹配網路失調',
            Complaint: '速率偏低。反射功率警報自己消失了，所以那個班就讓它繼續跑。',
            Truth: '匹配網路只把設定值的約 70% 送進電漿。吸收功率變少代表電漿變稀、離子變少——而偏壓功率被分攤到更少的離子上，每一顆反而打得更重。',
            Evidence: [
              '實際輸入功率明顯低於設定值——這是決定性讀數。',
              '離子能量比標稱值更高而不是更低，這正是把它與供氣問題區分開的關鍵。',
              '升壓率與流量驗證都正常。',
            ],
          },
          pumpDegraded: {
            Label: '幫浦組效能劣化',
            Complaint: '交班時基礎真空度警報。製程還跑得動。',
            Truth: '幫浦組已經抽不到基礎真空度。殘餘氣體把腔體的有效壓力抬到設定值以上，因而拖慢了往晶圓中心的擴散。',
            Evidence: [
              '基礎真空度是正常值的好幾倍。',
              '升壓率略為升高，但遠達不到真正洩漏的程度。',
              '流量與實際輸入功率都正常。',
            ],
          },
          heavySeasoning: {
            Label: '腔體清洗已經逾期',
            Complaint: '速率整週都在慢慢往下掉。每一批都比前一批稍慢一點。',
            Truth: '經過許多片之後腔壁上積起了沉積物。它們在氟抵達晶圓之前就把氟複合掉，同時又讓匹配器失調——一個根因產生了兩個看起來像是兩種故障的症狀。',
            Evidence: [
              '距上次清洗的片數已遠超保養限值。',
              '實際輸入功率偏低，同時自由基供給也偏低——兩者同時出現。',
              '升壓率與流量驗證都正常。',
              '腔體清洗能恢復；只調匹配器則只能撐一小陣子。',
            ],
          },
          chillerFault: {
            Label: '吸盤冰水機守不住設定值',
            Complaint: '最近兩批的剖面看起來有側蝕。速率略為偏高。',
            Truth: '吸盤實際比設定值高約 85 C。自發氟反應這一支隨溫度呈阿瑞尼士關係，因此被放大——而自發化學沒有方向性，於是側壁被側蝕。',
            Evidence: [
              '吸盤溫度回讀與獨立的晶圓量測結果不符。',
              '速率是升高而不是下降，這一下就排除了所有供給側的故障。',
              '側壁角變小，而離子能量沒有變化。',
            ],
          },
          wornFocusRing: {
            Label: '聚焦環磨耗超過限值',
            Complaint: '晶圓邊緣遠早於中心就蝕穿了。平均速率看起來還好。',
            Truth: '聚焦環已經磨蝕，無法再整形晶圓邊緣的電場，邊緣離子通量因此偏高。平均速率幾乎不動，所以這個問題躲得過速率圖，只會在均勻性圖上現形。',
            Evidence: [
              '聚焦環上的射頻時數已過更換限值。',
              '平均蝕刻速率接近標稱——速率管制圖抓不到它。',
              '均勻性圖呈現明顯的邊緣偏快，而且分布是一圈環形，不是單側傾斜。',
            ],
          },
          houseVacuumLeak: {
            Label: '共用真空總管洩漏',
            Complaint: '速率下降，選擇比也變得古怪——和上次保養後腔門密封圈被夾傷時一模一樣。那個密封圈我們已經換過了。DEP-02 也在報同樣的問題。',
            Truth: '上週末次廠房施工時動到了共用製程真空總管上的一處法蘭，現在正在漏。掛在這條總管上的每一個腔體都會把它當成自己的漏點——因為從腔體內部看，它就是。唯一不成立的是「這是本腔體的漏」，而花在拆開這台機台上的每一個小時，總管都在繼續向其他每一台機台漏。',
            Evidence: [
              '升壓率遠超限值，基礎壓力也跟著上去了——典型的漏氣特徵。',
              '對「本」腔體做氦檢結果乾淨。正是這一條讀數，把它從維修變成了通報。',
              '流量驗證與輸入功率都正常。',
              '同一條總管上的其他機台也各自報著同一件事——這條線索不花一分錢，卻幾乎總是被忽略。',
            ],
          },
          warmPcw: {
            Label: '冷卻水溫度偏高',
            Complaint: '速率低了大約 15%，輸入功率讀數也偏低。上一班已經重調過一次匹配器，結果照舊。',
            Truth:
              '冰水站送來的供水比標稱高了約 22 C。這台機台本身沒有任何故障。影響從兩條路進來：吸盤溫度上浮約 19 ' +
              'C，因為冰水機沒有足夠冷的介質可以排熱；更重要的是，射頻產生器與匹配器接在同一迴路上，正在降額運轉，輸入功率因此下降。這就是它為什麼看起來像匹配失諧，也是為什麼調匹配器解決不了。',
            Evidence: [
              '輸入功率偏低，看起來和匹配網路失諧一模一樣。',
              '重調匹配器幾乎沒有恢復。真的失諧是會恢復的。',
              '每一片晶圓都還在規格內——這正是陷阱：沒有任何東西逼你去查，機台就這樣安靜地慢著15% 一直跑，直到有人注意到產能。',
              '廠務公用設施檢查顯示冷卻水遠高於其供水溫度。',
            ],
          },
        },
        SectionProcessState: '製程狀態',
        SectionWaferMap: '晶圓圖 — {{sites}} 點取樣',
        SectionRadialProfile: '徑向分布',
        OesGround: '基態',
        OesElectron: '電子進入',
        OesPhoton: '光子發出',
        OesSpectrumTitle: '光譜儀所見',
        OesSpectrumX: '波長 (nm)',
        OesSpectrumY: '每 nm 強度（譜線面積即其強度；Ar 750 在 3 eV、2.1×10¹⁷ m⁻³ 時 = 1）',
        OesSpectrumSeries: '發射',
        OesTraceTitle: '貫穿整段製程的兩條譜線——終點',
        OesTraceX: '製程時間 (s)',
        OesTraceY: '譜線強度（Ar 750 在 3 eV、2.1×10¹⁷ m⁻³ 時 = 1）',
        OesTraceSiF: 'SiF 440 nm（產物）',
        OesTraceF: 'F 703.7 nm',
        OesClearing: '薄膜蝕穿',
        OesActinometry: '光強比測定 F 703.7 / Ar 750.4：{{ratio}}，為運行開始時的 ×{{fold}}',
        OesActinometryNow: '光強比測定 F 703.7 / Ar 750.4：{{ratio}}',
        OesActinometryWatching: '光強比測定 F 703.7 / Ar 750.4：{{ratio}}，為本面板開始觀察時（運行已在進行中）的 ×{{fold}}',
        OesUnwatched: '這次運行有一段發生在本面板關閉期間。那一段的產物譜線來自腔室自己的紀錄；氟譜線留空，因為當時沒有任何東西在讀取腔室的氟，事後無法重建。',
        OesActinometryNone: '光強比測定需要進氣中含有氬，而這個配方沒有。',
        OesFailed: '發射模型載入失敗。',
        OesStatus: 'T_e {{te}} eV · n_e {{ne}} m⁻³ · {{line}} nm：k = {{k}} m³/s，強度 {{rel}}',
        OesLoading: '正在載入發射模型…',
        OesTeSource: '電子溫度',
        OesFollow: '跟隨腔體',
        OesManual: '手動設定',
        OesTe: 'T_e',
        OesPause: '暫停',
        OesRun: '執行',
        OesReset: '重設',
        SectionEmission: '終點訊號從何而來——電子激發原子，原子發射譜線（能階與馬克士威分布）',
        EmissionNote: '上方的終點曲線，是光譜儀在看電漿的輝光，而這輝光就是每個班都在用的量子力學。腔體裡的原子有分立的能階。電漿中的電子只有帶著不低於該能階的能量到達，才能把原子抬上去；原子落回時發出一個光子，其波長由兩個能階決定：λ = hc/(E上 − E下)。氬的 750 nm 譜線需要 13.5 eV 的電子；而電子是幾 eV 的馬克士威分布，所以光來自分布的尾端，尾端按 exp(−13.5/T_e) 變化——這就是為什麼 T_e 的微小變化會讓氬線大幅改變，而閾值僅 2.9 eV 的產物譜帶幾乎不動。每條譜線的速率都是算出來的：從閾值起的 Bethe 截面，對分布取平均。氟由解離產生，只要還有矽可蝕就被消耗；SiF 是產物。所以到達終點時兩件事同時發生：SiF 譜帶熄滅，氟線上升，因為再沒有什麼在消耗氟。氬是平衡氣體，沒有什麼消耗它，所以晶圓廠真正監看的終點是氟與氬之比（光強比測定）：電漿本身的漂移會同時移動兩條譜線而相互抵消。能階取自 NIST。省略了級聯、淬熄以及譜帶的振動結構，譜帶畫成一個寬峰。',
        SectionEndpoint: '光學發射終點曲線',
        SectionIedf: '離子能量分布 — 微觀尺度',
        IedfNote: '上面這條分布是從放電求解出來的，不是查表得到的：波姆通量決定有多少離子抵達，偏壓功率除以該電流決定它們打得多重，低能拖尾則是穿越鞘層時發生電荷交換的那一部分。',
        SectionRunControl: '執行控制',
        RunControlNote: '這層膜的真實蝕刻大約需要兩分半鐘。倍速只縮放製程時間——物理在每一步都照樣完整求解。',
        SectionChamber: '腔體狀態 — 配方管不到的部分',
        SectionRecipe: '配方 — {{code}}',
        SectionStoredRecipes: '已存配方',
        StoredRecipesNote: '載入已存配方時會同時裝入一片新晶圓。',
        ModeThickness: '剩餘膜厚',
        ModeRate: '蝕刻速率',
        ModeDeviation: '相對均值的偏差',
        TileEtchRate: '蝕刻速率',
        TileNonUniformity: '不均勻度',
        TileSelectivity: '選擇比',
        TileRegime: '限制機制',
        TileIonEnergy: '離子能量',
        TileIonFlux: '離子通量',
        TileSidewall: '側壁',
        TileProcessTime: '製程時間',
        TileCleared: '蝕穿比例',
        FastEdge: '邊緣偏快',
        FastCentre: '中心偏快',
        Flat: '平坦',
        RegimeTransport: '傳輸受限',
        RegimeMixed: '混合',
        RegimeReaction: '反應受限',
        FromSheathSolve: '來自鞘層求解',
        Anisotropic: '非等向性',
        Undercut: '側蝕',
        FilmIntact: '氧化層完好',
        OxideLost: '氧化層損失 {{nm}} nm',
        UnitNmRemaining: 'nm 剩餘',
        CaptionDeviation: '藍 = 慢於均值，紅 = 快於均值',
        CaptionNonUniformity: '不均勻度 {{percent}}%',
        ChartProfileTitle: '沿半徑的蝕刻速率與蝕刻劑供給',
        ChartProfileX: 'r / R（0 = 中心）',
        ChartProfileSeries: '蝕刻速率',
        ChartEndpointTitle: '蝕刻產物的發射強度 — 膜蝕穿時下降',
        ChartEndpointX: '製程時間（s）',
        ChartEndpointY: '訊號',
        ChartIedfTitle: '離子能量分布 — 平均 {{ev}} eV',
        ChartIedfX: '離子能量（eV）',
        ChartIedfY: '占比',
        ChartMean: '平均',
        PreventiveMaintenance: '預防保養',
        MaintButton: '{{label}} — 停機 {{hours}} 小時',
        AssistantBlurb: '提出問題，我會設計一個實驗，用這台求解器把它跑出來，並報告真正得到的結果——然後再還你一個更銳利的問題。',
        AssistantLead: '先啟動製程、看著晶圓圖，然後問我它為什麼長這樣。',
      },
      patterning: {
        NoteMeanIsStillOnTarget: '平均值 {{a}} nm，仍在目標上',
        NoteCentred: '已置中',
        NoteSpacersMeet: '側壁相遇：{{a}} nm 的間隔不算間隔。薄膜對這個週期太厚了，或者芯軸修整過頭了。',
        ResultFourLines: '一根變四根——週期 {{a}} nm',
        ResultAnisotropicAgain: '再來一次各向異性蝕刻',
        ResultAldOverFirstPass: '在第一道側壁上再鍍 {{a}} nm ALD——它們現在成了芯軸',
        ResultTwoLines: '一根變兩根——週期 {{a}} nm',
        ResultAnisotropicClears: '各向異性：清除水平面，留下側壁',
        ResultAldConformalSidewall: '{{a}} nm ALD，保形度 {{b}}% → 側壁上 {{c}} nm',
        ResultTrimBothSides: '{{a}} → {{b}} nm（兩側）',
        ResultNmLinesOnPitch: '{{b}} nm 週期上的 {{a}} nm 線條',
        NoteMeanSpacingWalks: '平均間距 {{a}} nm——正中目標——但四個間隔之間有 {{b}} nm 的分散。週期在遊走。把芯軸修整量設為 {{c}} nm ' +
          '就能置中，而那一步在你測到問題的地方上游六步。',
        NoteAllFourSpacingsAre: '四個間隔都是 {{a}} nm。圖形已置中。',
        SectionPasses: '道次',
        SectionRoute: '流程',
        SecondaryLabel: '線條 CD 均勻性',
        ToolLabel: 'PAT-21 自對準四重圖形化單元',
        NextTheRouteSurvivedOnPaper: '這條路線在紙面上活了下來。現在問問：2% 的 ALD 厚度波動和不垂直的芯軸側壁會對同一配方做什麼——這台機台的現狀兩樣都佔。',
        AxisXSpacer1ThicknessNm: '第一層側壁厚度 (nm)',
        TitleFinalPitchAgainstFirstSpacer: '最終週期隨第一層側壁厚度的變化',
        LabelTrimmedMandrel: '修整後的芯軸',
        HypPitchDivisionIsSubtractionEach: '週期分割是減法。每層側壁都從它沉積其中的間隙裡拿走寬度，到某個點，剩下的間隙就再也裝不下下一層薄膜了。如果是這樣，失效應是突然的而不是漸進的——配方一直好使、好使、好使，然後就沒地方了。',
        AskedWhereDoesThisRouteStop: '這條路線到哪裡就在幾何上走不通了？',
        SumTheGeometricLimitsOfPitch: '週期分割的幾何極限，以及什麼最先耗盡。',
        LabelFinalCd: '最終 CD',
        AxisXSpacer2ThicknessNm: '第二層側壁厚度 (nm)',
        TitleFinalCdFollowsTheSpacer: '最終 CD 跟隨側壁薄膜',
        NoteToPrintThisDirectly: '若要直接印出此週期',
        LabelScannerNeeded: '所需掃描機',
        LabelMultiplication: '倍增係數',
        HypIfSaqpWorksTheWay: '如果 SAQP ' +
          '按設計運作，掃描機只定芯軸週期，之後的一切都是除法。最終週期應跟隨側壁厚度——一個由具有次奈米控制精度的沉積機台決定的數字——而對掃描機的解析度完全不敏感。',
        AskedWhichKnobDecidesThePitch: '最終出貨的週期由哪個旋鈕決定？',
        SumADepositedFilmThicknessNot: '決定權在沉積薄膜的厚度，不在掃描機——以及這買到了什麼。',
        NextEveryOtherLineInThis: '這個圖形裡每隔一根線就來自不同的來源。如果其中一半系統性地偏窄，這會對 PRB-14 的良率圖做什麼——它看起來會像缺陷，還是像參數失效？',
        LabelMeanSpacing: '平均間距',
        AxisYMeanSpacingNm: '平均間距 (nm)',
        TitleAndTheMeanWhichBarely: '而平均值幾乎毫無察覺',
        LabelIdealTrim: '理想修整量',
        AxisYWalkNm: '遊走 (nm)',
        AxisXMandrelTrimNm: '芯軸修整量 (nm)',
        TitlePitchWalkAgainstMandrelTrim: '週期遊走隨芯軸修整量的變化',
        LabelIdealTrimL126: '理想修整量',
        NoteLooksFineEitherWay: '怎麼看都正常',
        LabelMeanSpacingL122: '平均間距',
        AskedWhyAreTheSpacesIn: '為什麼最終圖形裡的間隙不是全都一樣寬？',
        SumPitchWalkTheTrimThat: '週期遊走、造成它的修整量，以及能修好它的修整量。',
        fault: {
          slopedMandrel: {
            Evidence: [
              '芯軸側壁角 4.5°，限值 1°。',
              '最終 CD 均勻性超限，節距仍然居中。',
              'ALD 的階梯覆蓋率和厚度散布都正常。',
            ],
            Truth: '芯軸蝕刻留下了 4.5° 的側壁。沉在斜壁上的側壁下厚上薄，於是蝕出來的線不再等於膜厚——和 ALD 漂移造成的 CD ' +
              '均勻性損失一模一樣，只是出自蝕刻機。能把兩者分開的是 ALD 的讀數，而它們是乾淨的。',
            Complaint: '還是那個變差的 CD 均勻性，而 ALD 昨天剛重新認證過。',
            Label: '芯軸側壁不垂直',
          },
          aldNonUniform: {
            Evidence: [
              'ALD 厚度散布 4.2%，限值 1.5%。',
              '最終 CD 均勻性超限，而節距漂移為零。',
              '階梯覆蓋率和芯軸輪廓都正常。',
            ],
            Truth: 'ALD 噴淋頭漂了，片內厚度散布到了 ' +
              '4.2%。最終的線就是這層膜，膜的均勻性就是線的均勻性——而因為它對每個側壁一視同仁，節距一點都不會漂。均勻性超差而節距居中，就是它的特徵。',
            Complaint: '全片的線寬均勻性變差了。節距完全居中。',
            Label: '側壁厚度全片波動',
          },
          thinSidewallFilm: {
            Evidence: [
              '階梯覆蓋率 86%，底線是 97%。',
              'CD-SEM 顯示間隔在漂移。',
              'ALD 厚度分布圖和掃描機的 CD 控制都正常。',
            ],
            Truth: 'ALD 的階梯覆蓋率只有 ' +
              '86%，於是側壁上的膜——唯一會變成線條的那部分——比厚度監控在平面上量到的更薄。節距由那個側壁厚度決定，於是它漂了，而沉積在任何人量過的每一塊平面上都完美合格。微影拒絕得有理。',
            Complaint: '節距開始漂了。有人要求微影收緊芯軸 CD 控制，微影拒絕了，理由是他們的控制全廠最好。',
            Label: '側壁膜比頂面薄',
          },
          patHealthy: {
            Evidence: [
              '檯上的每個讀數都正常。',
              '節距居中，CD 散布很小。',
            ],
            Truth: '什麼問題都沒有。正確的判定就是放行這一批。',
            Complaint: '例行批次。最終節距和 CD 都在目標上。',
            Label: '一切正常',
          },
        },
        NoteNmHalfPitchDuvLimit: '半節距 {{a}} nm，DUV 極限 {{b}} nm',
        NoteSetToNmThisIs: '設為 {{a}} nm——這是把圖形調正的那個旋鈕',
        NoteTheScannerAloneWouldGive: '掃描機單幹只能給 {{a}} nm',
        NoteNmPrintedDivided: '曝印 {{a}} nm，再除以 {{b}}',
        SectionThePitchStopsBeingThe: '節距不再歸掃描機管',
        NoteA193NmScannerCannot: '193 nm 掃描機印不了約 36 nm 半節距以下的圖形，2007 ' +
          '年以來一直如此。更細的一切都是先印粗的再分割出來的：在印好的線上沉一層保形薄膜，各向異性地蝕刻讓它只留在側壁上，再把中間的線抽掉。一條線變兩條。做兩遍就是四條。最終 ' +
          'CD 是一層膜厚——DEP-02 能把它控制到百分之一，而 LITH-03 只能控制到百分之幾。',
        TextPatternCollapsed: '圖形塌陷',
        SectionCellState: '單元狀態',
        SectionThePatternThatComesOut: '做出來的圖形',
        TextRunTheCellOnThis: '在這批晶圓上跑一遍圖形化單元',
        LabelSaqpTwoPasses: 'SAQP——兩遍',
        LabelSadpOnePass: 'SADP——一遍',
        LabelFinalPitch: '最終節距',
        LabelPitchWalk: '節距漂移',
        LabelFinalLineCd: '最終線寬',
        NoteThisIsAFilmThickness: '這是一層膜厚，不是曝印出來的圖形',
        LabelCdUniformity: 'CD 均勻性',
        LabelIdealMandrelTrim: '理想芯軸修整量',
        LabelAgainstAScannerAlone: '對比單用掃描機',
        AssistantLead: 'PAT-21 探究助理',
        AssistantBlurb: '可以問：間距為什麼一寬一窄、最終節距到底由什麼決定、這條製程路線在哪一步沒空間了。每個回答都是用這套配方真實跑完的八步流程。',
        reading: {
          cdUniformity: {
            Label: '最終線寬均勻性，49 點（2.0 小時）',
          },
          pitchWalk: {
            Limit: '散布 < 1 nm',
            Label: '對一個週期內每個間隔做 CD-SEM，200 點（3.0 小時）',
          },
          scannerCd: {
            Label: '掃描機芯軸 CD 控制',
          },
          sidewallAngle: {
            Label: '芯軸側壁偏離垂直角',
          },
          aldMap: {
            Label: 'ALD 片內厚度散布',
          },
          conformalityCheck: {
            Label: '監控結構上的 ALD 階梯覆蓋率',
          },
        },
        aspect: {
          scanner: {
            Action: '這裡無須維修——芯軸會被耗掉，它的 CD 到不了成品',
            Label: 'LITH-03 掃描機 CD 控制',
          },
          sidewall: {
            Action: '重調芯軸蝕刻以獲得垂直輪廓',
            Label: 'ETCH-01 芯軸側壁角',
          },
          aldUniformity: {
            Action: '重調 ALD 噴淋頭並重測全片厚度分布',
            Label: 'DEP-02 側壁厚度均勻性',
          },
          conformality: {
            Action: '重新認證 ALD 飽和窗口——側壁比頂部薄',
            Label: 'DEP-02 側壁保形性',
          },
        },
      },
      cmp: {
        NextHoldingIsTheEasyHalf: '扣住是簡單的那一半。這一班已經拋完出去的片子，用的是同一張單子——你要量什麼，才能判斷其中有沒有該收回來的？',
        NextTheSheetPassedToday: '今天這張單子過了。上面哪一行離限值最近？在它變成扣住機台的那一行之前，你覺得還剩幾批？',
        BridgingClear: '無',
        BridgingShorted: '短路',
        LabelBridging: '金屬搭橋',
        LabelPlanarity: '平整度',
        VerdictWithAWatchItem: '放行，但有一項要盯著',
        VerdictHeld: '扣住',
        VerdictQualified: '已認定',
        LabelVerdict: '判定',
        HypAQualificationIsADecision: '資格認定是一個決定，不是一段解釋。只要監控片拋完後平整度夠下一層曝光、拋光時間在產線能吸收的範圍內、沒有任何金屬搭橋，而且檯面每一項讀值都在限值內，機台就放行；否則扣住。再用同一台機器跑已認定配方，就能看出該負責的是配方還是機台。',
        AskedIsThisPolisherFit: '這台拋光機現在能不能跑產品，如果不能該怎麼辦？',
        SumPolishTheMonitorWafer: '拋一片監控片，把檯面讀值逐項對照限值，然後做出放行判斷。',
        UnitNmAcrossDie: 'nm（跨裸晶）',
        NoteTheRegionsAboveAre: '上面的區域是一張列表：每個區域按自己的公式清除、按自己的規律碟形磨損，誰也不知道鄰居的存在。下面，同一顆裸晶是一張按時間步進的圖——研磨墊是毫米尺度的卷積核，哪裡凸起就往哪裡壓得最重，所以平坦化是一種回饋而不是一個係數，一塊佈局挨著什麼，決定它怎麼被拋。下方的剖線橫穿裸晶中部：焊墊、緻密陣列、孤立線條、其間的開闊區。',
        NoteTheTwoModelsDisagree: '兩個模型在這裡對時鐘意見不一，這通常意味著配方已經離開了區域列表擬合時所在的區間——來料階梯太重，或者過拋光太極端。仍在做物理的是網格：壓力跟隨它實際壓著的那個表面。',
        NoteOnThisRecipeTheTwo: '在這個配方上，兩者在時鐘和失效次序上是一致的——網格本身就包含區域列表的規律，所以在區域真正獨立的地方它能複現列表。列表永遠無法包含的是研磨墊的作用長度：硬墊平坦化，軟墊保形拋光，侵蝕取決於鄰域，而過拋光會把裸晶重新磨得不平——階梯高度在終點時降到最低，隨後侵蝕又把它買了回來。',
        ValueNoSuchTerm: '無此項',
        ValueInTheKernel: '在卷積核裡：佈局的拋光取決於它的鄰居',
        MetricNeighbourhood: '鄰域效應',
        ValuePerRegionTimes: '只有各區域時間——沒有場，沒有圖',
        ValueSOfSequence: '先後相差 {{a}} s，開闊區最後清除',
        MetricClearing: '清除',
        MetricDieSurfaceRange: '裸晶表面高差',
        MetricWorstErosion: '最嚴重侵蝕',
        MetricWorstDishing: '最嚴重碟形磨損',
        MetricEndpoint: '終點',
        LegendTheRegionList: '區域列表',
        LegendTheDieStepped: '裸晶，按時間步進（{{a}}×{{a}} 格）',
        ValueClears: '清除時間',
        LabelRegion: '區域',
        LabelRemoval: '去除量',
        LabelRemovalNonUniformity: '去除非均勻性',
        LabelPolishTime: '拋光時間',
        SecondaryLabel: '拋光時間',
        ToolLabel: 'CMP-11 · 銅鑲嵌拋光機',
        NextIfTheLayoutBuildsThe: '如果失效是佈局內建的，那麼解決辦法就不在這台機台上。你會對設計做什麼修改讓它能被拋平——又需要誰來同意？',
        AxisYDishingNm: '碟形磨損 (nm)',
        AxisXLineWidthUm: '線寬 (um)',
        TitleDishingAgainstFeatureWidthAt: '碟形磨損隨圖形寬度的變化，圖形密度固定',
        NoteSamePolishSameWafer: '同一次拋光，同一片晶圓',
        LabelFineArrayDishes: '細密陣列碟形磨損',
        LabelWidestFeatureDishes: '最寬圖形碟形磨損',
        LabelClearsLast: '最後清除',
        LabelClearsFirst: '最先清除',
        HypTwoSeparateLayoutPropertiesAre: '是兩個互不相同、又容易混淆的佈局屬性在起作用。一個區域有多大比例是凸起的，決定它何時被清除，因為只有凸起部分接觸研磨墊並承擔全部載荷。一個圖形有多寬，決定它是否碟形磨損，因為研磨墊必須彎進凹陷才能碰到底部的金屬，而它的彎曲能力有限。密度決定時機；寬度決定損傷。',
        AskedYouWantToKnowWhy: '你想知道為什麼同一次拋光下，裸晶上有些圖形完好而有些被毀掉。',
        SumShowThatTheLayoutNot: '證明是佈局而不是拋光機決定哪些圖形失效。',
        NextIfMatchedSpindlesMakeThe: '如果主軸匹配使速度均勻，那麼這台機台上殘留的任何徑向特徵都是壓力問題。載具上有兩樣東西能造成徑向特徵——而且它們的作用方向相反。哪個是哪個？',
        LabelMatchedToPlaten: '與壓盤匹配',
        AxisYRemovalNonUniformity: '去除非均勻性 (%)',
        AxisXCarrierSpeedRpm: '載具轉速 (rpm)',
        TitleRemovalUniformityAgainstCarrierSpeed: '去除均勻性隨載具轉速的變化，壓盤轉速固定',
        LabelEdgeSpeedThen: '此時邊緣速度',
        LabelCarrierAtHalf: '載具轉速減半',
        LabelNonUniformityMatched: '非均勻性，匹配時',
        NoteIdenticalAtEveryRadius: '每個半徑處完全相同',
        LabelMatchedCentreToEdge: '匹配時，中心到邊緣',
        HypAPointOnTheWafer: '晶圓上一點相對研磨墊的速度為 w_p x d + (w_p - w_c) x r，其中 d 是兩個中心的偏移量，r ' +
          '是該點在晶圓上的位置。當兩個轉速相等時第二項恰好為零，所以每個點無論在哪裡都看到相同的速度。如果這是對的，主軸匹配應給出完全均勻的去除，而任何失配都會把徑向特徵直接印在晶圓上。',
        AskedYouWantToKnowWhyL193: '你想知道為什麼兩個主軸要以相同轉速運轉，以及不相同時晶圓會發生什麼。',
        SumShowThatMatchingTheTwo: '證明讓兩個主軸轉速匹配能使研磨墊速度完全均勻。',
        NextOverPolishBuysInsuranceAgainst: '過拋光是為防短路買的保險。是什麼決定了你需要多少保險——這台機台上哪個旋鈕改變的是這一點，而不是改變你拋光多久？',
        LabelYourRecipe: '你的配方',
        LabelDishingWidestFeature: '碟形磨損，最寬圖形',
        LabelMetalStillBridging: '金屬仍在橋接',
        AxisXOverPolish: '過拋光 (%)',
        NoteOfTheScannerBudget: '佔掃描機預算',
        LabelCdCostAt20: '20% 時的 CD 代價',
        NoteSameRecipeMoreTime: '同一配方，更長時間',
        LabelDishingAt120: '120% 時的碟形磨損',
        NoteWidestFeature: '最寬的圖形',
        LabelDishingAt20: '20% 時的碟形磨損',
        NoteMetalStillBridging: '金屬仍在橋接',
        LabelShortsBelow: '短路閾值以下',
        HypTheseTwoFailuresPullIn: '這兩種失效朝相反方向拉扯，不存在同時避免兩者的設定，因為終點偵測器靠整體摩擦變化觸發，看不到最後仍殘留金屬的那幾個百分點的面積。過拋光就是為這個盲區付出的代價，而過拋光的每一秒同時也在把最先清除乾淨的區域磨出碟形。',
        SumFindTheTradeBetweenMetal: '找出金屬殘留橋接與金屬過度碟形磨損之間的取捨。',
        fault: {
          zoneDrift: {
            Evidence: [
              '去除是中心快型——和護環磨損符號相反，這也是分開兩者的唯一依據。',
              '兩項規格照樣都過。沒有報廢，沒有什麼會逼出一個決定。',
              '壓力標測晶圓和分區調壓閥報的數對不上。',
              '護環量出來沒問題，排除了另一個壓力類故障。',
            ],
            Truth: '載具中心分區的一只調壓閥漂了，實際給出的壓力比它報的高約 ' +
              '40%。每片晶圓的中心都拋得快、先清完，然後在邊緣收尾時被過拋。平坦度和拋光時間照樣合格，這正是陷阱：機台已經有 16% ' +
              '的不均勻而每片晶圓都能出貨，所以在漂移大到開始報廢之前，沒有什麼會逼人做決定。',
            Complaint: '晶圓圖變成了中心快。一切照樣合格，班組想接著跑。',
            Label: '載具中心分區壓力虛高',
          },
          wornRing: {
            Evidence: [
              '去除是邊快型——邊緣減中心的讀數強烈為正。',
              '平坦度超差，而且邊緣處最差。',
              '載具分區漂移給出的是相反的徑向特徵。方向就是全部診斷，一張晶圓圖一眼看穿。',
              '護環厚度量出來低於更換限值。',
            ],
            Truth: '護環是消耗件，這只已經超限。它突出的高度不夠，壓不住晶圓前方的墊子，墊子越過晶圓邊緣時回彈，最後那幾毫米受到的壓力超過配方要求。邊緣先清完，然後在中心趕上來的剩餘時間裡一直被過拋，這就是它既不均勻又下凹、而不只是不均勻的原因。',
            Complaint: '邊緣測點過拋，晶圓邊緣的下凹超差。晶圓中心沒問題。',
            Label: '護環磨損超限',
          },
          agedSlurry: {
            Evidence: [
              '平坦度嚴重超差，而速率和均勻性都接近正常。',
              '損傷在全片是均勻的，這一下排除了兩個壓力類故障——載具或護環造成的缺陷不可能沒有徑向特徵。',
              '研磨液滴定顯示緩蝕劑濃度遠低於限值。',
              '監控片輪廓儀顯示寬結構下凹、陣列被侵蝕。',
            ],
            Truth: '料桶在機台上掛太久，緩蝕劑分解了。磨料幾乎不受影響，所以去除速率紋絲不動——但緩蝕劑幹的是兩份活。它鈍化介電層，製程的選擇比就是從這來的；它還保護接觸點之間低窪處的銅。它一沒，每條寬線都下凹，每個密集陣列都被侵蝕，而且全片均勻地發生。',
            Complaint: '銲墊上的下凹翻了三倍。速率看著正常，均勻性也正常。',
            Label: '研磨液過期',
          },
          glazedPad: {
            Evidence: [
              '拋光時間遠超，而平坦度和均勻性恰好正常。晶圓本身什麼都沒變。',
              '去除速率掉了一半還多。',
              '墊切削率檢查表明修整器沒有在削去墊材。',
              '這是品質體系看不見的故障。只有機台日誌抓得住它。',
            ],
            Truth: '金剛石修整器切不動了，墊面封釉，再也帶不動研磨液進入接觸區。同樣的壓力和轉速，去除量掉了下來。它之所以容易被忽略，是因為機台是端點控制的：它就多拋一會兒，產出一片一模一樣的晶圓。缺陷根本不在晶圓上，它在產線的產能裡，而且會一直隱形，直到有人去看產能圖而不是品質圖。',
            Complaint: '拋光時間漲了一整週——原來九十秒的配方現在快三分鐘了。每片晶圓量出來還是完美的。沒人看得出問題。',
            Label: '拋光墊釉化，修整器切不動',
          },
          healthy: {
            Evidence: [
              '平坦度、均勻性、拋光時間都在各自的認證值上。',
            ],
            Truth: '什麼問題都沒有。正確的判定就是放行這一批。',
            Complaint: '拋光墊週一換的，機台通過了認證。沒有任何報告。',
            Label: '拋光機已認證',
          },
        },
        TextArrivedWithNmOfSurface: '來料帶著 {{a}} nm 的表面起伏。',
        NoteNmTotal: '共 {{a}} nm',
        TextNm: '{{a}} / {{b}} nm',
        region: { pad: '銲墊，80 um', array: '密集陣列，0.5 um', iso: '孤立線條，2 um' },
        TextMetal: '{{a}}——金屬佔 {{b}}%',
        NoteRecessedMetalAtOfBlanket: '凹陷處金屬按全片速率的 {{a}}%',
        NoteNm: '< {{a}} nm',
        NoteEndpointAtS: '端點在 {{a}} 秒',
        NoteMSPadSpeed: '墊速 {{a}} m/s',
        SectionRemovalAcrossTheWafer: '全片去除分布',
        NoteTurnThePlatenAndThe: '讓拋光盤和載具同速旋轉，晶圓上每一點看到的墊速完全相同——是嚴格相同，不是近似。讓它們不同速，就會出現一個任何壓力修正都消不掉的徑向特徵。',
        SectionTheDieRegionByRegion: '裸晶，一個區域一個區域看',
        NoteEndpointFiresWhenTheBulk: '端點在晶圓的大部分發生轉變時觸發，而不是在最後一個區域完成時。先清完的地方只能等——而且邊等邊被過拋。',
        SectionWhatTheNextLayerInherits: '下一層繼承到什麼',
        NoteAScannerHasOneFocal: '掃描機只有一個焦平面，而這個表面有一個高低範圍。這裡剩下的任何起伏，兩步之後都要從微影的焦深預算裡扣——扣在一台工作完全正常的掃描機上。',
        SectionSolvedBesideTheFormulaIt: '數值解與它取代的公式並排',
        TextDishingErosion: '下凹 / 侵蝕',
        AxisXPositionOnTheDieMm: '裸晶上的位置（mm）',
        AxisYNmAboveTheLowestPoint: '高出最低點（nm）',
        LabelRemovalRate: '去除速率',
        LabelPlanarityAcrossDie: '裸晶內平坦度',
        LabelMetalBridging: '金屬橋接',
        LabelSlurrySelectivity: '研磨液選擇比',
        AxisXNormalisedRadius: '歸一化半徑',
        AxisYMetalRemovedNm: '去除金屬（nm）',
        LabelSurfaceHandedOn: '交下去的表面',
        NoteAcrossTheDie: '跨裸晶範圍',
        LabelCdSpreadItCauses: '它造成的 CD 散布',
        NoteAtLith03FromDefocus: '在 LITH-03，僅離焦一項',
        LabelOfTheCdBudget: '佔 CD 預算',
        NoteNoLotOnThePlaten: '拋光盤上沒有批次。從上游機台送一片晶圓過來拋光。',
        NoteThisLotIsStillAn: '這批貨還是一根晶棒。得先由 WPR-08 切片才能拋光。',
        TextPolishThisWaferAndPass: '拋光這片晶圓並傳下去',
        reading: {
          profilometry: {
            Label: '監控片輪廓儀測量（4 小時）',
          },
          zonemap: {
            Label: '壓力標測晶圓，全部分區（3 小時）',
          },
          ringgauge: {
            Label: '護環厚度測量（1 小時）',
          },
          inhibitor: {
            Label: '研磨液滴定，抑制劑含量（1 小時）',
          },
          padcut: {
            Label: '修整器切削率檢查（2 小時）',
          },
          short: {
            Limit: '無橋接',
            Label: '拋後金屬橋接',
          },
          edge: {
            Label: '邊緣減中心去除量',
          },
          nu: {
            Label: '去除不均勻度',
          },
          rate: {
            Label: '全片去除速率',
          },
          cycletime: {
            Label: '拋至端點的時間',
          },
        },
        aspect: {
          carrier: {
            Action: '用壓力標測晶圓重新校準各區調壓閥',
            Label: '載具分區壓力',
          },
          slurry: {
            Action: '排空迴路，換新桶，沖洗並重新認證',
            Label: '研磨液供給',
          },
          ring: {
            Action: '更換護環並重新歸零載具',
            Label: '護環',
          },
          pad: {
            Action: '磨合新墊並重新認證修整器掃掠',
            Label: '拋光墊',
          },
        },
        AssistantBlurb: '可以問過拋、主軸轉速，或者為什麼同一顆晶片上這個圖形失效、旁邊那個卻在同一次研磨裡安然無恙。每一個回答都是拿這台研磨機在它當下的真實狀態下跑出來的實驗。',
        AssistantLead: 'CMP-11 探究助理',
      },
      plating: {
        TransportSurface: '晶圓表面 Cu(II)',
        TransportOfLimit: '佔極限',
        TransportBurning: '表面耗盡 — 燒焦',
        SectionTransport: '極限電流是怎麼來的（質量傳輸）',
        TransportNote: '晶圓上的電流把槽液中的銅消耗掉，槽液再透過表面的一層擴散把它補回來。顏色表示實際有多少 Cu(II)。把電流調大，表面就被抽空；調得夠大它歸零，這就是「燒焦鍍層」的含義 — ' +
          '銅只能以擴散允許的速度到達，於是落下的是粉末而不是薄膜。真正精妙的是改變槽液濃度時會發生什麼：無論槽液起點多高，同樣的電流在表面之下留下的缺口總是一樣大，所以表面被抽空時的電流恰好正比於其中的銅含量。這就是上面面板用作上限的那條直線 ' +
          '— 斜率不再是選來的，而是被解釋了。一點誠實的侷限：這裡解的是歐姆場，所以電流越過極限後仍會繼續上升，而不像真實電解槽那樣趨於平台。請讀表面濃度，不要讀電流。',
        NoteBothModelsAgreeOn: '兩個模型在這個結構上意見一致，而這與它們的分歧同樣有價值——一個在公式適用之處卻複現不出公式的求解器只能是錯的。把深寬比推過六左右，或者讓加速劑枯竭，就能看著它們分道揚鑣。',
        NoteTheTwoModelsReturn: '兩個模型對這個結構給出的是不同的判定，而不只是不同的數字。賽跑判據靠一條擬合直線把一個比值映射成空洞比例；網格則要麼最後剩下未填的格子，要麼沒有。兩者中只有一個能對著橫截面去核對——這正是關鍵所在。',
        NoteAboveValidatedDomain: '這個加速劑濃度已超過認證槽液的 {{a}} ' +
          '倍，而那正是這個求解器不再可信的地方。在那個區間它的覆蓋度平衡存在一種未經實測檢驗的失控解，所以請把這幅圖當作示意，而不是結果。',
        ValueAtTheBottomByDefinition: '{{a}}，按定義位於槽底',
        ValueAtOfTheDepth: '{{a}}，位於 {{b}} % 深度處',
        MetricPeakAcceleratorCoverage: '加速劑峰值覆蓋度',
        ValueXAssumed: '{{a}}×（假定）',
        ValueXMeasured: '{{a}}×（實測）',
        MetricBottomUpGain: '自底向上增益',
        ValueATimeNotAnEvent: '只是一個時間，不是一個事件',
        ValueNever: '從不',
        ValueSteps: '第 {{a}} 步',
        MetricMouthClosesAt: '槽口封閉於',
        ValueNoSuchQuantity: '無此量',
        ValueNone: '無',
        ValueNmWideNmDown: '寬 {{a}} nm，深 {{b}} nm 處',
        MetricVoidAsAPlace: '空洞，按位置',
        MetricVoidAsAFraction: '空洞，按比例',
        ValueFilled: '填滿',
        MetricVerdict: '判定',
        NoteTheCellAboveDecides: '上面的電鍍槽用兩個數字賽跑來決定結構的命運：底部長到頂要多久，對側壁合攏要多久。下面則改為在網格上推進銅前沿。其中沒有任何環節去判斷溝槽是否留洞——側壁要麼在槽底到達之前合攏，要麼沒有，剩下的就是空洞。於是這裡有一幅可以端詳的橫截面，而兩個數字的賽跑永遠給不出這個。',
        LabelNonUniformity: '非均勻性',
        ValueVoid: '空洞',
        ValueSeam: '縫隙',
        ValueClean: '完好',
        LabelFill: '填充',
        LabelVoidLegend: '空洞',
        LabelDielectric: '介電質',
        SecondaryLabel: '自底向上增益',
        ToolLabel: 'ECD-12 銅電鍍槽',
        NextEveryNanometreOfOverburdenHere: '這裡的每一奈米過鍍層都是 CMP-11 的拋光時間，而拋光時間就是碟形磨損。仍能完全填滿溝槽的最薄鍍層是多少？',
        AxisXCurrentDensityMaCm: '電流密度 (mA/cm²)',
        TitleFieldThicknessAgainstCurrentDensity: '平場厚度隨電流密度的變化',
        LabelFieldThickness: '平場厚度',
        AskedWhatSetsPlatedThicknessAnd: '是什麼決定電鍍厚度？鍍得更快要付出什麼？',
        NextTryTheSameSweepAgainst: '把同樣的掃描換成對填充品質做一遍。哪個種子層厚度既厚到能鍍平、又薄到還能填滿溝槽——這裡存在這樣的厚度嗎？',
        AxisYEdgeCentre: '邊緣 − 中心 (%)',
        AxisXSeedThicknessNm: '種子層厚度 (nm)',
        TitleTerminalEffectAgainstSeedThickness: '終端效應隨種子層厚度的變化',
        NoteOverburden: '過鍍層',
        NoteEdgeOverCentre: '邊緣高於中心',
        LabelSeedSheetR: '種子層片電阻',
        HypCurrentEntersTheWaferThrough: '電流從晶圓邊緣的觸點進入，必須穿過種子層才能到達中心。種子層是薄金屬，所以它是個電阻，中心的電位比邊緣低。如果機制是這個，更厚的種子層就應把分佈拉平——而且完全不用碰槽液。',
        AskedWhyDoesPlatedThicknessLean: '為什麼電鍍厚度從邊緣到中心有傾斜？',
        NextTheAdditivesBreakDownAs: '添加劑在工作中不斷分解，所以早上還能填滿的槽液，下午未必還能填滿。這種失效在 INSP-13 的檢測掃描上會是什麼樣子——它到底會不會顯出任何樣子？',
        AxisYFractionOfTrench: '佔溝槽比例',
        TitleVoidFraction: '空洞比例',
        LabelConformalNoAdvantage: '保形——無增益',
        AxisXAcceleratorQualifiedBath: '加速劑（× 認證槽液）',
        TitleBottomUpGainAgainstAccelerator: '自底向上增益隨加速劑的變化',
        LabelAspectRatio: '深寬比',
        HypIfPlatingWereUniformA: '如果電鍍是均勻的，溝槽處處以相同速率鍍膜，槽口會在底部填滿之前先封死，每個結構裡都會留一個空洞。通常沒有空洞，說明底部的生長必須快於槽口。如果做到這一點的是加速劑，去掉它就應重新引入這個製程存在的意義所要避免的空洞。',
        AskedWhyDoesTheTrenchEnd: '為什麼溝槽最後是個空洞，而不是實心的銅？',
        SumBottomUpSuperfillAndWhat: '自底向上的超級填充，以及添加劑配比失衡時會發生什麼。',
        fault: {
          starvedBath: {
            Evidence: [
              '鍍液銅含量 14 g/L，低於 34 g/L 的下限。',
              '每片晶圓厚度偏低，並帶有燒焦鍍層特有的不均勻。',
              '陽極電位、接觸電阻、鍍液壽命和溫度全部正常。',
              '廠務的公用設施面板顯示 ECD-12 化學品管線洩漏，輸送已被連鎖關停。',
            ],
            Truth: '地下層的電鍍化學品管線在雙套管內洩漏，櫃下托盤感測器報警，洩漏連鎖關停了輸送泵——這正是它的用途。在樓上這意味著鍍液整個班次都沒有補液：每片晶圓都從鍍液裡帶走銅，如今只剩配方銅量的三分之一。極限電流隨之下降，同樣的 20 mA/cm² 已超出鍍液的供銅能力，鍍層燒焦——變薄，並在電流集中的邊緣變粗糙。這個鍍槽上做什麼都補不了一個供液在兩層樓下被連鎖切斷的鍍液。',
            Complaint: '整片晶圓的銅都偏薄，鍍層在邊緣變得暗淡起粉。陽極、接觸環和鍍液溫度都正常；鍍液按計畫加過藥。',
            Label: '鍍液缺銅——輸送管線洩漏',
          },
          dirtyContact: {
            Evidence: [
              '接觸電阻 70 mΩ，限值 15 mΩ。',
              '厚度分布又低又不均。',
              '陽極電位正常。',
            ],
            Truth: '接觸環髒了。它像鈍化的陽極一樣餓著晶圓的電流，還添了一樣陽極永遠做不到的事：每根觸指上的損耗不一樣，於是晶圓鍍得又薄又不均。薄加不均，就是它的特徵。',
            Complaint: '銅偏薄，而且分布圖在一個扇區上邊緣偏重。',
            Label: '接觸環電阻偏高',
          },
          passivatedAnode: {
            Evidence: [
              '陽極電位高出標稱 1.4 V，限值 0.4 V。',
              '厚度分布偏低。',
              '接觸環電阻正常。',
            ],
            Truth: '陽極上長了一層膜，吃掉了驅動電位，晶圓看到的電流比電源以為的少。電流少就是銅少，法拉第定律說得明明白白。接觸環是乾淨的，這是它和另一種餓著晶圓的方式的分界。',
            Complaint: '銅鍍出來偏薄，CMP 在靠過拋找齊。',
            Label: '陽極鈍化',
          },
          exhaustedAdditives: {
            Evidence: [
              '鍍液時齡 32 Ah/L，限值 12 Ah/L。',
              '剖面顯示填充帶空洞。',
              '厚度和均勻性都完美在目標上，這正是不毀一片晶圓就看不見這個故障的原因。',
            ],
            Truth: '鍍液已到 32 Ah/L，加速劑分解了。法拉第定律不管添加劑——銅的總量一點沒少——但讓溝槽自底向上填滿的 CEAC ' +
              '正回饋沒了，於是每個結構中間都藏著一條空洞。它通過全廠擁有的每一種非破壞性量測，然後在客戶手裡失效。',
            Complaint: '可靠性部門退回了一批通孔開路的元件，而那批貨在分選時每項測試都過了。電鍍那邊說晶圓是完美的：厚度對、均勻性對、節拍也對。',
            Label: '添加劑體系耗竭',
          },
          ecdHealthy: {
            Evidence: [
              '檯上的每個讀數都正常。',
              '剖面顯示乾淨的自底向上填充。',
            ],
            Truth: '什麼問題都沒有。正確的判定就是放行這一批。',
            Complaint: '例行批次。厚度和均勻性都在目標上。',
            Label: '一切正常',
          },
        },
        NoteSPerWafer: '每片 {{a}} 秒',
        NoteSeedSqTheCentreIs: '種子層 {{a}} Ω/sq——晶圓中心離接觸環最遠',
        NoteAcceleratorCoverageAtTheTrench: '槽底加速劑覆蓋度 {{a}}',
        NoteGainAgainstNeededAtAr: '增益 {{a}} 倍，深寬比 {{c}} 需要 {{b}} 倍',
        SectionAPositiveFeedbackMadeOf: '一個由幾何構成的正回饋',
        NoteTheAcceleratorIsConservedOn: '加速劑在它附著的表面上是守恆的。溝槽底部往上填的時候，那個表面在收縮——同樣多的分子佔了更小的面積，覆蓋度升高，底部長得更快，底面積於是縮得更快。這就是自底向上填充的全部機理，也是超填充恰好在最需要它的結構上出力最猛的原因。增益必須超過深寬比的兩倍，否則側壁先合攏，溝槽就空了。',
        SectionSolvedBesideTheFormulaIt: '數值解與它取代的公式並排',
        LabelCopperLate: '銅，後期',
        LabelCopperEarly: '銅，早期',
        SectionCellState: '鍍槽狀態',
        SectionBathAndRecipe: '鍍液與配方',
        TextPlateTheWaferAndPass: '鍍完這片晶圓，傳給 CMP-11',
        LabelBottomUpGain: '自底向上增益',
        LabelOverburden: '餘量厚度',
        NoteEveryNanometreIsCmp11: '每一奈米都是 CMP-11 的下凹時間',
        LabelTerminalEffect: '端子效應',
        Note4AcrossTheWafer: '全片 < 4%',
        LabelChargePassed: '已通過電量',
        AssistantLead: 'ECD-12 探究助理',
        AssistantBlurb: '可以問：溝槽為什麼留了空洞、邊緣為什麼鍍得更厚、要鍍多久。每個回答都是在這個鍍液裡真實跑出來的一次填充。',
        reading: {
          bathCopper: {
            Limit: '> 34 g/L',
            Label: '鍍液銅含量與補液目標',
          },
          houseutilities: {
            Limit: '所有系統正常',
            Label: '致電廠務查看公用設施面板（0.5 小時）',
          },
          crossSection: {
            Limit: '填滿',
            Label: '溝槽 FIB 剖面——破壞性（3.0 小時）',
          },
          thickness: {
            Label: '四探針厚度標測，49 點（1.0 小時）',
          },
          bathTemp: {
            Label: '鍍液溫度',
          },
          contactOhms: {
            Label: '接觸環電阻',
          },
          anodeVolts: {
            Label: '陽極電位高出標稱',
          },
          bathAge: {
            Label: '距上次放舊的鍍液時齡',
          },
        },
        aspect: {
          house: {
            Action: '停止本機台作業，上報廠務',
            Label: '本機台無故障——升級到廠務',
          },
          temperature: {
            Action: '重新校準鍍液熱電偶並重調加熱迴路',
            Label: '鍍液溫度',
          },
          contact: {
            Action: '清潔接觸環並逐指複測電阻',
            Label: '接觸環',
          },
          anode: {
            Action: '剝除陽極膜並重新活化，或更換陽極',
            Label: '陽極',
          },
          bath: {
            Action: '對鍍液放舊補新，並按 CVS 分析重設加藥量',
            Label: '添加劑體系',
          },
        },
      },
      thermal: {
        TunnelDrawnMag: '牆後的影像比實際放大了 ×{{m}} 倍亮度',
        NoteOnTheMonitor: '監控片上',
        LabelJunction: '接面深度',
        NextHoldingIsTheEasyHalf: '扣住是簡單的那一半。早些時候在這根爐管跑過的批次，用的是同一張檯面單——你要量什麼、量哪幾片，才能判斷其中有沒有該收回來的？',
        NextOneMonitorInAFiftyWafer: '一片監控片放行了五十片一爐。你會把這片監控片放在舟的什麼位置？在裝載的另一處再放一片，能告訴你這一片說不了的什麼？',
        LabelActivation: '劑量活化比例',
        LabelSheetResistance: '方塊電阻',
        LabelGateOxide: '閘氧化層',
        VerdictWithAWatchItem: '放行，但有一項要盯著',
        VerdictHeld: '扣住',
        VerdictQualified: '已認定',
        LabelVerdict: '判定',
        HypAQualificationIsADecision: '資格認定是一個決定，不是一段解釋。只要監控片回來時氧化層厚度落在視窗內、方塊電阻在目標容差之內，而且檯面每一項讀值都在限值內，爐子就放行；否則扣住。再用同一根爐管跑已認定配方，就能看出該負責的是配方還是機台。',
        AskedIsThisFurnaceFit: '這台爐子現在能不能跑產品，如果不能該怎麼辦？',
        SumRunTheMonitorWafer: '跑一片監控片，把檯面讀值逐項對照限值，然後做出放行判斷。',
        NotePerNm3: '矽本身約為每 nm³ 50 個原子',
        BudgetSpikeCaveat: '圖中下面兩個面板是同一實驗按流傳的兩種「熱預算」定義分別打分。∫T dt —— 溫度乘時間 —— 認為這兩個流程只差約 ' +
          '4%：它的兩條曲線幾乎重合，而且它的單位 °C·s 根本算不出深度。∫D dt（單位 ' +
          'nm²）則認為它們相差上百倍，而它才是能預測硼去了哪裡的那個。實驗寫在場景腳本裡 —— 沒有旋鈕，因為除了尖峰之外兩片晶圓必須共享一切 —— ' +
          '流程結束時它會自己停下；按重置就把九十分鐘重新跑一遍。',
        BudgetSpikeNote: '兩片晶圓，同樣的硼佈植劑量，同樣的目標：900 °C 下 90 分鐘。恆溫那片得到的正是這些，正中目標。有尖峰那片除了在第二十分鐘起經歷十分鐘 ' +
          '1200 °C 外完全相同 —— ' +
          '九十分鐘流程裡的一步，探針處卻深了好幾倍，而且幾乎所有損害都發生在那十分鐘裡。這就是預算的含義：爐子不會對流程取平均，它對 D 做積分，而 D ' +
          '隨溫度呈指數變化。',
        SectionBudgetSpike: '熱預算 —— 九十分鐘裡的十分鐘',
        BudgetSteady: '恆溫',
        BudgetSpiked: '有尖峰',
        BudgetSpiking: '尖峰 —— 左側晶圓 1200 °C',
        BudgetShared: '同一流程 —— 兩片晶圓完全相同',
        BudgetLabelSpiked: '尖峰 · 其中 10 分鐘 1200 °C',
        BudgetLabelSteady: '恆溫 · 全程 900 °C',
        BudgetNowTemp: '目前 {{t}} °C',
        BudgetDtNote: '每一步各自的 ∫D·dt，單位 nm² —— 這才是結深真正積分的量，也是上面兩種單位的換算關係：熱預算磁貼把同一塊面積除以 1000 °C 下的 ' +
          'D，折合成當量秒數。按步畫出來，指數關係一目了然：又短又熱的一步可能比又長又冷的一步花得更多。',
        SeriesStepDt: '每步 D·t',
        ChartDtAxis: 'D·t (nm²)',
        ChartBudgetDtTitle: '每一步的 D·t —— 花掉預算的是溫度',
        HopBuilding: '正在構建晶體 —— 放入間隙原子並讓 217 個原子在力場上鬆弛……',
        HopGlowNote: '黃色原子就是間隙原子。它是即時找出來的：離理想晶格所有格點最遠的那個原子 —— ' +
          '正因如此，每次踢出交換把間隙身份交給另一個原子時，標記都能跟上。在高溫下缺陷有時會攤在共享一個格點的兩個原子上（啞鈴構型）；這時兩個都會發光，因為它們倆確實都是缺陷。',
        HopMsdNote: '晶體旁邊的圖有兩條曲線，兩者之間的差距正是這一課的重點。實線是測量值：填隙原子實際走到了哪' +
          '裡，連續取樣，所以它隨晶格顫動，跳躍發生時上升，下一次踢出反向進行時又落回去。幾次跳躍的單' +
          '條軌跡不是任何東西的平均——同一溫度下三次執行分別達到 9.5、51 和 3.4 Å²，這' +
          '只是隨機行走小樣本的常態，所以不要從它上面讀斜率。虛線則把跳距的平方累加起來：如果這些跳躍' +
          '沒有一次折返，它們會走出的那條路。它只會上升，D 就是從這條線讀出來的——斜率除以六，單位' +
          '與推進擴散所用的相同。當實線落到虛線下方時，你看到的是關聯：填隙原子又回到了原處，這正是實' +
          '測擴散係數帶有關聯因子的原因。也要讀那些平段：跳躍是卜瓦松過程，所以即使在 1650 K，' +
          '兩皮秒內一次跳躍都沒有也完全正常，一次執行要跑滿十皮秒再讀數。對照組讓兩條線永遠平直——沒' +
          '有缺陷，就沒有什麼可追蹤，也沒有什麼可計數，D = 0。',
        HopMsdStatus: '填隙原子已離開出發點 {{a}} Å² · 跳躍求和 Σλ² = {{b}} Å² → D ≈ {{c}} Å²/ps（6·D·t）',
        HopChartY: '位移² (Å²)',
        HopMeasured: '填隙原子目前走到哪裡',
        HopJumpSum: '由跳躍推得的隨機行走（Σλ²）',
        HopChartX: '模擬時間 (ps)',
        HopArrTitle: '阿瑞尼斯圖 —— 每次 {{a}} ps 執行一個點，斜率 = −Eₐ/k',
        HopArrX: '1000 / T（K⁻¹）',
        HopArrY: 'ln(每 ps 跳躍次數)',
        HopArrPerPs: '次/ps',
        HopArrPoints: '已完成的執行',
        HopArrFit: '最小平方直線',
        HopArrEmpty: '在某個爐溫下讓間隙原子執行 {{a}} ps：執行會自行停止，並在這裡落成一個點。兩個爐溫就能畫出直線。',
        HopArrOne: '目前一次執行 —— 換一個爐溫再跑一次就能畫出直線',
        HopArrStatus: '{{n}} 次執行 · 由斜率得 Eₐ ≈ {{ea}} eV · 每個點帶有 ±1/√跳躍數 的卜瓦松計數誤差',
        HopArrSkipped: '{{n}} 次無跳躍的執行落在對數軸之外',
        HopArrClear: '清除各點',
        HopArrNote: '活化能就是這樣量的，在爐子裡和在這裡都一樣。跳躍速率按 exp(−Eₐ/kT) 變化，所以其對數對 1/T 是一條直線，斜率就是 −Eₐ/k。間隙原子每執行 {{a}} ps 就是一次量測：在幾個爐溫下各跑一次，點就會排成線，並帶著卜瓦松計數應有的離散——六次事件的一次執行，其速率大約只有 40% 的準確度。同一爐溫下的重複直接顯示了這種離散，因此直線是對全部點擬合而不是在兩點之間連線。完美晶體不畫在圖上：它在任何溫度下速率都是零，而零沒有對數。',
        SectionTunnel: '閘極氧化層為什麼有下限——穿隧',
        TunnelNote: 'THRM-04 成長這層氧化層，上面的配方想做多薄都可以。可電晶體用不了。薄到兩奈米以下，通道裡的電子就不再被氧化層擋住，因為電子是一列波，而波能夠伸進一堵它沒有足夠能量翻越的牆。這裡是一維薛丁格方程式的解：一個波包撞上一個高度等於矽–SiO₂ 能帶偏移的矩形位障。穿過去的比例每增厚十分之一奈米就按一個固定倍數下降，所以把氧化層從 2 nm 減到 1.2 nm，漏電會放大幾千倍——這正是業界轉向更厚的氧化鉿薄膜而不是更薄的二氧化矽的原因。位障兩側和位障內部統一使用 0.5 m₀ 的有效質量；這堂課依賴的是氧化層內部的衰減，而這個質量對它是正確的。 兩側的矽只是畫出它的晶格作為參照：模型中的電子以有效質量的自由粒子形式穿過它——晶體對這些能量的電子正是這樣起作用的——所以並沒有針對那些原子求解。 「按相位著色」按 ψ 的相位給波上色：條紋就是它的波長，隨波包移動，在走得快的地方變密；「藍與綠」只畫強度，牆後為綠色。',
        TunnelChartTitle: '越過氧化層的機率',
        TunnelChartX: '時間 (fs)',
        TunnelChartY: 'log₁₀ 比例',
        TunnelMeasured: '傳播的波包',
        TunnelFormula: '此波包的公式值',
        TunnelFailed: '薛丁格求解器載入失敗。',
        TunnelLoading: '正在載入薛丁格求解器…',
        TunnelStatus: '{{a}} fs · 越過氧化層 {{b}}（{{c}}）· 反射 {{d}}%',
        TunnelOneIn: '每 {{n}} 個電子中有一個',
        TunnelNone: '低於十億分之一',
        TunnelSum: 'Σ|ψ|² = {{s}}（反射 + 牆內 + 穿過，含吸收邊界）',
        TunnelColourLabel: '相位著色',
        TunnelChartShort: '轉移矩陣：穿透 {{a}} · 每奈米氧化層 {{b}} 個數量級',
        TunnelChartHelp: '這兩個數是什麼',
        TunnelChartStatus: '在這堵牆上用傳遞矩陣求解，並對波包的能量分布取平均：{{a}}（僅取平均能量則為 {{c}}）· 在此能量下每奈米氧化層 {{b}} 個數量級',
        TunnelThickTitle: '穿透率隨氧化層厚度的變化',
        TunnelThickX: '氧化層厚度 (nm)',
        TunnelRuns: '已完成的執行',
        TunnelLineAt: '{{e}} eV、{{v}} eV 位障下的公式',
        TunnelThickEmpty: '每次完成的執行都會在此按其厚度落成一個點。改變厚度再執行，直到把指數曲線畫出來。',
        TunnelThickStatus: '圖上的點：{{n}} · 在目前能量和位障下，虛線每奈米下降 {{b}} 個數量級',
        TunnelClear: '清除各點',
        TunnelThickNote: '上面那張圖一次只總結一次執行，這裡是它們合起來的實驗。每次完成的執行就是其厚度處的一個點；在三四個厚度下各跑一次，點會在這個對數軸上排成一條直線——對數軸上的直線就是指數。斜率是每奈米 2κ/ln 10 個數量級，κ 由電子能量低於位障多少決定，所以位障越矮直線越平緩：這就是 high-k 的全部理由，一張圖說完。在別的能量或位障下做出的點仍留在圖上並偏離目前的直線，這對它們來說是誠實的位置。',
        TunnelReset: '重設',
        TunnelSio2: 'SiO₂ · 3.1 eV',
        TunnelHfo2: 'HfO₂ · 1.5 eV',
        TunnelWidth: '氧化層厚度',
        TunnelEnergy: '電子能量',
        TunnelBarrier: '位障高度',
        TunnelPastLabel: '越過氧化層',
        BoxNote: '同一層氧化層，從上往下看，並且由原子構成。這是 Quantum Modeler 的二維盒子，牆由密排的排斥性原子核組成，間距 0.32 nm——大約是二氧化矽中相鄰原子的間距——層數由厚度決定：1.2 nm 的氧化層是四層。波包一邊前進一邊變寬，在原子前堆成駐波條紋——入射波與反射波在那裡交疊——一個微弱的副本穿過去繼續前進，用綠色放大畫出。原子核的高度使其在一層內的平均值等於能帶偏移，所以上面的平板正是它們的平均，虛線是這個厚度下平板公式的值。在旋鈕允許的每個厚度下，原子的穿透率與該平均值相差不過百分之幾十，這一點經過校驗；曲線與虛線之間的差距是原子造成的，不是誤差。「氧化層作為平板」把原子換成它們的平均。 細線是 |ψ|² 的等值線，取波包初始峰值的 2、9、20、36、56 和 81%；牆後按放大後的刻度繪製。',
        BoxChartTitle: '越過牆的機率',
        BoxChartStatus: '在這堵牆上用傳遞矩陣求解，並對波包的能量分布取平均：{{a}} · 在此能量下每奈米牆 {{b}} 個數量級',
        BoxPastLabel: '越過牆',
        BoxStatus: '{{a}} fs · 越過牆 {{b}}（{{c}}）· 反射 {{d}}%',
        BoxLayers: '{{n}} 層',
        TunnelTab1d: '一維 · 線',
        TunnelTab2d: '二維 · 俯視',
        TunnelTab3d: '三維 · 體積',
        TunnelTabLeak: '閘極漏電',
        LeakNote: '氧化層到底漏多少。上面幾個視圖回答的是一個電子有多大比例穿過去；而電晶體要問的是另一個問題——每平方公分多少安培，對照規格——這一頁回答的正是它。這裡的穿透率用傳遞矩陣求解，而不是傳播波包：對這個位形它是精確的，只要幾微秒，而且是對波包的獨立校驗，測試腳本把三者放在一起比對。然後對真正到達的電子積分，也就是 Tsu–Esaki 供給函數；它在零偏壓時為零：平的位障無論多薄都不導電流，所以這一頁也是位障開始傾斜的地方。把偏壓推過能帶偏移，氧化層遠端的角就落到電子以下，位障變成三角形，直接穿隧讓位給 Fowler–Nordheim。模型並沒有被告知這個轉變；傳遞矩陣只看得到位形。這裡有兩個不同的質量：氧化層內衰減用 0.5 m₀，矽中態密度計數用 0.19 m₀。沒有包含的、引用數字前該知道的：鏡像力位障降低、反轉層子能帶、任何陷阱輔助路徑，以及溫度（固定在 300 K）。結果是直接穿隧的估計，與實測氧化層相差約一個數量級，並且算在上面那些原子所平均成的平板上。',
        LeakStatus: '{{v}} V 下 {{j}} A/cm² · 電場 {{f}} MV/cm · {{r}}',
        LeakDirect: '直接穿隧',
        LeakFowler: 'Fowler–Nordheim',
        LeakBreakdown: ' · 已超過真實氧化層的崩潰場強',
        LeakOver: '超出 1 A/cm² 規格 {{n}} 倍',
        LeakUnder: '低於 1 A/cm² 規格 {{n}} 倍',
        LeakNone: '沒有偏壓就沒有電流：從閘極回來的電子和過去的一樣多。',
        LeakJvTitle: '閘極電流隨偏壓的變化',
        LeakJvX: '閘極偏壓 (V)',
        LeakJvY: 'log₁₀ A/cm²',
        LeakSeries: '{{w}} nm 氧化層',
        LeakBarrierSeries: '{{v}} eV 位障',
        LeakSpec: '規格，1 A/cm²',
        LeakHere: '目前設定',
        LeakThickTitle: '{{v}} V 下閘極電流隨氧化層厚度的變化',
        LeakJvCaption: '在目前偏壓處，曲線每伏特上升 {{d}} 個數量級。',
        LeakThickCaption: '在此偏壓下，曲線每奈米氧化層下降 {{d}} 個數量級。每微縮十分之一奈米，漏電就要付出一個固定的倍數，正是這一點終結了二氧化矽。',
        LeakBias: '閘極偏壓',
        LeakCathode: '矽通道',
        LeakOxide: '氧化層，{{w}} nm',
        LeakAnode: '閘極',
        LeakSpectrum: '電流來自哪裡',
        LeakThisWall: '目前這堵牆',
        LeakShort: '{{v}} V 下漏電 {{j}} A/cm²',
        LeakRunShort: '這次執行已確認 {{p}}%',
        LeakHelp: '這個電流是怎麼算出來的',
        LeakBeside: '這堵牆在 {{v}} V 下漏 {{j}} A/cm²。這是用傳遞矩陣在同一層氧化層上解出來的，而不是從左邊那個波包量出來的——電流需要通道所供給的每一個能量處的穿透率，那要跑上幾百次——兩者相差不過幾個百分點。',
        LeakRunCheck: '左邊這次執行到目前為止量到穿過這堵牆的是 {{a}}，而上面的電流所依據的是 {{b}}：已經走了 {{p}}%。電流是這堵牆的屬性，不是這次執行的屬性——執行所做的，是印證它。',
        VolumeNote: '再看三維。這是 Quantum Explorer 的三維模型——同樣的 Cayley 傳播子在 208 × 48 × 48 網格上按 x、y、z 拆分，同樣的密排原子核現在堆成真正的球層，同樣的吸收邊界和同樣的機率核算——在工作執行緒上求解，每次執行幾秒，並以體繪製畫出：波包所在處為藍色，牆後按自己的放大刻度為綠色。拖曳可旋轉，右鍵拖曳可平移，滾輪可縮放。穿透比例與二維盒子和一維模型量得的是同一個量，平板公式也是同一條虛線；兩者互相校驗。',
        VolumeIdle: '按 Run：波包在工作執行緒上傳播，每次執行幾秒。',
        VolumeRunning: '在工作執行緒上求解，每次幾秒',
        VolumeStop: '停止',
        VolumeUnavailable: '三維求解器需要工作執行緒，這裡無法啟動。',
        BoxAtoms: '氧化層作為原子',
        BoxSlab: '氧化層作為平板',
        BoxWallAtoms: '{{n}} 層原子 · {{w}} nm · 平均 {{v}} eV',
        BoxFormulaSlab: '同樣平均高度的平板',
        HopChartTitle: '填隙原子實際走了多遠，對比其跳躍所隱含的隨機行走',
        BudgetCaveat: '這個實驗是寫進場景腳本裡的，所以這個視圖沒有任何旋鈕，並且會在流程結束時自行停止：只有兩片晶圓拿到完全相同的預沉積，這個對比才有意義，而任何能單獨改動其中一片的旋鈕都會毀掉它。點重置會把整條流程重跑一遍。圖旁邊那兩條曲線就是熱預算本身 ' +
          '—— 每片晶圓的 ∫D ' +
          'dt，由場景自己的腳本即時累加，而不是這個面板算出來的。注意看它們分開的幅度比摻雜分布小得多：左邊晶圓多出大約三分之一的預算，卻在探針深度處造成三倍的濃度差，因為接面深度按 ' +
          '√(Dt) 變化。預算上的小變化，並不是元件上的小變化。',
        HopControlNote: '現在切換到完美晶體，把溫度推到滑桿的頂端。什麼都不動。不是變慢 —— ' +
          '是完全不動：即使把爐溫設到距熔點只差四十度，無缺陷晶格記錄到的跳躍次數也恰好是零；而同樣這個晶胞裡只要放進一個填隙原子，每隔兩三皮秒就會跳一次。這正是為什麼佈植損傷、以及修復它的退火，和摻雜屬於同一個主題：摻雜原子是搭著缺陷走的，而隔壁那台離子佈植機剛剛造出了大量缺陷。但請不要把這塊靜止的晶體讀成「沒有損傷的晶圓就不會擴散」。真實晶格在高溫下會自己產生缺陷——空位與填隙原子在熱平衡中不斷生成又復合，濃度由它們的形成能決定——1100 °C 的爐子裡多得很。這個晶胞做不到的是「等到」一個：216 個原子、皮秒量級的觀察窗，對這樣稀有的事件來說實在太小也太短。所以這個對照說明的是：缺陷是**載具**，而不是說高溫晶體裡沒有缺陷。',
        BudgetABNote: '兩片晶圓，相同的佈植、相同的預沉積。預沉積結束時流程分岔：左邊這片繼續走完剩下的步驟 —— 先 1000 °C，再 900 °C —— ' +
          '右邊這片則被淬冷到室溫，此後再沒有受過熱。淬冷的那片是對照組，它顯示的是你剛做完時這個接面原本的樣子。看著左邊那片繼續跑。到流程結束時，它的摻雜原子已經擴散出好幾倍的距離，而這全都來自那些跟形成這個接面毫無關係的步驟。上面那塊熱預算讀數統計的就是這件事，這也是為什麼一個接面要針對整條流程來設計，而不是只針對它自己那步退火。',
        SectionBudgetAB: '熱預算 —— 後續步驟會對已經做好的接面做什麼',
        HopReset: '重置計數',
        HopPause: '暫停',
        HopRun: '執行',
        HopTemp: '爐溫',
        HopPerfect: '完美晶體（對照）',
        HopWithDefect: '一個填隙原子',
        HopLoading: '正在載入分子動力學引擎…',
        HopFailed: '分子動力學引擎載入失敗。',
        HopStatus: '{{a}} 次跳躍 · {{b}}/ps · 實測 {{c}} K · {{d}} ps',
        HopCaveat: '這裡刻意沒有展示的，是一個硼原子的跳躍。硼的活化能是 3.46 eV —— 正是上面那個擴散場景的阿瑞尼斯關係所用的數字 —— 換算下來在 1100 ' +
          '°C ' +
          '大約每秒跳兩次。而這個視圖只能跑到皮秒量級，也就是說差了大約八個數量級，再快的電腦也補不上這個差距。填隙原子之所以看得見，僅僅因為它的位障低得多。正是這個差距，決定了晶圓尺度的擴散只能是偏微分方程裡一個擬合出來的係數，而不是對原子的模擬 ' +
          '—— 那個基本事件是真實的，只是稀有得根本無法觀看。',
        HopNote: '上面那個場景用一個隨溫度按阿瑞尼斯關係變化的擴散係數來搬運摻雜原子。這個數字就是由眼前這件事構成的：一個矽原子不在晶格格點上，而是卡在格點之間，把鄰居擠開、占據它們的位置。按下執行，看著計數往上走 ' +
          '—— 每一次跳躍都是 D 裡的一項。然後把爐溫調高，看著跳躍速率跟著升上去，這就是阿瑞尼斯因子在真實發生，而不是被斷言出來。',
        SectionHop: 'D(T) 是由什麼構成的 —— 一個原子換了位置',
        BudgetFlowEnded: '流程結束',
        BudgetQuenched: '淬冷',
        BudgetFullFlow: '走完整條流程',
        BudgetPredep: '共同的預沉積 —— 兩片晶圓完全相同',
        NoteTheSolverPutsThe: '求解器給出的接面比公式深 {{a}} 倍。原因就一句話：D 取決於那裡已有多少摻雜，所以重植入會自己往下挖，而這個分佈跨越了 {{b}} ' +
          '倍的擴散係數範圍，單獨一個阿瑞尼斯數表示不了。',
        NoteOnThisRecipeTheTwo: '在這個配方上兩者一致到 ' +
          '{{a}}%。對一個短週期來說這是誠實的結果：幾乎沒有擴散，分佈還是植入機留下的那個，用公式算完全沒問題。把退火加長，或者在下面加一步，就能看著它們分開。',
        ValueAllOfIt: '全部',
        ValueSolubilityCeiling: '{{a}} %（固溶度上限）',
        MetricElectricallyActive: '電活化比例',
        Value100ByConstruction: '構造上就是 100 %',
        MetricDoseLeftInThe: '留在晶圓內的劑量',
        ValueNoInterface: '沒有介面',
        ValueNmInterfaceMoving: '{{a}} nm，介面在移動',
        MetricSiliconConsumed: '消耗的矽',
        ValueOneNumberEverywhere: '處處同一個數',
        ValueSpreadNodeToNode: '節點間相差 {{a}} 倍',
        MetricDiffusivityAcrossThe: '分佈內的擴散係數',
        MetricSurfaceConcentration: '表面濃度',
        MetricJunctionDepth: '接面深度',
        LegendTheFittedGaussian: '擬合高斯',
        LegendTheEquationSolvedOn: '方程，在 {{a}} 個時間步上求解',
        LabelAnneal: '退火',
        LabelOxidation: '氧化',
        SecondaryLabel: '片電阻誤差',
        ToolLabel: 'THRM-04 · 立式爐與快速熱處理',
        LabelTryTheSpikeAnneal1100: '試試尖峰退火（1100 °C，2 秒）',
        NextASpikeAnnealSeparatesActivation: '尖峰退火靠又熱又短把活化和擴散分開。是什麼限制了它能有多短——升溫那麼快，晶圓又會發生什麼？',
        AxisYSheetResistanceSq: '片電阻 (Ω/sq)',
        AxisXJunctionDepthNm: '接面深度 (nm)',
        TitleJunctionDepthAgainstSheetResistance: '接面深度對片電阻——把取捨畫出來',
        NoteColdAndShortActivatesNothing: '低溫短時什麼都活化不了',
        LabelShortAnnealActivation: '短退火活化率',
        LabelSpikeAnnealActivation: '尖峰退火活化率',
        LabelItsSheetResistance: '它的片電阻',
        LabelShallowestRoute: '最淺的路線',
        HypJunctionDepthIsSetBy: '接面深度由植入的起點加上熱把它推了多遠決定，片電阻由這段深度裡有多少活化的摻雜決定。任何讓接面變淺的做法，都是把同樣的摻雜塞進更少的矽裡，所以電阻應該上升——除非這個改動同時也改善了活化。',
        AskedHowDoIMakeThe: '怎麼把接面做淺？每條路各要付出什麼代價？',
        SumTheJunctionDepthAndResistance: '接面深度與電阻的取捨，以及它為什麼沒有免費的一邊。',
        NextAGateOxideHasTo: '閘極氧化層只有幾奈米厚，還必須複現到其中的零頭。根據你剛看到的，你會用高溫短時還是低溫長時來長它——哪種對最終數字的控制更強？',
        TitleOxideThicknessAgainstTimeDry: '氧化層厚度隨時間的變化，乾氧與濕氧',
        NoteSqrt42WouldBe: 'sqrt(4) = 2 對應無線性項',
        LabelGrowthRatio: '生長比',
        LabelWet120Min: '濕氧，120 分鐘',
        LabelAt120Min: '120 分鐘時',
        LabelAt5Min: '5 分鐘時',
        AskedWhyDoesOxideGrowthSlow: '為什麼氧化層越厚，生長越慢？',
        SumTheLinearAndParabolicRegimes: '線性區與拋物線區，以及它們為什麼需要不同的配方。',
        LateralUnderstood: '推進退火是否只把摻雜劑向下推，還是也會把它橫向推到遮罩之下。',
        LateralHypothesis: '擴散沒有偏好的方向。遮罩決定的是摻雜劑從哪裡進入矽，而不是它最終到哪裡；一旦進入，它沿表面擴展應當和向體內擴展一樣容易——橫向侵入的距離應當跟隨結深，而不是隨退火進行越落越遠。',
        NextLateralBudget: '橫向侵入由與結深相同的 D·t 決定，所以收窄它的唯一辦法是少花熱預算。問我下游每個高溫工步會讓這個結付出什麼代價——那個實驗在一維裡跑，而你現在知道要把它的答案在橫向上再算一遍。',
        NextIfADownstreamStepIs: '如果下游步驟是固定的、去不掉的，剩下的唯一槓桿就是植入。問我：如果把接面做得淺到能挺過那個步驟，片電阻會怎麼樣。',
        LabelAfter1050C: '1050 °C 之後',
        LabelJunctionDepth: '接面深度',
        AxisYJunctionDepthNm: '接面深度 (nm)',
        AxisXStep0None: '步驟 (0 = 無)',
        TitleJunctionDepthAfterEachAdded: '每增加一個下游步驟後的接面深度',
        NoteEquivalentAt1000C: '折合 1000 °C 當量',
        LabelBudgetWorstCase: '預算，最壞情況',
        NoteAlmostFree: '幾乎免費',
        LabelAfterA450CStep: '經 450 °C 步驟後',
        LabelAfterA1050CStep: '經 1050 °C 步驟後',
        LabelJunctionAlone: '接面，單獨',
        HypDiffusionDependsOnlyOnThe: '擴散只取決於擴散係數與時間的乘積，對晶圓經歷過的每個步驟求和。如果這是對的，那麼下游新增的一個步驟——哪怕與這個接面毫無關係——照樣會移動它；而更熱的步驟會比更長的步驟移動得多得多，因為擴散係數對溫度是指數關係，對時間只是線性關係。',
        AskedTheImplantDidNotChange: '植入沒有變，接面卻變了。熱量是從哪裡來的？',
        SumShowThatEveryHotStep: '說明每個高溫步驟都在從同一個共享帳戶裡花錢。',
        fault: {
          wetHouseHeader: {
            Evidence: [
              '氧化層厚而接面沒動——水的特徵，不是爐管偏熱。',
              '管路露點偏高，而且新換的阱沒有解決。這兩件事合在一起，指向上游，別無他處。',
              '公用系統檢查發現總管帶水。',
              'ALD 那台機台在同一時間抱怨。它的症狀聽起來和這邊毫無相似，因為水在那邊幹的是完全不同的事——但那是同一股水。',
            ],
            Truth: '廠裡的乾燥氣乾燥器週末失效帶水了，總管裡帶著約 2% 的水——是液態攜帶，不是乾燥器飽和後 ppm ' +
              '級的緩慢爬升。它到達每一台呼吸廠務氮氣或氧氣的機台，到了之後幹什麼取決於那台機台拿這股氣做什麼用。注意兩個閾值差得有多遠：個位數 ppm ' +
              '的水就能毀掉 ' +
              'ALD，因為水是它的共反應物；而用蒸氣長氧化層的爐管低於約百分之一什麼都察覺不到。要兩台機台同時叫起來得是一次粗暴的失效，這正是兩個組幾乎從不把問題聯繫起來的原因。在這台機台上它看起來和水汽阱飽和一模一樣，因為就是同一股水換了條路來——在阱的上游，而不是在阱裡。這就是換阱毫無用處的原因，也是換完之後管路露點仍然讀濕的原因。',
            Complaint: '閘極氧化層又厚了，像上季度水汽阱那次。阱週一剛換過，沒有任何用。DEP-02 說他們的生長量也高了。',
            Label: '廠務氧氣總管帶水',
          },
          lowDose: {
            Evidence: [
              '片電阻遠高，而氧化層、接面和熱預算全都正常。熱的方面完全不涉及。',
              '峰值濃度掉了一半，任何退火錯誤都做不到這一點——退火只會攤開摻雜劑，不會拿走它。',
              '劑量監控片和植入機的日誌對不上。',
            ],
            Truth: '束流積分出了錯，晶圓實收劑量只有植入機日誌記的一半左右。摻雜劑減半就是載子減半，片電阻陡然上升。熱工步全都完全正常，所以接面幾乎不動——只是同樣的擴散分布裡坐著更少的摻雜劑。',
            Complaint: '片電阻高上天了。閘極氧化層沒問題。',
            Label: '植入機劑量不足',
          },
          hotAnneal: {
            Evidence: [
              '片電阻低、接面深，而閘極氧化層恰好在目標上——所以不管發生了什麼，都發生在氧化之後。',
              '熱預算高了約 90%，接面一動首先就該看這裡。',
              '植入劑量偏低也會動片電阻，但那是往上動，而且不會動接面。這次它往下動，接面還變深了。',
              '校準晶圓讀數比高溫計報的高約 50 C。',
            ],
            Truth: 'RTP 高溫計漂了，控制器把燈推到約 1100 C，報出來的卻是 1050 C。擴散係數服從阿瑞尼斯律，五十度幾乎讓退火花掉的 Dt ' +
              '翻倍：摻雜劑鋪得更遠，接面變深，片電阻下降。',
            Complaint: '片電阻偏低，接面比模型算的深。',
            Label: 'RTP 高溫計讀數偏低',
          },
          wetLine: {
            Evidence: [
              '氧化層厚了而接面沒有動。這一條一錘定音——爐管偏熱不可能放過接面。',
              '片電阻分毫不差，熱預算什麼都沒變。',
              '乾氧管路露點讀數遠超限值。',
            ],
            Truth: '乾氧管路上的水汽阱飽和了，到達爐管的氧化劑約有 5% ' +
              '是水。濕氧化比乾氧化快一個數量級，所以哪怕百分之幾也會讓氧化層嚴重超厚。製程的其他部分毫無察覺：水不擴散摻雜劑，接面和片電阻都原封不動。',
            Complaint: '閘極氧化層又厚了，跟上季度爐管那次一樣。',
            Label: '乾氧管路帶水',
          },
          hotFurnace: {
            Evidence: [
              '氧化層厚了，接面也變深了。只有溫度能同時做到這兩件事，因為只有溫度是每一步都在花的。',
              '氣路帶水會長出一模一樣的厚氧化層，卻把接面留在原地。這個對比本身就是診斷。',
              '測溫晶圓讀數比設定值高約 30 C。',
            ],
            Truth: '區域熱電偶漂了，爐管實際溫度約 930 C。氧化生長服從阿瑞尼斯律，30 C 就能多買 40% 的氧化層——但晶圓也以偏高 30 C ' +
              '的溫度待了二十分鐘，而這些時間花的是退火同一本熱預算。接面也跟著動了。',
            Complaint: '閘極氧化層厚了約 40%。配方沒動，設定值顯示 900 C。',
            Label: '氧化爐偏熱',
          },
          healthy: {
            Evidence: [
              '閘極氧化層和片電阻都在各自的認證值上。',
            ],
            Truth: '什麼問題都沒有。正確的判定就是放行這一批。',
            Complaint: '今早的監控片都在目標上。沒有任何報告。',
            Label: '爐管已認證',
          },
        },
        NoteXA: 'x/A = {{a}}',
        SectionSolvedBesideTheFormulaIt: '數值解與它取代的公式並排',
        NoteEverythingAboveWidensAGaussian: '上面的一切都是把高斯分布按根號 2Dt 展寬，D ' +
          '從退火溫度下的阿瑞尼斯直線上讀出。下面則是把擴散方程在網格上「解」出來——幾百個節點走完整個熱循環，每個節點的 D ' +
          '按局部濃度取值，氧化介面邊生長邊推進晶圓。退火短時兩者重合。退火長時兩者分開，而那道差距正是要造求解器的理由。',
        AxisYLogCm: 'log₁₀ nm⁻³',
        reading: {
          implantlog: {
            Label: '劑量監控片對植入機日誌（6 小時）',
          },
          pyrometer: {
            Label: 'RTP 高溫計對校準晶圓（3 小時）',
          },
          houseutilities: {
            Limit: '總管不漏，PCW 在供應溫度，乾燥氣 < 50 ppm',
            Label: '與廠務共同檢查公用系統（2 小時）',
          },
          moisture: {
            Label: '乾氧管路露點（2 小時）',
          },
          profilewafer: {
            Label: '全區爐溫測溫晶圓（4 小時）',
          },
          setpoints: {
            Limit: '按配方',
            Label: '爐溫 / 退火設定值',
          },
          budget: {
            Label: '已花費熱預算',
          },
          junction: {
            Label: '接面深度（SIMS）',
          },
          rs: {
            Label: '片電阻（四探針）',
          },
          oxide: {
            Label: '閘極氧化層（橢圓偏光儀）',
          },
        },
        aspect: {
          house: {
            Action: '停止在本機上的操作，知會廠務',
            Label: '本機無事可修——上報廠務',
          },
          implanter: {
            Action: '重新校準束流積分，重跑劑量監控片',
            Label: '植入機劑量控制',
          },
          rtp: {
            Action: '用測溫晶圓校準高溫計',
            Label: 'RTP 高溫計',
          },
          gasline: {
            Action: '更換水汽阱，吹淨並重新認證乾氧管路',
            Label: '氧化氣路',
          },
          furnace: {
            Action: '跑一片測溫晶圓並重新校準各區熱電偶',
            Label: '氧化爐溫度',
          },
        },
        SectionLot: '爐中的批次',
        LotNote:
          '上面的面板退火的是旋鈕所描述的東西。下面的爐子退火的是這片晶圓——它在 IMP-10 ' +
          '實際接受的植入,疊加在它已經歷的每一步熱製程之上。同一循環跑兩次,接面深度仍會繼續移動:晶圓記得,旋鈕不記得。',
        LotEmpty: '爐管處沒有批次。請從上游設備把晶圓送來退火。',
        LotIngot: '該批次還是晶錠。要先經 WPR-08 切片,爐子才能處理它。',
        LotCard: '流程卡',
        LotImplant: '攜帶植入:',
        LotNoImplant: '此晶圓沒有植入記錄——由配方旋鈕代替。',
        LotPrior: '步熱製程已在帳上——本循環將疊加其上',
        LotFresh: '尚無熱歷史。這是它的第一個循環。',
        LotRun: '對批次執行本循環並傳遞下去',
        SectionResult: '結果',
        SectionProfile: '摻雜分布',
        SectionDriveIn: '推進退火 — 即時二維擴散',
        SumShowThatADriveIn: '說明推進退火在加深接面的同時也同樣地展寬每一個圖形。',
        LabelJunctionDepth2D: '接面深度',
        LabelUnderTheMask: '遮罩下方',
        NoteEachSide: '每側',
        LabelLateralOverDepth: '橫向 / 縱向',
        NoteRoughlyConstant: '隨時間基本不變',
        LabelDopedWidth: '摻雜區寬度',
        NoteFromAWindow: '源自 {{nm}} nm 的窗口',
        TitleDepthAndLateralReach: '一次推進退火中的縱向深度與橫向擴展',
        AxisXAnnealMinutes: '退火時間（分鐘）',
        AxisYNm: 'nm',
        LabelDownDepth: '縱向（接面深度）',
        LabelSidewaysUnderMask: '橫向（遮罩下方）',
        TitleLateralAsAFraction: '橫向擴展佔縱向深度的比例',
        AxisYFraction: '橫向 / 縱向',
        LabelRatio: '比值',
        DriveInNote:
          '即時運行的模擬：硼通過 SiO₂ 遮罩上 0.6 µm 的窗口向矽中擴散，真實尺度' +
          '（畫面寬 2 µm）。硼的擴散係數按阿瑞尼斯規律隨退火溫度變化 — 一百度就是 D 的一個' +
          '數量級 — 試試同樣的時間分別在 1000 °C 和 1100 °C 下退火。再注意遮罩邊緣：接面在遮罩' +
          '下方橫向擴展約為縱向深度的 0.8 倍，這是任何一維分布圖都無法展示的。',
        DiLoading: '正在載入擴散引擎……',
        DiFailed: '擴散引擎載入失敗。',
        DiPause: '暫停',
        DiRun: '運行',
        DiReset: '重設',
        DiAnnealLabel: '退火',
        DiAnneal: '退火 {{c}} °C',
        DiJunction: '接面深 {{um}} µm',
        DiLateral: '遮罩下 {{um}} µm',
        DiClock: 't = {{min}} 分鐘',
        DiOpenInEnergy2D: '在 Energy2D 中開啟此場景 ↗',
        DiOpenInEnergy2DTitle: '在新分頁中用 Energy2D 編輯器開啟此場景，可以修改它的幾何結構與材料，也可以讓它的 AI 助手重建它。',
        DiGraphTitle: '各探針處的濃度',
        DiGraphX: '退火時間（分鐘）',
        ProfileNote: '摻雜原子最後落在哪裡。植入把它放在某個深度，此後的每一道熱製程都在把它攤開。接面深度，就是分布曲線降到基板摻雜濃度的那個位置。',
        SectionSteps: '下游熱製程步驟',
        StepsNote: '這些步驟發生在接面形成之後，跟這個接面本身毫無關係。加一道進去，看著接面照樣往下跑。擴散只認 D·t 的總和，矽並不知道哪一段熱是誰的。',
        SectionOxide: '氧化層成長——先線性，後拋物線',
        OxideNote: '薄氧化層受限於矽界面處的反應，厚度隨時間線性成長。厚氧化層受限於氧穿過既有氧化層的擴散，於是成長慢到與時間的平方根成正比。同一個方程式，兩種區制。',
        SectionBudget: '熱預算都花在哪',
        BudgetNote: '把每一道步驟都折算成「在 1000 °C 下產生同樣擴散所需的時間」。這樣各步驟之間才能比較，而 cm² 的數字不行。',
        SectionAmbient: '氧化氣氛',
        AmbientDry: '乾氧 O₂',
        AmbientWet: '濕氧（水氣）',
        AmbientDryShort: '乾氧',
        AmbientWetShort: '濕氧',
        AmbientNote: '水氣提供的氧化劑多得多，所以濕氧氧化要快上好幾倍。',
        SectionDopant: '摻雜劑',
        DopantBoron: '硼',
        DopantPhosphorus: '磷',
        DopantArsenic: '砷',
        DopantNote: '同樣的熱，越重的原子擴散得越慢——所以要接面淺的地方用砷，不要求淺的地方用硼。',
        SectionRecipe: '配方',
        SectionStored: '已存配方',
        SectionShift: '值班',
        NoSteps: '目前還沒有下游步驟。下面這個接面，就是植入和它自己那道退火做出來的。',
        Remove: '移除',
        StepContact: '接觸退火，450 °C，30 min',
        StepInterlayer: '層間氧化，700 °C，60 min',
        StepReflow: '迴流，900 °C，20 min',
        StepSecondGate: '第二道閘極氧化，1050 °C，30 min',
        StepOxidation: '氧化',
        StepAnneal: '退火',
        TileOxide: '氧化層厚度',
        TileRegime: '成長區制',
        RegimeLinear: '線性',
        RegimeMixed: '過渡',
        RegimeParabolic: '拋物線',
        TileJunction: '接面深度',
        NoteBefore: '下游步驟之前為 {{nm}} nm',
        NoteNoSteps: '沒有下游步驟',
        TileSheetR: '片電阻',
        TileActive: '活化比例',
        NoteLattice: '進入晶格位置的摻雜原子',
        TilePeak: '峰值濃度',
        TileBudget: '熱預算',
        NoteEquivalent: '折合 1000 °C 下的秒數',
        TileDt: 'D·t 總和',
        TileDownstream: '下游步驟數',
        ChartProfileTitle: '摻雜濃度隨深度的分布（對數座標）',
        ChartDepth: '深度（nm）',
        SeriesBefore: '下游步驟之前',
        SeriesAsProcessed: '實際處理後',
        AnnSubstrate: '基板摻雜',
        AnnJunction: '接面',
        ChartOxideTitle: '{{temp}} °C（{{ambient}}）下氧化層厚度隨時間的變化',
        ChartTime: '時間（min）',
        ChartThickness: '厚度（nm）',
        SeriesOxide: '氧化層',
        AnnYourTime: '你設的時間',
        ChartBudgetTitle: '各步驟時長——但真正花掉熱預算的是溫度',
        ChartStepIndex: '步驟序號',
        ChartSeconds: '秒',
        SeriesDuration: '時長',
        AssistantBlurb: '提出問題，我會設計一個實驗，用這台求解器把它跑出來，並報告真正得到的結果——然後再還你一個更銳利的問題。',
        AssistantLead: '整條流程裡每一道熱製程，花的都是同一個帳戶裡的錢。問我某一步花了多少，或者為什麼沒人動植入，接面卻自己變深了。',
      },
      gowning: {
        AirflowWafer: '晶圓處',
        AirflowWall: '牆面監測器',
        AirflowRatio: '產品/牆面',
        SectionAirflow: '看見這兩個「房間」（氣流與擴散）',
        AirflowNote:
          ' ' +
          '這是無塵區的一個剖面：天花板上的過濾器以設計風速把空氣向下推，一位穿著無塵衣的操作員站在氣流中，旁邊機台上放著敞開的產品，架高地板把空氣帶走。顏色表示操作員正在散發的粒子。看它往哪裡去。這裡沒有熱羽流，也不該有——溫熱的人體大約只能把空氣抬升到每秒零點二五公尺，而過濾器的風速接近它的兩倍。快到足以壓制下面工作的人，正是 ' +
          '0.45 m/s 這個數字的用途。操作員真正起的作用是擋路：氣流必須繞過身體，而這個障礙物的尾流才是把散發粒子帶到產品上的東西。 ' +
          '如果你看到這團雲爬到頭頂上方，那是尾流在翻轉，而不是熱氣上升：下降氣流中人體正上方的流動會隨著渦的脫落不時反向——此處實測某一刻向上 0.28 m/s，下一刻向下 0.19 ' +
          'm/s。這個區域裡沒有任何地方比別處更熱，也就沒有什麼能把它抬起來。現在把兩個探頭一起讀。牆面監測器幾乎什麼都讀不到，而操作員旁邊的產品正在被污染——這就是本模組反對它的全部理由。而且把下降風速調大，產品的讀數會更高而不是更低，因為正是氣流把散發的粒子往下送，再由機台把它橫向偏折到敞開的晶圓上。解決辦法是換個地方站，而不是加大風量。',
        SecondaryLabel: '擾動後恢復',
        ToolLabel: 'GOWN-00 更衣氣閘與規程區',
        fault: {
          starvedMakeup: {
            Evidence: [
              '區域壓力為負，低於 +5 Pa 的下限。',
              '工作區計數超出等級。',
              '濾網、潔淨服、互鎖和恢復時間全部正常——空氣在換，只是換進來的是走廊的空氣。',
              '全層每個區域讀數相同，廠務的公用設施面板顯示新風為設計值的 55%，房間為負壓。',
            ],
            Truth: '地下層的新風機組初效濾網堵塞，只送出約 55% 的設計新風量。本區域仍以全速換氣——空調機組、頂部濾網和潔淨服都正常——但排風機是以新風量來平衡的，平衡一失，整個潔淨室都低於走廊壓力。所有區域一起讀到負壓，走廊空氣從每條縫隙倒灌進來。追查本區域自身的排風什麼也找不到，因為本區域什麼都沒變；壓差梯度屬於建築，也只有建築能把它還回來。',
            Complaint: '所有區域的計數同時升高，而且每個區域相對走廊都讀到負壓。沒有新設備投運，也沒人動過排風。',
            Label: '整個潔淨室轉為負壓——新風不足',
          },
          starvedAir: {
            Evidence: [
              '恢復時間遠超 0.85 分鐘限值。',
              '過濾器組壓降遠在限值以內——風不是被堵住，而是根本沒送到。',
              '廠務公用系統面板顯示送風量只有設計值的 55%。',
            ],
            Truth:
              '四台循環空調機組裡有兩台皮帶打滑，這間潔淨間只拿到約 55% 的設計風量。這間房裡' +
              '沒有任何東西壞了——過濾器在壽命中段，壓差梯度正常，無塵服是新的。暴露它的數字是' +
              '恢復時間：潔淨間消化一次擾動要多久只由換氣次數決定，別的什麼都動不了它，所以過' +
              '濾器乾淨而恢復緩慢，問題在大樓，不在房間。換天花板過濾器要花十二小時，幾乎什麼' +
              '都換不回來。',
            Complaint:
              '同樣的人數下潔淨間讀數變髒，開門事件後恢復明顯變慢。天花板過濾器上個月剛換過。',
            Label: '潔淨間被廠務空調斷了風',
          },
          defeatedInterlock: {
            Evidence: [
              '互鎖讀作「被繞過」。',
              '工作區計數超出等級。',
              '其餘讀數全部正常，而且計數是陣發的，不是持續的。',
            ],
            Truth: '有人用膠帶封了氣閘的互鎖，好讓兩扇門能同時開——因為互鎖拖慢了一次裝機。他們每這麼幹一次，這個區就和走廊短暫連通一次。陣發本身就是特徵：持續的故障不會來了又走，而一扇被人撐開的門，多少通風都治不了。',
            Complaint: '計數一天裡一陣一陣地竄，而不是一直高。兩陣之間，能測的一切都在規格內。',
            Label: '氣閘互鎖被繞過',
          },
          wornGarments: {
            Evidence: [
              '無塵衣洗滌次數超過 30 次的限值。',
              '工作區計數超出等級。',
              '濾網壓降、區壓、恢復時間都正常。',
            ],
            Truth: '這個區領用的無塵衣批次已經洗到第 51 次了。織物越洗越鬆，鬆開了的無塵衣就不再是過濾器——它放過去的是新衣服的好幾倍。這個區機械上的一切都沒有問題。',
            Complaint: '只有一個區的計數在漲，而通風檢查完全正常。',
            Label: '無塵衣批次洗滌超次',
          },
          negativePressure: {
            Evidence: [
              '區壓 −14 Pa，下限 +5 Pa。',
              '工作區計數超出等級。',
              '濾網、無塵衣、互鎖全都正常——這不是一個區的問題，是一棟樓的問題。',
            ],
            Truth: '新排風把這個區抽到了 −14 ' +
              'Pa，於是它從每一條縫隙、每一個電纜穿孔往裡吸走廊的空氣，而不是往外推潔淨空氣。這個區在自己的邊界上不再是最乾淨的房間，而這正是潔淨室賴以成立的全部原理。',
            Complaint: '隔壁一台新機台的排風投用之後，全區的顆粒計數都上去了。',
            Label: '潔淨區變負壓',
          },
          loadedFilters: {
            Evidence: [
              '濾網壓降超過 220 Pa 的限值。',
              '恢復時間遠超 0.85 分鐘的限值。',
              '正壓、無塵衣、互鎖都沒問題。',
            ],
            Truth: '濾網組積滿了塵，風機推不動原來那麼多空氣，這個區的換氣次數遠低於設計值。穩態幾乎不動——發塵除以通風在發塵低時並不敏感——而恢復時間動得厲害，因為恢復時間只由通風決定。恢復慢的區，就是每次擾動之後髒得更久的區。',
            Complaint: '開過一台機台之後，這個區要老半天才能落定。牆上監測點還在等級內，誰也指不出哪裡不對。',
            Label: '濾網組積塵',
          },
          gownHealthy: {
            Evidence: [
              '檯上的每個讀數都正常。',
              '工作區計數在等級限值之內。',
            ],
            Truth: '什麼問題都沒有。這個區在產品處和在牆上一樣守得住等級。',
            Complaint: '例行巡查。牆上監測點讀數在等級之內。',
            Label: '一切正常',
          },
        },
        garment: {
          mask: '口罩',
          gloves: '手套',
          boots: '潔淨靴',
          hood: '頭罩',
          coverall: '連身服',
        },
        SectionGowning: '更衣',
        NoteOverMinOpenCln09: '敞開超過 {{a}} 分鐘——這些得靠 CLN-09 去除',
        NoteEffectiveAirChangesH: '有效換氣 {{a}} 次/小時',
        NotePeopleAtActivity: '{{a}} 人，活動強度 {{b}}%',
        NoteOf5Garments: '5 件無塵衣穿了 {{a}} 件{{b}}',
        NoteIsoAtMLimit: 'ISO {{a}}（{{b}} µm 粒徑）——限值 {{c}}',
        SectionAChainDoesNotAverage: '鏈條不取平均',
        NoteTheGarmentsMultiplyLeavingThe: '無塵衣的作用是相乘的。不戴頭罩丟掉的不是五分之一的防護，而是頭罩貢獻的整個倍數——牆上的房間監測點幾乎不會察覺，因為晶圓看到的世界由離它最近的人主導，不由全區平均值主導。穿衣出了錯，靠通風是補不回來的。',
        SectionStoredScenarios: '已存情境',
        SectionBayState: '潔淨區狀態',
        SectionBayAndProtocol: '潔淨區與規範',
        TextExposeTheLotToThis: '讓這批晶圓暴露在這個環境裡',
        LabelCorrectOrder: '順序正確',
        LabelOutOfOrder: '順序錯誤',
        LabelAtTheWafer: '晶圓處',
        LabelRoomMonitor: '房間監測點',
        NoteWhatTheWallReadsAnd: '牆上讀到的數——它不是產品看到的數',
        LabelGarmentPenetration: '無塵衣穿透率',
        LabelShedIntoTheBay: '散入潔淨區',
        LabelRecoveryAfterUpset: '擾動後恢復',
        LabelOntoTheWafer: '落到晶圓上',
        AssistantLead: 'GOWN-00 探究助理',
        AssistantBlurb: '可以問：監測讀數在潔淨等級內的區域，為什麼仍然在污染晶圓；一件無塵衣到底值多少粒子。每個回答都是在這個區域當前狀態下真實跑出來的。',
        reading: {
          houseutilities: {
            Label: '致電廠務查詢公用系統面板（0.5 h）',
          },
          recovery: {
            Label: '煙霧試驗與恢復時間，區內停產（2.0 小時）',
          },
          workZone: {
            Label: '工作區可攜式粒子計數，一小時（1.0 小時）',
          },
          interlock: {
            ValueBad: '已被旁路',
            ValueOk: '工作正常',
            Limit: '工作正常',
            Label: '氣閘互鎖',
          },
          garmentCycles: {
            Label: '無塵衣批次洗滌次數',
          },
          pressure: {
            Label: '潔淨區對走廊壓差',
          },
          filterDp: {
            Label: '濾網組壓降',
          },
        },
        aspect: {
          house: {
            Action: '停止在潔淨間裡換東西，上報廠務',
            Label: '問題不在這間房——上報廠務',
          },
          interlock: {
            Action: '修好互鎖，並查明是誰繞過了它、為什麼',
            Label: '氣閘互鎖',
          },
          garments: {
            Action: '撤下磨損的無塵衣批次，換發新洗滌週期的',
            Label: '無塵衣庫存',
          },
          pressurisation: {
            Action: '找出是什麼在抽走區內空氣，恢復壓差梯度',
            Label: '潔淨區正壓',
          },
          filters: {
            Action: '更換積塵濾網組並重新平衡頂棚送風',
            Label: '頂棚濾網',
          },
        },
      },
      gas: {
        ValueNotNeeded: '無需預警',
        NoteTheAlarmArrivesAfter: '報警到來時機台區已經處於危險之中',
        NoteThePurgeAsSpecifiedLeaves: '按規程吹掃仍殘留 {{a}} ppm——在這個比率下需要 {{b}} 個循環，而不是 {{c}} 個。不要打開面板。',
        NoteThePurgeAsSpecifiedReaches: '按規程吹掃可達到 {{a}} ppm，低於限值。面板可以打開。',
        VerdictImmediatelyDangerous: '立即危及生命或健康',
        VerdictAboveTheExposureLimit: '高於暴露限值',
        VerdictBelowTheExposureLimit: '低於暴露限值',
        NoteAlarmsAtPpmToRespond: '在 {{a}} ppm 報警，響應需 {{b}} 秒',
        ValueNoWarning: '無',
        NoteStaysBelowTheDangerous: '始終低於危險水平',
        NoteImmediatelyDangerousAt: '{{a}} 秒後立即危及生命',
        NoteEveryNumberOnThis: '這塊面板上的每個數字，都能在接上氣瓶之前用紙筆算出來：一根管線需要多少個吹掃循環，一處洩漏在穩態達到多少，一台探測器實際買到多少時間。吹掃是幾何級數，所以循環品質勝過循環次數——十次十比一和十次二比一花同樣的時間，結果差七個數量級。',
        ValueNever: '永遠不會',
        gasNote: {
          ammonia: '這張單子裡唯一在傷到你之前很久就能聞到的——這會養成壞習慣。',
          chlorine: '比空氣重，會在地面積聚，天花板上的探測器看不見它。',
          hydrogenFluoride: '氟離子追著鈣一直進到骨頭裡。全身性效應幾小時後才到。',
          phosphine: '既自燃又劇毒，所以一次洩漏既是火災也是中毒。',
          arsine: '五個 ppb。破壞紅血球；症狀出現之前傷害已經造成。',
          silane: '在空氣中自燃，有時有延遲——這讓洩漏有機會先積累。',
        },
        gasLabel: {
          ammonia: '氨氣 (NH₃)',
          chlorine: '氯氣 (Cl₂)',
          hydrogenFluoride: '氟化氫 (HF)',
          phosphine: '磷化氫 (PH₃)',
          arsine: '砷化氫 (AsH₃)',
          silane: '矽烷 (SiH₄)',
        },
        NotePyrophoricIgnites: '自燃性：在空氣中無需點火源即可起火。',
        SectionSpecies: '氣體種類',
        SecondaryLabel: '到達煙囪的量',
        ToolLabel: 'GAS-19 氣體庫與化學品分配',
        NextFac06SolvesTheSame: 'FAC-06 解的是同一套流導物理，只是用於真空而不是輸送。方程完全相同，算錯的後果卻不同——問問它：一根受限的前級管道要讓製程腔付出什麼。',
        TitleLineConductanceAgainstDiameter: '管線流導隨直徑的變化',
        LabelPyrophoric: '自燃性',
        LabelConductance: '流導',
        HypMolecularFlowConductanceGoesAs: '分子流流導與直徑的三次方成正比、與長度成反比，所以管線幾何對輸送的支配遠超直覺——直徑的小改動就是流導的大改動。而到達煙囪的東西應只取決於洗滌器，與管線完全無關。',
        AskedWhatDoesTheDeliveryLine: '輸送管線起什麼作用？到達排放煙囪的是什麼？',
        SumLineConductanceScrubberLoadingAnd: '管線流導、洗滌器負載，以及離開建築物的是什麼。',
        NextTheBayVentilationIsWhat: '機台區的通風決定穩態濃度。如果一台風機只跑半速而沒人發現，這些數字裡哪個先變——面板上有什麼會在洩漏之前把它顯出來嗎？',
        LabelNoWarning: '無預警',
        AxisYSecondsFromAlarmToIdlh: '報警到 IDLH 的秒數',
        AxisXLeakRateSccm: '洩漏速率 (sccm)',
        TitleWarningTimeAgainstLeakRate: '預警時間隨洩漏速率的變化',
        LabelSeverity: '嚴重度',
        LabelSteadyState: '穩態濃度',
        LabelAlarmsAt: '報警濃度',
        NoteAlarmToIdlh: '報警到 IDLH',
        HypADetectorAlarmsAtA: '探測器在某個濃度報警，而在它響應期間氣體還在繼續充滿機台區。有用的量不是報警濃度，而是從報警到空氣變得立即危險之間的秒數。洩漏夠快時，這個間隔縮到零，探測器就從警報變成了事後記錄。',
        AskedDoesTheDetectorGiveEnough: '探測器給出的預警夠多嗎？值得裝它嗎？',
        SumAlarmThresholdResponseTimeAnd: '報警閾值、響應時間，以及從報警到 IDLH 之間的秒數。',
        NextThePurgeNitrogenCarriesIts: '吹掃用的氮氣自帶水汽，濕吹掃會在管線裡生成固體，而不是清潔管線。這會對上面的曲線做什麼——規程裡寫的循環數還會是對的嗎？',
        TitleResidualConcentrationAgainstPurgeCycles: '殘餘濃度隨吹掃循環數的變化',
        LabelPurgeTime: '吹掃時間',
        LabelSetTo: '當前設定',
        LabelCyclesNeeded: '所需循環數',
        LabelResidual: '殘餘濃度',
        HypEachPurgeCycleReplacesA: '每個吹掃循環置換的是管線內容物的固定比例，不是固定數量。這使殘餘濃度隨循環數呈指數下降——從 100% 到 1% 所需的循環數與從 1% 到 ' +
          '0.01% 差不多，而「吹幾次就夠了」的直覺會錯上幾個數量級。',
        AskedHowManyPurgeCyclesDoes: '這根管線實際需要多少個吹掃循環？',
        SumCyclePurgingIsExponentialAnd: '循環吹掃是指數式的——最後一個數量級的濃度才是最慢的。',
        fault: {
          weakExtract: {
            Evidence: [
              '排風流量 35%，下限 90%。',
              '模擬釋放的穩態遠高於設計值。',
              '吹掃、閥門、洗滌器全都正常。',
            ],
            Truth: '排風機只剩設計流量的 ' +
              '35%。穩態濃度等於釋放速率除以通風，流量剩三分之一，任何一處洩漏的濃度就是三倍——它還拉長了清除洩漏的時間，而那是沒有人去算的另一半。',
            Complaint: '天熱的日子，氣瓶間裡有淡淡的溶劑味。',
            Label: '氣瓶間排風低於設計',
          },
          spentScrubber: {
            Evidence: [
              '介質負載 95%，限值 60%。',
              '排放口採樣超限。',
              '間內釋放模型完全沒有變化。',
            ],
            Truth: '洗滌介質已經吃到 ' +
              '95%。尾氣處理不會「關死」——它是退化的：去除效率下降，沒被摧毀的就從排放口上去了。氣瓶間裡的每個讀數都沒變，因為間裡確實什麼都沒變：這個故障完全發生在它所保護的人的下游，只有排放口採樣看得見它。',
            Complaint: '環保部門質疑了一個排放口讀數。氣瓶間內一切正常，而且一直正常。',
            Label: '尾氣處理介質耗盡',
          },
          seizedEfv: {
            Evidence: [
              '閥門功能測試讀作「未能關閉」。',
              '模擬釋放直接衝過 IDLH。',
              '水分、介質、排風全都正常——氣體和氣瓶間本身都沒有毛病。',
            ],
            Truth: '超流閥上次功能測試沒過，卻被簽成了通過。它是那道把斷管變成可控洩漏、而不是整瓶釋放的機械關卡——所以今天什麼都沒壞，而這個氣瓶間可能發生的事故規模已經放大了八倍。這是只會在要命的那一天才被發現的故障。',
            Complaint: '換瓶前的例行檢查。什麼都沒壞，什麼都沒發生。',
            Label: '超流閥卡死在開位',
          },
          wetHeader: {
            Evidence: [
              '總管水分 24 ppm，限值 1 ppm。',
              '吹掃後的管路分析遠超暴露限值。',
              '超流閥、洗滌器、排風都沒問題——問題在吹掃，也只在吹掃。',
            ],
            Truth: '氮氣總管的水分到了 24 ' +
              'ppm。水吸附在管壁上又緩慢脫附，於是每次抽空再也到不了乾燥時能到的真空，單循環的有效稀釋比垮了——而吹掃十次連乘的正是這個比。十個按設定完成的循環，在管路裡留下的砷化氫比規程假設的多四個數量級。面板數的是循環，數循環和數分子不是一回事。',
            Complaint: '上次換砷化氫鋼瓶時，一名技師報告聞到了點什麼。面板記錄了十個完成的吹掃循環——那正是認證規程。',
            Label: '吹掃氮氣帶水',
          },
          gasHealthy: {
            Evidence: [
              '檯上的每個讀數都正常。',
              '吹掃驗證結果低於暴露限值。',
            ],
            Truth: '什麼問題都沒有。正確的判定就是繼續換瓶。',
            Complaint: '換瓶前的例行檢查。面板上一片綠。',
            Label: '一切正常',
          },
        },
        TextPpmAgainstAPpmLimit: '{{a}} ppm，限值 {{b}} ppm',
        NoteSccmIntoMAtAch: '{{a}} sccm 漏入 {{b}} m³，換氣 {{c}} ACH',
        NoteCyclesAreNeeded: '做了 {{a}} 個循環——需要 {{b}} 個',
        NoteImmediatelyDangerousAtPpm: '{{a}} ppm 即危及生命',
        SectionArithmeticYouDoBeforeYou: '開閥之前先做的算術',
        SectionStoredScenarios: '已存情境',
        SectionBunkerState: '氣瓶間狀態',
        SectionAssessment: '評估',
        SectionPanelAndBay: '面板與氣瓶間',
        LabelExposureLimit: '暴露限值',
        LabelResidualAfterPurge: '吹掃後殘留',
        LabelLeakSteadyState: '洩漏穩態濃度',
        LabelToExposureLimit: '到暴露限值的時間',
        LabelWarningTheDetectorBuys: '偵測器換來的預警時間',
        LabelReachingTheStack: '到達排放口',
        NoteAfterAbatementAndAbatementDegrades: '經尾氣處理後——而尾氣處理是悄悄退化的',
        TextSignOffThisBayAs: '簽核：此氣瓶間可安全開啟',
        AssistantLead: 'GAS-19 探究助理',
        AssistantBlurb: '可以問：到底需要幾次吹掃循環、偵測器能不能及時警報、最後排到煙囪的是什麼。每個回答都是在這個氣瓶面板上真實跑出來的一次評估。',
        reading: {
          stackSample: {
            Label: '排放口採樣分析（5.0 小時）',
          },
          releaseModel: {
            Limit: '< 3 ppm，預警 > 0 秒',
            Label: '示蹤氣體釋放試驗，人員撤離（4.0 小時）',
          },
          purgeVerify: {
            Label: '吹掃後用可攜分析儀測管路（3.0 小時）',
          },
          extractFlow: {
            Label: '氣瓶間排風流量',
          },
          mediaHours: {
            Label: '洗滌介質負載',
          },
          efvTest: {
            ValueBad: '未能關閉',
            ValueOk: '通過',
            Limit: '通過',
            Label: '超流閥上次功能測試',
          },
          moisture: {
            Label: '吹掃氮氣水分',
          },
        },
        aspect: {
          ventilation: {
            Action: '把排風恢復到設計流量',
            Label: '氣瓶間排風',
          },
          scrubber: {
            Action: '更換洗滌器介質並在排放口重新認證去除效率',
            Label: '尾氣處理介質',
          },
          excessFlow: {
            Action: '更換超流閥，裝回鋼瓶前先做功能測試',
            Label: '超流閥',
          },
          purgeGas: {
            Action: '更換總管乾燥器，吹掃配氣管網並按水分重新認證',
            Label: '吹掃氮氣品質',
          },
        },
      },
      crystal: {
        LatticeStatus: '{{a}} 個原子 · 實測 {{b}} K · {{c}} ps',
        LatticeTemp: '晶體溫度',
        TraceTitle: '離晶格位點的距離 —— 熱振動',
        TraceX: '模擬時間（ps）',
        TraceY: '位移（Å）',
        TraceHost: '一個矽原子',
        TraceSiRef: 'Si 在 300 K 的均方根位移（X 光 Debye–Waller）',
        TraceStatus: '最近 {{a}} ps 內離位點的均方根位移：{{b}} Å · 鍵長 2.35 Å',
        TraceIdle: '按下執行：離位點的均方根距離在執行的最近 {{a}} ps 內測得',
        LatticeReset: '重設',
        LatticePause: '暫停',
        LatticeRun: '執行',
        LatticeFailed: '分子動力學引擎載入失敗。',
        LatticeLoading: '正在載入分子動力學引擎……',
        NoteLattice: '晶棒的原子級樣貌：鑽石立方結構的矽晶格——每個原子與四個近鄰共價鍵結——在 Stillinger–Weber ' +
          '力場下即時振動。沒有任何約束把原子固定在原位；晶體保持形狀，是因為這種排列正是該勢函數的基態。拖曳可旋轉視角，滾輪可縮放。把溫度升向熔點（1687 ' +
          'K），觀察熱振動如何模糊長晶爐辛苦贏得的秩序。',
        NoteBands: '這樣的原子排列對電子做了什麼——來自 AIMS 的緊束縛模型，不是畫出來的記憶曲線。陰影帶就是能隙：這塊晶體裡任何電子都不可能具有的能量。矽的導帶最低點並不在價帶最高點的正上方，所以虛線是斜的——越過能隙不僅要改變能量，還要改變動量，而單個光子給不了動量。這就是為什麼矽能做出極好的偵測器，卻做不出像樣的雷射。',
        BandsAxisEnergy: '相對價帶頂的能量（eV）',
        BandsLoading: '正在求解緊束縛模型……',
        BandsFailed: '該晶體沒有可用的能帶模型。',
        BandsGap: '能隙 {{ev}} eV',
        BandsDirect: '直接能隙，位於 {{at}}',
        BandsIndirect: '間接能隙，{{from}} → {{to}}',
        BandsMeasured: '實驗值 {{ev}} eV',
        SectionLattice: '最終產品——矽晶體晶格（分子動力學）',
        NoteSpecificationBand: '規格帶 {{a}} – {{b}} Ω·cm。{{d}} 片切片中有 {{c}} 片在帶內。',
        LabelGrowthTime: '生長時間',
        LabelPullRate: '拉速',
        SecondaryLabel: '拉速對上限',
        ToolLabel: 'CZ-07 柴氏長晶爐',
        NextTheFurnaceAtThrm04: 'THRM-04 的爐子會故意把這些氧沉澱到體內。問問它：一片帶著太少氧到貨的晶圓會怎麼樣。',
        AxisYOxygenCm: '氧 (nm⁻³)',
        AxisXCrucibleRotationRpm: '坩堝轉速 (rpm)',
        TitleOxygenAgainstCrucibleRotation: '氧含量隨坩堝轉速的變化',
        NoteAcrossTheSweep: '整個掃描範圍內',
        LabelRotationRange: '轉速範圍',
        LabelWith03TMagnet: '加 0.3 T 磁場',
        LabelOxygenAsSet: '當前設定的氧含量',
        HypTheMeltSitsInA: '熔湯盛在石英坩堝裡，所以坩堝一直在往熔湯裡溶解。如果這就是來源，那麼任何把熔湯攪得更猛的因素都會把更多的氧帶到界面——任何抑制對流的因素都會帶得更少。',
        AskedWhatPutsOxygenInThe: '是什麼把氧帶進晶體？什麼能改變它？',
        SumCrucibleDissolutionMeltConvectionAnd: '坩堝溶解、熔湯對流，以及為什麼氧是被規格化而不是被去除的。',
        NextVGHasTwoHalves: 'v/G 有兩半，你只動了一半。如果換成讓熱區改變梯度，窗口會怎樣——這兩個量裡哪個更容易穩穩保持三十個小時？',
        LabelPerfectSiliconBoundary: '完美矽邊界',
        AxisYVGCmMinK: 'v/G  cm²/(min·K)',
        AxisXPullRateMmMin: '拉速 (mm/min)',
        TitleVoronkovRatioAgainstPullRate: '沃龍科夫比隨拉速的變化',
        NoteLatentHeat: '潛熱',
        LabelRateCeiling: '拉速上限',
        LabelVGAsSet: '當前設定的 v/G',
        HypIfPullRateMatteredOnly: '如果拉速只關乎產量，這裡的每個拉速都會或快或慢地給出同一根晶體。如果沃龍科夫是對的，v/G ' +
          '會在這個範圍內的某處跨過一條邊界，主導點缺陷就換了種類——那是晶體本質的改變，不是製造快慢的改變。',
        AskedWhatDoesPullRateActually: '拉速除了決定生長要多久，實際上還決定什麼？',
        NextEveryWaferInABox: '一盒裡的每片晶圓都來自這條曲線上的不同位置。如果下游某個製程對基板電阻率敏感，那「批次」還算什麼？',
        LabelSpecLow: '規格下限',
        AxisXDistanceFromSeedMm: '距晶種距離 (mm)',
        NoteSpread: '分散',
        DesignOneGrowthAsSetThen: '先按當前設定長一根晶體，再用三份不同的電阻率規格去評判同一根晶體。三者之間晶體本身毫無變化：變的只是客戶願意接受其中多少。',
        HypBoronIsMoreSolubleIn: '硼在液態矽中的溶解度比在固態中高，所以每凝固一毫米，熔湯都比之前更富一點。如果確實如此，尾端的摻雜必然比晶種端重——電阻率更低——而且差距應朝末端越拉越大，而不是隨機漂移。',
        AskedWhyDoesResistivityChangeDown: '為什麼電阻率沿晶錠變化？這要付出什麼代價？',
        SumSegregationDownTheIngotAnd: '沿晶錠方向的分凝，以及一份規格允許你賣掉其中多少。',
        fault: {
          shakingLift: {
            Evidence: [
              '籽晶提升振動 55%，限值 10%。',
              '熱區探測沒問題——上限就在它該在的地方。',
              '加熱器校準正常。',
            ],
            Truth: '提升柱裡的一個軸承壞了，晶體在被提出時一直被搖晃。結構是在遠低於熱學上限的地方丟掉的，這就是熱區探測乾乾淨淨、爐次照樣失敗的原因。',
            Complaint: '這個月兩次失去結構，都在等徑段，而熱區是新的。',
            Label: '籽晶提升振動',
          },
          heaterDrift: {
            Evidence: [
              '加熱器校準值 78%，窗口是 ±2%。',
              '熱區探測得出的上限低於配方的拉速。',
              '籽晶振動正常，排除了機械那條失去結構的路。',
            ],
            Truth: '加熱器只輸出校準功率的 ' +
              '78%，介面處的軸向梯度遠比配方假設的平緩。梯度是帶走潛熱的東西，於是最大拉速掉到了一個沒變過的設定值之下——配方現在要的，比熱區給得起的多。',
            Complaint: '最近四爐裡有兩爐在放肩附近失去單晶結構。配方一年沒動過了。',
            Label: '加熱器失準',
          },
          restrictedArgon: {
            Evidence: [
              '氬氣流量 45%，下限 90%。',
              'FTIR 氧含量偏高。',
              '坩堝才第一爐——這不是耗材問題。',
            ],
            Truth: '氬氣管路堵到只剩 45% 的流量。氬氣的作用是在一氧化矽溶回去之前把它從熔體表面掃走；沒有氬氣，氧就回來了。它給出的 FTIR ' +
              '數字和用舊坩堝一模一樣，能分開兩者的是坩堝的讀數。',
            Complaint: '還是氧偏高，而坩堝上週才換的。',
            Label: '氬氣吹掃受阻',
          },
          spentCrucible: {
            Evidence: [
              '本坩堝的爐次已超限。',
              'FTIR 氧含量超出 12 ×10¹⁷ 的帶寬。',
              '氬氣流量正常，排除了氧上升的另一條路。',
            ],
            Truth: '坩堝已經是第五爐了。整個提拉過程中石英都在往熔體裡溶解，用舊的坩堝溶出的量幾乎是新坩堝的兩倍——於是氧含量上去了，而機台上每個設定值都紋絲沒動。什麼都沒改，而這恰恰是沒人往這裡看的原因。',
            Complaint: '最近兩根晶棒出的晶圓在爐裡析出氧了。元件那邊在問長晶爐是不是變了。沒有變。',
            Label: '坩堝爐次超限',
          },
          czHealthy: {
            Evidence: [
              '檯上的每個讀數都正常。',
              '上一根晶棒的氧含量在帶內。',
            ],
            Truth: '什麼問題都沒有。正確的判定就是開爐。',
            Complaint: '三天長晶前的開爐檢查。一切讀數正常。',
            Label: '一切正常',
          },
        },
        TextCm: '{{a}} Ω·cm',
        NoteLatentHeatCeilingMmMin: '潛熱上限 {{a}} mm/min',
        NoteVG: 'v/G = {{a}}',
        NoteCmSeedToTail: '{{a}} → {{b}} Ω·cm，從籽晶端到尾端',
        NoteOfMmGrown: '共長 {{a}} mm——{{b}}%',
        SectionWhyAnIngotIsNot: '為什麼一根晶棒不是同一種材料',
        SegregationLead: '晶體只取走熔體中摻雜劑的一個比例 k，所以沿長度方向摻雜越來越重。',
        SegregationHelp: '為什麼這只會讓晶錠更短，而不是更好',
        NoteDopantDoesNotPartitionEqually: '摻雜劑在固液兩相中的分配並不均等。晶體只取熔體中含量的 k ' +
          '分之一，其餘推回熔體，於是晶棒越長熔體越富集，晶體沿長度方向摻雜越來越高。電阻率是一條規格，達標的晶棒長度就是這台機台的良率——這就是為什麼把窗口收窄給不了客戶更好的晶棒，只給他們更短的一根。',
        SectionPullerState: '長晶爐狀態',
        SectionHotZone: '熱區 — 即時傳熱與流動',
        NoteHotZone:
          '即時運行的傳熱模擬，展示長晶爐的剖面：坩堝保持在加熱器溫度，熔融矽在浮力驅動下對流，' +
          '晶棒把熱量向上導到冷卻的籽晶頭。箭頭是熔體的流動 — 把熱量送到生長介面的環流。',
        NoteHotZoneMagnet:
          '磁場旋鈕在這裡同樣起作用。熔融矽是導體，橫加磁場後，任何運動的熔體微團都會被制動 — ' +
          '把磁場調大，就能看到箭頭逐漸平息。這就是磁控直拉的全部道理：正是這股環流把氧從石英坩堝' +
          '帶到生長介面，所以抑制環流就是長出低氧矽的辦法。被制動的熔體溫度也不再擺動，' +
          '而這正是晶體中不出現生長條紋的原因。',
        CzMagnet: '磁場',
        CzLoading: '正在載入傳熱引擎……',
        CzFailed: '傳熱引擎載入失敗。',
        CzPause: '暫停',
        CzRun: '繼續',
        CzReset: '重設',
        CzClock: 't = {{s}} 秒',
        CzProbeMelt: '熔體',
        CzProbeInterface: '介面',
        CzProbeBoule: '晶棒',
        SectionResistivityDownTheIngot: '沿晶棒的電阻率',
        TextGrowTheIngotAndSend: '長完這根晶棒，送去 WPR-08',
        BandsAbout: '旁邊的能帶結構：這種排列對電子意味著什麼',
        LabelUsableIngot: '晶棒可用比例',
        LabelResistivitySpread: '電阻率散布',
        LabelDefectRegime: '缺陷區制',
        LabelInterstitialOxygen: '間隙氧',
        NoteStrengthAndGetteringOrPrecipitates: '強度與吸雜，或是析出物',
        NoteOneCrystalStartToFinish: '一根晶體，從頭到尾',
        AssistantLead: 'CZ-07 探究助理',
        AssistantBlurb: '可以問：電阻率沿晶棒的偏析、這根晶體能拉多快、氧從哪裡來。每個回答都是在這台長晶爐上真實跑出來的一次成長。',
        reading: {
          gradientProbe: {
            Label: '熱區熱電偶探測，熱區打開（5.0 小時）',
          },
          oxygenCheck: {
            Label: '上一根晶棒的 FTIR 間隙氧（3.0 小時）',
          },
          vibration: {
            Label: '籽晶提升振動',
          },
          argonFlow: {
            Label: '氬氣流量',
          },
          heaterCal: {
            Label: '加熱器功率校準',
          },
          crucibleRuns: {
            Label: '本坩堝已用爐次',
          },
        },
        aspect: {
          seedLift: {
            Action: '更換提升柱軸承並重新平衡',
            Label: '籽晶提升機構',
          },
          argon: {
            Action: '清除氬氣管路堵塞並重設流量',
            Label: '氬氣吹掃',
          },
          heater: {
            Action: '對參考高溫計重新校準加熱器並重測熱區',
            Label: '加熱器校準',
          },
          crucible: {
            Action: '報廢坩堝重新裝料。三天產量，但無可避免',
            Label: '石英坩堝',
          },
        },
      },
      waferprep: {
        NoteSurfaceCaveats: '三點如實說明。這是潔淨表面 —— 真空設備在 HF ' +
          '浸洗或原位烘烤之後看到的那個表面；放在空氣中的晶圓幾分鐘內就會長滿自然氧化層。重構也並不是晶圓要花上幾皮秒去做的事，它就是潔淨表面本來所處的狀態；從理想切面出發，只是為了讓你看清這中間換掉了什麼。還有，真實的二聚體是傾斜的，每一對中一個原子高、一個原子低，因為電荷在兩者之間發生了轉移 ' +
          '—— 那屬於電子結構，而古典力場裡沒有電子，所以這裡的原子對保持對稱。板片底部被固定住：那些原子代表盒子之外那 775 µm 厚的晶圓。',
        NoteSurfaceDimers: '理想的切面並不是真實表面的樣子。把晶格切開，頂層每個原子都失去四條鍵中的兩條 —— ' +
          '那些紅色原子就是，每一條都是無處安放的斷鍵。按下執行看看：相鄰原子彼此傾靠、兩兩配對，各自用一條懸掛鍵換來它們之間的一條新鍵。配成的對叫二聚體，它們還排成一行行，這個 ' +
          '2×1 重構就是每一片潔淨 Si(100) 晶圓真正的表面結構。這裡沒有任何腳本安排它 —— 是 Stillinger–Weber ' +
          '勢告訴原子配對後的表面能量更低，原子就走了過去。它從來不會完全配完：配對是就近做出的決定，於是總有幾個原子被落下 —— ' +
          '它們兩側本該成為搭檔的原子都已經先跟別人配了對，真實的 Si(100) 表面也帶著同樣的缺陷。把晶圓冷到 150 K ' +
          '再重置，差得就更遠了：原子已經沒有能量去找到自己的搭檔。',
        SurfaceReset: '回到理想切面',
        SurfacePause: '暫停',
        SurfaceRun: '執行',
        SurfaceTemp: '晶圓溫度',
        SurfaceLoading: '正在載入分子動力學引擎…',
        SurfaceFailed: '分子動力學引擎載入失敗。',
        SurfaceChartTitle: '二聚體數隨時間變化',
        SurfaceChartX: '模擬時間 (ps)',
        SurfaceChartY: '二聚體數',
        SurfaceChartSeries: '二聚體',
        SurfaceChartAllSites: '全部位點配對',
        SurfaceStatus: '{{a}}/{{b}} 個二聚體 · {{c}} 個原子仍未配對 · 實測 {{d}} K · {{e}} ps',
        NoteSurface: '鋸切方向垂直於晶種，因此晶圓上的缺口其實是在聲明表面屬於哪個晶面 —— 對 CMOS 邏輯而言那就是 (100)，因為 (100)/SiO₂ ' +
          '介面的電學陷阱密度最低，反轉層中的電子遷移率最高。這裡顯示的就是那個晶面，取自單晶爐拉出的同一塊金剛石立方矽。左鍵拖曳旋轉，滾輪縮放，右鍵拖曳平移。',
        SectionSurface: '它呈現的表面 —— Si(100) 晶面（分子動力學）',
        NoteFrontOnly: '只加工正面——背面還是鋸切態',
        NoteBothFacesBalanced: '兩面平衡',
        LabelBow: '彎曲度',
        SecondaryLabel: '劃痕',
        ToolLabel: 'WPR-08 切片、研磨與拋光',
        NextCmp11FlattensEachLayer: 'CMP-11 每建好一層就壓平一層，並把自己的聚焦預算交給同一台掃描機。到第十層金屬時，兩者哪個更要緊？',
        AxisYTtvM: 'TTV (µm)',
        AxisXPolishTimeMin: '拋光時間 (min)',
        TitleTtvAndFlatnessYieldAgainst: 'TTV 與平整度良率隨拋光時間的變化',
        LabelRoughness: '粗糙度',
        LabelFlatnessYield: '平整度良率',
        HypTtvIsAThicknessVariation: 'TTV 是厚度差，拋光應能減小它。彎曲不是——它是一種形狀，而形狀來自兩面之間的失衡。如果這是對的，延長拋光應能壓平 TTV ' +
          '而對彎曲幾乎無用；只加工一面則應讓彎曲急劇惡化，而 TTV 幾乎無感。',
        AskedWhatSetsTheFlatnessOf: '是什麼決定成品晶圓的平整度？',
        SumTtvBowAndWarpAnd: 'TTV、彎曲與翹曲，以及晶圓交給微影的聚焦預算。',
        NextDice15GrindsThisWafer: 'DICE-15 會在元件做完之後把這片晶圓磨到十分之一的厚度，物理相同，餘量卻一點沒有。問問它：損傷在那裡要付出什麼。',
        AxisYDamageM: '損傷 (µm)',
        AxisXLapRemovalPerSideM: '每面研磨去除量 (µm)',
        TitleResidualDamageAndStrengthAgainst: '殘餘損傷與強度隨研磨去除量的變化',
        NotePerWafer: '每片晶圓',
        LabelScratches: '劃痕',
        LabelStrength: '強度',
        LabelResidual: '殘餘損傷',
        LabelSawDamage: '鋸痕損傷',
        HypAnAbrasiveCutLeavesCracks: '磨料切割會在它切出的表面之下留下裂紋，深度大致與磨粒尺寸成正比。如果是這樣，一片看起來完美的晶圓仍可能很脆弱——鋸後的去除工序不是修飾性的，而是結構性的。',
        AskedHowDeepDoesTheSaw: '鋸痕損傷有多深？去掉它要付出什麼？',
        SumSubsurfaceDamageAndWhyThree: '亞表面損傷，以及為什麼鋸後要跟三道工序而不是一道。',
        NextTheGapBetweenCutAnd: '那張圖上「切出」與「出貨」之間的差距就是平整度和破片。問我是什麼決定了它。',
        AxisXWireDiameterM: '鋼線直徑 (µm)',
        TitleWafersFromOneIngotAgainst: '單根晶錠出片數隨鋼線直徑的變化',
        NoteAfterFlatnessAndBreakage: '扣除平整度與破片後',
        LabelIngotLost: '晶錠損失',
        HypEveryCutRemovesASlot: '每一刀都切掉一條與鋼線加線上磨料同寬的槽，那些矽就沒了。如果鋸縫與晶圓厚度相當，損失就應大得驚人——不是捨入誤差，而是那根花了三十個小時才長成的晶體的一大部分。',
        AskedHowMuchOfTheIngot: '晶錠有多少變成了晶圓？由什麼決定？',
        SumKerfLossWaferCountAnd: '鋸縫損失、晶圓數量，以及以漿料形式流走的矽。',
        fault: {
          oversizeSlurry: {
            Evidence: [
              '拋光液粒徑是批次規格的 240%。',
              '刮痕計數遠超限值，而平整度分布乾乾淨淨。',
              '鋸和墊的每個讀數都正常。',
            ],
            Truth: '這批拋光液團聚了，粒徑跑到規格的 2.4 ' +
              '倍。超大顆粒對平整度毫無影響——它們犁出一道道深刮痕，而在一片其餘完美的晶圓上，刮痕就是致命缺陷。這是這台機台上最便宜的維修，而它在另外三個故障比拼的那條軸上完全隱形。',
            Complaint: '檢測在成品晶圓上發現長刮痕。每一片的平整度都完美。',
            Label: '拋光液批次粒徑超差',
          },
          glazedPad: {
            Evidence: [
              '拋光墊小時數超過 45 小時的限值。',
              '監控片上的去除量低於 0.28 µm 的下限。',
              '鋸縫和張力都正常。',
            ],
            Truth: '拋光墊用到 76 ' +
              '小時已經釉化。釉化的墊不再輸送拋光液，去除速率崩掉——於是拋光既磨不掉厚度，也做不了製程指望它做的整平。鋸完全無辜，兩個鋸的讀數都這麼說。',
            Complaint: '平整度勉勉強強，晶圓出來還偏厚。',
            Label: '拋光墊釉化',
          },
          slackWire: {
            Evidence: [
              '張力 19 N，窗口是 26 – 30 N。',
              '平整度分布嚴重超差，而鋸縫寬度完全正常。',
              '鋸線公里數在限內——這不是耗材。',
            ],
            Truth: '一只張力臂讀數偏低，鋸線只有 19 N 而不是 28 ' +
              'N。鬆的線在切縫裡游走，切槽就起伏——和磨鈍的線造成的退貨平整度一模一樣，起因卻完全不同。這裡的鋸縫是正常的，因為線還鋒利；它只是沒被繃直。',
            Complaint: '還是平整度退貨，而鋸線週一才換的。',
            Label: '線張力偏低',
          },
          wornWire: {
            Evidence: [
              '鋸線公里數超過 450 km 的限值。',
              '鋸縫寬度超過 185 µm。',
              '張力在目標上，拋光墊也在壽命內。',
            ],
            Truth: '鋸線已經跑了 810 ' +
              '公里。磨鈍的線丟了磨料，是在犁而不是在切，既加寬了鋸縫，也留下更起伏的切槽——而這份起伏能挺過研磨和拋光，變成厚度波動。鋸縫量測就是它和另外兩種丟平整度的方式的分界。',
            Complaint: '最近三根晶棒平整度都跑了，客戶退了兩根。',
            Label: '鋸線超程',
          },
          wprHealthy: {
            Evidence: [
              '每個耗材計數都在限值內。',
              '平整度分布遠低於 1.5 µm。',
            ],
            Truth: '什麼問題都沒有。正確的判定就是加工這根晶棒。',
            Complaint: '例行晶棒。出片數和平整度都正常。',
            Label: '一切正常',
          },
        },
        NoteTtvTheScannerHasTo: 'TTV——掃描機就得在這上面曝光',
        NoteFromMTheSawLeft: '從鋸留下的 {{a}} µm 算起',
        NoteMKerfKgOfCrystal: '{{a}} µm 鋸縫——{{b}} kg 晶體',
        NotePassFlatnessAndHandling: '{{a}} 片通過平整度與操作損檢驗',
        SectionTheOneThatIsGenuinely: '真正違反直覺的那一條',
        BowLead: '只要損傷在兩面都有，損傷更多的晶圓反而可能比更乾淨的晶圓更平。',
        BowHelp: '為什麼翹曲不是損傷的度量',
        NoteADamagedLayerIsA: '有損傷的層就是有應力的層，而兩面平衡的應力什麼也彎不了。只加工正面，背面就留著鋸下的全部損傷，晶圓於是弓彎——這意味著損傷更多的晶圓反而可能比更乾淨的更平，只要損傷是對稱的。弓彎不是損傷的度量。這就是研磨和拋光都做雙面的原因。',
        FacesBoth: '雙面加工',
        FacesFront: '僅正面加工',
        HistoryBareWafer: '裸拋光晶圓，無膜層',
        HistoryStockBlank: '庫存坯片——鋸檯上沒有來自 CZ-07 的晶錠。',
        SectionDoubleSidedProcessing: '雙面加工',
        SectionLineState: '產線狀態',
        TextSliceTheIngotAndStart: '切開晶棒，讓一片晶圓上線',
        LabelWafersFromTheIngot: '晶棒出片數',
        LabelLostAsSlurry: '損失為磨漿',
        LabelResidualDamage: '殘餘損傷',
        LabelBreakingStrength: '斷裂強度',
        NoteSetByTheWorstFlaw: '由留在表面的最壞一處缺陷決定',
        LabelFlatness: '平整度',
        AssistantLead: 'WPR-08 探究助理',
        AssistantBlurb: '可以問：切割損失了多少矽、損傷有多深、晶圓為什麼會翹曲。每個回答都是在這條線上真實跑出來的。',
        reading: {
          scratchCount: {
            Label: '暗場掃查刮傷，25 片（2.0 小時）',
          },
          removalRate: {
            Label: '監控片拋光去除量（1.0 小時）',
          },
          kerfCheck: {
            Label: '廢段上的鋸縫寬度（2.0 小時）',
          },
          ttvMap: {
            Label: '電容式平整度測繪，10 片（1.5 小時）',
          },
          slurrySize: {
            Label: '拋光液粒徑，對批次規格',
          },
          padHours: {
            Label: '拋光墊已用小時',
          },
          tension: {
            Label: '線張力',
          },
          wireKm: {
            Label: '鋸線已用公里數',
          },
        },
        aspect: {
          slurry: {
            Action: '更換拋光液批次並檢查粒徑分布',
            Label: '拋光液',
          },
          pad: {
            Action: '修整拋光墊；若釉化到修不動就更換',
            Label: '拋光墊',
          },
          tension: {
            Action: '重設張力臂並將載荷感測器歸零',
            Label: '線張力',
          },
          wire: {
            Action: '換線軸，並在廢晶棒段上重新認證鋸縫',
            Label: '鋸線',
          },
        },
      },
      inspection: {
        LeadTopOfDistribution: '這台設備回報的只是尺寸分布的頂端。它沒有壞，這是光學定律。',
        NoteThisScanWouldReport: '這次掃描會報出 {{a}}/cm²。這與晶圓實際攜帶的接不接近，只有探針台能回答。',
        SecondaryLabel: '誤報率',
        ToolLabel: 'INSP-13 圖形晶圓檢測',
        NextAYieldMapAtPrb: 'PRB-14 的良率圖按定義覆蓋每一顆裸晶。這讓晶圓測試成了什麼——一個檢測工步，還是產線上唯一的全覆蓋檢測？',
        AxisXWaferCoverage: '晶圓覆蓋率',
        TitleScanTimeAgainstCoverage: '掃描時間隨覆蓋率的變化',
        LabelTimeSaved: '省下的時間',
        LabelAtFullCoverage: '全覆蓋時',
        LabelAt10Coverage: '10% 覆蓋時',
        HypADensityIsAPer: '密度是按面積計的數字，所以局部掃描對它的估計應幾乎和全掃一樣好——抽樣對平均值有效。抽樣做不到的是找出局部化的特徵，因為落在未掃區域裡的缺陷簇對估計值和分佈圖都毫無貢獻。',
        AskedWhatDoesScanningLessOf: '少掃一部分晶圓要付出什麼？',
        SumSampledCoverageScanTimeAnd: '抽樣覆蓋、掃描時間，以及局部掃描能告訴你什麼、不能告訴你什麼。',
        NextPrb14MeasuresTheYield: 'PRB-14 測的是這個缺陷密度所預測的良率。如果兩者不一致，哪個錯了——你會把一批晶圓押在哪個上？',
        LabelDesignRule: '設計規則',
        AxisYDetectionLimitNm: '偵測極限 (nm)',
        AxisXPixelNm: '像素 (nm)',
        TitleDetectionLimitAndScanTime: '偵測極限與掃描時間隨像素尺寸的變化',
        HypScatteredIntensityFallsExtremelyFast: '散射強度隨顆粒尺寸下降得極快，所以小於某個直徑的缺陷返回的光比噪聲底還少，看多久都沒用。缺陷尺寸分佈是冪律，意味著小的才是多數。如果兩者都成立，看不見的群體應遠大於看得見的——而其中一部分仍大到足以殺死一顆裸晶。',
        AskedWhatCanThisRecipeNot: '這個配方看不見什麼？其中有要緊的嗎？',
        SumTheDetectionLimitAndWhy: '偵測極限，以及為什麼每個檢測數字都是低估。',
        NextNeitherEndOfThatCurve: '那條曲線的哪一端都到不了 100% 捕獲率。問我為什麼——答案不在閾值，而它是兩個極限裡更重要的那個。',
        AxisXThreshold: '閾值 (σ)',
        TitleCaptureAndNuisanceAgainstThreshold: '捕獲與誤報隨閾值的變化',
        NoteWhatIsActuallyThere: '實際存在的量',
        LabelReported: '報出數',
        LabelNuisance: '誤報',
        HypTheThresholdIsALevel: '閾值是噪聲底之上的一個水平，而真實缺陷和表面噪聲在同一根軸上。調低它必然兩者都抓到更多。如果是這樣，就不存在單純「更靈敏」的設定——只有哪種錯誤更貴的選擇，而誤報的代價是用 ' +
          'SEM 複檢小時數付的。',
        AskedWhatDoesTurningTheDetection: '把偵測閾值調低，實際買到了什麼？',
        SumCaptureRateAgainstNuisanceRate: '捕獲率對誤報率，以及為此買單的複檢時間。',
        fault: {
          roughIncoming: {
            Evidence: [
              '來料粗糙度 1.6 nm，限值 0.5 nm。',
              '霧度、雷射功率、載台振動全都正常。',
              '現象只出在一個產品上——機台故障會出在所有產品上。',
            ],
            Truth: '檢測機沒有任何問題。晶圓到貨就是 1.6 nm RMS 而不是 0.3——CLN-09 的 SC-1 ' +
              '下手太狠——而表面粗糙度正是誤報群體生長的地基。給一台光學本來就乾淨的機台洗光學，要花四個小時，什麼也治不了。',
            Complaint: '某個產品的誤報數翻了三倍。檢測機正在背鍋。',
            Label: '晶圓本身粗糙，機台沒有問題',
          },
          stageShake: {
            Evidence: [
              '載台振動 60%，限值 10%。',
              '捕獲率下降，而雷射功率和霧度都正常。',
            ],
            Truth: '一只氣浮隔振墊漏了壓，載台把地板的振動帶進了每一次掃描。圖像拖影，丟靈敏度的方式和弱光源一樣——但振動讀數直接點了它的名，而雷射是好的。',
            Complaint: '掃描變慢了，圖看起來沿掃描方向拖了影。',
            Label: '載台隔振退化',
          },
          hazedOptics: {
            Evidence: [
              '霧度讀 45%，限值 10%。',
              '誤報率遠超 40% 的複檢限值。',
              '雷射功率監測完全正常。',
            ],
            Truth: '收光光路起霧了。它把雜光散進偵測器，既抬高了雜訊本底，又丟了靈敏度——機台同時變得更瞎、更吵。這個組合就是特徵：弱雷射只佔前一樣，不佔後一樣。',
            Complaint: '複檢那邊快淹死了。他們看的點一半什麼都沒有，佇列排到兩天開外。',
            Label: '收光光學被汙染',
          },
          tiredLaser: {
            Evidence: [
              '功率監測讀 55%，下限 85%。',
              '標準片上的捕獲率崩了。',
              '誤報率正常——弱光源只丟靈敏度、不添雜訊，這是它和光學起霧的分界。',
            ],
            Truth: '雷射只剩額定功率的 55%。散射訊號隨照明強度變化，檢出下限於是抬高，最小的那批缺陷乾脆不再被報出來。計數下跌是因為機台瞎了，不是因為廠子乾淨了。',
            Complaint: '所有產品的缺陷計數連跌了兩個星期。產線以為是廠子變乾淨了。',
            Label: '照明光源衰退中',
          },
          inspHealthy: {
            Evidence: [
              '檯上的每個讀數都正常。',
              '捕獲率就在標準片說它該在的地方。',
            ],
            Truth: '什麼問題都沒有。正確的判定就是放行這一批。',
            Complaint: '例行開班。這台機台一直安安靜靜。',
            Label: '一切正常',
          },
        },
        NoteOfTheWafer: '晶圓的 {{a}}%',
        NoteOfReviewsWasted: '{{b}} 次複檢浪費了 {{a}} 次',
        NoteRealNuisance: '真缺陷 {{a}} + 誤報 {{b}}',
        NoteNmLight: '{{a}} nm 光源，{{b}}σ',
        SectionWhyTheNumberIsAlways: '為什麼報數總是偏低',
        NoteScatteringFromASmallParticle: '小顆粒的散射隨直徑的六次方變化，所以存在一個尺寸，低於它這台機台什麼都看不見——而缺陷尺寸服從冪律，小的遠多於大的。機台報出的是分布的頂端。它沒壞；這是光學。',
        SectionScanResult: '掃描結果',
        LabelDetectionLimit: '檢出下限',
        LabelCaptureRate: '捕獲率',
        NoteOfTheDefectsActuallyPresent: '佔實際存在缺陷的比例',
        LabelReportedDensity: '報出密度',
        LabelNuisanceRate: '誤報率',
        LabelKillerDensity: '致命缺陷密度',
        NoteBigEnoughAndOnPattern: '足夠大、且落在圖形上',
        LabelScanTime: '掃描時間',
        NoteNoLotOnTheStage: '載台上沒有批次。送一片晶圓過來掃描。',
        TextScanTheWaferAndPass: '掃描這片晶圓並傳下去',
        AssistantLead: 'INSP-13 探究助理',
        AssistantBlurb: '可以問：降低閾值買到了什麼、這套配方根本看不見什麼、部分掃描夠不夠。每個回答都是在這台機台上真實跑出來的一次掃描。',
        reading: {
          nuisance: {
            Label: 'SEM 複檢 50 個報出點（2.0 小時）',
          },
          sensitivity: {
            Limit: '> 8%（認證值：10%）',
            Label: '標準缺陷片捕獲率（1.0 小時）',
          },
          roughness: {
            Label: '來料表面粗糙度',
          },
          vibration: {
            Label: '載台振動',
          },
          haze: {
            Label: '光學霧度',
          },
          laserPower: {
            Label: '雷射功率監測',
          },
        },
        aspect: {
          incoming: {
            Action: '不是維修——晶圓本身粗糙，歸上游清洗檯管',
            Label: '來料表面',
          },
          stage: {
            Action: '重調氣浮隔振並重整載台伺服',
            Label: '載台與隔振',
          },
          optics: {
            Action: '拆洗收光光路，再用標準片重新認證',
            Label: '收光光學',
          },
          laser: {
            Action: '更換雷射頭並重新校準功率監測',
            Label: '照明光源',
          },
        },
      },
      probe: {
        ValueDie: '{{a}} 顆裸晶',
        signature: {
          clustered: '成簇',
          radial: '徑向型',
          centre: '中心型',
          edge: '邊緣型',
          uniform: '均勻',
        },
        LotDefectsShort: '本批次：{{a}} 個缺陷/cm²，其中致命缺陷 {{b}}/cm²',
        LeadMeanHidesTheMap: '同一個平均良率，可能是三個不同的問題，歸三個不同的人負責。',
        NoteThisLotCarriesDefects: '這批晶圓攜帶 {{a}} 個缺陷/cm²，其中 {{b}}/cm² 是致命的。拿它與 INSP-13 ' +
          '寫在流轉卡上的數字比一比——兩者不會一致，差值就是檢測機看不見的那部分。',
        NoteNoLotOnTheProber: '探針台上沒有批次。在晶圓到來之前，它按產線假定的 {{a}}/cm² 運行。',
        LabelEdgeExclusion: '邊緣排除區',
        SecondaryLabel: '測量不確定度',
        ToolLabel: 'PRB-14 晶圓探針測試與分選',
        NextFt18AppliesAGuard: 'FT-18 會對封裝後的產品再加一道自己的保護帶，用的是帶著自身量具誤差的測量。問問它：兩道保護帶串聯要付出什麼——第二道買到了第一道沒買到的東西嗎？',
        LabelParametric: '參數良率',
        LabelSignature: '特徵',
        HypSortYieldIsAProduct: '晶圓測試良率是三個獨立因子的乘積，其中只有一個與晶圓有關。如果損失來自缺陷，清洗探針卡不會有任何變化；如果來自接觸，變化會很大，而且分佈圖會長得像探針卡而不像製程。保護帶則完全是第三回事——它是一個決定，不是一種失效。',
        AskedWhereIsThisYieldActually: '這些良率究竟丟到哪裡去了？',
        SumSeparatingAProcessSignatureFrom: '把製程特徵、接觸問題和保護帶三者區分開。',
        LabelNegativeBinomial: '負二項',
        AxisXClusteringLowHeavilyClustered: '聚簇 α（低 = 高度聚簇）',
        TitleTwoModelsOneWafer: '兩個模型，一片晶圓',
        LabelImpliedDensity: '隱含缺陷密度',
        NotePoisson: '泊松',
        LabelNegativeBinomialL196: '負二項',
        HypPoissonAssumesEveryDefectLands: '泊松模型假設每個缺陷都獨立落下。真實的缺陷是成劃痕、成塗佈條紋、成邊緣環到來的——它們彼此重疊，好幾個缺陷落在早已報廢的裸晶上。如果是這樣，同樣的缺陷總數下聚簇應把良率抬到泊松之上，而泊松恰恰在產線有特徵簽名時才悲觀。',
        AskedWhyDoTheYieldModels: '為什麼各個良率模型互不一致？產線該用哪個？',
        SumClusteringAndWhyTheSimplest: '聚簇，以及為什麼最簡單的良率模型總是悲觀的。',
        NextThatCurveAssumedDefectsLand: '那條曲線假設缺陷是各自獨立落下的。它們不是——它們成簇。問我聚簇會對同樣的數字做什麼，因為這是一個能預測你產線的模型和一個不能的模型之間的差別。',
        LabelGoodDie: '好裸晶',
        TitleGoodDieOut: '產出好裸晶數',
        AxisXDieAreaCm: '裸晶面積 (cm²)',
        TitleDefectYieldAgainstDieArea: '缺陷良率隨裸晶面積的變化',
        LabelTestTime: '測試時間',
        LabelEdgeLoss: '邊緣損失',
        HypADieFailsIfAny: '只要有一個致命缺陷落在裸晶上它就報廢，所以存活概率隨面積指數下降。如果這是對的，裸晶面積翻倍的代價遠不止良率減半，而且任何現實規模的製程改進都補償不了一個在光罩開刻之前就定下的設計決定。',
        AskedHowMuchDoesDieArea: '與其他一切相比，裸晶面積對良率有多重要？',
        SumYieldIsExponentialInDie: '良率是裸晶面積的指數函數，所以面積是最大的槓桿，而它握在設計手裡。',
        fault: {
          chuckStarved: {
            Evidence: [
              '卡盤真空 21 kPa，低於 60 kPa 的下限。',
              '晶圓圖特徵為邊緣型，而探針卡平面度在 6 µm 限值以內。',
              '短路標準片上的接觸損失遠超 2%，探針磨損正常。',
              '廠務的公用設施面板顯示 PRB-14 的乾式泵停機，其餘各泵正常抽氣。',
            ],
            Truth: '這台機台下方、地下層裡的乾式泵卡死了：前級管路接近大氣壓，卡盤只用應有真空的五分之一吸著晶圓。沒被吸平的晶圓邊緣會翹起，翹起的邊緣在探針卡下落針偏輕，和探針卡不平的表現完全一樣——所以晶圓圖說「邊緣」，而平面度量規卻說探針卡沒問題。重新墊卡、清潔探針：這台機台上做什麼都恢復不了它自己並不產生的真空。廠裡其他機台都沒變，因為沒有別的機台共用這台泵。',
            Complaint: '晶圓圖一夜之間變成邊緣型，所有產品的接觸損失都上升了。探針卡上週剛重新墊過，平面度檢查合格。',
            Label: '乾式泵故障導致卡盤失去真空',
          },
          noisyGauge: {
            Evidence: [
              '量具 sigma 是規格的 14%，限值 5%。',
              '晶圓圖形貌均勻——雜訊沒有形狀。',
              '吸盤、平面度、針尖磨損全都正常。',
            ],
            Truth: '參數測量單元雜訊大——量具 sigma 是規格寬度的 14%，限值是 ' +
              '5%。靠近判限的好裸晶這次掛、下次過。平均良率幾乎不動，所以一直沒人發現；複測結果對不上，是唯一能抓住它的症狀。',
            Complaint: '同一片晶圓複測，每次的分級都不一樣。平均良率倒是大差不差。',
            Label: '參數測量鏈路雜訊大',
          },
          chuckOffset: {
            Evidence: [
              '吸盤偏差 +9 °C，限值 ±2 °C。',
              '晶圓圖形貌讀作放射型，它跟著吸盤走，不跟製程走。',
              '分選良率沒有變化——這個故障不報廢裸晶，它挪的是判限落在群體上的位置。',
              '接觸損失正常——這不是落針的問題。',
            ],
            Truth: '吸盤熱電偶漂了，晶圓比日誌報的溫度高 9 °C。參數測試對溫度敏感，於是整個群體相對於在正確溫度下定的判限整體挪了位。裸晶本身是好的。',
            Complaint: '參數分級挪位了。導通沒有掛的，掛掉的裸晶呈放射狀散布。',
            Label: '吸盤溫度偏高',
          },
          cardOutOfPlane: {
            Evidence: [
              '平面度 14 µm，限值 6 µm。',
              '晶圓圖形貌讀作邊緣型。',
              '針尖磨損在限值內，這不是清針的問題。',
            ],
            Truth: '探針卡失平了 14 µm，一側落針太輕。那些裸晶根本沒接觸上，被判成了壞品。形貌就是告密者：失平的卡掛掉的是邊緣，而邊緣型的圖不是缺陷群體該有的長相。',
            Complaint: '晶圓圖變成了邊緣偏重。所有人都在怪邊緣排除區。',
            Label: '探針卡失平',
          },
          wornTips: {
            Evidence: [
              '距上次清針的觸點數遠超 150,000 的限值。',
              '短路標準片上的接觸損失超過 2%。',
              '損失出現在所有產品上，晶圓缺陷不會這樣。',
            ],
            Truth: '針尖已經超過觸點壽命，扎不穿銲墊氧化層了。電學上完好的裸晶在導通測試上掛掉——損失發生在接觸上，不在晶圓上，而接觸電阻標準片會直接把這句話說出來。',
            Complaint: '從週二起，這個測試單元上所有產品的良率都掉了四個點。',
            Label: '探針針尖磨損',
          },
          probeHealthy: {
            Evidence: [
              '檯上的每個讀數都正常。',
              '晶圓圖形貌是均勻的。',
            ],
            Truth: '什麼問題都沒有。正確的判定就是放行這一批。',
            Complaint: '例行批次。良率就在模型說它該在的地方。',
            Label: '一切正常',
          },
        },
        NoteMmRingHToProbe: '{{a}} mm 排除環，{{b}} 小時測完',
        NotePoissonWouldSay: '卜瓦松模型會說 {{a}}%',
        NoteCentreEdge: '中心 {{a}}%，邊緣 {{b}}%',
        NoteGoodOfProbed: '{{b}} 顆中良品 {{a}} 顆',
        SectionReadTheMapNotThe: '讀圖，別只讀數',
        NoteAMeanYieldOf78: '78% 的平均良率，可以是均勻的 78%，可以是中間 95% ' +
          '而邊緣全死，也可以是一片完美晶圓上劃了一道。三個不同的問題，歸三個不同的人管——而平均值分不出它們。',
        InvBandEdge: '導帶底',
        InvFermi: '費米能階',
        InvInterface: '氧化層 | 矽',
        InvLevel: '{{ladder}} 第 {{n}} 階',
        InvShape: '每個電子所在之處（|ψ|²）',
        InvBandTitle: '閘極挖出的位能井及其能階',
        InvBandX: '距氧化層的深度 (nm)',
        InvBandY: '電子能量（eV，塊材導帶底 = 0）',
        InvDensityTitle: '通道電荷所在的位置',
        InvDensityX: '距氧化層的深度 (nm)',
        InvDensityY: '電子密度 (10¹⁹ cm⁻³)',
        InvDensityQ: '量子',
        InvDensityCl: '古典（費米–狄拉克）',
        InvCentroid: '形心',
        InvCvTitle: '探針卡量到的量：閘極電容',
        InvCvX: '閘極電壓 (V)',
        InvCvY: '電容 (µF/cm²)',
        InvCvQ: '量子',
        InvCvCl: '古典（費米–狄拉克）',
        InvCox: '僅氧化層',
        InvHere: '目前閘極電壓',
        InvFailed: '通道求解器載入失敗。',
        InvStatus: 'φ_s = {{phis}} V · N_inv = {{ninv}} cm⁻² · 電荷形心距氧化層 {{zavg}} nm · 等效氧化層 +{{dt}} nm · 臨界電壓偏移 +{{dvt}} mV',
        InvLoading: '正在載入通道求解器…',
        InvStatusDepleted: 'φ_s = {{phis}} V · 尚未反轉：閘極還沒有把通道拉到表面 · 臨界電壓偏移 +{{dvt}} mV',
        InvComputing: '正在求解電容掃描與臨界電壓…',
        InvSweepFailed: '電容掃描無法計算。',
        InvRight: '右圖',
        InvRightCv: '電容—閘極電壓',
        InvRightDensity: '電荷—深度',
        InvVg: '閘極電壓',
        InvTox: '氧化層厚度',
        InvNa: '基板摻雜',
        SectionInversion: '臨界電壓為何不在公式所說之處——把通道當作量子井（薛丁格–帕松）',
        InversionNote: '這塊探針卡量到的每一個臨界電壓，都由氧化層之下一奈米處的一個事實決定，而古典的電荷薄層公式把它漏掉了：閘極拉到表面的電子並不能待在表面上。閘極電場把導帶壓彎成緊貼氧化層的三角形位能井，而這麼窄的井只允許離散的能階，每一階的波函數在氧化層處為零、在約一奈米深處達到峰值。這裡是把這個井真正解出來：帕松方程貫穿閘極、氧化層與基板，薛丁格方程處理 (100) 矽的兩組能谷階梯，兩者迭代到彼此自洽。左圖是帶有能階與每個電子形狀的能帶圖；右圖是探針卡看到的量——閘極電容，量子解對照採用同樣費米–狄拉克統計的古典解，所以兩條曲線之間的差距純粹來自量子化。兩者都達不到氧化層電容，因為稠密的電子氣本身就有電容；量子曲線更低，是因為每多加一伏所帶來的電荷落在離氧化層更遠幾埃的地方，而這段間距給出的差距大小，與實際差距相差不超過三分之一。狀態列裡的臨界電壓偏移，是兩種解在同一薄層電荷下的差值。閘極按視作金屬的 n⁺ 多晶矽處理；多晶矽空乏、介面缺陷與汲極偏壓均未計入，電洞按古典處理，所以累積一側在這裡沒有量子化。',
        SectionShortChannel: '閘極為什麼不再縮小——源汲之間的能障，以及穿隧而過的電子（轉移矩陣，傳播的波包）',
        ShortChannelNote: '電晶體靠在源極與通道之間築起一道能障來關斷，關態下漏掉的電流，就是那些熱能足以翻過能障的電子的尾巴：每一個數量級的電流要六十毫伏的閘極電壓，任何熱元件都做不得更好。長的鰭做得到這一點：它的基體完全空乏，沒有什麼來分走閘極電壓的擺動，模型裡的長閘極就在熱極限上擺動。這裡呈現的是短閘極對那道能障做了什麼。源極與汲極同樣是電極，它們的影響會沿著由基體厚度與氧化層決定的特徵長度伸進通道，因此當閘長只有幾個這樣的長度時，閘極失去一部分控制，是汲極自己把能障壓了下去——次臨界擺幅退化到六十以上，臨界電壓隨汲極偏壓下降。這個臨界電壓是按一條扣除了汲極自身回注入的判據讀出的，所以長閘極的 DIBL 就是它應有的每伏零點幾毫伏。能障同時變薄，而兩奈米寬的能障，對根本翻不過去的電子而言是透明的。兩者都出自同一次計算：靜電學用的是特徵長度模型（Young；雙閘極形式出自 Yan、Ourmazd 與 Lee），穿透率用的是 THRM-04 用在閘極氧化層上的同一套轉移矩陣——能障之上接近一，之下按指數衰減，於是熱電子發射與穿隧是同一條曲線，而不是兩個模型。左邊那道波，是把這條穿透率傳播出來而不是算出來的。波包刻意取得很長：波包是一段能量的展寬，只有長波包才窄到能整個落在能障頂之下，所以從另一側出來的那部分——在閘極之後放大重畫了一遍——才是穿隧，從 10 nm 的閘極到 20 nm 的閘極，它下降幾百倍。即便如此它也不是單一能量，所以給出三個數：波包實際送過去的份額、轉移矩陣對波包自身各能量的平均，以及只按其平均能量算的 T。前兩個在閘長 20 nm 以內相差不到百分之一，40 nm 時不到百分之三；第三個可以小一百萬倍。把閘長往下拉，看穿隧在漏電流中的占比越過一半，看開關比崩塌，也看到閘極再也關不斷元件的那個長度。在這麼薄的鰭裡，摻雜只按其基體電荷移動臨界電壓，而不改變擺幅，這正是實際的鰭不摻雜的原因。散射沒有計入，所以開態電流是彈道傳輸的上限；沿基體厚度方向的量子侷限是上一節的內容；絕對電流取決於假定的通道厚度，所以要讀的是各種比值，而不是安培數。',
        ScBandTitle: '沿通道的能障，以及迎面而來的一個電子',
        ScBandX: '沿通道的位置（nm）',
        ScBandY: '電子能量（eV，源極能帶邊緣 = 0）',
        ScBand: '導帶邊緣',
        ScWave: '電子在哪裡（|ψ|²）',
        ScGate: '閘極',
        ScTop: '能障頂',
        ScLaunch: '發射能量',
        ScTransferTitle: '探針台量到的：電流隨閘極電壓的變化',
        ScTransferX: '閘極電壓（V）',
        ScTransferY: 'log₁₀ 汲極電流（µA/µm）',
        ScTransferHigh: '汲極 {{vd}} V',
        ScTransferLow: '汲極 {{vd}} V',
        ScCriterion: '臨界判準',
        ScHere: '目前閘極電壓',
        ScVt: '臨界電壓',
        ScScaleOffTitle: '微縮的代價：關態電流隨閘長的變化',
        ScScaleTunTitle: '漏電流中有多少是穿隧',
        ScScaleX: '閘長（nm）',
        ScScaleOffY: 'log₁₀ 關態電流（µA/µm）',
        ScScaleTunY: '低於能障頂的占比（%）',
        ScScaleOff: '閘極接地',
        ScScaleTun: '穿隧',
        ScThisGate: '目前閘長',
        ScStatusShort: '位能障 {{top}} meV · {{tun}}% 的電流從其下方穿隧 · {{current}} µA/µm',
        ScNeverOnShort: '始終未開啟：臨界電壓高於閘極所能達到的 {{max}} V · 擺幅 {{s}} mV/dec',
        ScPacketShort: '{{fs}} fs · 穿過閘極 {{through}} · 轉移矩陣 {{matrix}}',
        ScStatus: '能障 {{top}} meV，半高處寬 {{width}} nm · 特徵長度 {{lambda}} nm · 閘極電壓擺動的 {{grip}}% 傳到能障頂 · 本電流中 {{tun}}% 走在能障頂之下 · 此處 {{current}} µA/µm',
        ScMeasured: '擺幅 {{s}} mV/dec · DIBL {{dibl}} mV/V · 臨界電壓 {{vt}} V · 關態電流 {{off}} µA/µm · 開關比 {{ratio}}',
        ScPunch: '已貫穿：閘極無法關斷此元件。閘極接地時仍通過 {{off}} µA/µm，因此沒有臨界電壓、沒有擺幅，也沒有臨界電壓漂移可報。',
        ScPacket: '{{fs}} fs · 穿過閘極 {{through}} · 轉移矩陣對本波包各能量取平均得 {{matrix}}，只按其平均能量算為 {{single}} · 已反射 {{back}} · 尚在途中 {{coming}} · 機率合計 {{norm}}',
        ScComputing: '正在求解轉移曲線、擺幅與臨界電壓漂移…',
        ScSweepFailed: '無法計算轉移曲線。',
        ScFailed: '短通道求解器載入失敗。',
        ScLoading: '正在載入短通道求解器…',
        ScNone: '無',
        ScRun: '發射一個電子',
        ScPause: '暫停',
        ScReset: '重設',
        ScRight: '微縮圖',
        ScRightOff: '關態電流',
        ScRightTun: '穿隧占比',
        ScLength: '閘長',
        ScVg: '閘極電壓',
        ScVd: '汲極電壓',
        ScTox: '閘極氧化層',
        ScBody: '基體厚度',
        ScNa: '基體摻雜',
        ScEnergy: '發射能量',
        ScEnergyValue: '{{ev}} ± {{spread}} meV，為能障的 {{pct}}%',
        ScEnergyNone: '已無能障可瞄準——以 {{ev}} meV 發射',
        ScWavePast: '閘極之後，放大 ×{{gain}}',
        ScStale: '旋鈕動了：變暗的曲線屬於上一個元件，本元件的曲線正在求解…',
        ScNeverOn: '始終未開啟：臨界電壓高於閘極所能達到的 {{max}} V。滿閘壓下僅通過 {{on}} µA/µm · 擺幅 {{s}} mV/dec，取自量程頂端 · 關態電流 {{off}} µA/µm',
        ScNaValue: '{{na}} cm⁻³ · 臨界電壓 +{{shift}} mV',
        ScBenchDevice: '元件',
        ScBenchBias: '偏壓與電子',
        SectionSortResult: '分選結果',
        LabelSortYield: '分選良率',
        LabelMapSignature: '晶圓圖形貌',
        LabelDefectYield: '缺陷良率',
        LabelImpliedKillerDensity: '反推致命缺陷密度',
        NoteInvertedFromTheYield: '由良率反推',
        LabelContactYield: '接觸良率',
        NoteLostToTheCardNot: '損失在探針卡，不在晶圓',
        TextProbeTheWaferAndPass: '針測這片晶圓，把合格裸晶傳下去',
        AssistantLead: 'PRB-14 探究助理',
        AssistantBlurb: '可以問：晶粒面積大了良率為什麼差這麼多、這條線該用哪個良率模型、損失是晶圓的還是探針卡的。每個回答都是針對這批晶圓真實跑出來的一次分類。',
        reading: {
          chuckVacuum: {
            Limit: '> 60 kPa',
            Label: '卡盤真空',
          },
          houseutilities: {
            Limit: '所有系統正常',
            Label: '致電廠務查看公用設施面板（0.5 小時）',
          },
          contactResistance: {
            Label: '短路標準片接觸電阻檢查（0.5 小時）',
          },
          mapShape: {
            Limit: '均勻或成簇',
            Label: '全片晶圓圖，讀判形貌（1.5 小時）',
          },
          gauge: {
            Label: '參數量具 sigma',
          },
          chuckTemp: {
            Label: '吸盤溫度偏差',
          },
          planarity: {
            Label: '探針卡平面度',
          },
          tipWear: {
            Label: '距上次清針的觸點數',
          },
        },
        aspect: {
          house: {
            Action: '停止本機台作業，上報廠務',
            Label: '本機台無故障——升級到廠務',
          },
          gauge: {
            Action: '重新校準參數測量單元及其線纜',
            Label: '參數測量鏈路',
          },
          chuck: {
            Action: '重新校準吸盤熱電偶並重調控溫迴路',
            Label: '吸盤溫度',
          },
          planarity: {
            Action: '重新墊平探針卡並四象限複測平面度',
            Label: '探針卡平面度',
          },
          tips: {
            Action: '在研磨板上清針；磨損過度則換卡',
            Label: '探針針尖',
          },
        },
      },
      litho: {
        ExposeLot: '曝光該批次並送去蝕刻',
        NextHoldingIsTheEasyHalf: '扣住是簡單的那一半。這一班早些時候曝的批次走的是同一套光學——什麼量測能告訴你其中有沒有該收回來的？顯影之後那個量測還做得了嗎？',
        NextASendAheadIsOneField: '先導片只是一片上的一個曝光場。你要曝什麼、曝多少個，才會相信剛才據以放行機台的那個數字？',
        PatternResolved: '已成像',
        PatternUnresolved: '沒有成像',
        LabelResolved: '圖形',
        LabelRoughness: '粗糙度 3σ',
        LabelPrintedCd: '實測線寬',
        VerdictWithAWatchItem: '放行，但有一項要盯著',
        VerdictHeld: '扣住',
        VerdictQualified: '已認定',
        LabelVerdict: '判定',
        HypAQualificationIsADecision: '資格認定是一個決定，不是一段解釋。只要先導片顯影出圖形、線寬落在視窗內、粗糙度低於限值，而且檯面每一項讀值都在限值內，掃描機就放行；否則扣住。再用同一套光學跑已認定配方，就能看出該負責的是配方還是機台。',
        AskedIsThisScannerFit: '這台掃描機現在能不能曝產品，如果不能該怎麼辦？',
        SumExposeTheSendAhead: '曝一片先導片，把檯面讀值逐項對照限值，然後做出放行判斷。',
        UnitNmCd: 'nm CD',
        NoteResolutionImprovesLinearly: '解析度隨 NA 線性改善，而聚焦預算至少以 NA 的平方下降——一旦角度不再算小就下降得更快，' +
          '而在這些孔徑上角度早就不小了。所以 High-NA 在半週期上買到 1.7 倍，卻在焦深上還回去 2.9 ' +
          '倍——而這台機台一開始也只有 72 nm。這就是 CMP-11 存在的原因。而讓 NA 0.55 ' +
          '成為可能的變形光學，把掃描方向的曝光場砍了一半，於是 26×32 mm ' +
          '的裸晶現在要曝兩次再拼接。光子能量沒有變，所以本來就是瓶頸的隨機效應一點沒變好。',
        ValueFieldsStitched: '{{a}} 場——需拼接',
        ValueFields: '{{a}} 場',
        HeadPerDie: '每顆裸晶',
        HeadField: '曝光場',
        HeadFocusBudget: '聚焦預算',
        HeadHalfPitch: '半週期',
        NotePresetEuvFine: '把光源也換成 EUV。能印出來，但光子只剩一個零頭。',
        NotePresetTightPitch: '超出傳統照明的舒適區：對比度 0.57，窗口收縮。',
        NotePresetUnderdosed: '20 mJ/cm²。線條印得太寬——光少了，去除的光阻就少。',
        NotePresetFocusExcursion: '90 nm 離焦。對比度跌到 0.42，線寬嚴重偏離目標。',
        NotePresetBaseline: '在 180 nm 週期、最佳焦點下按目標尺寸曝光。對比度 0.97，NILS 7.1，LER 2.4 nm。',
        LabelUnderdosed: '劑量不足',
        SecondaryLabel: 'LER 3σ',
        ToolLabel: 'LITH-03 · 浸潤式掃描機與塗佈顯影軌道',
        NextIfDoseCannotFixRoughness: '如果劑量本身治不了粗糙度，還剩下什麼？想想曝光後烘烤對邊緣做了什麼，同時又讓你付出了什麼。',
        AxisYLerNm3: 'LER (nm, 3σ)',
        AxisXDoseMjCm: '劑量 (mJ/cm²)',
        TitleRoughnessAgainstDoseAndThe: '粗糙度隨劑量的變化——以及它跨不過去的下限',
        LabelFailuresIn300: '300 條中的失效數',
        NoteDoseOnlyBuysBackThe: '劑量只能買回光子那一項',
        LabelAtTwiceTheDose: '劑量加倍時',
        LabelCdSpread3: 'CD 分散 (3σ)',
        HypDoseIsDeliveredAsA: '劑量是以有限個光子的形式送達的。如果邊緣位置由數光子決定，那麼計數會按其平方根漲落，邊緣的移動量應隨劑量升高而下降——但永遠降不到零，因為光阻本身也是由有限個分子組成的。',
        AskedWhyDoesTheSameExposure: '為什麼同一次曝光重複一遍，印不出兩條一樣的線？',
        SumPhotonStatisticsLineEdgeRoughness: '光子統計、線邊緣粗糙度，以及 EUV 為什麼改變了規則。',
        NextEverythingAboveUsedConventionalIllumination: '上面的一切都用的是傳統照明。離軸照明捨棄光源中心，只保留在緊密週期下仍能成像的角度。這會對上面的數字產生什麼影響？代價又是什麼？',
        LabelProductionMinimum: '量產下限',
        AxisYDepthOfFocusNm: '焦深 (nm)',
        AxisXPitchNm: '週期 (nm)',
        TitleDepthOfFocusAgainstPitch: '焦深隨週期的變化',
        LabelManufacturable: '可量產',
        LabelDoseLatitude: '劑量寬容度',
        LabelDepthOfFocus: '焦深',
        DesignFocusSwept140NmAgainst: '聚焦掃描 ±140 nm，劑量掃描 ±40%，在三個週期下進行。統計 CD 保持在目標 ±10% 以內的區域。',
        HypAProcessWindowIsThe: '製程窗口是兩個容差的重疊，而不是一個。窗口寬，圖形就能挺過不夠平整的晶圓和漂移的光源；窗口窄，圖形可以在測試中印得很漂亮，卻仍在量產中失效。',
        AskedHowMuchFocusAndDose: '這個圖形在超出規格之前，能吸收多大的聚焦和劑量誤差？',
        SumMeasureDepthOfFocusAnd: '測量焦深與劑量寬容度，並判斷其是否可量產。',
        LabelReturnToBestFocus: '回到最佳焦點',
        TitleCdAgainstFocusAtThree: '三個劑量下 CD 隨聚焦的變化',
        LabelNilsAsSet: '當前設定的 NILS',
        LabelDiagnosis: '診斷',
        LabelDoseSensitivity: '劑量靈敏度',
        HypDoseAndFocusLeaveDifferent: '劑量和聚焦留下的指紋不同。劑量單調地移動 CD——光越多線條越細；而聚焦關於最佳焦點對稱，無論偏向哪一側，CD 的變化方向都相同。如果 CD ' +
          '對聚焦的響應不對稱，機台就不在最佳焦點；如果只對劑量響應，那就是劑量誤差。',
        AskedTheCdIsNotOn: 'CD 不在目標值上。兩個旋鈕裡是哪一個的責任？',
        SumSeparateADoseErrorFrom: '區分劑量誤差與聚焦誤差——它們在 CD 讀數上看起來一樣。',
        fault: {
          warmPcwLitho: {
            Evidence: [
              'CD 偏寬而對比度、NILS、LER 都正常——劑量的特徵。',
              '劑量計交叉核對是乾淨的，光阻對比度曲線也是。兩個慣常嫌疑人都被排除了，而這正是多數人開始瞎猜的時刻。',
              '公用系統檢查顯示冷卻水遠高於供水溫度。',
              '蝕刻機在同一時間變慢，原因看起來完全是另一回事。它不是另一回事。',
            ],
            Truth: '冰水主機送出的供水比標稱高了約 22 ' +
              'C。沒有任何一台機台壞了；每台向那條迴路排熱的機台只是再也守不住自己的設定值了。掃描機透過它的雷射感受到這一點：準分子光源是水冷的，冷卻水一熱就降額，於是它給出的劑量只有劑量計以為的四分之三左右。劑量計沒有說謊——它量的是別人告訴它該預期的脈衝能量，而機台沒有任何辦法知道自己的水是熱的。',
            Complaint: '線條印寬了約 7%。看著像春天那次光源問題，可劑量計交叉核對是乾淨的，光阻對比度曲線也乾淨。ETCH-01 同時在變慢，沒有人覺得這兩件事有關係。',
            Label: '冷卻水偏熱',
          },
          hotPlate: {
            Evidence: [
              'LER 低於它的帶寬。這不是好消息，是訊號——這台機台上沒有別的東西能把邊做得比認證製程還光滑。',
              '像對比度和 NILS 沒動，光學沒問題。模糊發生在曝光之後，不在曝光之中。',
              '烘板熱電偶巡檢讀數明顯高於設定值。',
            ],
            Truth: '曝光後烘烤板偏熱，酸在烘烤期間擴散出四倍遠。模糊是雙面刃，這就是全部教訓：它抹平了酸的分布，實實在在改善了線邊粗糙度；它也沖淡了分布，讓線變窄。機台正在超差的圖形上做出更好看的邊。',
            Complaint: 'CD 窄了一個星期了。怪的是：線條邊緣看起來比平時還好。',
            Label: '烘烤板偏熱',
          },
          focusDrift: {
            Evidence: [
              '像對比度和 NILS 雙雙大跌。劑量或光阻故障做不到這一點——它們改變閾值在哪裡被越過，改變不了像越過閾值時有多銳。',
              'LER 升高了，這是 NILS 丟失的直接後果。',
              '穿焦曝光找到的最佳焦點，離機台以為的位置差了約 35 nm。',
            ],
            Truth: '調平感測器漂了，晶圓離焦平面約 35 nm，而機台以為自己在最佳焦點。離焦最先毀掉的是空間像：對比度從 0.97 掉到 0.80，NILS ' +
              '跟著掉，發軟的像印出又窄又毛的線。',
            Complaint: 'CD 偏窄，SEM 圖上線條邊緣發軟。',
            Label: '調平感測器偏移',
          },
          weakResist: {
            Evidence: [
              'CD 偏寬而對比度、NILS、LER 都正常——在機台上和光源衰退分不出來。',
              '劑量計交叉核對回來是乾淨的。就是這條讀數拍的板，而它靠的是排除另一個，不是靠找到什麼。',
              '監控片上的對比度曲線顯示 gamma 只有認證值的一半左右。',
            ],
            Truth: '這批光阻丟了差不多一半的對比度——在貨架上放太久了。低對比度的膠沿著酸梯度溶解得更平緩，邊緣落點更靠外，線條就印寬了。像是完美的；材料不是。',
            Complaint: '線條又印寬了，跟春天那次光源問題一個樣。劑量上週才重新校準過。',
            Label: '光阻批次對比度超差',
          },
          sourceDrift: {
            Evidence: [
              'CD 偏寬而機台上其餘一切正常。對比度、NILS、LER 都沒動，所以光學和烘烤都不涉及。',
              '劣化的光阻批次在機台可見的每一個讀數上都長得一模一樣。要分開它們只有劑量計交叉核對這一條路，別的什麼都做不到。',
              '對參考偵測器的交叉核對顯示實際劑量遠低於設定值。',
            ],
            Truth: '準分子光源老化了，現在給出的劑量只有劑量計以為的八成左右。產酸變少，顯影閾值在像的更外側被越過，線條就印寬了。「像」本身什麼都沒變——對比度、NILS、粗糙度全都恰好在標稱上——這正是它難以察覺的原因。',
            Complaint: '全片的線條都印寬了約 6%。同樣的配方、同樣的光罩，而機台說它給的劑量分毫不差。',
            Label: '光源輸出衰退',
          },
          healthy: {
            Evidence: [
              'CD 在目標上，對比度和粗糙度都在認證值上。',
            ],
            Truth: '什麼問題都沒有。正確的判定就是放行這一批。',
            Complaint: '機台通過了每日 CD 檢查。沒有任何報告。',
            Label: '掃描機已認證',
          },
        },
        TextNmOfIncomingTopographyCd: '{{a}} nm 來料形貌 → CD 散布 ',
        LabelBaseline193i: '基線-193i',
        LabelFocusExcursion: '焦距漂移',
        LabelTightPitch110Nm: '緊節距 110 nm',
        LabelEuv36NmPitch: 'EUV 36 nm 節距',
        LabelHighNaEuv: '高 NA EUV',
        reading: {
          resistlot: {
            Label: '監控片光阻對比度曲線（4 小時）',
          },
          plateprofile: {
            Label: '烘板熱電偶巡檢（90 分鐘）',
          },
          focusprobe: {
            Label: '監控片穿焦曝光（3 小時）',
          },
          houseutilities: {
            Limit: '總管不漏，PCW 在供應溫度，乾燥氣 < 50 ppm',
            Label: '與廠務共同檢查公用系統（2 小時）',
          },
          dosemeter: {
            Label: '劑量計對參考偵測器交叉核對（2 小時）',
          },
          setpoint: {
            Limit: '按配方',
            Label: '劑量設定值 / 焦距設定值',
          },
          nils: {
            Label: '歸一化像對數斜率',
          },
          contrast: {
            Label: '空間像對比度',
          },
          ler: {
            Label: '線邊粗糙度，3 sigma',
          },
          cd: {
            Label: '曝印 CD（SEM）',
          },
        },
        aspect: {
          house: {
            Action: '停止在本機上的操作，知會廠務',
            Label: '本機無事可修——上報廠務',
          },
          resist: {
            Action: '撤下該批次，測對比度曲線，換新瓶供膠',
            Label: '光阻批次',
          },
          bakeplate: {
            Action: '巡檢烘板熱電偶並重新調平近接銷',
            Label: '曝光後烘烤板',
          },
          stage: {
            Action: '用穿焦晶圓重新認證調平感測器',
            Label: '調平與對焦',
          },
          source: {
            Action: '交叉核對劑量計，重新校準光源輸出',
            Label: '曝光源與劑量控制',
          },
        },
        SectionLot: '吸盤上的批次',
        LotNote:
          '曝光機只有一個焦平面,而晶圓自帶表面形貌。CMP-11 沒磨平的部分在這裡直接從 CD 預算中扣除——而曝光機本身毫無故障。CMP ' +
          '的問題往往隔了兩台設備,在這裡才第一次被發現。',
        LotEmpty: '吸盤上沒有批次。上面的旋鈕曝光的是一片理想平坦的晶圓。',
        LotIngot: '該批次還是晶錠。要先經 WPR-08 切片才能曝光。',
        LotCard: '流程卡',
        SectionPrinted: '曝顯結果',
        SectionSource: '光源',
        SourceDuv: '193 nm 浸潤式（NA 1.35）',
        SourceEuv: 'EUV 13.5 nm（NA 0.33）',
        SourceNote: '換光源，同時改變了兩件事：能分辨到多細，以及同樣一份劑量能送來多少光子。這兩個後果的方向正好相反——關於 EUV 的全部爭論，就在這裡。',
        SectionAerial: '空間像與光阻響應',
        SectionAerialWave: '空間像從哪來——兩個繞射級次的干涉（波動光學）',
        AerialWaveNote:
          '上面那張圖是用公式算出來的。這裡則是公式所描述的那件事本身。兩束同調光——被物鏡收進來的 +1 與 −1 ' +
          '繞射級次——在晶圓面上相交，明暗是波場平方的時間平均，也正是光阻所積分的量。這裡沒有任何東西在「計算」' +
          '一幅像：兩條線光源在輻射，求解器在傳播，條紋就是兩束光相加與相消的地方。它們的間距，就是正在印出來的' +
          '節距。按執行，看兩束光抵達、條紋成形；從它們相遇的那一刻起畫面就是靜止的，因為兩列交叉的波本來就形成' +
          '駐波圖樣。然後切換上面的光源。更大的數值孔徑無非就是兩個級次之間更陡的夾角，而更陡的夾角就是更細的' +
          '條紋——這就是 λ / 2NA 的全部，是發生出來的，而不是被斷言的。',
        AerialWaveImmersion:
          '而這正是水的用處。介質的折射率以波速的形式進入，頻率保持不變，因為光進入液體時就是這樣：頻率保留，' +
          '波長變短。所以同樣的角度在水下印出更細的線條。但真正的關鍵是算式本身洩露的那一點——NA 等於 n sin θ，' +
          '而正弦不可能大於一，所以乾式物鏡無論怎麼造都永遠到不了 NA 1。1.35 的浸潤式掃描機並不是一台更好的' +
          '物鏡，它只是把同一套幾何放進了一個「這個角度確實存在」的介質裡。',
        AerialWaveCaveat:
          '三條誠實的邊界。無論波長是多少，這個方框都是六個波長寬，因為 193 nm 和 13.5 nm 無法共用一張網格——' +
          '所以畫面以波長為單位，而讀數則按你所選的光源換算成奈米。光源長六個波長而非無限長，所以光束會在自己的' +
          '邊緣發生繞射，測得的週期落在約百分之三以內而不是絲毫不差；在最小的數值孔徑下，方框裡只容得下兩三條' +
          '條紋可供測量。而且這裡刻意只取「雙光束」的情形——一個孔徑能印出的最細節距，也就是本面板解析度數字所' +
          '假定的 k₁ = 0.25 極限。實際生產中較寬鬆節距的成像還會帶上零級，而那第三束光正是上面那張圖所計算、' +
          '這裡所略去的。',
        ImageWaferPlane: '晶圓',
        ImageAngle: '級次夾角',
        ImageHalfPitch: '半節距',
        ImageVersus: '對比',
        ImageContrast: '對比度',
        ImageAxisX: '沿晶圓方向（nm）',
        ImageAxisY: '相對強度',
        ImageLabelSolved: '波動求解器印出來的',
        ImageLabelIdeal: 'λ / 2NA，兩束光該有的週期',
        ImageVerdict:
          '求解器僅憑一個角度就印出了 {{measured}} nm 的半節距。而這台機台的解析度極限，0.25 λ / NA，' +
          '給出的是 {{limit}} nm。{{dry}}',
        ImageDryImpossible: '在空氣中根本不存在能做到這件事的角度：sin θ 得大於一。水就是為此而來的。',
        ImageDryAngle: '在空氣中，同樣的孔徑需要 ±{{angle}}°。',
        SectionStack: '光落到晶圓上之後——光阻中的駐波',
        StackNote:
          '晶圓不是螢幕。到達的光會進入光阻、穿過它、在下面的材料上反射，再穿回已經被自己曝光過的光阻。' +
          '下行波與上行波是同一束光的兩半，因而是同調的，會發生干涉：光阻不是被一束均勻的光曝光，' +
          '而是被一列駐波曝光——明暗相間的平面沿深度方向層層堆疊。這些平面正是顯影後光阻側壁呈扇貝狀' +
          '而非光滑的原因，在畫布上也看得到：那一疊垂直排列的亮斑，單靠空間像本來會畫成乾淨的直條紋。',
        StackNoteSwing:
          '現在拖動厚度。光阻本身就是一個光學腔，往返一圈回來是否同相取決於它有多厚，' +
          '於是膜吸收的劑量隨厚度上下擺動——線寬也跟著擺動。這就是擺動曲線，也是為什麼光阻厚度是' +
          '控制到幾奈米的規格而不是偏好，為什麼塗佈軌道要把轉速控制到幾轉每分。然後把抗反射塗層切進來。' +
          '駐波塌縮，擺動曲線變平，因為已經沒有反射波可供入射波干涉了。這就是這層膜的全部工作，' +
          '和相機鏡頭上的鍍膜是同一個把戲。',
        StackNoteCaveat:
          '三條據實說明的限制。本節固定在 DUV 浸潤式而不跟隨光源選擇器，因為這個故事講的是厚度只有' +
          '波長幾分之一的光阻，而 193 nm 與 13.5 nm 不可能同時如此。基板不是矽：純量波模型無法承載' +
          '矽在 193 nm 處 0.88 − 2.78i 這樣的折射率，因此這裡用一個高折射率、強吸收的替身，其反射率' +
          '相當；畫在求解器旁邊的精確疊層用的是同一個替身，好讓兩者回答同一個問題。另外，求解出的' +
          '圖樣與精確解給出的位置相差不到一個網格單元——約六奈米——這正是陡峭界面在百格網格上的代價；' +
          '比較的是週期、對比度與形狀，所以精確曲線是對齊到實測曲線畫出的。',
        StackResistTop: '光阻',
        StackBarc: '抗反射塗層',
        StackSubstrate: '基板',
        StackResist: '光阻',
        StackRipple: '駐波週期',
        StackCoated: '已鍍抗反射膜',
        StackAxisDepth: '進入光阻的深度 (nm)',
        StackLabelExact: '精確的薄膜疊層解',
        StackAxisThickness: '光阻厚度 (nm)',
        StackAxisDose: '光阻內平均劑量',
        StackLabelBare: '裸基板上',
        StackLabelCoated: '帶抗反射塗層',
        StackLabelHere: '求解器在該厚度的結果',
        StackThickness: '光阻厚度',
        StackBare: '裸基板',
        StackWithBarc: '加抗反射塗層',
        StackVerdict:
          '求解器給出的明暗平面間距為 {{measured}} nm。兩列反向穿過薄膜的波，其拍出的週期等於它們' +
          '在膜內波長的一半（沿深度方向量取）；對這層光阻、這個角度而言即 {{predicted}} nm。' +
          '注意它不是 {{normal}} nm：繞射級偏離垂直方向七十度入射，這個餘弦占了答案的六成。' +
          '擺動曲線重複的正是同一個週期，因為二者是同一套物理——每增加半個膜內波長的光阻，' +
          '這個腔就重新回到同相。',
        StackThin:
          '這層膜太薄，容納不下值得測量的駐波——裡面幾乎只有一個暗面。把厚度拖大，' +
          '週期才成為可以向求解器提問的量。',
        SectionFocus: '景深從哪裡來——第三束光',
        FocusNote:
          '上面第二節的場景讓兩束光相交，而兩束光根本沒有任何景深依賴：沿光軸移動晶圓，兩個繞射級獲得的相位' +
          '完全相同，所以它們形成的圖樣處處一樣。因此本面板上所有的 Bossung 曲線都另有來源，來源就是這裡——' +
          '零級，即徑直穿過、未被繞射的那部分光。它沿軸傳播，而正負一級斜著傳播，於是三者一路走一路失步，' +
          '它們合成的像先升起、跌到零，再帶著明暗互換回來。注意看畫布上的條紋在中途縮到原間距的一半：' +
          '那正是零級落後四分之一週期、場中只剩下兩個一級的時刻。',
        FocusNoteDipole:
          '然後把零級去掉。曲線變平——不是變小，是變平——畫面也一樣。這就是離軸照明與偶極照明的全部理由：' +
          '用光瞳邊緣的兩束光構成的像沒有景深上限，因為沒有第三束光可以與之失步。代價是普適性，' +
          '因為這兩束光是為某一個週期擺放的，光罩上其餘的圖形都會印得更差。',
        FocusBest: '最佳焦面',
        FocusGone: '像已消失',
        FocusPitch: '週期',
        FocusThree: '三個繞射級',
        FocusTwo: '兩個繞射級',
        FocusVanishes: '像消失於',
        FocusNoDof: '完全沒有景深依賴',
        FocusAxisDepth: '相對最佳焦面的深度 (nm)',
        FocusAxisImage: '印出週期上的像',
        FocusLabelExact: '精確離焦相位的餘弦',
        FocusLabelParaxial: '教科書的近軸相位',
        FocusLabelHalf: '半週期分量',
        FocusAllThree: '三個繞射級全在',
        FocusJustTwo: '去掉零級（偶極）',
        FocusVerdictThree:
          '像在最佳焦面下方 {{null}} nm 處跌到零，再反相回來——原來是空的地方變成了線。這就是景深：' +
          '不是變模糊，而是對比度在振盪，也正是上面面板用公式畫出的 Bossung 曲線。注意虛線的近軸曲線' +
          '到盒子底部時已經和求解結果偏離多遠；在水中七十度入射時，π z λ / P² 並不是離焦相位。',
        FocusVerdictTwo:
          '去掉零級後，曲線是一條壓在零上的直線，下面的半週期分量也紋絲不動——盒子裡每個深度上的像' +
          '都是同一個像。兩束光完全沒有景深依賴，因為移動晶圓給它們兩個添加的相位一模一樣。' +
          '這就是偶極照明與其他離軸照明的全部論據：把傳播方式不同的那一級丟掉，景深就不再是約束，' +
          '代價是只有一個週期印得好，其餘都印得差。',
        SectionMask: '線條終止的地方——二維的像',
        MaskNote:
          '上面所有的光學場景成的都是線條/間隔光柵的像，而那是一個一維物體：它沿橫向變化，沿線條方向永遠不變。' +
          '對解析度極限來說這是對的對象，對光罩設計師每天真正面對的問題來說卻是錯的對象，' +
          '那個問題是：線條終止的地方會發生什麼。線端會縮回。轉角拒絕印成方的。接觸窗永遠收不到' +
          '大開口能收到的光。這些在剖面裡一個也看不到，因為它們都不是一維現象——所以這一節是一個曲面，而且可以轉動。',
        MaskNoteWhy:
          '印出來的邊緣，就是這個曲面在光阻顯影劑量處的等高線，也就是橫切它的那張薄片；' +
          '下面那個平的輪廓是光罩原本畫的樣子。兩者之間的差距正是光學鄰近效應修正花錢去彌合的東西，' +
          '而它無法用劑量彌合的原因就寫在形狀裡：劑量只是把薄片抬高或壓低，等於同時移動所有邊緣，' +
          '可轉角與線端偏離的幅度不同、方向也不同。拖動離焦量，看曲面塌下去——線端最先失守，' +
          '因為它本來就是像裡對比度餘量最少的部分。',
        MaskDrag: '拖動可以轉動它。平的輪廓是光罩畫的樣子；那張薄片是光阻顯影的位置。',
        MaskEnds: '兩個線端',
        MaskHoles: '接觸窗',
        MaskElbow: '一個轉角',
        MaskDefocus: '離焦量',
        MaskSigma: '部分同調因子 σ',
        MaskReadEnds:
          '畫出的間隙為 {{drawn}} nm；每個線端縮回 {{pull}} nm，於是間隙印成 {{printed}} nm——' +
          '比畫的寬了 {{pct}}%。',
        MaskReadHoles:
          '畫出的窗徑為 110 nm；中心窗的峰值只有明場的 {{peak}}，印出 {{width}} nm。' +
          '窗永遠收不到大開口能收到的光，這正是接觸窗層要單獨定劑量的原因。',
        MaskReadElbow:
          '臂部印出 {{width}} nm 寬，而畫的是 100 nm；轉角則根本印不成方的：外角被磨圓，內角被填平。' +
          '改劑量解決不了，因為劑量是把所有邊緣一起移動。',
        SectionPeb: '夾在中間的那一烘——一個模糊長度會對形狀做什麼（酸擴散）',
        PebNote:
          '上面的配方把曝光後烘烤壓縮成了一個數字，一個擴散長度，而空間像模型也只用一行就把它捲積掉了。這裡就是那個數字所代表的' +
          '烘烤：光照到哪裡就在哪裡生成的光酸，在熱板加熱期間在光阻裡擴散開來。這幅圖是**俯視圖**——從上往下看晶圓，而不是' +
          '看它的剖面——因為只有這樣才能看見一個模糊長度說不出口的東西。黃線是顯影液將會停下的地方，它畫在「長直邊恰好印在' +
          '標稱尺寸上」的那個水平。盯住那條直邊：無論烘多久，它都不動。然後再看別的。肘形圖案的外角向內變圓，內角向外被填平，' +
          '而那兩個線端則彼此後退，直到它們之間的縫隙明顯比畫出來的更寬。',
        PebNoteWhy:
          '為什麼是這三處而不是直邊：一條被模糊掉的邊，是「酸離開」與「酸補進來」之間的平衡，而沿著一條長直邊，兩者恰好相等。' +
          '在凸角處，曝光的一側少了一個象限，於是走掉的比補進來的多，輪廓就往回縮。在凹角處正好相反，於是輪廓往外推。' +
          '在線端處，酸同時朝三個方向漏走，而一旦模糊長度可以與線寬相比，線端就撐不住而開始後退——這就是為什麼這裡的縫隙在' +
          '幾個奈米的模糊下幾乎不動，然後迅速張開。這些都不是劑量誤差。劑量讓所有的邊一起移動，所以它能拿線寬去換間距，' +
          '卻永遠換不回一個角。這正是光學鄰近效應修正存在的全部理由，也是它把襯線加在外角、把切口開在內角的原因。',
        PebNoteCaveats:
          '三條誠實的邊界。這裡的酸一開始就是光罩本身，邊緣銳利得任何鏡頭都交付不出來，所以你看到的是烘烤自己的那份貢獻，' +
          '而不是烘烤疊在光學之上——那一半由上面那一節負責。這裡也沒有顯影：輪廓只是顯影液將會停下的地方，而不是光阻正在被溶解。' +
          '還有，畫面是 300 nm 鋪在一百個格子上，所以低於大約三奈米的模糊比網格還細，畫面就分辨不出來了——而那也差不多正是' +
          '真實烘烤的貢獻在光學面前不再重要的地方。',
        PebBlur: '模糊',
        PebBake: '相當於',
        PebBakeAt: '秒、溫度',
        PebCorner: '外角內縮',
        PebGap: '縫隙張開',
        PebOver: '已烘過頭，超出配方',
        PebVerdict:
          '在 {{blur}} nm 的模糊下，直邊一點也沒動，而其他地方全動了：外角向內圓了 {{corner}} nm，內角向外填了 {{notch}} nm，' +
          '兩個線端之間的縫隙張開了 {{gap}} nm。改劑量會讓所有的邊一起移動，其中任何一樣都撤不回來。這就是光學鄰近效應修正的' +
          '全部理由——而落到熱板本身上，這也是烘烤要按零點幾度來規定的原因：活化能接近一個電子伏時，一度大約相當於模糊量的 ' +
          '{{perDegree}}%。',
        AerialNote: '上面那條曲線是落在晶圓上的光，由鏡頭能接住的那幾階繞射級合成。下面那條是曝後烘烤之後剩下的酸。線條就是顯影後活下來的部分，它的寬度就是 CD。',
        SectionBossung: 'Bossung 曲線——CD 隨焦距變化，每條線一個劑量',
        BossungNote: '微影工程師賴以為生的一張圖。曲線平坦，說明焦距影響不大；曲線扇形張開，說明劑量與焦距互相牽扯，而可用視窗就是它們同時都還落在 CD 公差內的那一塊。',
        MeasureBossung: '量測 Bossung 曲線',
        SectionWindow: '焦距—曝光視窗',
        WindowNote: '對每一個焦距，給出仍能印在規格內的劑量範圍。晶圓從來不是絕對平的，掃描機也從來不是絕對穩的，所以一個製程只有在這塊區域寬到能同時吸收這兩者時才算可用。',
        MeasureWindow: '量測視窗',
        SectionStochastics: '隨機效應——同一件事印 300 次',
        PhotonCurveEuv: 'EUV 曝光機，92 eV 光子',
        PhotonCurveArf: 'ArF 曝光機，6.4 eV 光子',
        PhotonCurveSame: '用 ArF 光子構成的 EUV 影像',
        PhotonCurveHere: '這片晶圓',
        PhotonChartTitle: '邊緣粗糙度隨劑量的變化',
        PhotonChartX: '劑量 (mJ/cm²)',
        PhotonChartY: '線邊緣粗糙度，3σ (nm)',
        PhotonStatus: '{{energy}} eV 光子 · 每 nm² {{perNm2}} 個，每像素 {{perPixel}} 個 · LER {{ler}} nm · 線寬 {{width}} nm · {{defects}} 列有缺陷',
        PhotonPicImage: '透鏡成的像',
        PhotonPicCounts: '到達的光子',
        PhotonPicPrint: '顯影結果，疊上設計邊緣',
        PhotonSource: '用誰的光子',
        PhotonChoiceEuv: 'EUV 曝光機',
        PhotonChoiceArf: 'ArF 浸潤式曝光機',
        PhotonChoiceSame: 'EUV 的影像，ArF 的光子',
        PhotonDose: '劑量',
        PhotonBlur: '光阻作用距離（酸、二次電子）',
        PhotonReroll: '再曝光一片晶圓',
        SectionPhotons: '影像是由什麼構成的——被計數的光子（空間像上的卜瓦松統計）',
        PhotonsNote: '這塊面板上的每一幅影像都是平均值。光阻從來得不到平均值：它得到的是有限個光子，每一個不是落在這裡就是不在這裡，而落在決定一條邊緣的那幾奈米裡的數目，是一次均值為 N、漲落為 √N 的卜瓦松抽樣。劑量是能量，一個 92 eV 的 EUV 光子攜帶的能量是 6.4 eV ArF 光子的十四倍，所以同樣的 mJ/cm² 劑量到達時光子數少了十四倍。這裡由面板自己的傅立葉成像器生成 120 nm 週期、60 nm 線條的空間像，再逐像素以帶種子的卜瓦松計數交付，計數經光阻自身的作用距離模糊後依常規閾值顯影，最後逐列量測印出的邊緣。粗糙度隨劑量的平方根下降。曝光機對曝光機比較，在這個週期下 ArF 的邊緣反而更粗糙，因為它的透鏡給出的邊緣較平緩，而斜率補回了光子損失的部分——所以用虛線把光子單獨分離出來：同一幅 EUV 影像若由 ArF 光子構成，會平滑 √14 倍。這裡計數的是入射光子；吸收率和酸產率會進一步削減有效計數，因此真實的 EUV 情形比所示更糟。',
        StochasticsNote: '下面每一次曝光用的都是完全相同的設定。劑量是能量，但曝顯本質上是在數數：落進每個圖形的光子數是有限的，尺寸一小，這個計數的漲落就足以把邊緣推動。這個散布就是良率的上限。',
        RunExposures: '跑 300 次曝光',
        SectionRecipe: '曝光配方',
        DoseToSize: '調劑量到目標尺寸',
        SectionStored: '已存配方',
        SectionResist: '光阻為什麼響應這個波長——光子把電子抬起來（PPP-CIS）',
        ResistChartTitle: '分子的吸收，與曝光所用的譜線對照',
        ResistChartX: '波長 (nm)',
        ResistChartY: '吸光度，相對值',
        ResistStatus: '{{formula}}，{{bonds}} 個雙鍵 · 最強吸收在 {{lambda}} nm · 響應 {{lines}}',
        ResistBlind: '都不響應——這個分子對每一條譜線都是透明的',
        ResistConjugation: '共軛長度',
        ResistBonds: '{{n}} 個雙鍵 · {{formula}}',
        ResistFailed: '分子光譜引擎載入失敗。',
        ResistLoading: '正在載入分子光譜引擎…',
        ResistNote: '上面的一切都是光學：收進的繞射級、形成的像、給出的劑量。而這一切都預設了唯一不屬於光學的那一步——光子到達時，光阻要有反應。它的反應是把一個電子從分子最高佔據軌域抬到最低空軌域，而分子只能吸收能量與該間隙相匹配的光子。波長太紅，光就直接穿過一層與玻璃無異的膜。這個間隙由電子能擴展多遠決定：共軛鏈中的 π 電子就是一個盒中粒子，盒長即共軛長度，盒子越長能階越密。把鏈拉長，看吸收帶如何從深紫外一路走進可見光，依次越過每一條曝光譜線。這正是為 365 nm i 線設計的增感劑在 193 nm 完全透明、毫無用處的原因，也是每一次向更短波長邁進都意味著全新光阻化學而不只是換一盞燈的原因。',
        ResistWhatNote: '這些並不是光阻。它們是全反式多烯——單雙鍵交替的直碳鏈——而真正的光阻是含重氮萘醌增感劑的酚醛樹脂，或是含光酸產生劑的丙烯酸酯：都是本模型不涵蓋其化學的大分子。多烯序列精確承載的，是本面板所需的那個關係：共軛長度與吸收波長，而且是以最乾淨的形式呈現。請注意沒有任何一條鏈落在 193 nm 的 ArF 上：短鏈吸收在其下，長鏈在其上——這恰好說明了為什麼 193 nm 需要另一族發色團，而不是把舊的做短一點。引擎是 AIMS 的 PPP-CIS，它把乙烯定在 161 nm，實測值為 165 nm。',
        SectionShift: '值班',
        TilePrintedCd: '曝顯 CD',
        DidNotPrint: '沒有印出來',
        NoteTarget: '目標 {{nm}} nm',
        TileCdError: 'CD 誤差',
        NoteSpec: '規格 ±10%',
        K1BelowLimit: '低於物理極限',
        K1Aggressive: '偏積極',
        K1Comfortable: '較寬裕',
        TileContrast: '成像對比度',
        NoteNils: '邊緣處的像對數斜率',
        TileLer: '線邊緣粗糙度',
        TilePhotons: '送達光子數',
        TilePhotonEnergy: '光子能量',
        TileWavelengthNa: '波長 / NA',
        NotMeasured: '尚未量測',
        ChartAerialTitle: '落在晶圓上的光，以及它留下的酸',
        ChartPosition: '跨越一個節距的位置（nm）',
        ChartNormalised: '正規化',
        SeriesAerial: '空間像',
        SeriesAcid: '烘烤後的酸',
        AnnDevelop: '顯影閾值',
        ChartBossungTitle: '不同劑量下 CD 隨焦距的變化',
        ChartFocusOffset: '離焦量（nm）',
        ChartCd: 'CD（nm）',
        AnnTarget: '目標',
        ChartWindowTitle: '劑量寬容度隨焦距變化——DOF {{dof}} nm',
        ChartDoseLatitude: '劑量寬容度（%）',
        SeriesDoseLatitude: '劑量寬容度',
        AnnNeeded: '量產至少需要 5%',
        ChartStochTitle: '300 次完全相同的曝光——sigma {{sigma}} nm',
        ChartStochFailures: '，其中 {{n}} 次徹底沒印出來',
        ChartPrintedCd: '曝顯 CD（nm）',
        ChartCount: '計數',
        SeriesExposures: '曝光次數',
        AssistantBlurb: '提出問題，我會設計一個實驗，用這台求解器把它跑出來，並報告真正得到的結果——然後再還你一個更銳利的問題。',
        AssistantLead: '真正抵達晶圓的只有兩個數：劑量和焦距。它們都不直接決定 CD。問我它們是怎麼走到那一步的。',
      },
      clean: {
        TransportSurface: '晶圓表面',
        TransportStarved: '虧缺',
        SectionTransport: '一槽藥液可能短缺的是什麼——串聯的兩個阻力（質量傳輸）',
        TransportCaveat: '這是**一般情形，不是這一槽**，而這個區別值得說準確。SC-1 中過氧化氫與氫氧化物的濃度大約是莫耳量級，' +
          '而表面每分鐘只消耗幾個奈米，供給比需求高出好幾個數量級，真實的 SC-1 槽並不會缺料。上面那個區間來自一個特意選取的速率常數，' +
          '它把反應與輸運放在同一量級上，而課程正活在那裡——並且這也是真實濕製程確實會進入的區間：稀釋或用舊的槽液、快速蝕刻、' +
          '以及深結構的底部。它同樣**不是**換能器存在的理由。兆聲波是靠**機械**方式把顆粒取下來的：聲流不斷拖曳顆粒，' +
          '直到拖曳力勝過按住它的凡得瓦力，空化在旁邊幫忙。那是一種「脫附」機制，而不是「輸送」機制。這樣一來，上面配方裡把熱因子' +
          '乘以兆聲因子的算法依舊是錯的——熱和聲不是同一個旋鈕的兩檔——只不過錯的理由是這一條，而不是這幅圖所展示的那條。',
        TransportNote: '化學品必須先到達晶圓才談得上起作用，而這裡晶圓消耗它的速度快於靜止槽液的補給 — 於是表面之上形成一層供應不足的區域，這裡的顏色就是實際存在的氧化劑 ' +
          '有多少。攪動槽液，這層就變薄，表面重新被補滿。現在把兩個旋鈕對著比一比。在靜止槽中，把溫度從 70 升到 85 ' +
          '°C，反應速率漲了一倍多，但去除量只多了約四分之一，因為表面只是被榨得更乾。讓槽液流動起來再做同樣一步，回報是三倍。而在冷槽中，攪動完全買不到任何東西 — ' +
          '瓶頸在化學反應，攪它是在修錯地方。串聯的兩個阻力，值得攻的永遠只有較大的那一個。',
        ActionRunTheCleanAnd: '運行清洗，把晶圓傳下去',
        NoteNoLotInTheBench: '清洗台上沒有批次。把一片晶圓拿到這裡來清洗。',
        SecondaryLabel: '表面金屬',
        ToolLabel: 'CLN-09 RCA 濕法清洗台',
        NextTheRinseWaterIsA: '漂洗水低於約 15 MΩ·cm 時本身也是污染源。如果槽液化學沒問題而晶圓還是髒著出來，你會先查哪裡？',
        AxisY10AtomsCm: '×10¹⁰ 原子/cm²',
        AxisXSc2TimeMin: 'SC-2 時間 (min)',
        TitleMetalsAndParticlesAgainstSc: '金屬與顆粒隨 SC-2 時間的變化',
        NoteSc1SJob: 'SC-1 的活',
        LabelMetalsAsSet: '金屬，當前設定',
        LabelMetalsNoSc2: '金屬，無 SC-2',
        HypTheTwoBathsHaveOpposite: '兩個槽的化學性質相反，原因也相反。SC-1 是鹼性的，靠底切把顆粒抬起來；SC-2 是酸性的，溶解鹼性化學留在表面上的金屬。如果這是對的，SC-2 ' +
          '時間應該移動金屬數值而幾乎不動顆粒數值，去掉 SC-1 則應相反。',
        AskedWhatDoesTheSecondBath: '第二個槽去除的是什麼？第一個槽為什麼去不掉？',
        SumMetalsVersusParticlesAndWhy: '金屬對顆粒，以及為什麼一個槽幹不了兩件事。',
        NextThrm04GrowsAGate: 'THRM-04 要在這個表面上長閘極氧化層。在髒檯面上、空氣裡長出來的額外半奈米自然氧化層，會對一個假定從裸矽出發的 Deal-Grove 生長做什麼？',
        AxisYOxideNm: '氧化層 (nm)',
        AxisXMinutesAfterHf: 'HF 後分鐘數',
        TitleNativeOxideRegrowthAgainstQueue: '自然氧化層再生長隨排隊時間的變化',
        LabelOxideImmediate: '氧化層，立即',
        HypHfStripsTheNativeOxide: 'HF ' +
          '剝掉自然氧化層，讓表面以氫終結。空氣立刻開始把氧化層放回去，而且是對數式的——表面活性高時很快，隨後爬行。如果是這樣，排隊的代價大部分花在頭半小時裡，等四小時只比等一小時差一點點。',
        AskedWhatDoesTheWaitBetween: '從這個清洗台到下一台機台之間的等待要付出什麼代價？',
        SumNativeOxideRegrowthAgainstThe: '自然氧化層隨排隊時鐘的再生長，以及為什麼 HF 會啟動這個時鐘。',
        NextTheFloorThisCurveFlattens: '這條曲線趨平的下限不是零——是漂洗和乾燥重新放回去的量。問我 HF 浸之後會發生什麼，那裡的情況要糟糕得多。',
        AxisYNmRms: 'nm RMS',
        TitleAndTheRoughnessItCost: '以及它付出的粗糙度',
        AxisYParticlesCm: '顆粒/cm²',
        AxisXSc1TimeMin: 'SC-1 時間 (min)',
        TitleParticlesRemainingAgainstSc1: '殘留顆粒隨 SC-1 時間的變化',
        LabelRoughness: '粗糙度',
        LabelParticles: '顆粒',
        AskedDoesMoreBathTimeKeep: '更長的槽浸時間會讓晶圓一直更乾淨嗎？',
        SumDiminishingReturnsOnBathTime: '槽浸時間的收益遞減，以及為此付出的粗糙度。',
        fault: {
          poorRinse: {
            Evidence: [
              '沖洗水電阻率 11 MΩ·cm，下限 17。',
              '顆粒檢查和金屬檢查都超差。',
              '兩個槽的時齡和換能器都正常。',
            ],
            Truth: 'DI 水廠的拋光柱需要再生，沖洗水只有 11 ' +
              'MΩ·cm。沖洗是晶圓看到的最後一道，它帶著什麼，就在兩種化學都完美幹完活之後又放回什麼。顆粒和金屬同時掛掉，是任何單個槽都做不出來的特徵——而且維修根本不在這台機台上。',
            Complaint: '這張檯子上顆粒和金屬雙雙超差。兩個槽都是新的，兆聲也檢查無誤。',
            Label: '沖洗水超差',
          },
          deadTransducer: {
            Evidence: [
              '兆聲實際輸出 30%，下限是 85%。',
              '監控片上的去除率低於 98%。',
              '兩個槽的時齡都正常——這不是化學的問題。',
            ],
            Truth: '兆聲換能器只輸出指令功率的 30%。兆聲的作用是加速被掀起的顆粒離開表面，沒有它，化學照常起作用，顆粒又落了回去。新槽液加上差去除，合在一起就是特徵。',
            Complaint: '顆粒去除變差了，而兩個槽今早剛重配過。',
            Label: '兆聲換能器失效中',
          },
          spentSc2: {
            Evidence: [
              'SC-2 槽液時齡超壽命。',
              'VPD-ICPMS 表面金屬遠超 5 ×10¹⁰ 的限值。',
              '顆粒去除完全正常。',
            ],
            Truth: 'SC-2 ' +
              '槽液失效了，金屬沒有被去除。晶圓看上去是乾淨的——光學檢測儀看不見單層的銅——它們就這樣把銅直接帶進爐管，銅在那裡擴散開來，殺死氧化層。這是全廠每一種便宜的量測都看不見的失效。',
            Complaint: '某個產品的閘極氧化層完整性掉下來了。顆粒計數完全正常，沒有人找得到缺陷。',
            Label: 'SC-2 槽液失效',
          },
          spentSc1: {
            Evidence: [
              'SC-1 槽液時齡超壽命。',
              '監控片顯示去除率遠低於 98%。',
              '表面金屬正常，SC-2 在幹它的活——壞的是一種化學，不是兩種。',
            ],
            Truth: 'SC-1 裡的過氧化氫分解了——槽液已經 34 小時，壽命是 16 ' +
              '小時。活性槽裡的去除是一階過程，失效的槽幾乎不幹活，顆粒逕直穿了過去。機台看不出任何異樣，因為一槽透明液體從來看不出任何異樣。',
            Complaint: '凡是過這張檯子的貨，到 INSP-13 缺陷密度都翻倍了。檯子自己沒報警，看起來跟平時一模一樣。',
            Label: 'SC-1 槽液失效',
          },
          clnHealthy: {
            Evidence: [
              '兩個槽都是新配的。',
              '顆粒去除和表面金屬都在帶內。',
            ],
            Truth: '什麼問題都沒有。正確的判定就是放行這一批。',
            Complaint: '例行班次。沒有針對這張清洗檯的任何報告。',
            Label: '一切正常',
          },
        },
        NoteMinAtC: '{{b}} °C 下 {{a}} 分鐘',
        NoteFromCmIncoming: '來料 {{a}}/cm²',
        SectionTwoThingsThisBenchIs: '這張清洗檯在交換的兩樣東西',
        NoteParticleRemovalIsFirstOrder: '顆粒去除是一階過程，所以最後那幾顆顆粒最費時間——而每多一分鐘熱 SC-1 都在蝕刻矽、讓表面變粗糙。然後，如果你用 HF ' +
          '把氧化層剝掉，一只時鐘就開始走了：自然氧化層在頭二十分鐘裡長回來得最快，所以排隊時間是一條規格，不是一句客套。',
        NoteThisLotIsStillAn: '這批貨還是一根晶棒。得先由 WPR-08 切片，這台機台才碰得了它。',
        SectionBenchState: '清洗檯狀態',
        LabelParticlesLeft: '剩餘顆粒',
        LabelRemovalEfficiency: '去除效率',
        LabelMetalRemaining: '殘留金屬',
        Note5BeforeAFurnace: '進爐前需 < 5',
        LabelSurfaceRoughness: '表面粗糙度',
        NoteSc1EtchesAndEtching: 'SC-1 會蝕刻，蝕刻就會變粗糙',
        LabelOxideAtTheNextStep: '到下一步時的氧化層',
        LabelHfBenefitLost: 'HF 效果損失',
        AssistantLead: 'CLN-09 探究助理',
        AssistantBlurb: '可以問：延長槽內時間有沒有用、HF 之後的等待時間代價是什麼、第二道槽是做什麼的。每個回答都是在這台清洗槽上真實跑出來的一次清洗。',
        reading: {
          houseutilities: {
            Label: '致電廠務查詢公用系統面板（0.5 h）',
          },
          metalCheck: {
            Label: 'VPD-ICPMS 表面金屬——破壞性（4.0 小時）',
          },
          particleCheck: {
            Limit: '去除 > 98%',
            Label: '監控片清洗前後顆粒計數（1.5 小時）',
          },
          resistivity: {
            Label: '沖洗水電阻率',
          },
          transducer: {
            Label: '兆聲實際輸出功率',
          },
          sc2Age: {
            Label: 'SC-2 槽液時齡',
          },
          sc1Age: {
            Label: 'SC-1 槽液時齡',
          },
        },
        aspect: {
          house: {
            Action: '上報廠務——超純水廠的拋光混床需要再生',
            Label: '沖洗水供給——不在本機',
          },
          megasonic: {
            Action: '更換換能器並重測槽內聲場分布',
            Label: '兆聲換能器',
          },
          sc2: {
            Action: '倒槽重配 SC-2',
            Label: 'SC-2 槽',
          },
          sc1: {
            Action: '倒槽重配 SC-1，並縮短槽液壽命間隔',
            Label: 'SC-1 槽',
          },
        },
      },
      atomView: {
        Atom: '原子',
        Coordinates: '座標',
        AtomicMass: '質量',
        AtomicRadius: '半徑',
        ElectricCharge: '電荷',
        AutoRotate: '自動旋轉',
        Axes: '顯示坐標軸',
        Container: '顯示容器',
        Fog: '有霧',
        ViewDirection: '觀察方向',
        PositiveX: '正X軸方向',
        NegativeX: '負X軸方向',
        PositiveY: '正Y軸方向',
        NegativeY: '負Y軸方向',
        PositiveZ: '正Z軸方向',
        NegativeZ: '負Z軸方向',
        Mechanics: '力學',
        KineticEnergyColors: '動能著色',
        MomentumVectors: '顯示動量向量',
        ForceVectors: '顯示力向量',
        GlobalStyle: '全域風格',
        BallAndStick: '球和棍',
        Wireframe: '線框架',
        Stick: '棍',
        SpaceFilling: '空間填滿',
        Material: '材質',
        Diffuse: '散射',
        Soft: '柔軟',
        Glossy: '光澤',
        Metal: '金屬',
        Translucent: '半透明',
        Glass: '玻璃',
        Toon: '卡通',
        Flat: '平均',
        BackgroundColor: '背景顏色',
        TakeScreenshot: '截屏',
      },
      e2d: {
        ViewProperties: '檢視屬性……',
        Properties: '屬性……',
        ThisPart: '此部件',
        ModelProperties: '模型屬性……',
        Loading: '正在載入模擬引擎……',
        Failed: '模擬引擎載入失敗。',
        Run: '執行',
        Pause: '暫停',
        Reset: '重設',
      },
      implant: {
        BeamWafer: '晶圓',
        BeamSpot: '最高溫',
        BeamClamp: '夾持散熱',
        SectionBeamHeat: '束流把什麼加熱了 — 夾持台上的晶圓（傳熱）',
        BeamHeatNote: '束流功率就是電壓乘電流：30 keV、10 mA 即 300 W ' +
          '全部落在一片晶圓上。這裡展示的就是這份功率進入晶圓、帶狀束以每秒一公尺掃過，以及靜電夾盤透過晶圓背面的氦氣把熱量抽走。有三點值得看。晶圓只比夾持台高出幾度就穩住了 — ' +
          '決定溫度的是夾持散熱而不是束流；一旦背面氦氣失效，同樣的束流會把晶圓推過 300 °C，光阻隨之龜裂。束流電流同時買來產能和熱量。還有，掃描的帶狀束並不會留下一道灼痕：矽的導熱太好了 ' +
          '— 而這正是上面的面板可以老老實實只用一個晶圓溫度、而不必用一張溫度分佈圖的原因。',
        DamageFurnace: '退火爐溫',
        DamageReset: '重設',
        DamagePause: '暫停',
        DamageRun: '執行',
        DamageFailed: '分子動力學引擎載入失敗。',
        DamageLoading: '正在載入分子動力學引擎……',
        DamageHighlight: '突顯缺陷',
        DamageChartTitle: '殘留缺陷隨時間變化——退火',
        DamageChartX: '模擬時間 (ps)',
        DamageChartY: '缺陷數（空位 + 填隙）',
        DamageChartSeries: '殘留缺陷',
        DamageChartAsImplanted: '植入後初始值',
        RdfTitle: '徑向分布函數 g(r) —— 把晶體畫成曲線',
        RdfX: '原子對間距 r（Å）',
        RdfY: 'g(r)',
        RdfSeries: '目前 g(r)',
        RdfUncorrelated: 'g = 1，無結構',
        RdfStatus: '峰位於 {{a}} Å 與 {{b}} Å（理想值 2.35 與 3.84）· 二者之間 g(3.0 Å) = {{c}} —— 晶體中為零，碎晶中被填滿',
        RdfNote: '把同一批原子的所有原子對間距做成直方圖，並歸一化使無關聯氣體讀數為 1。晶體是落在標出的配位殼層上的尖峰，殼層之間空無一物；加熱會讓峰變寬，而損傷做的是另一件事——它把間隙填滿，讓第二、第三殼層糊成一片。把上方的劑量從零拖到上限，看曲線從梳齒變成土包：這就是繞射儀眼中晶態與非晶態的區別。曲線即時更新，退火重新銳化某個峰時這裡也能看到。',
        DamageStatus: '{{a}} 個空位 · {{b}} 個填隙原子 · 束流損傷為非晶化劑量的 {{c}}% · {{d}} K',
        DamageNote: '每一個停留在晶圓中的離子，在進入的路上都會把矽原子撞離晶格位。每個被撞出的原子留下一個空位——紅色籠形標記，代表空缺的晶格位——自己則停在晶格間隙成為填隙原子，以黃色顯示。這一對就是弗蘭克爾缺陷對；數量足夠多時就是所謂的「非晶化」：整齊的鑽石秩序變成一片瓦礫。這個晶格由上方配方驅動，因此提高劑量或換用更重的離子，就能看到損傷攀升；再提高晶圓溫度，損傷又會下降，因為熱佈植會邊佈植邊自我修復。晶胞只有 ' +
          '216 個原子，所以損傷是按比例放大以便看見，而非字面數值。',
        CarriersTitle: '載子隨溫度的變化',
        CarriersX: '溫度（K）',
        CarriersY: 'log₁₀ nm⁻³',
        CarriersSeries: '載子',
        CarriersIntrinsic: '本徵矽',
        CarriersKnee: '全部釋放',
        CarriersCrossover: '矽本身佔主導',
        CarriersFailed: '載子模型不適用於該摻雜濃度。',
        CarriersLoading: '正在求解載子統計……',
        CarriersAtRoom: '300 K 時有 {{pct}}% 在貢獻載子',
        CarriersKneeAt: '到 {{k}} K 全部釋放',
        CarriersCrossAt: '{{k}} K 起矽本身佔主導',
        CarriersDoping: '摻雜 1e{{exp}} nm⁻³',
        NoteCarriers: '摻雜原子佔據了晶格位置，還不等於就有了載子。晶格旁邊這條曲線是 AIMS 用費米–狄拉克統計佔據雜質能階、並求解電荷中性得到的：溫度低時載子會重新落回雜質能階，濃度急劇塌陷——這就是為什麼在液氮裡量到的電阻率和室溫規格完全不同。溫度升高後每個雜質都釋放載子，平台高度就是你摻進去的濃度；正是這段平坦區間，才使摻雜成為可用的設計手段。溫度再高，矽自身的電子被激發越過能隙，材料便不再理會你注入了什麼——這就是接面溫度的上限。滑桿調的是井區或基板的摻雜，不是這次注入的峰值濃度——後者要高出大約兩個數量級。超過 10¹⁸ cm⁻³ 之後，雜質能階已併入能帶，模型的非簡併統計不再成立，所以滑桿就停在這裡，而不去畫一條自信而錯誤的曲線；而這塊面板剛剛做出的那次注入，正落在這個範圍之外。',
        SectionDamage: '離子束造成的破壞——晶格損傷（分子動力學）',
        LatticeHighlight: '突顯摻雜原子',
        LatticeStatus: '{{a}}：{{c}} 個原子中有 {{b}} 個摻雜原子 · 實測 {{d}} K',
        LatticeConc: '摻雜濃度（已誇大）',
        TraceTitle: '離晶格位點的距離 —— 熱振動',
        TraceX: '模擬時間（ps）',
        TraceY: '位移（Å）',
        TraceDopant: '位點上的 {{a}}',
        TraceHost: '基體 Si 原子',
        TraceSiRef: 'Si 在 300 K 的均方根位移（X 光 Debye–Waller）',
        TraceStatus: '最近 {{a}} ps 內離位點的均方根位移：{{b}} {{c}} Å · Si {{d}} Å · 鍵長 2.35 Å',
        TraceIdle: '按下執行：離位點的均方根距離在執行的最近 {{a}} ps 內測得',
        LatticeReset: '重設',
        LatticePause: '暫停',
        LatticeRun: '執行',
        LatticeFailed: '分子動力學引擎載入失敗。',
        LatticeLoading: '正在載入分子動力學引擎……',
        DopantBohr: 'a*',
        DopantMeanR: '⟨r⟩',
        DopantHalfSpacing: '到下一個摻雜原子的一半距離',
        DopantOrbitTitle: '多出來的那個電子在哪裡',
        DopantOrbitX: '距摻雜原子的距離 (nm)',
        DopantOrbitY: '徑向密度 4πr²|ψ|²，峰值 = 1',
        DopantOrbitSeries: '被束縛的電子',
        DopantOrbitNone: '沒有束縛態——電子是自由的',
        DopantModelNc: '模型：原子消失',
        DopantMeasuredNc: '實測 Si:P 轉變點',
        DopantMeasuredE: '{{dopant}} 的實測值',
        DopantBindingTitle: '束縛有多緊，隨摻雜濃度的變化',
        DopantBindingX: '摻雜濃度的 log₁₀ (cm⁻³)',
        DopantBindingY: '束縛能 (meV)',
        DopantBindingSeries: '計算值，含遮蔽',
        DopantBindingHere: '目前配方',
        DopantFailed: '摻雜原子求解器載入失敗。',
        DopantShort: 'a* = {{bohr}} nm · 此處束縛能 {{bind}} meV · 在 {{nc}} cm⁻³ 時失去束縛',
        DopantHelp: '這個原子的全部數值',
        DopantStatus: 'a* = {{bohr}} nm · Ry* = {{ry}} meV（{{dopant}} 實測：{{measured}}）· 此處束縛能 {{bind}} meV · 德拜長度 {{debye}} nm，下一個摻雜原子在 {{spacing}} nm 之外 · 在 {{nc}} cm⁻³ 處消失',
        DopantStatusGone: 'a* = {{bohr}} nm · 沒有束縛態：德拜長度為 {{debye}} nm，下一個摻雜原子在 {{spacing}} nm 之外 · 原子在 {{nc}} cm⁻³ 處已消失',
        DopantLoading: '正在載入摻雜原子求解器…',
        DopantConc: '摻雜濃度',
        DopantHost: '基材與載子',
        DopantHostSiDonor: '矽，施體 (P)',
        DopantHostSiAcceptor: '矽，受體 (B)',
        DopantHostGe: '鍺，施體',
        DopantHostGaAs: '砷化鎵，施體',
        SectionDopant: '摻雜原子是什麼——矽裡的一個氫原子（薛丁格方程式，徑向）',
        DopantNote: '上面矽位置上的那個磷原子比這個位置需要的多帶一個電子，而這個電子並不自由：磷核比鄰居多一個正電荷，電子繞著它運動，就像電子繞質子運動。這是一個氫原子，只是吸引力被晶體的介電常數除過，電子帶的是有效質量——於是軌道擴大到約 2.4 nm，束縛能縮小到幾十 meV，這正是摻雜原子在室溫下游離、在液態氮裡凍結的原因。徑向薛丁格方程式在網格上求解，解析解只用來核對。右圖沒有解析解：每個游離的摻雜原子都留下一個自由載子，自由載子會遮蔽，超過幾個 10¹⁸ 每立方公分之後，位能井淺得根本容不下束縛態。此時矽成了金屬——這就是莫特轉變，與 Si:P 實測值相差約 10%。模型是等向性的，所以矽中施體算出 26 meV，而實測為 45；其餘部分由中心晶胞修正補上。遮蔽採用德拜模型，300 K。',
        Orbital3dHostSi: '矽',
        Orbital3dHostGe: '鍺',
        Orbital3dHostGaAs: '砷化鎵',
        Orbital3dFailed: '軌域產生器載入失敗。',
        Orbital3dLoading: '正在產生軌域…',
        Orbital3dLegend: '束縛電子的 |ψ|² · 亮度 ∝ √密度，以其自身中心為基準 · 屏蔽使中心密度降低時雲隨之變淡，但不低於 30% · 兩個摻雜原子的電子重疊處顯示為琥珀色',
        Orbital3dClipped: '電子只有 {{inside}}% 落在所畫的最大盒子之內（±{{half}} nm；⟨r⟩ = {{mean}} nm），因此雲在邊緣處被截斷顯示。',
        DopantWallHeld: '勉強束縛：此時的束縛能已小於求解器本身 {{box}} a* 盒子的侷限能，⟨r⟩ 已擴展到 {{mean}} a*。盒子的邊界與摻雜原子一樣在束縛這個電子，因此這個束縛能應視為模型已到極限，而不是原子本身的性質。',
        Orbital3dUnbound: '沒有束縛態',
        Orbital3dCaption: 'a* = {{bohr}} nm（{{bohrCells}} 個晶胞）· ⟨r⟩ = {{mean}} nm（{{meanCells}} 個晶胞）· 摻雜原子平均間距 {{spacing}} nm（{{spacingCells}} 個晶胞）',
        Orbital3dCaptionGone: 'a* = {{bohr}} nm · 摻雜原子平均間距 {{spacing}} nm（{{spacingCells}} 個晶胞）· 沒有束縛態：電子不再屬於任何一個摻雜原子',
        Orbital3dLattice: '{{host}}晶體畫成穿過摻雜原子的兩層相鄰原子面，共 {{count}} 個原子，範圍到 ±{{half}} nm：這是一片薄層，而不是整塊晶體；整個盒子裡的晶體會有 {{full}} 個原子。底邊上的綠色比例尺長一個 a*。',
        Orbital3dNeighbours: '盒子裡有 {{k}} 個相鄰摻雜原子，位於平均間距 {{spacing}} nm 處。它們的電子雲與中心那團相遇的地方顯示為琥珀色：電子在那裡可以從一個摻雜原子跳到另一個，這種重疊就是莫特轉變。',
        Orbital3dNoNeighbours: '下一個摻雜原子在 {{spacing}} nm 之外，不在這個盒子裡：在這個摻雜濃度下，每個電子都獨佔自己的摻雜原子。',
        LatticeNote: '離子佈植後的晶圓在原子尺度的樣子：鑽石立方矽晶格中，配方所選的摻雜劑以替位方式佔據矽位，在 ' +
          'Stillinger–Weber 力場下即時振動。「n ' +
          '型」並不神祕，就是這些原子：一個施體佔據一個晶格位，多出一個價電子。在上方配方中更換佈植種類，晶格會重新摻雜（BF₂ ' +
          '佈植的是硼，氟在退火時離開）。濃度滑桿被刻意誇大——真實摻雜是百萬分之一量級，在這麼小的晶胞裡根本看不見。左鍵拖曳旋轉，滾輪縮放，右鍵拖曳平移。',
        SectionLattice: '摻雜的本質——晶格（分子動力學）',
        ActionImplantAndPassThe: '植入後把晶圓傳給爐子',
        UnitPctOnTarget: '%（相對目標）',
        NoteNoLotOnTheEndstation: '終端台上沒有批次。把一片帶光罩的晶圓拿到這裡來植入。',
        NoteCrystalline: '晶態',
        NoteAmorphisedTheAnnealIs: '已非晶化——退火不是可選項',
        NoteThePanelAboveRuns: '上面的面板跑的是四條擬合公式：射程用冪律，離散取它的一個比例，溝道化比例用傾角高斯，非晶化用劑量閾值。下面，同一次植入被求解——三千個離子在晶體中逐次碰撞地追蹤。在解析式被擬合過的區間，兩者一致；離開那裡就不一致，而這個差距正是要造求解器的理由。',
        NoteTheCriticalAngleIs: '對這種離子在這個能量下，臨界角是 ' +
          '{{a}}°，而且其中沒有任何擬合參數——它直接由晶格常數和兩個原子序數導出。傾角設在它以內，束流就溝道化；設在它以外就不會。上面的公式對所有種類、所有能量只有一條傾角曲線，所以它沒法告訴你：砷在七度時仍會溝道化，而硼不會。',
        ValueThresholdAsOneNumber: '閾值的 {{a}} 倍，只有一個數',
        ValueVacanciesPerIon: '每離子 {{a}} 個空位，以分佈給出',
        MetricDamage: '損傷',
        ValueZeroGaussian: '0（高斯）',
        MetricDistributionSkew: '分佈偏度',
        ValueNoSuchQuantity: '無此量',
        MetricCriticalAngle: '臨界角',
        MetricChannelled: '溝道化比例',
        MetricStraggle: '射程離散',
        MetricProjectedRange: '投影射程',
        LegendTheFittedFormula: '擬合公式',
        LegendIonsTraced: '追蹤 {{a}} 個離子',
        LabelPeakConcentration: '峰值濃度',
        SecondaryLabel: '劑量非均勻性',
        ToolLabel: 'IMP-10 大束流離子植入機',
        NextBothOfThoseProfilesGet: '這兩種分佈都要經過退火。爐子對哪一種改變更大——這讓淺植入比這裡看起來更好還是更糟？',
        AxisXEnergyKev: '能量 (keV)',
        TitleProjectedRangeAgainstEnergy: '投影射程隨能量的變化',
        LabelStraggleDeep: '離散，深植入',
        LabelStraggleShallow: '離散，淺植入',
        HypEnergyBuysDepthButThe: '能量買到深度。但分佈的展寬並不按比例縮小，所以淺植入相對而言應比深植入更寬——射程越小，離散佔射程的比例越大。如果這成立，「更淺」和「更陡」就不是同一個要求。',
        AskedWhatSetsHowDeepThe: '是什麼決定摻雜進多深？做淺要付出什麼？',
        SumEnergySetsDepthAndDose: '能量決定深度，劑量決定濃度——兩者不可互換。',
        NextThrm04HasToAnneal: 'THRM-04 得把這些損傷退火掉，而這次退火花的是與閘極氧化層同一份熱預算。問問爐子：修復這些損傷要讓你剛放好的接面付出什麼。',
        LabelDamageRatio: '損傷比',
        AxisYDamageAmorphisationThreshold: '損傷 / 非晶化閾值',
        AxisXDoseCm: '劑量 (nm⁻²)',
        TitleLatticeDamageAgainstDose: '晶格損傷隨劑量的變化',
        LabelUniformity: '均勻性',
        LabelDamageRatioL226: '損傷比',
        HypEveryIonKnocksLatticeAtoms: '每個離子在進入時都把晶格原子撞離原位。累積密度低於某個值時，晶體能在級聯之間自我修復；高於它，損傷彼此重疊，整層完全非晶化。如果是這樣，劑量上應存在一個閾值而不是漸變——而且讓晶圓熱著植入應把閾值推高，因為溫熱的晶格邊受損邊退火。',
        AskedHowMuchDamageIsThis: '這次植入造成了多少損傷？什麼時候變成非晶？',
        SumLatticeDamageAgainstDoseAnd: '晶格損傷隨劑量的變化，以及爐子被要求修復的是什麼。',
        NextTheStageHasATilt: '載台自身有遠小於一度的傾角誤差。看看這條曲線最陡的地方——半度的載台誤差在那裡要付出什麼？在 7° 處又付出什麼？',
        LabelTailDepth: '尾部深度',
        TitleAndTheDepthItReaches: '以及它到達的深度',
        AxisYFractionOfDose: '劑量比例',
        AxisXTiltDegrees: '傾角（度）',
        TitleChannelledFractionAgainstTilt: '溝道化比例隨傾角的變化',
        LabelTailAt7: '7° 時的尾部',
        LabelTailOnAxis: '沿軸向的尾部',
        LabelTableRange: '表列射程',
        HypSiliconIsACrystalNot: '矽是晶體，不是非晶固體，沿低指數方向它大部分是空的。順著溝道進入的離子損失能量的速度遠低於數據表的假設。如果確實如此，深度應強烈依賴於傾角而與能量幾乎無關——而且幾度就足以把溝道關上。',
        AskedWhyDoesTheImplantGo: '為什麼植入比投影射程預測的更深？',
        SumChannellingDownTheLatticeAnd: '沿晶格的溝道效應，以及擋住它的那七度傾角。',
        fault: {
          weakSource: {
            Evidence: [
              '源壓力 35%，下限 85%。',
              '片電阻分布超限。',
              '掃描均勻性正常——束被掃得沒錯，只是沒有一束穩定的束可掃。',
            ],
            Truth: '源壓力掉到標稱的 ' +
              '35%。餓著的源打出不穩的束，不穩的束注出劑量不勻的晶圓——和掃描壞掉造成的不均勻一模一樣，只是出在束線的另一頭。能分開兩者的是掃描的讀數。',
            Complaint: '束流不穩，節拍變長，分布圖發花。',
            Label: '離子源失效中',
          },
          scanDrift: {
            Evidence: [
              '掃描均勻性 30%，下限 90%。',
              '片電阻分布超過 1% 的不均勻度限值。',
              '監控片總劑量正確，分布也沒有尾巴。',
            ],
            Truth: '掃描系統的均勻性因子只剩 30%。劑量平均起來是對的，具體到每個位置都是錯的——總電荷正確，法拉第杯心滿意足，而晶圓沒有被均勻植入。',
            Complaint: '片電阻分布圖沿掃描方向出現了條紋。',
            Label: '掃描波形劣化',
          },
          tiltZeroLost: {
            Evidence: [
              '傾角回讀 0.6°，設定值是 7°。',
              'SIMS 顯示 40% 的劑量在一條深尾巴裡。',
              '退火監控片的劑量正確——法拉第杯沒問題。',
            ],
            Truth: '傾角編碼器丟了零點，檯面偏了 6.4°，要 7° 的配方實際在 0.6° ' +
              '下植入——正對通道。四成的束流鑽到三倍深的地方，而峰值原地不動，於是均值沒問題，尾巴才是接面。片電阻一積分就把尾巴抹掉了，這就是它能一路漏到產品的原因。',
            Complaint: '某個產品接面漏電。片電阻在目標上，劑量在目標上，分布峰值也恰好在該在的位置。',
            Label: '傾角台零點丟失',
          },
          driftedCup: {
            Evidence: [
              '校準標籤在有效期內——好機台上它也在有效期內。',
              '退火後的監控片只有預期劑量的 87%。',
              '傾角、掃描、離子源全都正常。',
            ],
            Truth: '劑量積分器高讀 ' +
              '13%，於是機台提前停止植入，還報告足量。它沒有說謊——它在精確地測一個錯的東西，這更糟，因為全廠每一份配方都是照著那個數寫的。抓住它的唯一辦法，是別再測束流，去測晶圓。',
            Complaint: '凡是過這台植入機的產品片電阻都超差。機台咬定它給的劑量分毫不差，還有積分電荷為證。',
            Label: '法拉第杯讀數偏高',
          },
          impHealthy: {
            Evidence: [
              '檯上的每個讀數都正常。',
              '監控片的劑量和分布都核對無誤。',
            ],
            Truth: '什麼問題都沒有。正確的判定就是放行這一批。',
            Complaint: '例行批次。機台報的劑量和配方要的一致。',
            Label: '一切正常',
          },
        },
        NoteMaOfBeam: '束流 {{a}} mA',
        NoteTailToNmAtTilt: '{{b}}° 傾角下尾巴伸到 {{a}} nm',
        NoteCmDelivered: '實注 {{a}}/nm²',
        NoteStraggleNm: '離散 ±{{a}} nm',
        SectionTheFailureThatHidesIn: '藏在平均值裡的失效',
        NoteSiliconIsACrystalAnd: '矽是晶體，沿主軸方向大部分是空的。把傾角去掉，很大一部分束流會順著通道直落下去，停在三倍深的地方——而峰值恰好留在配方說的位置。平均值沒問題。尾巴才是接面。',
        SectionSolvedBesideTheFormulaIt: '數值解與它取代的公式並排',
        SectionBeamlineState: '束線狀態',
        LabelProjectedRange: '投影射程',
        LabelChannelled: '通道化份額',
        LabelLatticeDamage: '晶格損傷',
        LabelDoseNonUniformity: '劑量不均勻度',
        LabelImplantTime: '植入時間',
        AssistantLead: 'IMP-10 探究助理',
        AssistantBlurb: '可以問：接面為什麼比手冊深、晶格什麼時候變成非晶、能量到底決定了什麼。每個回答都是在這條束線上真實跑出來的一次植入。',
        reading: {
          uniformityMap: {
            Label: '片電阻標測，監控片 49 點（3.0 小時）',
          },
          sims: {
            Label: 'SIMS 深度剖析——破壞性，外送（24 小時）',
          },
          sheetRho: {
            Label: '監控片退火後四探針測量（6.0 小時）',
          },
          sourcePressure: {
            Label: '源壓力',
          },
          scanUniformity: {
            Label: '掃描均勻性因子',
          },
          tiltReadback: {
            Label: '傾角回讀對設定值',
          },
          doseCal: {
            Value: '在有效期內',
            Limit: '在有效期內',
            Label: '法拉第杯校準日期',
          },
        },
        aspect: {
          source: {
            Action: '更換離子源並重新起弧',
            Label: '離子源',
          },
          scan: {
            Action: '重調掃描波形並重測全片均勻性',
            Label: '束流掃描系統',
          },
          tiltStage: {
            Action: '傾角編碼器歸零並對機械基準核驗',
            Label: '傾角台',
          },
          faraday: {
            Action: '對參考杯重新校準積分器並在監控片上重新認證',
            Label: '法拉第杯與劑量積分器',
          },
        },
      },
      facilities: {
        SecondaryLabel: '抽氣到 10⁻⁵',
        ToolLabel: 'FAC-06 · 製程真空',
        LabelPureOutgassing: '純釋氣',
        LabelPureLeak: '純洩漏',
        LabelThisChamber: '該腔體',
        LabelReaches1e5: '達到 10⁻⁵',
        LabelBaseAt24H: '24 小時後本底壓力',
        LabelBaseAt1H: '1 小時後本底壓力',
        DesignATwentyMinuteRateOf: '對腔體現狀做二十分鐘的壓升測試，並與調到相同初始斜率的純洩漏和純釋氣曲線並列——這樣就只有形狀能區分它們。',
        HypBothRaiseBasePressureAnd: '兩者都會抬高本底壓力，而且機制相同——都是幫浦必須排走的氣體流量。但洩漏由大氣供給，永遠不會枯竭；釋氣由有限的吸附物供給，會枯竭。所以關上閥門：洩漏應給出一條永遠筆直的直線，釋氣則應逐漸彎平。',
        AskedTheChamberWillNotReach: '腔體到不了本底壓力。是空氣在漏進來，還是腔壁在釋氣？',
        SumSeparateARealLeakFrom: '透過壓升曲線的形狀區分真實洩漏與腔壁釋氣。',
        NextConductanceSetsHowFastYou: '流導決定你多快到達，但不決定你停在哪裡。是什麼決定腔體最終穩定的本底壓力？為什麼一台完美的幫浦仍然到不了那裡？',
        TitleEffectiveSpeedAgainstLineDiameter: '有效抽速隨管路直徑的變化，幫浦不變',
        LabelTripleThePump: '幫浦抽速增至三倍',
        AskedPumpingIsSlowerThanExpected: '抽氣比預期慢。是幫浦太小，還是有什麼東西擋在中間？',
        SumShowThatThePipeNot: '證明通常是管路而不是幫浦決定腔體處的抽速。',
        fault: {
          wornPump: {
            Evidence: [
              '本底壓力合格。每片晶圓都能出貨。這就是陷阱。',
              '抽到切換點的時間從幾秒變成了遠超限值。',
              '泵口實測抽速遠低於額定——一錘定音，代價是兩個小時。',
              '管路流導健康，怪不到管子頭上。',
              '升壓率形狀正常，沒有什麼在餵腔體。',
            ],
            Truth: '軸承和葉片間隙都不行了；渦輪泵只剩額定抽速的約二十分之一。規管什麼都不說，而且有它的道理：本底壓力等於氣載除以抽速，抽了一整夜的腔體氣載幾乎為零，隨便多少抽速都能到達一個漂亮的本底。一台快死的泵只顯形於它花了多久，從不顯形於它停在哪裡。這是這個故障還能被找到的唯一原因，也是記錄抽氣時間的廠務日誌比記錄本底壓力的日誌更值錢的原因。',
            Complaint: '沒有任何警報。抽氣時間明顯比日誌裡過去的紀錄長，泵的聲音也不一樣了。本底壓力沒問題。',
            Label: '泵組老化',
          },
          throttledLine: {
            Evidence: [
              '腔體處的有效抽速只是泵額定值的一小部分——這就是那個決定性的數字。',
              '升壓率的斜率和形狀都正常，既沒有漏氣，壁面也是乾的。',
              '本底壓力最終能到；錯的是時間，不是終點。',
            ],
            Truth: '腔體掛在一根 5 cm ' +
              '粗、兩米長的管子後面。流導隨直徑的立方變化，這根管子只放得過泵所能吞的一小部分，腔體從來沒見過花錢買來的那個抽速。把泵換成三倍大幾乎什麼都不會變，因為泵和它前面的管子像串聯電阻一樣相加。',
            Complaint: '抽氣慢得要命。已經有人去詢價三倍大的泵了。',
            Label: '連接管路又長又細',
          },
          wetChamber: {
            Evidence: [
              '隨著表面放空，升壓率的斜率在二十分鐘裡塌下去。這個衰減就是全部診斷；一小時時的壓力不是。',
              '泵速、流導、密封全都檢查無誤。',
              '接著抽下去，本底壓力持續變好。要是漏氣，它早就不再變好了。',
            ],
            Truth: '腔體開過大氣，裝回去時帶著潮氣。壁面吸滿了水，正在慢慢放出來。什麼都沒壞，什麼都不用拆——它需要的是時間，或者一次烘烤。為了找漏把這個腔拆開要花六個小時，而且什麼也找不到。',
            Complaint: '跟上個月門封那次一樣：抽一個小時下不去 10⁻⁵ 出頭。',
            Label: '腔體裝回時帶潮',
          },
          realLeak: {
            Evidence: [
              '升壓率的斜率二十分鐘都不衰減。餵著腔體的那個來源不會耗盡，而任何放氣都做不到這一點。',
              '腔體已經抽了一整夜，壁面是乾的——這也是這個測試能拍板的唯一前提。',
              '泵速和管路流導都正常。',
            ],
            Truth: '上次保養後重新裝配時，一條門封被夾了。空氣在持續漏入。隨之而來的有兩件事，第二件才是全廠在乎的：本底壓力卡住不動，而隨空氣進來的氧在蝕刻機裡清除氟——於是兩層樓上的一位製程技師看到一個謎，而一位廠務技師看到的是一條門封。',
            Complaint: '腔體降不到 10⁻⁵ 出頭以下。上週還抽得好好的。樓上的蝕刻機也在變慢，氣流正常、射頻正常。',
            Label: '門封被夾傷',
          },
          healthy: {
            Evidence: [
              '本底壓力在規格內，升壓率平坦。',
            ],
            Truth: '什麼問題都沒有。真空不是你的問題。',
            Complaint: '系統抽了一整夜，停在本底壓力上。沒有任何報告。',
            Label: '腔體在本底',
          },
        },
        TextH: '{{a}}——{{b}} 小時。',
        NoteVSEff: 'V / S_eff',
        reading: {
          speedcheck: {
            Label: '腔體處通量檢查（1 小時）',
          },
          pumpspeed: {
            Limit: '> 額定值的 70%',
            Label: '泵口抽速測量（2 小時）',
          },
          outgas: {
            Label: '抽一整夜後複測（14 小時）',
          },
          riseShape: {
            Limit: '緻密',
            Label: '關閥升壓率，20 分鐘（25 分鐘）',
          },
          conductance: {
            Label: '管路流導',
          },
          throttle: {
            Limit: '> 720 L/s（泵的 60%）',
            Label: '腔體處抽速',
          },
          timeto: {
            Label: '抽到 10⁻⁵ Torr 的時間',
          },
          base: {
            Label: '1 小時時的本底壓力',
          },
        },
        aspect: {
          walls: {
            Action: '繼續抽，或對腔體烘烤除氣',
            Label: '腔體表面',
          },
          seals: {
            Action: '氦檢漏，重新壓緊門封',
            Label: '密封與法蘭',
          },
          line: {
            Action: '改用更短更粗的管路重新連接',
            Label: '連接管路',
          },
          pump: {
            Action: '維修或更換渦輪泵及其前級泵',
            Label: '泵組',
          },
        },
        SectionSystem: '系統',
        SectionPumpdown: '抽真空',
        PumpdownNote: '從粗抽真空開始。前面快的那一段是幫浦在抽空腔體裡的氣體；後面長長的拖尾，是腔壁在把開腔期間吸進去的東西慢慢吐出來。基礎壓力，就是進氣量和抽氣量相等的那個點。',
        SectionRise: '升壓率——決定性的一測',
        RiseNote: '關掉隔離閥，然後看著。真正的漏以恆定速率往腔裡灌氣，所以曲線是一條永遠不彎的直線。釋氣則隨著表面被抽空而衰減，所以曲線會轉彎。兩者起始斜率相同——形狀才是全部的診斷。',
        RunRise: '做一次升壓率測試（20 分鐘）',
        SectionConductance: '流導——為什麼管路比幫浦更要緊',
        ConductanceNote: '在你現有這台幫浦的條件下，腔體處的有效抽速隨管徑的變化。流導正比於管徑的三次方，所以管子稍微細一點，代價遠比看上去大——而管子那一頭再大的幫浦也補不回來。',
        SectionConfig: '系統組態',
        SectionStored: '已存組態',
        SectionShift: '值班',
        SectionUpw: '超純水廠',
        UpwNote:
          '每個濕法工步都要喝的迴路。這裡有三個習慣。電導表先讀溫度後讀純度——45 °C 的完全純水' +
          '讀數不到 7 MΩ·cm，所以每支真實探頭都補償到 25 °C。混床在幾乎整個壽命裡穩住 18.2，' +
          '然後在最後幾個百分點內崩潰，所以按處理水量再生，絕不按讀數。電阻率只數離子——迴路可以' +
          '帶著十倍於限值的 TOC 而表針安然停在 18.2，所以 TOC 是獨立的儀器。',
        TileUpwRaw: '探頭（未補償）',
        NoteUpwRaw: '純度與溫度混在一起',
        TileUpwComp: '儀表（25 °C 補償）',
        NoteUpwComp: 'CLN-09 用來沖洗的就是它',
        TileUpwLeakage: '離子污染',
        TileUpwToc: '使用點 TOC',
        NoteUpwToc: '電阻率表看不見它',
        ChartUpwTitle: '迴路電阻率 vs 混床壽命',
        ChartUpwX: '混床容量用量（%）',
        SeriesUpwLoop: '25 °C 下的迴路',
        AnnUpwBed: '你的混床',
        AnnUpwFloor: 'CLN-09 下限',
        SectionUtilities: '公用系統——整座大樓即時狀態',
        DeskNote:
          '調度台。這裡的每個數字都是大樓此刻的狀態；數字背後的儀器在廠務層的設備上——' +
          '走這台設備後面的樓梯下去，點擊設備即可。維修也在下面進行。',
        SectionHouse: '廠務系統——整座廠房',
        HouseHealthy: '廠務正常——無事件',
        HouseNote: '樓裡發生一件事，接在它上面的每一台機台都會感覺到。掛一個上去，然後到廠區走一圈：各處的症狀彼此毫不相像，而且沒有一個能在它顯現的那台機台上修好。',
        TileConductance: '管路流導',
        TileSpeed: '腔體處抽速',
        NotePercentOfPump: '幫浦能力的 {{pct}}%',
        TilePumpRating: '幫浦標稱抽速',
        NoteOwnInlet: '在幫浦自己的入口處',
        TileBase1h: '1 小時後的基礎壓力',
        TileBase24h: '24 小時後的基礎壓力',
        NoteLeakFloor: '漏氣給出了一個下限',
        NoteOutgassed: '釋氣已經衰減掉了',
        TileReaches: '達到 10⁻⁵ Torr',
        Never: '永遠達不到',
        TileTimeConstant: '抽氣時間常數',
        TileVerdict: '升壓率判定',
        NotRun: '未測',
        RunTheTest: '先做一次測試',
        NoteSlopeRatio: '斜率比 {{ratio}}',
        VerdictLeak: '漏氣',
        VerdictOutgassing: '釋氣',
        VerdictMixed: '兩者兼有',
        VerdictTight: '氣密良好',
        TileThroughput: '進氣流量',
        NoteAt1h: '1 小時處的 Torr·L/s',
        ChartPumpTitle: '從粗抽真空開始的抽氣過程',
        ChartTimeS: '時間（s）',
        ChartLogPressure: 'log₁₀ 壓力（Torr）',
        SeriesChamber: '腔體壓力',
        AnnBase1h: '1 小時處的基礎壓力',
        NotRunYet: '尚未執行',
        ChartRiseTitle: '升壓率——讀作「{{verdict}}」',
        ChartTimeAfterValve: '關閥之後的時間（s）',
        ChartPressureU: '壓力（µTorr）',
        SeriesMeasured: '實測',
        SeriesPureLeak: '純漏氣會長成這樣',
        ChartConductanceTitle: '腔體處抽速隨管徑的變化（管長 {{cm}} cm）',
        ChartDiameter: '管徑（cm）',
        ChartEffectiveSpeed: '有效抽速（L/s）',
        SeriesEffectiveSpeed: '有效抽速',
        AnnYourLine: '你的管路',
        AnnPumpRating: '幫浦標稱值',
        AssistantBlurb: '提出問題，我會設計一個實驗，用這台求解器把它跑出來，並報告真正得到的結果——然後再還你一個更銳利的問題。',
        AssistantLead: '樓上那台蝕刻機怪到這個房間頭上的次數，比它自己以為的多。問我真空到底是不是問題，以及是真空的哪一部分。',
      },
      epi: {
        SectionWell: '只長幾個奈米——隨之出現的能階階梯（薛丁格方程，一維）',
        WellNote: '夾在矽之間的一薄層 SiGe，對電洞而言其能量低於兩側的矽，於是這層裡的電洞就處在一個盒子中——而盒中粒子不能取任意能量。它得到一架允許能階的階梯，間距由盒子寬度決定，而盒子正是這道配方所生長的厚度。把層變薄，每一階都會升高，因為壓縮一個波會縮短它的波長，而更短的波長要付出能量。升得夠高，最上面那一階便觸到壁而消失：原本容納五階的位能井只剩四階。這裡沒有任何東西是畫上去的——能階就是所生長剖面的本徵值，當求解器不再能在位障之下找到它時，它就從列表中消失。',
        WellCarrierNote: '是電洞而不是電子，而這種不對稱正是要點。矽鍺生長在矽上時，其能帶偏移幾乎全部落在價帶：導帶幾乎不動，因此電子幾乎看不到位能井，而電洞看到的卻很深。這正是 SiGe 用於異質接面雙極電晶體的基極、用於 p 通道 FET 的應變源汲，而不用於侷限電子的原因。偏移取矽基板上應變層的標準值，每單位鍺組成 0.74 eV；質量取沿生長方向的重電洞質量。輕電洞處在同一個位能井中，有自己的一架階梯，這裡略去，因為兩套交錯的線條什麼也教不了。',
        WellChartTitle: '生長的這一層作為一個盒子，以及它所允許的能階',
        WellChartX: '沿疊層的位置 (nm)',
        WellChartY: '電洞的能量 (eV)',
        WellProfile: '生長的剖面',
        WellDensity: '最低電洞所在之處',
        WellTop: '位能井頂',
        WellLevel: 'E{{n}}',
        WellStatus: '{{width}} nm、鍺含量 {{ge}}% 中有 {{n}} 個束縛能階 · 井深 {{depth}} meV · 最低能階 {{ground}} meV',
        WellWidth: '生長厚度',
        WellGe: '鍺組成',
        WellGeValue: '{{pct}}% · 井深 {{depth}} meV',
        WellFailed: '量子井求解器載入失敗。',
        WellLoading: '正在載入量子井求解器…',
        StepBake: '氫氣烘烤',
        StepGrowth: '磊晶生長',
        ReactorDepletion: '到遠端已消耗',
        ReactorLayer: '主流高於表面',
        SectionReactor: '反應器內部的同一套物理（氣相輸運）',
        ReactorNote: ' ' +
          '氣體從左側進入，掠過被加熱的基座；顏色表示還剩多少源氣體。這裡有兩件事是上面那條曲線在結構上無法呈現的。原料沿流動方向被逐漸耗盡——到出口邊緣大約已少了三分之一，所以那一端的成長比進氣端慢，這正是基座必須旋轉的全部原因，也是磊晶以均勻性而非速率來評判的原因。還有，邊界層是一段真實的距離：上方幾毫米處的主流仍保持滿濃度，而其下的表面卻在挨餓，這個落差就是曲線上畫成虛線上限的那個輸運阻力。調大氫氣載氣可以讓這層變薄；升高溫度則讓表面消耗得更猛，把自己餓得更厲害。有一處標籤值得多看一眼：上面的配方計量的是三氯氫矽，而這一幕用的是 Energy2D 自帶的**矽烷**反應器，所以感測器上寫著的是這台機台並不使用的氣體。究竟是哪種分子發生熱解，改變的是數字而不是這幅圖——原料沿流動方向被耗盡、邊界層有一個實實在在的厚度，這是任何矽源氣體在熱基座上都會發生的事。形狀看這裡，速率看上面那條曲線。',
        fault: {
          spentSusceptor: {
            Evidence: [
              '基座小時數遠超塗層更換間隔。',
              '監控片上的新增缺陷密度上升一個數量級。',
              '49 點厚度圖上有淡淡的斑駁——發射率不均——而速率、霧值和動力學探針都保持乾淨。',
            ],
            Truth: '基座塗層已經磨穿，正往氣流裡掉屑。反應器能測量的一切都健康——速率、均勻性、霧值——因為這些都不由塗層決定。它只表現為磊晶層上的缺陷，那是 ' +
              'INSP-13 的證據，不是反應器的證據。',
            Complaint: '顆粒增量一批比一批高。其他什麼都沒動。',
            Label: '基座塗層耗盡',
          },
          wetHydrogen: {
            Evidence: [
              '機台處露點遠高於 -85 °C 限值。',
              '霧值掃描超限一個數量級，而生長速率完全正常。',
              '延長烘烤沒有用——這排除了烘烤配方錯誤。',
            ],
            Truth: 'H2 ' +
              '純化床已經穿透，載氣帶著水。烘烤剝掉自然氧化層，潮濕的氣氛立刻把它放回去，所以不管烘烤多久，表面都在引出疊差。生長動力學幾乎無感——速率說一切正常，而表面說一切都不正常。',
            Complaint: '從週末起每片晶圓都觸發霧值報警。速率和厚度與配方分毫不差。',
            Label: '氫氣中有水汽',
          },
          tiltedLamps: {
            Evidence: [
              '燈象限電流散佈遠超 3% 限值。',
              '49 點厚度圖顯示傾斜；平均厚度接近標稱。',
              '綴飾蝕刻下晶圓邊緣可見滑移線。',
              '動力學探針與生產工作點一致——溫度控制沒問題，溫度分佈有問題。',
            ],
            Truth: '一個燈象限輸出偏低，徑向分佈傾斜了 ' +
              '9%。在輸運平台區平均速率幾乎不動——但梯度帶來的應力在生長溫度下驅動差排，邊緣就滑移了。這是平台無法原諒的故障，因為滑移取決於梯度，不取決於平均值。',
            Complaint: '最近兩批出現邊緣滑移，厚度圖長出了徑向傾斜。平均速率沒問題。',
            Label: '燈象限失效',
          },
          coldPyrometer: {
            Evidence: [
              '動力學探針與生產工作點不一致：1120 °C 時虧缺不大，950 °C 時崩塌。',
              '起泡器液位和源管線輸送驗證無誤。',
              '均勻性略差，因為更冷的晶圓在平台上坐得更低。',
            ],
            Truth: '高溫計漂移了 60 °C、讀數偏樂觀，所以環路把晶圓壓得比所有人以為的低 60 °C。在生產工作點，輸運平台把大部分虧缺藏了起來；降到 950 °C ' +
              '虧缺就急劇放大，因為在阿瑞尼斯曲線下坡，速率本身就是溫度計。與起泡器同樣的症狀，相反的區間簽名。',
            Complaint: '和氣路問題一樣的抱怨：磊晶層偏薄。氣路面板檢查無誤，起泡器昨天剛補滿。',
            Label: '高溫計讀數偏高',
          },
          starvedBubbler: {
            Evidence: [
              '動力學探針顯示 950 °C 與 1120 °C 的百分比虧缺完全相同——這是氣路側的簽名，任何溫度故障都做不出來。',
              '起泡器液位讀數低於浸入管。',
              '均勻性和霧值不受影響。',
            ],
            Truth: '起泡器液位已低於浸入管，實際輸送的 TCS 只有指令值的約 55%。在 1120 °C ' +
              '製程處於輸運受限區，速率隨氣體一比一變化——而溫度環路說的是實話，這正是盯著它看毫無結果的原因。',
            Complaint: '生產配方下磊晶層薄了 40%。整個運行期間溫度回讀穩如磐石。',
            Label: 'TCS 起泡器供料不足',
          },
          epiHealthy: {
            Evidence: [
              '速率、均勻性和霧值全部在範圍內。',
              '動力學探針與生產工作點一致。',
            ],
            Truth: '什麼問題都沒有。正確的判定就是放行這一批。',
            Complaint: '例行班次。沒有人對反應器提出任何問題。',
            Label: '一切正常',
          },
        },
        reading: {
          hazeCheck: {
            Limit: '< 3 ppm',
            Label: '裸矽烘烤後表面霧值掃描（1.0 小時）',
          },
          uniformityCheck: {
            Value: '半程 {{a}} %',
            Limit: '< 2%',
            Label: '監控晶圓 49 點厚度圖（1.5 小時）',
          },
          kineticProbe: {
            Value: '{{b}} °C 時為標稱的 {{a}}%，950 °C 時為 {{c}}%',
            Limit: '兩者應一致',
            Label: '動力學探針——950 °C 重新生長並對比（2.5 小時）',
          },
          susceptorHours: {
            Limit: '< 240 h',
            Label: '基座塗層後小時數',
          },
          dewpoint: {
            Limit: '< -85 °C',
            Label: '機台處 H2 露點',
          },
          bubblerLevel: {
            ValueOk: '在範圍內',
            ValueLow: '低於浸入管',
            Limit: '高於浸入管',
            Label: 'TCS 起泡器液位',
          },
          pyro: {
            Value: '一致（閉環——偏移在這裡顯不出來）',
            Limit: '需用測溫晶圓驗證',
            Label: '待機時高溫計對設定點',
          },
          lampCurrent: {
            Limit: '< 3%',
            Label: '燈象限電流散佈',
          },
        },
        aspect: {
          susceptor: {
            Action: '換下基座，運行塗層配方',
            Label: '基座塗層',
          },
          ambient: {
            Action: '上報氣站——H2 管線的純化床已經穿透',
            Label: '氫氣品質',
          },
          gasline: {
            Action: '補滿起泡器，並在源管線上做壓升測試驗證輸送量',
            Label: 'TCS 輸送',
          },
          pyrometer: {
            Action: '用裝有熱電偶的晶圓重新校準高溫計',
            Label: '高溫計校準',
          },
          lamps: {
            Action: '更換偏弱的燈象限，並重新標定徑向溫度分佈',
            Label: '燈組平衡',
          },
        },
        SecondaryLabel: '厚度非均勻性',
        ToolLabel: 'EPI-20 減壓磊晶反應器',
        NextIfTheLayerMustBe: '如果磊晶層必須 4 µm、一天要出 20 批，你會用 TCS 買時間，還是用第二台反應器——兩者各要付出什麼對方不用付的代價？',
        AxisXTcsTorr: 'TCS (Torr)',
        TitleRateAndItsPrice: '速率及其代價',
        LabelDefectsAtMax: '最大值時缺陷',
        LabelRateAtMax: '最大值時速率',
        HypOnTheTransportPlateauThe: '在輸運平台上，速率應隨供給一比一變化。但表面的消耗能力有限——把氣相推得夠猛，它就會自行成核，而每個核都是一顆落在磊晶層上的顆粒。',
        AskedIsTcsAFreeThroughput: 'TCS 是個免費的產能旋鈕嗎？',
        SumRateFollowsTheGasOne: '速率隨氣體一比一變化——直到氣相自己開始成核。',
        NextTheHazeScanIsClean: '霧值掃描是乾淨的，但烘烤跑長了。損傷會顯現在哪裡？產線下游哪台機台會最先看到它？',
        AxisYHazePpm: '霧值 (ppm)',
        AxisXBakeMin: '烘烤 (min)',
        TitleTheTwoCostsOfThe: '烘烤的兩筆代價',
        LabelSeamAsSet: '當前設定的介面寬度',
        LabelHazeAsSet: '當前設定的霧值',
        HypTheBakeDoesTwoThings: '烘烤同時做兩件事，沒法只讓它做一件。它剝掉自然氧化層——跳過它，氧化層就會引出讀作霧狀缺陷的疊差——同時又把摻雜從熱基板裡蒸出來，生長前沿再把它吃成一道抹開的介面。如果兩者都真實，霧值應隨烘烤時間下降，而自摻雜過渡層隨之變寬。',
        AskedWhatDoesThePreGrowth: '生長前烘烤實際買到了什麼？又付出了什麼？',
        SumTheBakeStripsOxideAnd: '烘烤既剝氧化層又抹開介面——兩件事總是同時發生、成比例發生。',
        NextLayersAreComingOutThin: '磊晶層出來偏薄，而溫度回讀很穩。你會在哪個區重新測量？每種答案各說明什麼？',
        TitleGrowthRateAgainstTemperature: '生長速率隨溫度的變化',
        LabelRegimeAsSet: '當前設定所在區',
        LabelRatePlateau: '速率，平台區',
        LabelRateColdEnd: '速率，低溫端',
        HypTheGasHasToArrive: '氣體必須先到達、再反應——兩個速率串聯，慢的那個說了算。如果這是對的，速率應在低溫端沿阿瑞尼斯牆攀升，然後彎上一個溫度碰不到的平台，因為在那上面起泡器才是瓶頸。',
        AskedDoesTemperatureKeepBuyingGrowth: '溫度會一直買到生長速率嗎？',
        NoteSurface: '表面反應佔 {{a}}%',
        TextThisRecipeOnThisSubstrate: '這份配方在這塊基板上：{{a}} µm，',
        LabelGrowthRate: '生長速率',
        LabelTransportCeiling: '傳輸上限',
        SectionResult: '生長所得的磊晶層',
        SectionSiGe: '鍺矽——合金的能隙',
        SiGeNote: '打開鍺源閥門，這層就不再是矽了。AIMS 會在你選定的組分下求解合金的緊束縛模型：能隙從矽的 1.12 eV 向鍺的 0.66 eV 下降，這正是 SiGe 基區或應變通道所要買的東西。但這條曲線來自「虛擬晶體」——其中每個原子都是矽與鍺的虛構平均——而真實合金有一個平均做不出來的特徵：它的導帶最低點在 x ≈ 0.85 之前一直是矽型的，之後才切換到鍺型，留下一個任何平滑曲線都重現不了的轉折。正因如此，計算曲線旁邊不畫任何實測曲線。',
        SiGeCurveTitle: '能隙隨組分的變化',
        SiGeCurveX: '鍺組分 x',
        SiGeCurveY: '能隙（eV）',
        SiGeCurveSeries: '緊束縛能隙',
        SiGeAtX: 'x = {{x}}',
        SiGeCrossover: '真實合金中的 Δ → L',
        SiGeGeFraction: '鍺組分 {{x}}',
        SectionRegime: '串聯的兩個阻力',
        RegimeLead: '兩個速率串聯，由較慢的那個決定。圖上的點就是目前的配方。',
        LotLead: '晶體會反過來影響磊晶層：基板摻雜物會擴散進磊晶層最初的零點幾微米。',
        RegimeNote: '氣體要先到達,然後才能反應——兩個速率串聯,慢者為王。交叉點以下反應是瓶頸,速率就是一支溫度計;以上則由鼓泡器決定速率,五十度幾乎無關緊要。量產刻意跑在平台區:那是能原諒燈組的區間。圖上的點就是目前配方。',
        SectionRecipe: '配方',
        SectionStored: '已存配方',
        SectionLot: '基座上的批次',
        LotNote:
          '磊晶層長在 CZ-07 ' +
          '拉出的晶體之上,而晶體會回話:摻雜劑從基板蒸發,瀰散進最初的零點幾微米。基板摻得越重——烘烤越久——瀰散的接縫就越寬。層一旦存在,元件就住在其中:下游每個接面都對著磊晶摻雜形成,而不是對著塊材。',
        LotEmpty: '基座上沒有批次。請從 WPR-08 或 CLN-09 送晶圓來生長。',
        LotIngot: '該批次還是晶錠。要先經 WPR-08 切片才能生長磊晶層。',
        LotCard: '流程卡',
        LotBlank: '庫存空白片——基板按 1.0 × 10⁻⁶/nm³ 假定。',
        LotRun: '生長磊晶層並傳遞批次',
        SectionShift: '班次',
        TileRate: '生長速率',
        NoteSpitting: '已超過氣相成核極限',
        TileRegime: '限制性阻力',
        TileThickness: '厚度',
        TileNu: '不均勻性',
        TileSeam: '自摻雜接縫',
        NoteSeam: '基板在回話',
        NoteSeamQuiet: '輕摻基板,接縫安靜',
        TileHaze: '霧狀缺陷',
        TileSlip: '滑移',
        SlipYes: '邊緣出現',
        SlipNo: '無',
        TileCycle: '週期',
        ChartHere: '目前配方',
        ChartSpit: '氣相成核',
        AssistantBlurb: '提出一個問題,我會設計實驗、在該求解器上執行,並回報真實結果——然後把一個更銳利的問題交還給你。',
        AssistantLead: '掃一遍溫度,看生長速率如何彎向平台;然後問我為什麼量產都住在那上面。',
      },
      dicing: {
        NoteNoStressRelief: '未做應力釋放',
        NoteAfterStressRelief: '應力釋放後',
        ActionGrindDiceAndPass: '研磨、切割，把裸晶傳下去',
        NoteNoLotOnTheChuck: '吸盤上沒有批次。把測過針的晶圓送到這裡來研磨和切割。',
        SecondaryLabel: '邊緣崩邊',
        ToolLabel: 'DICE-15 背面研磨與切割',
        NextTheseDieGoToBond: '這些裸晶接下來去 BOND-16，那裡的瓷嘴會以一定的力壓在它們上面。更弱的裸晶不只在這裡碎——問問打線機，薄矽上的彈坑風險長什麼樣。',
        TitleDieLostAtSingulation: '切割分離時損失的裸晶',
        LabelResidualDamage: '殘餘損傷',
        AxisYDamageM: '損傷 (µm)',
        AxisXGrit: '粒度 (#)',
        TitleDamageAndDieLostAgainst: '損傷與損失裸晶數隨砂輪粒度的變化',
        NoteCoarseToFine: '從粗到細',
        LabelDieSaved: '省下的裸晶',
        LabelWeibullM: '韋伯 m',
        LabelStrength: '強度',
        HypDamageDepthScalesWithAbrasive: '損傷深度隨磨料尺寸縮放，而強度是損傷的負冪函數，不是線性關係。如果這是對的，換更細的磨粒應買到不成比例的強度——而且因為碎裂服從韋伯分佈而不是硬閾值，回報會表現為損失的裸晶變少，而不是某個極限的移動。',
        AskedIsAFinerFinishingWheel: '更細的精磨砂輪值得它在產能上的代價嗎？',
        SumGritAgainstDamageDepthAnd: '磨粒粒度對損傷深度，以及倖存者的韋伯統計。',
        NextNarrowerStreetsMeanMoreDie: '切割道越窄，每片晶圓的裸晶越多，而那三種方法裡只有一種經得起窄道。按這個配方的裸晶數算，30 µm 的切割道值多少？',
        LabelReachesTheDie: '碰到裸晶',
        AxisYChipM: '崩邊 (µm)',
        AxisXFeedRateMmS: '進給速度 (mm/s)',
        TitleChipOutAgainstFeedRate: '崩邊隨進給速度的變化',
        HypABladeCuttingFasterRemoves: '刀片切得越快，每轉去除的材料越多，就從磨削變成撕扯，所以崩邊應隨進給速度增大。這裡的極限是硬的而不是軟的：崩邊要麼留在切割道內，要麼碰到裸晶，一旦越界，切口看著再漂亮裸晶也報廢了。',
        AskedWhatDoesCuttingFasterCost: '切得更快要付出什麼？極限在哪裡？',
        SumFeedRateAgainstChipOut: '進給速度對崩邊，以及必須容納它的切割道寬度。',
        NextWpr08RemovesSawDamage: 'WPR-08 用的正是這套物理去除鋸痕損傷，但那是在有 775 µm 餘量的晶圓上。這裡一點餘量都沒有。這說明兩台機台裡哪台用得起粗砂輪？',
        LabelBackSide: '背面',
        AxisXThicknessM: '厚度 (µm)',
        TitleBreakingStrengthAgainstTargetThickness: '斷裂強度隨目標厚度的變化',
        LabelBackStrength: '背面強度',
        HypTheWheelLeavesCracksOf: '砂輪留下的裂紋深度由磨粒決定，而這個深度不會隨晶圓變薄而變淺。所以晶圓越薄，損傷層佔的比例越大，裸晶變弱的速度快於僅憑厚度的預測。如果是這樣，極限根本不是一個厚度——而是損傷與厚度之比，去除損傷就該移動這個極限。',
        AskedHowThinCanThisWafer: '這片晶圓能磨到多薄，裸晶才不至於開始碎裂？',
        SumGrindingDamageAgainstThicknessAnd: '磨削損傷對厚度，以及為什麼應力釋放會改變答案。',
        fault: {
          weakTape: {
            Evidence: [
              '剝離力低於 1.9 N 的限值。',
              '崩邊高，而切縫和刀都正常。',
              '吸盤真空良好，排除了晶圓移動的另一條路。',
            ],
            Truth: '這批膠帶黏不牢，刀過時裸晶跟著動，在出刀邊上崩角。鋸沒有問題；壞的是耗材，而這是這台機台上最便宜的維修。',
            Complaint: '換了新批次膠帶後，裸晶在切割中發生位移。',
            Label: '貼片膠帶黏性不足',
          },
          chuckLeak: {
            Evidence: [
              '吸盤真空低於 70 kPa 的限值。',
              '崩邊遠超限值而切縫寬度正常——磨鈍的刀會兩個都動。',
              '刀片米數在限值內。',
            ],
            Truth: '吸盤漏了，晶圓吸不平，在刀下發生微觀移動。刀碰到哪裡，哪裡就崩。看著像刀的問題，而刀的讀數乾乾淨淨。',
            Complaint: '一台切割機上崩邊猛漲，裸晶還不好拾取。',
            Label: '吸盤漏真空',
          },
          wornBlade: {
            Evidence: [
              '刀片切割米數超過 450 m 的限值。',
              '切縫寬度超過 45 µm 的限值。',
              '裸晶強度正常——這個故障在邊緣上，不在表面之下。',
            ],
            Truth: '刀片超過了切割壽命。磨鈍的刀切出更寬的縫、崩出更多的邊——和磨輪那個故障不同，這個只要有人量一量切縫，立刻就在晶圓上現形。',
            Complaint: '切割道越吃越寬，兩個產品的密封環快保不住了。',
            Label: '切割刀片磨損',
          },
          glazedWheel: {
            Evidence: [
              '磨輪小時數超過修銳限值。',
              '三點彎曲顯示強度遠低於 300 MPa 的下限。',
              '切縫和崩邊都正常，這正是切割自認無辜的原因。',
            ],
            Truth: '磨輪釉化了，在犁而不是在磨，留下三倍的亞表面損傷。裸晶數一顆不少——每顆都在，看著都好——而它們底下的強度分布已經崩了。PKG-17 的模壓機一壓 ' +
              '183 MPa，真相大白。',
            Complaint: '組裝在兩站之後的模壓機上損裸晶。切割說自己的裸晶數完美無缺，拒絕背鍋。',
            Label: '磨輪釉化',
          },
          diceHealthy: {
            Evidence: [
              '檯上的每個讀數都正常。',
              '切縫和崩邊都在限值內。',
            ],
            Truth: '什麼問題都沒有。正確的判定就是放行這一批。',
            Complaint: '例行批次。裸晶數和外觀都正常。',
            Label: '一切正常',
          },
        },
        NoteLostMinWafer: '損失 {{a}}，每片 {{b}} 分鐘',
        NoteKerfMIntoAM: '{{b}} µm 切割道裡 {{a}} µm 鋸縫',
        NoteAtMpaFromThePackage: '封裝應力按 {{a}} MPa 計',
        NoteWeibullM: '韋伯 m = {{a}}',
        SectionWhyThisToolIsDangerous: '為什麼這台機台危險',
        NoteNothingYouCanMeasureHere: '在這裡你能量到的任何東西，都不會告訴你裸晶能不能活下來。研磨損傷是看不見的，在這台機台上它一顆裸晶都不損失，卻決定了兩台機台之後的模壓機上有多少封裝會裂。',
        NoteThisLotIsStillAn: '這批貨還是一根晶棒。得先由 WPR-08 切片，這台機台才碰得了它。',
        LabelDieThickness: '裸晶厚度',
        LabelGrindingDamage: '研磨損傷',
        LabelBackSideStrength: '背面強度',
        LabelEdgeStrength: '邊緣強度',
        NoteSetByChippingNotBy: '由崩邊決定，不由磨輪決定',
        LabelSurvivesTheMouldPress: '能扛過模壓',
        LabelChipOut: '崩邊',
        LabelGoodDie: '合格裸晶',
        AssistantLead: 'DICE-15 探究助理',
        AssistantBlurb: '可以問：晶圓能薄化到多少、更細的砂輪值不值、切得更快的代價是什麼。每個回答都是用這套配方真實跑出來的一次研磨與切割。',
        reading: {
          chipping: {
            Label: '邊緣檢查，50 顆裸晶（1.5 小時）',
          },
          kerf: {
            Label: '監控片切縫寬度（1.0 小時）',
          },
          strength: {
            Label: '20 顆裸晶三點彎曲——破壞性（2.0 小時）',
          },
          tapePeel: {
            Label: '膠帶剝離力',
          },
          chuckVacuum: {
            Label: '吸盤真空',
          },
          bladeCuts: {
            Label: '刀片已切米數',
          },
          wheelHours: {
            Label: '磨輪距上次修銳小時數',
          },
        },
        aspect: {
          tape: {
            Action: '改用新批次膠帶並重新貼膜',
            Label: '貼片膠帶',
          },
          chuck: {
            Action: '找到並封住漏點，整盤複測吸持力',
            Label: '吸盤真空',
          },
          blade: {
            Action: '換刀片並在監控片上重新認證切縫寬度',
            Label: '切割刀片',
          },
          wheel: {
            Action: '修銳磨輪；修不動就更換',
            Label: '磨輪',
          },
        },
      },
      bonding: {
        failure: {
          'attach void': '黏晶空洞',
          intermetallic: '介金屬化合物',
          'cratered pad': '焊墊彈坑',
          'lifted ball': '焊球脫落',
          none: '無',
        },
        ActionAttachBondAndPass: '黏晶、打線，把裸晶傳下去',
        UnitPctWelded: '%（銲合面積）',
        NoteNoDieOnTheBonder: '打線機上沒有裸晶。在 DICE-15 切割一片晶圓，把裸晶拿到這裡來。',
        SecondaryLabel: '黏晶空洞',
        ToolLabel: 'BOND-16 黏晶與打線接合',
        NextFt18AcceleratesExactlyThis: 'FT-18 加速的正是這種擴散，用來找出那些會在現場失效的產品。問問它：這些介金屬化合物折合多少小時的預燒。',
        LabelImcThickness: 'IMC 厚度',
        AxisXCureTemperatureC: '固化溫度 (°C)',
        TitleIntermetallicAgainstCureTemperature: '介金屬化合物隨固化溫度的變化',
        LabelFromTheBond: '來自銲接本身',
        LabelImcTotal: 'IMC 總量',
        HypGoldAluminiumIntermetallicGrowsBy: '金鋁介金屬化合物靠擴散生長，所以它的厚度應只取決於時間和溫度，而與銲接方式無關。銲接本身只持續毫秒，環氧固化卻持續數小時——所以如果機制是擴散，幾乎所有生長都應發生在固化期間，而沒人把這一步當作銲接的一部分。',
        AskedHowMuchIntermetallicIsThis: '這個配方在長多少介金屬化合物？在哪裡長？',
        SumTimeTemperatureGrowthOfIntermetallic: '介金屬化合物隨時間-溫度的生長，以及為什麼固化是銲接的一部分。',
        NextPrb14HasTheSame: 'PRB-14 有同樣的算術，只是把裸晶上的引線換成了晶圓上的裸晶。兩者都是別人選定的某個數目的指數函數——製程工程師對這兩個裡的哪一個真正有辦法？',
        AxisXWiresPerDie: '每裸晶引線數',
        TitleDieYieldAgainstWireCount: '裸晶良率隨引線數的變化',
        LabelPerWireYield: '單線良率',
        HypADieIsGoodOnly: '裸晶只有在每根引線都合格時才合格，所以裸晶良率應是單線良率的線數次方。這是接腳數的指數函數，意味著在低接腳數下完全夠用的銲接品質，到高接腳數就不能用了——而打線機什麼都沒變。',
        AskedWhyDoesAHigherPin: '配方沒變，為什麼接腳數更多的產品良率更差？',
        SumPerWireYieldRaisedTo: '單線良率的線數次方，以及這對每個銲點提出的要求。',
        NextThatDieYieldIsOne: '這個裸晶良率是單線良率的線數次方。問我：換成六百根引線的產品而不是這個，它會變成什麼樣。',
        TitleDieYieldAcrossTheWindow: '跨窗口的裸晶良率',
        LabelCrateringRisk100: '彈坑風險 ×100',
        LabelBondedArea: '銲合面積',
        AxisXUltrasonicPowerMw: '超音波功率 (mW)',
        TitleTwoFailureModesOneKnob: '兩種失效模式，一個旋鈕',
        NotePerBond: '每個銲點',
        LabelCratering: '彈坑',
        LabelBondedAreaL113: '銲合面積',
        HypUltrasonicEnergyIsWhatScrubs: '超音波能量的作用是擦掉焊墊上的氧化物並把焊球銲上去，所以能量太少會留下沒銲牢、會脫落的球。而當銲接已經完成時，同樣的能量總要去某個地方——去了焊墊下面的矽裡。如果是這樣，兩種失效模式就坐在同一個旋鈕的兩端，窗口在兩者同時都小的地方，而不是某一個最小的地方。',
        AskedWhereIsTheBondingWindow: '銲接窗口在哪裡？窗口兩側各是什麼失效？',
        SumLiftedBallsAtOneEnd: '一端是焊球脫落，另一端是焊墊彈坑，中間是製程窗口。',
        fault: {
          starvedDispense: {
            Evidence: [
              '點膠量 45%，下限 90%。',
              'X 光空洞佔比超過 10% 的限值。',
              '打線銲點完美——這個故障在裸晶底下，不在上面。',
            ],
            Truth: '點膠泵只給出標稱量的 45%。環氧不夠潤濕整個裸晶底面，黏晶於是帶洞——那是一個散熱通道問題，元件要到在現場跑熱了才會因它失效。',
            Complaint: '一批銲接完美的貨，X 光在裸晶底下照出了空洞。',
            Label: '點膠量不足',
          },
          dirtyPads: {
            Evidence: [
              '銲墊沾汙 55%，限值 15%。',
              '輸出功率、銲球幾何、銲接計數全都正常。',
              '只出在一個產品上——機台故障會出在所有產品上。',
            ],
            Truth: '銲線機沒有任何問題。銲墊到貨就是氧化的——上游漏做了一次電漿清洗——而鋁的氧化層正是超音波能量必須擊穿的東西。換一只好好的換能器要五個小時，什麼也治不了。',
            Complaint: '第一銲點就不粘，只出在一個產品上，而銲線機每項檢查都過。',
            Label: '銲墊到貨帶汙',
          },
          wornCapillary: {
            Evidence: [
              '距換刀的銲接次數超過 500,000 的限值。',
              '銲球直徑超過 62 µm 的限值。',
              '超音波實際輸出功率正常。',
            ],
            Truth: '劈刀超過了銲接壽命。磨損的刀頭壓出更寬、更不規則的球，在細間距上就是短路風險——它還夾持不穩，銲點本身也更差。它同時是後段最便宜的維修，這就是值得把它和換能器分清楚的原因。',
            Complaint: '銲球又大又不規則，有兩個已經和鄰點短路了。',
            Label: '劈刀磨損',
          },
          tiredTransducer: {
            Evidence: [
              '實際輸出功率 62%，下限 90%。',
              '拉線顯示銲合面積低於 70% 的限值。',
              '銲墊乾淨，劈刀也在壽命之內。',
            ],
            Truth: '換能器只輸出指令功率的 62%。設定值沒錯，到達銲球的能量錯了——這就是配方看起來無辜的原因。銲合面積掉了下來，而拉線測試是唯一能讓它現形的東西。',
            Complaint: '一台銲線機上的不粘失效多了起來。配方沒動過，功率設定值讀著也對。',
            Label: '換能器輸出低於所報',
          },
          bondHealthy: {
            Evidence: [
              '檯上的每個讀數都正常。',
              '銲合面積高於 70% 的下限。',
            ],
            Truth: '什麼問題都沒有。正確的判定就是放行這一批。',
            Complaint: '例行批次。銲接良率在它該在的地方。',
            Label: '一切正常',
          },
        },
        NoteSPerDie: '每顆 {{a}} 秒',
        NoteOverWires: '共 {{a}} 根線',
        SectionTheWindowHasAFloor: '窗口有下限也有上限',
        NoteUltrasonicEnergyHasToBreak: '超音波能量必須先破掉鋁的氧化層，金屬才可能銲合，所以能量太小銲球會翹起。銲點形成之後，同樣的能量會打進矽裡，所以能量太大會把銲墊打出彈坑。把功率調上去，兩頭都得盯著。',
        LabelWeldedArea: '銲合面積',
        NoteOfTheBallFootprint: '佔銲球面積的比例',
        LabelBallShear: '推球力',
        LabelCrateringRisk: '彈坑風險',
        NotePerWire: '每根線',
        LabelIntermetallic: '介金屬化合物',
        NoteVoidingPast15M: '超過 1.5 µm 出現空洞',
        LabelDieYield: '裸晶良率',
        LabelFailureMode: '失效模式',
        AssistantBlurb: '可以問：打線窗口在哪裡、引線數量為什麼改變良率、固化對介金屬化合物做了什麼。每個回答都是在這台機台上真實跑出來的一次打線。',
        AssistantLead: 'BOND-16 探究助理',
        reading: {
          attachVoid: {
            Label: '黏晶 X 光檢查，10 只（1.5 小時）',
          },
          ballShear: {
            Label: '推球至破壞，20 點（1.0 小時）',
          },
          pullStrength: {
            Label: '拉線至斷裂，30 根（2.0 小時）',
          },
          dispenseVolume: {
            Label: '點膠量',
          },
          padClean: {
            Label: '來料銲墊沾汙',
          },
          capillaryBonds: {
            Label: '距換劈刀的銲接次數',
          },
          ultrasonicDelivered: {
            Label: '超音波實際輸出功率',
          },
        },
        aspect: {
          epoxy: {
            Action: '重新校準點膠泵並排空針筒',
            Label: '點膠',
          },
          pads: {
            Action: '這裡修不了——銲墊被汙染，歸上游電漿清洗管',
            Label: '來料銲墊狀況',
          },
          capillary: {
            Action: '更換劈刀並重新認證銲球幾何',
            Label: '劈刀',
          },
          transducer: {
            Action: '更換換能器並對參考件重新校準實際輸出功率',
            Label: '超音波換能器',
          },
        },
      },
      packaging: {
        failure: {
          'wire sweep': '沖線',
          'mould void': '模塑空洞',
          popcorn: '爆米花開裂',
          warpage: '翹曲',
          none: '無',
        },
        ActionMouldCureReflow: '模塑、固化、迴銲，把封裝傳下去',
        NoteNoDieOnThePress: '模壓機上沒有裸晶。在 BOND-16 打線一批，拿到這裡來。',
        SecondaryLabel: '迴銲內部蒸汽',
        ToolLabel: 'PKG-17 模塑與固化',
        NextEveryPackageThatLeavesHere: '每個離開這裡的封裝都要去 FT-18，然後到客戶手裡。這個面板上的失效裡，哪些預燒能找到，哪些只會在電路板上現身？',
        AxisXCureMin: '固化 (min)',
        TitlePackageYieldAgainstPostMould: '封裝良率隨模後固化的變化',
        HypTransferMouldingFillsACavity: '傳遞模塑用黏稠的模封膠填滿模穴，包住那些可能被沖歪的引線。隨後的固化讓它交聯。如果固化的意義在力學而不在外觀，那麼在產品看起來已完工之後，翹曲和良率還應繼續變化——而完全沒有引線的封裝形式應能繞開一整類失效模式。',
        AskedWhatIsTheCureFor: '固化是幹什麼用的？封裝形式又改變了什麼？',
        SumTransferMouldingVoidsCureAnd: '傳遞模塑、空洞、固化，以及封裝形式改變了什麼。',
        NextTheStressFreeTemperatureIs: '無應力溫度就是模塑溫度。模塑溫度降 30 °C 會對這兩條曲線做什麼——又要在固化和流動性上付出什麼？',
        LabelAtRoomTemperature: '室溫時',
        LabelAtReflow: '迴銲時',
        AxisXMouldCapM: '模帽 (µm)',
        TitleWarpageAgainstMouldCapThickness: '翹曲隨模帽厚度的變化',
        LabelMouldVoids: '模塑空洞',
        NoteTheOneThatMatters: '要緊的那個',
        LabelWarpAtReflow: '迴銲翹曲',
        LabelWarpAtRoom: '室溫翹曲',
        HypMouldCompoundSiliconAndLaminate: '模封膠、矽和基板的膨脹係數各不相同，而它們是在模塑溫度下黏到一起的。那是封裝唯一無應力的溫度；在其他任何溫度它都會捲曲。如果是這樣，翹曲應取決於各層的厚度比而不是任何單獨一層，而且應該存在一個平衡點。',
        AskedWhatMakesThePackageWarp: '是什麼讓封裝翹曲？哪個翹曲才是要緊的？',
        SumABimetallicStripMadeOf: '一根由三種材料做成的雙金屬片，以及決定錫球命運的翹曲。',
        NextReflowPeakIsTheOther: '迴銲峰值溫度是這件事的另一半。如果組裝廠實際比曲線標稱高 5 °C，這些數字裡哪個會動——有人會在產品上板之前發現嗎？',
        AxisYFractionOfSaturation: '飽和度比例',
        LabelSteamPressure: '蒸汽壓',
        AxisXHoursOnTheFloor: '在車間的小時數',
        TitleSteamPressureAgainstFloorLife: '蒸汽壓隨車間壽命的變化',
        LabelSteamPressureL116: '蒸汽壓',
        LabelMoisture: '水汽含量',
        HypMouldCompoundAbsorbsWaterFrom: '模封膠從空氣中吸水，緩慢而可逆。迴銲時產品幾秒內衝過 250 ' +
          '°C，這些水在密封的腔體裡變成蒸汽。如果機制是這個，失效應取決於產品擱了多久，而不是對它做過什麼——一個由存放製造出來的缺陷。',
        AskedWhyDoesAPackageThat: '為什麼一個什麼都通過了的封裝，一過迴銲就失效？',
        SumAbsorbedMoistureSteamPressureAt: '吸收的水汽、裸晶介面處的蒸汽壓，以及車間壽命時鐘。',
        fault: {
          wetParts: {
            Evidence: [
              '出袋時間遠超 48 小時的限值。',
              '迴銲後剖切顯示分層超過 2% 的限值。',
              '爐溫曲線在目標上——這不是超溫失效。',
            ],
            Truth: '乾燥包裝被打開了，元件在外面放了一個星期。吸進去的水氣在迴銲時閃蒸成蒸氣，從裡面把封裝炸開——經典的爆米花裂紋。PKG-17 ' +
              '什麼都沒壞；壞的是操作紀律，而唯一的解藥是 24 小時的烘烤。',
            Complaint: '過完迴銲出現分層和封裝開裂，而這批貨模封和測試都乾乾淨淨。',
            Label: '元件吸了潮',
          },
          staleCompound: {
            Evidence: [
              '模封料時齡到了保存期的 85%，限值 30%。',
              '流動長度偏短。',
              '轉移壓力正常——壓機在幹它的活。',
            ],
            Truth: '模封料在袋子裡就預固化了，凝膠化來得比該來的早。它做出的短射和壓機無力一模一樣——而壓機的讀數完全正常，這是在檯邊能把兩者分開的唯一依據。',
            Complaint: '還是充填不滿，而壓機上週才重新校準過。',
            Label: '模封料過保存期',
          },
          lowTransfer: {
            Evidence: [
              '轉移壓力 45%，下限 90%。',
              '流動長度低於 55 mm 的限值。',
              '模封料時齡遠在保存期內，排除了那個長得像的故障。',
            ],
            Truth: '轉移柱塞只給出標稱壓力的 45%。模封料在凝膠化之前到不了型腔盡頭，遠端的角落就空著。這是壓機的問題，而模封料在效期內。',
            Complaint: '大尺寸封裝體的遠端角落充填不滿。',
            Label: '轉移壓力偏低',
          },
          pkgHealthy: {
            Evidence: [
              '檯上的每個讀數都正常。',
              '流動長度和過迴銲存活都很好。',
            ],
            Truth: '什麼問題都沒有。正確的判定就是放行這一批。',
            Complaint: '例行批次。翹曲和外觀都正常。',
            Label: '一切正常',
          },
        },
        NoteHAtRh: '{{b}}% 濕度下 {{a}} 小時',
        NoteMmBody: '{{a}} mm 封裝體',
        SectionWarpageIsGeometryNotProcess: '翹曲是幾何，不是製程',
        NoteThePackageIsFlatAt: '封裝只在模封溫度下是平的，其他任何溫度都不平。之後的一切都是溫差作用在膨脹失配上，而且隨封裝體尺寸的平方增長——所以要靠材料或厚度來解決，從來不是在模壓機上解決。',
        LabelWarpageAtRoom: '室溫翹曲',
        LabelWarpageAtReflow: '迴銲時翹曲',
        Note100MToSeatThe: '< 100 µm 才能坐實錫球',
        LabelMoistureAbsorbed: '吸入水氣',
        LabelSteamAtTheInterface: '介面處蒸氣壓',
        NoteInterfaceHolds26Bar: '介面能扛 26 bar',
        LabelWireSweep: '沖線',
        NoteWiresTouchPast04: '超過 0.4 引線就會相碰',
        LabelPackageYield: '封裝良率',
        AssistantLead: 'PKG-17 探究助理',
        AssistantBlurb: '可以問：好裸晶為什麼在回焊時失效、封裝為什麼翹曲、後固化是做什麼的。每個回答都是用這套配方真實跑出來的一次封膠與回焊。',
        reading: {
          popcorn: {
            Limit: '無裂紋，< 2 bar',
            Label: '20 只過迴銲並剖切（4.0 小時）',
          },
          mouldVoid: {
            Label: '12 只剖切查空洞——破壞性（2.5 小時）',
          },
          ovenPeak: {
            Label: '迴銲峰值偏差',
          },
          moisture: {
            Label: '乾燥包裝外暴露時間',
          },
          compoundAge: {
            Label: '模封料對保存期的時齡',
          },
          transferPressure: {
            Label: '轉移壓力',
          },
        },
        aspect: {
          oven: {
            Action: '用測溫板重新標定爐溫曲線',
            Label: '迴銲爐溫曲線',
          },
          drypack: {
            Action: '125 °C 烘烤除濕，並恢復乾燥包裝紀律',
            Label: '乾燥包裝管理',
          },
          compound: {
            Action: '報廢已開封的料餅，裝入在效期內的新批次',
            Label: '模封料',
          },
          press: {
            Action: '重新校準轉移壓力並檢查柱塞密封',
            Label: '模壓機',
          },
        },
      },
      finaltest: {
        ValueNo: '否',
        ValueYes: '是',
        ValueDays: '{{a}} 天',
        ActionBurnInTestAndBin: '預燒、測試、分級',
        UnitPoints: '個百分點',
        NoteNoLotOnTheHandler: '分選機上沒有批次。在 PKG-17 封裝一批，拿到這裡來。',
        NoteThisPopulationIsNot: '這個群體沒有早期失效',
        NoteInfantMortalityScreening: '早期失效——篩選正在清除它',
        LabelEscapes: '漏檢',
        SecondaryLabel: '預燒淘汰率漂移',
        ToolLabel: 'FT-18 終測與預燒',
        LabelLotHours: '批次小時數',
        TitleAndWhatItCostsThe: '以及產線為此付出的',
        AxisYPartsEscaping: '漏檢件數',
        AxisXTestSecondsPerPart: '每件測試秒數',
        TitleEscapesAgainstTestTime: '漏檢隨測試時間的變化',
        LabelRoomOnlyEscapes: '僅常溫測試的漏檢',
        LabelLotTime: '批次時間',
        HypMoreTestTimeMeansMore: '測試時間越長，跑的圖形越多，產品被覆蓋的部分越多，漏檢應隨之下降——但收益遞減，因為容易的失效最先被找到。測試時間要乘以批量，所以邊際上的每一秒都很貴，按單件算時極易低估。',
        AskedHowMuchTestTimeDoes: '這個產品需要多少測試時間？花在哪裡最划算？',
        SumTestTimeAgainstEscapesAnd: '測試時間對漏檢，以及最花錢的溫度角。',
        NextBond16GrowsIntermetallicThat: 'BOND-16 長出的介金屬化合物在工作溫度下還會繼續長。那是預燒能抓住的機制，還是會被預燒加速、把本來沒問題的產品搞壞的機制？',
        LabelLotTimeL241: '批次時間',
        AxisYLotHours: '批次小時數',
        TitleWhatItCosts: '它的代價',
        AxisYFractionScreened: '篩出比例',
        AxisXBurnInHours: '預燒小時數',
        TitleScreenedFractionAndLotTime: '篩出比例與批次時間隨預燒時長的變化',
        LabelJustified: '是否值得',
        LabelScreened: '篩出比例',
        LabelFieldHours: '折合現場小時',
        LabelAcceleration: '加速因子',
        HypBurnInWorksByRunning: '預燒的原理是讓產品在高溫下運行，使失效機制比在現場使用中進行得更快。它只有在群體確有早期失效可篩——韋伯形狀參數小於一——時才篩得出東西。對健康的群體，預燒的每一小時都在消耗本來就沒問題的產品的有效壽命。',
        AskedIsBurnInEarningThe: '在這個產品群體上，預燒對得起它花掉的小時數嗎？',
        SumInfantMortalityTheAccelerationFactor: '早期失效、加速因子，以及預燒什麼時候只是在消耗壽命。',
        NextPrb14AlreadyAppliedA: 'PRB-14 已經對這些產品裡的裸晶加過一道保護帶。兩道保護帶串聯，報廢的比任何一道單獨都多——第二道找到了第一道沒找到的東西嗎？',
        LabelGoodPartsScrapped: '報廢的好品',
        LabelBadPartsShipped: '發出的壞品',
        AxisXGuardBandFractionOfSpec: '保護帶（佔規格寬度比例）',
        TitleTwoErrorsOneKnob: '兩種錯誤，一個旋鈕',
        HypTheTesterMeasuresWithAn: '測試機自身帶有測量不確定度，所以靠近限值的產品可能讀在限值任一側。把限值往裡收能抓住更多邊緣的壞品，也必然誤殺更多邊緣的好品。如果這是對的，就不存在兩者皆零的設定——只有企業更願意犯哪種錯誤的選擇。',
        AskedWhatDoesMovingTheTest: '把測試限往裡收，實際買到什麼、付出什麼？',
        SumEscapesAgainstOverkillAndWhy: '漏檢對誤殺，以及為什麼兩者都不可能為零。',
        fault: {
          infantMortality: {
            Evidence: [
              'Weibull 形狀參數 0.35，下限 0.45——比當初為之設計預燒的母體更糟。',
              '預燒淘汰率遠超限值，而複測一致性完美。',
              '量具、測試座、分選機全都正常。',
            ],
            Truth: '測試機沒有任何問題。來料的 Weibull 形狀參數掉到了 ' +
              '0.35——一條脆弱的早期尾巴，而早夭就是這個意思——預燒恰恰在幹它的本職：把它找出來。問題出在前段，而預燒正是它沒有落到客戶手裡的唯一原因。',
            Complaint: '預燒淘汰率翻了三倍。測試工程要求重新校準測試機。',
            Label: '來料母體存在早夭',
          },
          coldHandler: {
            Evidence: [
              '分選機浸溫偏差 −18 °C，窗口是 ±3 °C。',
              '複測一致性正常，因為測試機是好的。',
              '是現場退貨而不是良率損失——漏檢，不是過殺。',
            ],
            Truth: '分選機比日誌聲稱的溫度低 18 ' +
              '°C。元件是在沒熱起來的狀態下做的高溫測試，高溫判限根本沒被真正壓過——測試在放行本該判死的元件，那是漏檢，是代價昂貴的那一邊。',
            Complaint: '高溫測試過得有點太順了，而且一個客戶那邊開始出現現場退貨。',
            Label: '分選機浸溫不到位',
          },
          wornContactor: {
            Evidence: [
              '插拔次數超過 300,000 的限值。',
              '複測不一致超限。',
              '量具 sigma 在限值內，測量鏈路本身是健康的。',
            ],
            Truth: '測試座插拔超限，接觸電阻上來了。它造成的複測不一致和測試機雜訊大一模一樣——而插拔計數直接點它的名，量具校準則乾乾淨淨。',
            Complaint: '四工位分選機上有一個工位在掛導通。',
            Label: '測試座磨損',
          },
          noisyTester: {
            Evidence: [
              '量具 sigma 16%，限值 6%。',
              '複測不一致遠超 0.5%——同一批元件兩次分級不一樣。',
              '測試座插拔數和分選機溫度都正常。',
            ],
            Truth: '測試機的量具 sigma 是規格寬度的 16%，限值 ' +
              '6%。貼著判限的好品被判了死刑——損失是過殺，不是缺陷，而且除非有人去複測被拒的那批，它就一直隱形。每個班都在白扔兩個點的良率。',
            Complaint: '一級品良率掉了兩個點，而客戶一件退貨都沒有。',
            Label: '測試機測量鏈路雜訊大',
          },
          ftHealthy: {
            Evidence: [
              '檯上的每個讀數都正常。',
              '複測一致性在限值內。',
            ],
            Truth: '什麼問題都沒有。正確的判定就是出貨。',
            Complaint: '例行批次。分級結果和預測吻合。',
            Label: '一切正常',
          },
        },
        NotePartsAtS: '{{a}} 只，每只 {{b}} 秒',
        NoteGoodPartsScrapped: '誤殺好品 {{a}} 只',
        NotePartsEachOneAReturn: '{{a}} 只——每一只都是一次退貨',
        NoteFromHOfBurnIn: '來自 {{a}} 小時預燒',
        NoteCAgainstCUse: '{{a}} C，使用溫度 {{b}} C',
        SectionTheGuardBandIsThe: '保護帶就是全部的決定',
        NoteATesterMeasuresWithError: '測試機的量測帶誤差，於是有壞品測成好、也有好品測成壞。把判限往裡挪，買到的是更少的漏檢，代價是一比一的過殺。沒有哪個設定能兩頭都躲開，你在這筆交易裡坐在哪，是一道關於退貨成本的算術題。',
        LabelAccelerationFactor: '加速因子',
        LabelEquivalentFieldLife: '等效現場壽命',
        LabelBurnInJustified: '預燒是否划算',
        LabelOverkill: '過殺',
        LabelTestFloorTime: '測試機時',
        AssistantBlurb: '可以問：保護帶的代價是什麼、燒機測試值不值那些小時、測試時間到底要多久。每個回答都是在這台測試機上真實跑出來的一個批次。',
        AssistantLead: 'FT-18 探究助理',
        reading: {
          burnInFallout: {
            Label: '500 只預燒淘汰率（12 小時）',
          },
          retest: {
            Label: '複測 200 只並比對分級（1.0 小時）',
          },
          weibull: {
            Limit: '> 0.45（認證值：0.55）',
            Label: '來料 Weibull 形狀參數',
          },
          handlerTemp: {
            Label: '分選機浸溫偏差',
          },
          contactorInsertions: {
            Label: '測試座插拔次數',
          },
          gaugeSigma: {
            Label: '測試機量具 sigma',
          },
        },
        aspect: {
          population: {
            Action: '這裡修不了——裸晶存在早夭，歸前段製程管',
            Label: '來料母體',
          },
          handler: {
            Action: '重新校準分選機浸溫熱電偶',
            Label: '分選機溫度',
          },
          contactor: {
            Action: '更換測試座並用黃金樣品複測導通',
            Label: '測試座',
          },
          gauge: {
            Action: '重新校準測試機並用黃金樣品核驗',
            Label: '測試機測量鏈路',
          },
        },
      },
      common: {
        StartProcess: '開始製程',
        HoldProcess: '暫停製程',
        LoadWafer: '裝入新片',
        Measuring: '量測中……',
        SessionRecord: 'SimFab — 工作階段紀錄',
        ExportRecord: '匯出工作階段紀錄',
      },
      scope: {
        Pending: '這個站點已經就位、可以進入，但還沒有模擬。今天有六個模組跑的是完整物理——蝕刻、沉積、微影、熱製程、量測與廠務——在這六個模組上驗證過的架構，就是其餘站點將要建立的基礎。',
        NothingFaked: '在此期間不會有任何假造。下面是 {{tag}} 需要涵蓋的範圍：這正是那六個已上線模組各自當初據以建構的同一份文件。',
        WhereItSits: '{{zone}}——這一站在流程中的位置',
        Takes: '輸入',
        Makes: '輸出',
        Macro: '巨觀——規範與製程',
        Micro: '微觀——底下的科學',
        Engines: '計畫中的求解器',
        Competency: '這一站服務的能力目標',
        BackToFloor: '回到廠區',
      },
      deposition: {
        MdChartTitle: '成膜原子數隨時間變化',
        MdChartX: '模擬時間 (ps)',
        MdChartY: '成膜原子數',
        MdChartSeries: '已成膜',
        MdChartAllVapor: '全部氣相原子',
        MdStatus: '{{b}} 個前驅體原子中 {{a}} 個已成膜 · 晶圓 {{c}} K · {{d}} ps',
        MdTemp: '晶圓溫度',
        MdReset: '重設',
        MdPause: '暫停',
        MdRun: '執行',
        MdFailed: '分子動力學引擎載入失敗。',
        MdLoading: '正在載入分子動力學引擎……',
        MdNote: '這是即時運行的分子動力學模擬，而非動畫：氣相原子落向固定的晶圓基板，倫納德-瓊斯力，恆溫器作用於所有可動原子，再加上一個溫和的向下通量代表輸運氣流。沒有任何程式命令原子黏附——冷晶圓把蒸氣捕獲成不斷生長的薄膜，熱晶圓則把它重新蒸發。把溫度拖動幾百克耳文，觀察凝結與脫附此消彼長。',
        RxStatus: '{{b}} 個前驅體 Si 中 {{a}} 個已長入晶圓 · 表面 H {{c}} 個 · 晶圓 {{d}} K · {{e}} ps',
        RxGas: '氣相中：',
        RxGasEmpty: '氣相中已無剩餘',
        RxChartTitle: '長入的矽與表面氫隨時間變化',
        RxChartY: '原子數',
        RxChartGrown: '長入晶圓的 Si',
        RxChartSurfaceH: '表面上的 H',
        RxChartAllSi: '全部前驅體 Si',
        RxChartAllSites: '全部懸鍵',
        RxPrecursor: '前驅體',
        RxSilane: '矽烷（SiH₄，熱 CVD）',
        RxSilyl: '矽基自由基（SiH₃，電漿 CVD）',
        RxSurface: '晶圓表面',
        RxBare: '裸矽',
        RxHydrogen: '氫終止',
        SectionRx: '另一半——會反應的前驅體：化學鍵的生成與斷裂（反應性分子動力學）',
        RxNote: '同一引擎換上反應性力場：每一對原子都帶有即時鍵級，凡本步超過閾值處即畫出一根鍵棒。一個矽烷分子抵達晶圓，其一個 Si-H 鍵在懸鍵處斷裂，生成一個 Si-Si 鍵，這個矽便成為薄膜的一部分——這是被觀察到的化學吸附，沒有任何腳本在驅動它。前驅體用的是矽烷在矽上，而不是本配方的三甲基鋁：力場包含矽而不含鋁，而且矽烷在矽上正是上方窗口圖中與 ALD 相競爭的 CVD 化學，所以在這裡觀察它恰如其分，並非替代品。兩個切換是化學：矽烷需要表面先斷開一個鍵才能附著，電漿產生的矽基自由基不需要——這正是電漿 CVD 能低幾百克耳文運行的原因；而氫終止的晶圓（HF 末道清洗後的狀態）在氫以 H₂ 形式離開之前什麼都不接受。',
        RxTimeNote: '請看機理與先後次序，而不是速率。在 900 K 反應器中需要微秒的事件在這裡等不起，所以恆溫器把腔室加熱到同一機理能在皮秒內發生的溫度，而矽的參數是代表性數值，並非某個已發表參數集的照錄。經過這種壓縮仍然成立的才是要點：自由基先於分子附著，裸矽先於鈍化矽接受前驅體，氫必須先離開生長才能繼續。不成立的是以奈米每分鐘計的生長速率——那是 EPI 工具中反應器求解器的任務。',
        SectionMd: '低於窗口——前驅體不反應而是凝結（分子動力學）',
        MdWindowNote:
          '請把這一幕讀作窗口的低溫端，而不是上面那層薄膜的生長方式。更上面那個表面模型讓四個過程互相競爭，' +
          '**凝結**就是其中之一：低於窗口溫度時，前驅體不再與表面反應，而只是以多層物理吸附堆積起來——' +
          '這種生長在位點佔滿之後並不會停下。這正是這裡所展示的失效，而且值得一看，因為一個發生凝結的劑量' +
          '看上去就是漂亮的高生長速率，直到你去量厚度分佈圖為止。它**沒有**展示的，是構成窗口平坦中段的那半步反應。' +
          'ALD 靠的是**化學吸附**——一次配體交換，真實地成鍵與斷鍵，然後就無處可去了——而化學鍵恰恰是' +
          '倫納德-瓊斯勢所沒有的東西。所以這裡的原子是一種通用的可凝結氣體，而不是本配方的三甲基鋁：' +
          '物理吸附勢阱對「黏不黏得住」是誠實的，對化學反應則是沉默的；假裝它能代表化學，恰恰就是這塊面板' +
          '花了三台儀器去證明 ALD 並非如此的那件事。',
        presetLabel: {
          highAspect: '高深寬比',
          tooHot: '高於窗口',
          tooCold: '低於窗口',
          shortPurge: '短吹掃',
          starvedDose: '短劑量',
          baseline: 'BASELINE-AL2O3',
        },
        SecondaryLabel: '非均勻性',
        ToolLabel: 'ALD-01 · Al2O3 沉積',
        fault: {
          wetHouseGas: {
            Evidence: [
              '每循環生長量高、寄生 CVD 佔比大——吹淨故障的特徵，這正是它如此有迷惑性的原因。',
              '前級抽速檢查是乾淨的。正是這條讀數把它從一次維修變成一次上報。',
              '飽和度仍是 100%，測溫晶圓在設定值上，供給和溫度都不涉及。',
              '爐管在同一時間抱怨著一件聽起來毫不相干的事。它不是不相干。',
            ],
            Truth: '廠裡的乾燥氣乾燥器週末失效帶水了，總管裡帶著約 2% 的水——是液態攜帶，不是乾燥器飽和後 ppm ' +
              '級的緩慢爬升。它到達每一台呼吸廠務氮氣或氧氣的機台，而到了之後幹什麼，完全取決於那台機台拿這股氣做什麼用。注意兩個閾值差得有多遠：個位數 ppm ' +
              '的水就能毀掉 ' +
              'ALD，因為水是它的共反應物；而用蒸氣長氧化層的爐管，低於約百分之一什麼都察覺不到。要兩台機台同時叫起來，得是一次粗暴的失效，而這正是兩個組幾乎從不把各自的問題聯繫起來的原因。在這台機台上它比全廠任何地方都糟，因為水正是這道製程的共反應物。帶水的吹掃氣在 ' +
              'TMA 劑量期間把水放上表面，而這恰恰是吹淨存在的唯一目的——於是薄膜看到的和吹淨太短時一模一樣，而且再怎麼吹淨都治不好。',
            Complaint: '生長偏高、薄膜回蝕不均——跟前級管路那次一樣。可管路上個月剛清過，抽速檢查也沒問題。同時 THRM-04 在報氧化層偏厚。',
            Label: '廠務吹掃氣帶水',
          },
          heaterReadsLow: {
            Evidence: [
              '每循環生長量遠超標稱，寄生佔比非常大。',
              '測溫晶圓讀數明顯高於設定值——和另一個加熱器故障符號相反，這也是同一種維修能治好兩者的原因。',
              '吹淨長短在這裡幾乎不起作用，這排除了前級管路。',
            ],
            Truth: '熱電偶往另一邊漂了：控制器為了維持 200 C 的讀數拚命加熱，晶圓實際上接近 350 C。這高於 ALD 窗口，TMA ' +
              '不等共反應物就自行分解。結果是披著 ALD 配方的 CVD：又快又厚，保形全靠運氣。',
            Complaint: '生長量高得離譜，高深寬比批次的階梯覆蓋率也掛了。',
            Label: '加熱器熱電偶讀數偏低',
          },
          heaterReadsHigh: {
            Evidence: [
              '每循環生長量高、寄生佔比高——形態上和前級堵塞一模一樣。',
              '測溫晶圓是唯一能把兩者分開的讀數，它讀出比設定值低約 85 C。',
              '飽和度仍是 100%：這不是供給問題。',
            ],
            Truth: '熱電偶漂了，控制器以為在 200 C，晶圓實際上接近 115 C。這低於 ALD 窗口，TMA ' +
              '在表面上冷凝而不是化學吸附成單層。冷凝的前驅物不自我侷限，於是每循環生長量反而升高——這就是為什麼晶圓偏冷看起來像吹淨故障，而不像安瓿偏冷。',
            Complaint: '跟上季度那次前級管路的問題一模一樣：生長高、膜發霧、HF 回蝕不均。',
            Label: '加熱器熱電偶讀數偏高',
          },
          restrictedExhaust: {
            Evidence: [
              '每循環生長量高於標稱，寄生 CVD 佔比明顯大於零。',
              '飽和度仍是 100%——劑量本身是健康的，這排除了供給故障。',
              '測溫晶圓讀數在設定值上，這正是它與加熱器故障的分界——那是這台機台上得到高生長加高 CVD 的另一條路。',
              '把配方裡的吹淨拉長，速率就恢復了，這本身就是一次診斷。',
            ],
            Truth: '前級管路裡的沉積物把有效抽速砍到了三分之一，吹淨期間腔體已經排不乾淨。水進來時 TMA 還在，於是一部分生長變成了 CVD：更快、不自我侷限、也不均勻。',
            Complaint: '每循環生長量偏高，而且薄膜在 HF 裡回蝕不均勻。',
            Label: '前級管路堵塞',
          },
          coldAmpoule: {
            Evidence: [
              '飽和度掉到 95% 以下——劑量已經吃不滿了。這是最關鍵的讀數；這台機台上沒有別的故障會碰它。',
              '不均勻度嚴重超差而均值幾乎沒動，這是跌出飽和的特徵，不是晶圓偏熱或偏冷的特徵。',
              '把劑量拉長，薄膜就恢復了。溫度故障不會對此有反應。',
              '安瓿溫度遠低於設定值。',
            ],
            Truth: '安瓿加熱器往低漂了，於是 TMA ' +
              '的蒸氣壓——連同腔體內的前驅物分壓——不到標稱值的一半。劑量不再飽和。這才是它嚴重的原因：劑量飽和時，薄膜不在乎前驅物是怎麼分布的；一旦不再飽和，薄膜就只在乎這一件事。均勻性比均值先垮。',
            Complaint: '最近三批的晶圓圖變成了靶心狀，均值略微偏低。配方沒動過。',
            Label: 'TMA 安瓿溫度偏低',
          },
          healthy: {
            Evidence: [
              '每循環生長量在認證值上，劑量處於飽和。',
              '檯上的每個讀數都在限值以內。',
            ],
            Truth: '什麼問題都沒有。正確的判定就是直接跑片。',
            Complaint: '機台今早剛通過認證。沒有任何報告。',
            Label: '已認證機台',
          },
        },
        reading: {
          flowcheck: {
            Label: '噴淋頭流量檢查（60 分鐘）',
          },
          houseutilities: {
            Limit: '總管不漏，PCW 在供應溫度，乾燥氣 < 50 ppm',
            Label: '與廠務共同檢查公用系統（2 小時）',
          },
          foreline: {
            Label: '前級抽速檢查（40 分鐘）',
          },
          parasitic: {
            Label: '監控片 HF 回蝕（45 分鐘）',
          },
          instrumented: {
            Label: '測溫晶圓（90 分鐘）',
          },
          ampoule: {
            Label: '安瓿溫度檢查（20 分鐘）',
          },
          saturation: {
            Label: '劑量飽和曲線（25 分鐘）',
          },
          setpoint: {
            Limit: '按配方',
            Label: '加熱器設定值',
          },
          step: {
            Label: '10:1 階梯覆蓋率',
          },
          edge: {
            Label: '邊緣減中心',
          },
          nu: {
            Label: '不均勻度',
          },
          gpc: {
            Label: '每循環生長量',
          },
        },
        aspect: {
          house: {
            Action: '停止在本機上的操作，知會廠務',
            Label: '本機無事可修——上報廠務',
          },
          showerhead: {
            Action: '拆下清洗噴淋頭，更換密封墊',
            Label: '噴淋頭',
          },
          heater: {
            Action: '用測溫晶圓重新校準加熱器',
            Label: '基板加熱器',
          },
          purge: {
            Action: '清除前級管路堵塞並複測抽速',
            Label: '吹淨 / 排氣路徑',
          },
          precursor: {
            Action: '重新加注並加熱安瓿，對照流量計核實供給',
            Label: 'TMA 供給',
          },
        },
        knob: {
          doseMs: 'TMA 脈衝時間',
          purgeMs: 'TMA 後吹淨',
          coReactantMs: 'H2O 脈衝時間',
          coPurgeMs: 'H2O 後吹淨',
          pressureMtorr: '腔體壓力',
          carrierSccm: '載氣流量',
          substrateTempC: '基板溫度',
          cycles: '循環數',
          aspectRatio: '結構深寬比',
        },
        preset: {
          baseline: 'ALD 視窗內的已驗證配方：脈衝已飽和，吹淨充分。',
          starvedDose: 'TMA 脈衝縮到 15 ms。低於飽和，因此每循環成長量下降——更糟的是，它現在取決於有多少前驅物抵達晶圓的各個位置，均勻性也跟著一起垮。',
          shortPurge: '吹淨縮到 200 ms。水氣進來時腔體裡還殘留著前驅物，於是一部分成長變成了寄生 CVD：更快，但既不自我侷限也不均勻。',
          tooCold: '基板 100 C。太冷，表面反應無法完成。',
          tooHot: '基板 360 C。前驅物自行分解，成長不再是 ALD。',
          highAspect: '同一份配方用在 60:1 的結構上。溝槽底部需要的曝露量遠大於頂部，而這個脈衝量給不了。',
        },
        SectionProcessState: '製程狀態',
        SectionRunControl: '執行控制',
        RunControlNote: 'ALD 是按循環數算的，不是按秒算的。沒有速率可設——你決定重複多少次循環，每次拿走多少則由表面自己決定。',
        StartCycling: '開始循環',
        Hold: '暫停',
        RunToCompletion: '跑完全部循環',
        LoadBareWafer: '裝入裸片',
        SectionWaferMap: '晶圓圖 — 沉積膜厚',
        ModeThickness: '膜厚',
        ModeDeviation: '相對均值的偏差',
        SectionRadialProfile: '徑向分布',
        SectionSaturation: '飽和曲線 — 這個脈衝量是自我侷限的嗎？',
        SaturationNote:
          '在其他條件不變的前提下，以每循環成長量對脈衝時間作圖。真正的 ALD ' +
          '製程會先上升然後走平：一旦表面位點被占滿，再多前驅物也沒用。如果這條曲線一直往上爬，這個製程就不是自我侷限的，也就不是 ALD。',
        MeasureSaturation: '量測飽和曲線',
        SectionWindow: 'ALD 視窗 — 這個製程成立的溫度區間',
        WindowNote: '低於視窗，前驅物會以多層形式凝結；高於視窗，它不等共反應物就自行分解。兩種情況都會讓膜長得更快，而且都不是自我侷限的。視窗就是中間剩下的那段平台。',
        MeasureWindow: '量測製程視窗',
        SectionRecipe: '配方 — {{code}}',
        SectionStoredRecipes: '已存配方',
        TileGpc: '每循環成長量',
        TileThickness: '膜厚',
        TileNonUniformity: '不均勻度',
        TileSaturation: '飽和度',
        TileParasitic: '寄生 CVD',
        TileStepCoverage: '階梯覆蓋率',
        TileCycles: '循環數',
        TileCycleTime: '單循環時間',
        TileRunTime: '總執行時間',
        SelfLimiting: '自我侷限',
        DoseStarved: '脈衝量不足',
        TrueAld: '真正的 ALD',
        NotSelfLimiting: '非自我侷限',
        AtAspect: '深寬比 {{ratio}}:1',
        PurgeResidence: '吹淨為滯留時間的 {{factor}} 倍',
        CaptionNonUniformity: '不均勻度 {{percent}}%',
        CaptionNoFilm: '每循環成長量 — 還沒有沉積任何膜',
        ChartProfileThickness: '沿半徑的沉積膜厚',
        ChartProfileGpc: '沿半徑的每循環成長量',
        ChartProfileX: 'r / R（0 = 中心）',
        ChartSeriesFilm: '薄膜',
        NotMeasured: '尚未量測',
        ChartSaturationTitle: '每循環成長量對脈衝時間 — 走平即為自我侷限',
        ChartSaturationX: 'TMA 脈衝時間（ms）',
        ChartSeriesGpc: '每循環成長量',
        AnnYourDose: '你的脈衝量',
        ChartWindowTitle: '每循環成長量對溫度',
        ChartWindowX: '基板溫度（°C）',
        AnnYourSetpoint: '你的設定值',
        ChartParasiticTitle: '這些成長裡有多少不是自我侷限的',
        ChartParasiticY: '寄生占比 %',
        ChartSeriesParasitic: '寄生 CVD',
        AnnAldLimit: '5% — ALD 的實用上限',
        SectionOnChuck: '吸盤上',
        SendToMet: '把晶圓送到 MET-05',
        SectionAtoms: '原子尺度——一個循環，一顆一顆分子看',
        AtomsNote:
          '這不是分子動力學——真正的 MD ' +
          '以飛秒計，而這裡是完整的一個循環。它是一排表面位點加一組寫定的反應規則，其統計行為受上方各圖所用的同一套速率方程式約束，並由本面板當前的配方驅動。縮短一次吹驅，或走出溫度視窗，看看化學會作何反應。',
        AtomsRun: '繼續',
        AtomsPause: '暫停',
        AtomsReset: '重設',
        AtomsPhasePurge: '吹驅',
        AtomsLegendOh: 'OH 位點——可接受 TMA',
        AtomsLegendCh3: 'CH₃ 封端——已佔滿',
        AtomsLegendCh4: 'CH₄ 逸出',
        AtomsLegendCvd: '氣相 CVD 顆粒',
        AtomsCycle: '第 {{n}} 個循環',
        AtomsCoverage: '覆蓋率',
        AtomsFilm: '膜厚',
        AtomsCvdCount: 'CVD 事件',
        AssistantBlurb: '提出問題，我會設計一個實驗，用這台求解器把它跑出來，並報告真正得到的結果——然後再還你一個更銳利的問題。',
        AssistantLead: '這裡真正要緊的問題不是膜長得多快，而是當表面被填滿時成長會不會停下來。讓我來幫你驗證。',
      },
      metrology: {
        D3Note: '上面那個盒子讓波打在一排原子上，它的屏是一條線。真實樣品是一層原子，在兩個方向上都有週期性，它的屏是一個布滿斑點的平面——這才是繞射儀器真正交到技術員手裡的東西。把它讀成翻轉過來的晶格：斑點相距遠，說明原子靠得近；把網格沿一個方向拉長，斑點就只沿那個方向靠攏，別的方向不變。把能量調低，虛線圓會縮小到只包住中心的十字；低於 ' +
          '1.5 eV ' +
          '時波長比網格還長，這層原子就讓波作為一整束原樣通過，束裡幾乎沒有任何東西能說明那裡有過原子。說「幾乎」，是因為這麼短的波包並不只有一個能量：它的高速尾部仍在閾值之上，會撐起一圈很淡的一級斑，亮度只有五分之一，直到旋鈕遠低於閾值才消失。斑點是求解器所傳播的波的傅立葉轉換，不是畫上去的：十字和圓是預測，是事後疊加到屏上的。網格取 ' +
          '1 nm，比真實的表面網格更寬，好讓兩圈斑點都在旋鈕範圍內出現；這套幾何關係與尺度無關。原子實是光滑的排斥位障，只有一層，也沒有任何非彈性散射。',
        D3Energy: '電子能量',
        D3Rect: '沿 z 拉長',
        D3Square: '正方網格',
        D3ScreenCaption: '遠處的屏：穿過原子層的波要去往哪裡。十字是網格的倒易晶格，即 2π 除以間距；虛線圓是電子自身的波數。只有圓內的十字上才可能亮起斑點。',
        D3Idle: '按「執行」：波包在工作執行緒上傳播，每次執行五到十秒。',
        D3Gain: '波的亮度比實際放大了 ×{{m}}',
        D3Status: '{{fs}} / {{run}} fs · {{fwd}} % 已穿過原子層 · Σ|ψ|² = {{norm}}（含吸收邊界）',
        D3NoOrders: '不存在繞射束：波長比網格還長',
        D3FirstOrder: '一個一級斑佔 {{p}} %，偏離束方向 {{deg}}°',
        D3Straight: '落在直通斑上的比例',
        D3NoNextRing: '這個旋鈕範圍內的每一圈都已出現',
        D3NextRing: '下一圈斑點在 {{e}} eV 出現',
        D3Beams: '這層原子能產生的束數',
        D3MeshRect: '網格為 {{a}} nm × {{b}} nm',
        D3MeshSquare: '網格為 {{a}} nm 的正方形',
        D3Wavelength: '波長與網格的比較',
        D3Circle: '束必須落在 k = {{k}} nm⁻¹ 之內',
        D3ScreenX: '橫向波向量 k_y (nm⁻¹)',
        D3About: '這裡展示了什麼，模型又略去了什麼',
        SectionDiffraction3d: '一層原子，以及它留下的斑點——三維電子繞射（薛丁格方程，分裂 Cayley 步進）',
        UnitNmReported: 'nm（報出值）',
        LabelFitResidual: '擬合殘差',
        SecondaryLabel: '量具 R&R',
        ToolLabel: 'METR-05 · 光譜反射儀',
        fault: {
          wrongIndex: {
            Evidence: [
              '殘差漲了五倍而偵測器雜訊正常。這個組合就是全部診斷：數據吵會同時抬高殘差和 R&R，模型錯只抬高殘差。',
              '量具 R&R 正常，量測是可重複的——它在可重複地擬合一種錯誤的材料。',
              '橢圓偏光儀同時解 n 和厚度，解出的折射率遠高於氧化物的值。',
            ],
            Truth: '沉積機台往富氮方向漂了，膜其實是折射率接近 1.54 的氮氧化物，而量測配方還按純氧化物的 1.46 ' +
              '假設。擬合被要求用錯誤的材料去重現條紋，它只能用唯一的辦法補償——報一個更厚的膜。這是唯一一個量測機台無辜的故障：它報告的是上游一次真實的變化。',
            Complaint: '氧化層厚度高報 4%，擬合看起來也比平時略差。',
            Label: '薄膜不是配方以為的那種',
          },
          badStandard: {
            Evidence: [
              '量具 R&R 和殘差都正常——又一次，沒有任何東西像壞量測。',
              '誤差是固定的奈米數，不是百分比。兩點核查上，薄標準片和厚標準片都是同樣的 3 nm，而波長誤差恰恰不會這樣。',
              '標準片送去重新認證，發現它比證書上更厚。',
            ],
            Truth: '機台用來歸零的認證標準片在抽屜裡放久了，長出了自然氧化層，真實厚度已經不是證書上寫的那個數。機台對著一個錯誤的數字歸了零，現在把這個誤差加進它量的每一樣東西。',
            Complaint: '什麼都厚了約 3 nm，跟去年光柵那次一樣。',
            Label: '校準標準片長了自然氧化層',
          },
          gratingDrift: {
            Evidence: [
              '量具 R&R 正常，殘差正常。這裡沒有任何東西像一次壞的量測。',
              '誤差和厚度成正比——厚膜薄膜都是 3%。用兩種厚度的認證標準片做兩點核查，誤差隨膜厚一起長，這就是它和壞標準片的分界。',
              '這台機台精密而錯誤，這是任何管制圖都永遠抓不住的失效模式。',
            ],
            Truth: '單色儀的光柵滑了。每個波長都被高報約 3%，條紋看起來落在比實際更長的波長上，擬合於是回報厚 3% ' +
              '的膜厚。量測完全可重複，殘差恰好正常，因為數據本身沒有任何問題——錯的只是寫在旁邊的那個數。一個製程組追著一台從來沒壞的機台跑了兩個星期。',
            Complaint: '沉積膜厚偏厚 3% 已經兩週了。沉積機台重新校準了兩次，蝕刻組已經開始做補償。',
            Label: '單色儀失準',
          },
          dimLamp: {
            Evidence: [
              '量具 R&R 超過 30%，管制圖上的波動大半是量具自己。',
              '重複量測的均值仍在認證值上——準確度沒丟，丟的只是精密度。',
              '殘差隨雜訊成比例上升，數據吵時就該這樣，模型錯時不是這樣。',
            ],
            Truth: '燈老化了，收光光路也髒了，偵測器雜訊是標稱的五倍。擬合被要求在更吵的光譜裡找一個厚度，於是它游移不定。沉積機台沒有任何問題，答案本身也沒有問題——機台仍然圍著正確值散布。丟掉的是分辨真實製程漂移和量測散布的能力，而那是這台機台存在的唯一意義。',
            Complaint: '量測結果滿天飛。同一片晶圓量五次給五個數。工程師認為是沉積機台不穩了。',
            Label: '燈老化，偵測器雜訊上升',
          },
          healthy: {
            Evidence: [
              '報出厚度在認證值上，量具 R&R 低於 10%。',
            ],
            Truth: '什麼問題都沒有。這台機台說的是真話，而且說得可重複。',
            Complaint: '每日標準片檢查通過。沒有任何報告。',
            Label: '量具已認證',
          },
        },
        reading: {
          lampcheck: {
            Label: '燈輸出與暗電流檢查（1 小時）',
          },
          ellipsometer: {
            Label: '橢圓偏光儀交叉核對，解出 n（4 小時）',
          },
          certcheck: {
            Label: '標準片送外重新認證（5 天）',
          },
          twopoint: {
            Limit: '兩點均在 +/- 1 nm 內',
            Label: '兩點核查，20 與 400 nm 標準片（3 小時）',
          },
          model: {
            Limit: '按配方',
            Label: '所設膜折射率',
          },
          repeat: {
            Label: '重複性，1 sigma',
          },
          residual: {
            Label: '擬合殘差（RMS）',
          },
          grr: {
            Label: '量具 R&R',
          },
          reported: {
            Label: '認證標準片讀數',
          },
        },
        aspect: {
          filmmodel: {
            Action: '重測該膜的 n 和 k，更新配方模型',
            Label: '薄膜光學模型',
          },
          standard: {
            Action: '召回標準片、重新認證、機台重新歸零',
            Label: '校準標準片',
          },
          grating: {
            Action: '用發射線光源重新校準光柵',
            Label: '單色儀波長標尺',
          },
          lamp: {
            Action: '更換燈泡，清潔收光光路',
            Label: '燈與偵測器',
          },
        },
        SectionMeasurement: '量測',
        SectionSpectrum: '反射光譜與擬合',
        SpectrumNote: '這台機台並不量厚度。它量的是反射光隨波長的變化，然後用一個膜層結構去擬合這些干涉條紋。它報出來的數字，就是那次擬合收斂到的結果。',
        SectionTruth: '晶圓上真正是什麼',
        TruthNote: '膜本身。學生通常並不會知道這一項。',
        SectionAssumed: '機台配方假設的是什麼',
        AssumedNote: '把這兩項設成不同的膜，機台照樣會報出一個精確到小數點後兩位的厚度，而且錯得很離譜。量測本身就是一個模型，而模型可以錯得信心十足。',
        SectionGauge: '量具能力',
        GaugeNote: '對同一片不變的晶圓反覆量測多次。這個散布來自機台，不是來自製程。真正要緊的，是把它和製程本身實際的變異放在一起比：量具從來沒有絕對的好壞，只有對某項工作夠不夠好。',
        RunGauge: '做一次量具研究（重複 25 次）',
        SectionControl: '管制圖——60 批',
        ControlNote: '每一點都是製程真值加上量測雜訊。管制規則對兩者都會觸發，而圖本身無法告訴你它反應的是哪一個。判斷這件事，正是這份工作。',
        RunStable: '跑一個穩定的製程',
        RunDrift: '跑一個緩慢漂移的製程',
        RunNoisy: '用一台雜訊大的量具來跑',
        ResetGauge: '重設量具',
        SectionAbsorption: '折射率從何而來——基板對光的吸收（緊束縛能帶）',
        AbsNote: '上面的擬合需要膜層中每一種材料的折射率，而折射率不是材料的常數：它是材料中的電子在該能量的光到來時的響應。低於能隙時沒有光子能把電子抬過去，晶體透明，n 幾乎不動；高於能隙時晶體吸收，k 從零升起，n 隨之擺動。這裡的譜由 CZ-07 所畫的同一套緊束縛能帶算出：整個布里淵區內從滿帶到空帶的每一次垂直躍遷，按其強度加權。矽的吸收起點在其直接能隙處，約 3 eV，遠高於 1.1 eV 的基本能隙，因為單個光子無法提供間接躍遷所需的動量：所以晶圓在反射儀的紅端是透明的，只在藍端強烈吸收。鍺和砷化鎵起點低，吸收整個掃描範圍。形狀與起點是計算結果；尺度為相對值，因為模型不含激子與局域場修正。',
        AbsChartTitle: '吸收隨光子能量變化',
        AbsChartX: '光子能量 (eV)',
        AbsChartY: 'ε₂，相對值',
        AbsOnset: '起點 {{ev}} eV（直接能隙）',
        AbsGap: '能隙 {{ev}} eV，間接',
        AbsOnsetGap: '起點 {{ev}} eV，能隙 {{gap}} eV',
        AbsShort: '{{formula}} 自 {{onset}} eV 起吸收 · 能隙 {{gap}} eV，{{kind}}',
        AbsHelp: '以奈米表示的吸收起點，以及琥珀色標線的含義',
        AbsStatus: '{{formula}} 自 {{onset}} eV（{{nm}} nm）開始吸收 · 基本能隙 {{gap}} eV，{{kind}} · 琥珀色標線：反射儀 800-400 nm 掃描範圍',
        AbsIndirect: '間接',
        AbsDirect: '直接',
        AbsCrystal: '晶體',
        AbsFailed: '能帶結構引擎載入失敗。',
        AbsLoading: '正在載入能帶結構引擎…',
        SectionDiffraction: '儀器能分辨什麼——電子波遇到靶（薛丁格方程，二維）',
        PhononAcoustic: '聲學支',
        PhononOptical: '光學支',
        PhononChartTitle: '聲子色散',
        PhononChartX: '沿 Γ–X–W–K–Γ–L 的波向量',
        PhononChartY: '頻率 (cm⁻¹)',
        PhononMeasured: '實測 {{cm}} cm⁻¹',
        PhononRamanTitle: '一階拉曼譜線',
        PhononRamanX: '拉曼位移 (cm⁻¹)',
        PhononRamanY: '強度，峰值 = 1',
        PhononRamanSeries: '計算值：[001] 單態',
        PhononFailed: '晶體引擎載入失敗。',
        PhononShort: '{{material}}：拉曼線 {{line}} cm⁻¹（實測 {{measured}}）',
        PhononHelp: '這次求解的全部數值',
        PhononStatus: '{{material}}：拉曼譜線（[001] 單態）位於 {{line}} cm⁻¹（實測 {{measured}}）· 面內雙態 {{doublet}} cm⁻¹ · 沿 [100] 聲速 {{sound}} km/s（實測 {{soundMeasured}}）· {{ms}} ms',
        PhononImaginary: '不穩定：出現虛頻模式',
        PhononLoading: '正在載入晶體引擎…',
        PhononStrain: '雙軸應變',
        PhononCrystal: '晶體',
        SectionPhonons: '拉曼儀讀到的是什麼——晶體的聲子，以及隨應變移動的譜線（Stillinger–Weber 晶格動力學）',
        PhononsNote: '拉曼光譜儀量的是從晶圓返回、恰好移動了一個晶格振動量子的光；晶圓廠之所以配備它，是因為這個量子會隨應變移動：壓縮晶格，鍵變硬，譜線上移；拉伸晶格，譜線下移。下面沒有任何一條是記住的曲線。在 IMP-10 晶格所用的同一個 Stillinger–Weber 力場上，以週期性邊界搭建所選晶體的 3×3×3 超晶胞，把每個子晶格中的一個原子沿各軸推動百分之一埃，再讀出落在其他所有原子上的力——十二次力計算就是雙原子基底所需的全部 Hessian。由此組裝的動力學矩陣給出沿 Γ–X–W–K–Γ–L 的六支色散、旁邊的態密度，以及 Γ 點的拉曼譜線。請預期誠實力場給出的數字，而不是實測值：SW 把矽的譜線放在約 593 cm⁻¹，實測為 520，因為它是按熔點和結合能擬合的，而不是按聲子——正如 CZ-07 的能帶視圖同時顯示計算能隙與實測能隙。在雙軸應變下，三重簡併的譜線分裂為沿 [001] 偏振的單態與面內的雙態；正對 (001) 晶圓量測的儀器只看得到單態，雙態被這一幾何禁制，所以畫成虛線。SW 的方向是對的——拉伸時下移，壓縮時上移——但大小與先後不對：實測形變勢給出矽的單態每 1% 約 −7 至 −8 cm⁻¹，比雙態移得更多；SW 給出 −4.4，反而是雙態移得更多；鍺的單態 SW 給出 −1.4，實測為 −4.1。省略了：非諧線寬與溫度（譜線以固定 3 cm⁻¹ 寬度繪製）以及同位素質量無序。',
        Mode3dLoading: '正在建立晶體的振動模態…',
        Mode3dStatusStill: 'Γ 點的 {{name}} · 0 cm⁻¹ · 整塊晶體一起平移：沒有回復力，所以沒有頻率',
        Mode3dWaveInfinite: '無窮大',
        Mode3dShort: '{{name}} · {{cm}} cm⁻¹ · 波長 {{wave}}',
        Mode3dHelp: '關於這個模態和這塊晶體的更多資訊',
        Mode3dStatus: '{{name}} · {{cm}} cm⁻¹（{{thz}} THz）· 波長 {{wave}} · 一個週期 {{period}} fs，畫面放慢了 {{slow}} 倍',
        Mode3dTogether: '同向運動',
        Mode3dAgainst: '彼此反向運動',
        Mode3dMixed: '部分同步',
        Mode3dSublattices: '兩套子晶格{{how}}（{{phase}}）',
        PhononRamanForbidden: '面內雙態，正對 (001) 時被禁制',
        PhononDosTitle: '態密度',
        PhononDosX: '每 cm⁻¹ 的模態數',
        Mode3dPartial: '這列波比晶塊更長，所以只顯示了一個波長的一部分。',
        Mode3dBlock: '{{atoms}} 個原子，{{cells}} 個晶胞',
        Mode3dLegend: '琥珀色與藍色是鑽石結構中相互嵌套的兩套子晶格。',
        Mode3dAmplitude: '繪製振幅',
        Mode3dAmplitudeValue: '{{a}} Å（300 K 下真實的熱運動約為 {{thermal}} Å）',
        Mode3dPause: '暫停',
        Mode3dPlay: '播放',
        Mode3dChartMark: '下方繪製的模態',
        Mode3dSegment: '波向量所在路徑',
        Mode3dFraction: '在該段上的位置',
        Mode3dBranch: '分支',
        DiffNote: '波無法分辨比自身波長更小的細節，這一個事實決定了廠房裡每台儀器的極限：反射儀幾百奈米的光能看到膜厚，卻看不到膜的紋理；SEM 的 1 keV 電子波長 0.04 nm，能看到 20 nm 的線條。這裡在網格能夠呈現的能量下展示這一事實。一個高斯電子波包遇到兩條狹縫或一排原子，穿過去的部分按角度收集在螢幕上。間距為 p 的週期性靶把波長 λ 送入 sin θ = mλ/p 的各級繞射——圖上的標線——而當 λ 大於 p 時任何級次都不存在。把能量降到那一步，各級繞射消失：波作為單一光束離開，樣品便沒有可見的結構。沒有任何東西是畫上去的；波包遇到勢場，盒子的吸收邊緣記錄到達的一切。從靶上反彈回來的機率也被計入，所以總和為一。',
        DiffChartTitle: '到達螢幕的分布（按角度）',
        DiffChartX: '與前進方向的夾角 (°)',
        DiffChartY: '每度機率，峰值 = 1',
        DiffChartSeries: '螢幕上',
        DiffOrder: 'm = {{m}}',
        DiffShort: 'λ = {{lambda}} nm · 前向 {{forward}}%，後向 {{back}}%',
        DiffHelp: '間距、繞射級與時間',
        DiffStatus: 'λ = {{lambda}} nm，間距 {{spacing}} nm · 繞射級在 {{orders}} · 前向 {{forward}}%，後向 {{back}}% · {{fs}} fs',
        DiffNoOrders: '無——波長大於間距',
        DiffEnergy: '電子能量',
        DiffTarget: '靶',
        DiffSlits: '雙縫，間距 1.5 nm',
        DiffAtoms: '一排原子，間距 0.5 nm',
        DiffRun: '執行',
        DiffPause: '暫停',
        DiffReset: '重設',
        DiffFailed: '波動求解器載入失敗。',
        DiffLoading: '正在載入波動求解器…',
        SectionShift: '值班',
        TileToolReports: '機台報告值',
        TileActuallyIs: '實際值',
        TileError: '誤差',
        TileFitResidual: '擬合殘差',
        TileRepeatability: '重複性',
        TileGaugeRR: '量具 R&R',
        TileCpk: 'Cpk',
        TileChartAlarms: '管制圖警報',
        TileGaugeNoise: '量具雜訊',
        NoteAssuming: '假設為 {{material}}',
        NoteWrongModel: '假設的模型不對',
        NoteModelCorrect: '模型正確',
        NoteResidualRaised: '幾乎沒升高——它不會警告你',
        NoteResidualFloor: '處在偵測器雜訊底線',
        NotMeasured: '尚未量測',
        NoteToolSigma: '機台的 1σ',
        Capable: '合格',
        NotCapable: '不合格',
        RunAStudy: '先做一次研究',
        NoteAllFalse: '製程是穩定的——全是誤報',
        NoteInLots: '在 60 批中',
        NoteMeasurementSigma: '每批的量測 σ',
        SectionLot: '載台上的批次',
        StageEmpty: '載台是空的。先在 DEP-02 跑一次沉積，把晶圓送到這裡再量——這台機台報出來的數字，是第一次有人知道那份配方到底做出了什麼。',
        TravelCard: '流程卡',
        TileReported: '報告厚度',
        TileOffTarget: '偏離目標',
        TileNonUniformity: '不均勻度',
        NoteModelMatch: '模型擬合得有多好',
        TileAssumedIndex: '假設折射率',
        NoteFromRecipe: '來自量測配方',
        TileVerdict: '判定',
        VerdictShips: '放行',
        VerdictHold: '扣留',
        NineSites: '中心到邊緣共九個點。這台機台既沒有做出這層膜，也修不了它——如果數字不對，答案在上游；而交接班報告裡的量具校驗，就是你先把這台機台排除掉的辦法。',
        ChartSpectrumTitle: '實測光譜與擬合模型對照',
        ChartWavelength: '波長（nm）',
        ChartReflectance: '反射率',
        SeriesMeasured: '實測',
        SeriesFitted: '擬合模型',
        ChartGaugeTitle: '對同一片不變晶圓量測 25 次——σ {{sigma}} nm',
        ChartGaugeEmpty: '尚未量測',
        ChartReadingNumber: '第幾次讀數',
        ChartReportedThickness: '報告厚度（nm）',
        SeriesReadings: '讀數',
        AnnTrueValue: '真值',
        ChartSpcTitle: '管制圖——{{alarms}} 次警報，Cpk {{cpk}}',
        ChartSpcEmpty: '尚未執行',
        ChartLot: '批次',
        ChartThickness: '厚度（nm）',
        SeriesTrue: '真值（操作員看不到）',
        AnnCentre: '中心線',
        AnnSpec: '規格',
        AssistantBlurb: '提出問題，我會設計一個實驗，用這台求解器把它跑出來，並報告真正得到的結果——然後再還你一個更銳利的問題。',
        AssistantLead: '這台機台只負責看。你可以問我：它告訴你的這件事是真的嗎——還是量具、模型，或者只是運氣。',
      },
    },

    house: {

      gowning: {
        AssistantBlurb:
          '可以問：監測讀數在潔淨等級內的區域，為什麼仍然在污染晶圓；一件無塵衣到底值多少粒子。每個回答都是在這個區域當前狀態下真實跑出來的。',
        AssistantLead: 'GOWN-00 探究助理',
      },

      crystal: {
        AssistantBlurb:
          '可以問：電阻率沿晶棒的偏析、這根晶體能拉多快、氧從哪裡來。每個回答都是在這台長晶爐上真實跑出來的一次成長。',
        AssistantLead: 'CZ-07 探究助理',
      },

      waferprep: {
        AssistantBlurb:
          '可以問：切割損失了多少矽、損傷有多深、晶圓為什麼會翹曲。每個回答都是在這條線上真實跑出來的。',
        AssistantLead: 'WPR-08 探究助理',
      },

      clean: {
        AssistantBlurb:
          '可以問：延長槽內時間有沒有用、HF 之後的等待時間代價是什麼、第二道槽是做什麼的。每個回答都是在這台清洗槽上真實跑出來的一次清洗。',
        AssistantLead: 'CLN-09 探究助理',
      },

      implant: {
        AssistantBlurb:
          '可以問：接面為什麼比手冊深、晶格什麼時候變成非晶、能量到底決定了什麼。每個回答都是在這條束線上真實跑出來的一次植入。',
        AssistantLead: 'IMP-10 探究助理',
      },

      patterning: {
        AssistantBlurb:
          '可以問：間距為什麼一寬一窄、最終節距到底由什麼決定、這條製程路線在哪一步沒空間了。每個回答都是用這套配方真實跑完的八步流程。',
        AssistantLead: 'PAT-21 探究助理',
      },

      plating: {
        AssistantBlurb:
          '可以問：溝槽為什麼留了空洞、邊緣為什麼鍍得更厚、要鍍多久。每個回答都是在這個鍍液裡真實跑出來的一次填充。',
        AssistantLead: 'ECD-12 探究助理',
      },

      inspection: {
        AssistantBlurb:
          '可以問：降低閾值買到了什麼、這套配方根本看不見什麼、部分掃描夠不夠。每個回答都是在這台機台上真實跑出來的一次掃描。',
        AssistantLead: 'INSP-13 探究助理',
      },

      probe: {
        AssistantBlurb:
          '可以問：晶粒面積大了良率為什麼差這麼多、這條線該用哪個良率模型、損失是晶圓的還是探針卡的。每個回答都是針對這批晶圓真實跑出來的一次分類。',
        AssistantLead: 'PRB-14 探究助理',
      },

      dicing: {
        AssistantBlurb:
          '可以問：晶圓能薄化到多少、更細的砂輪值不值、切得更快的代價是什麼。每個回答都是用這套配方真實跑出來的一次研磨與切割。',
        AssistantLead: 'DICE-15 探究助理',
      },

      bonding: {
        AssistantBlurb:
          '可以問：打線窗口在哪裡、引線數量為什麼改變良率、固化對介金屬化合物做了什麼。每個回答都是在這台機台上真實跑出來的一次打線。',
        AssistantLead: 'BOND-16 探究助理',
      },

      packaging: {
        AssistantBlurb:
          '可以問：好裸晶為什麼在回焊時失效、封裝為什麼翹曲、後固化是做什麼的。每個回答都是用這套配方真實跑出來的一次封膠與回焊。',
        AssistantLead: 'PKG-17 探究助理',
      },

      finaltest: {
        AssistantBlurb:
          '可以問：保護帶的代價是什麼、燒機測試值不值那些小時、測試時間到底要多久。每個回答都是在這台測試機上真實跑出來的一個批次。',
        AssistantLead: 'FT-18 探究助理',
      },

      gas: {
        AssistantBlurb:
          '可以問：到底需要幾次吹掃循環、偵測器能不能及時警報、最後排到煙囪的是什麼。每個回答都是在這個氣瓶面板上真實跑出來的一次評估。',
        AssistantLead: 'GAS-19 探究助理',
      },

      system: {
        vacuum: {
          Label: '廠務製程真空',
          Action: '通報廠務：對共用真空總管做檢漏',
        },
        pcw: {
          Label: '製程冷卻水',
          Action: '通報廠務：把冰水供水溫度恢復正常',
        },
        gas: {
          Label: '廠務乾燥氣體總管',
          Action: '通報廠務：更換總管乾燥器，吹驅並重新認證',
        },
        upw: {
          Label: '超純水廠',
          Action: '通報廠務：再生拋光混床並重新認證迴路',
        },
        hvac: {
          Label: '潔淨室空調送風',
          Action: '通報廠務：恢復循環空調機組到設計風量',
        },
        mau: {
          Label: '新風機組',
          Action: '升級到廠務：更換新風初效濾網並重新平衡壓差梯度',
        },
        pumps: {
          Label: '機台乾式泵',
          Action: '升級到廠務：更換機台下方的乾式泵並重新驗證前級管路',
        },
        chem: {
          Label: '化學品輸送',
          Action: '升級到廠務：隔離洩漏管線，更換內管並重新認證雙套管',
        },
      },
      fault: {
        headerLeak: {
          Label: '共用製程真空總管洩漏',
          Truth:
            '上週末次廠房施工時動到了共用製程真空總管上的一處法蘭，現在正在漏。掛在這條總管上的' +
            '每一個腔體都會把它當成自己的漏點——因為從腔體內部看，它就是。',
        },
        warmPcw: {
          Label: '製程冷卻水溫度偏高',
          Truth:
            '冰水站送來的供水比標稱高了約 22 C。任何一台機台本身都沒有故障；只是所有把熱排進' +
            '這條迴路的機台，都已經守不住自己的設定值了。',
        },
        wetHeader: {
          Label: '廠務乾燥氣體總管帶水',
          Truth:
            '廠務乾燥氣體的乾燥器週末失效帶水，總管裡現在大約含 2% 的水——這是液帶，' +
            '不是乾燥器飽和時那種 ppm 級的緩慢爬升。它會抵達每一台呼吸廠務氮氣或氧氣的機台，' +
            '而到達之後造成什麼後果，完全取決於那台機台拿這股氣做什麼。注意兩個閾值相差有多遠：' +
            'ALD 在個位數 ppm 就已經被毀掉，因為水正是它的共反應物；而用水氣長氧化層的爐管，' +
            '一個百分點以下根本察覺不到。要兩台機台同時喊問題，得是一次嚴重失效——' +
            '而這恰恰就是兩個組很少把各自的問題聯繫起來的原因。',
        },
        spentBed: {
          Label: '拋光混床耗盡',
          Truth:
            '超純水迴路的拋光混床已用掉 91% 的交換容量，鈉開始穿透：上週還讀 18.1 MΩ·cm 的迴路' +
            '今天只有 11。沒人預見到，因為根本無從預見——離子交換床在幾乎整個壽命裡都把表針穩在' +
            ' 18.2，然後在最後幾個百分點內崩潰，這正是按處理水量而不是按讀數再生的原因。沖洗水是' +
            '晶圓在濕法台看到的最後一道水，於是那台設備表現得像兩種化學同時失效——單一槽體不可能' +
            '造出的特徵。',
        },
        mauFiltersLoaded: {
          Label: '新風初效濾網堵塞',
          Truth: '新風機組的初效濾網經過一季花粉和施工粉塵已經堵塞，機組只送出約 55% 的設計新風量。循環空調機組正常，各區域仍以全速換氣——但排風機是以新風量來平衡的，平衡一失，整個潔淨室都低於走廊壓力。所有區域同時讀到負壓，走廊空氣從每條縫隙倒灌進來；任何區域對自身排風的處理都無法恢復建築已失去的壓差梯度。在樓下更換初效濾網需要四小時。',
        },
        dryPumpFailed: {
          Label: 'PRB-14 下方的乾式泵故障',
          Truth: 'PRB-14 下方的乾式泵軸承損壞卡死：原本保持在 50 mTorr 的前級管路現在停在 600 Torr，只比大氣壓低一點。探針台靠真空把每片晶圓吸在卡盤上，吸力只剩五分之一，晶圓就鬆了——卡盤中心密封還抓得住的地方是平的，抓不住的邊緣翹起來。探針卡在翹起的晶粒上落針偏輕，這些晶粒就接觸失敗，看起來和探針卡不平完全一樣；但探針卡沒問題，探針也沒問題，廠裡其他機台都沒變，因為沒有別的機台共用這台泵。到樓下換泵需要三小時。',
        },
        chemLineLeak: {
          Label: 'ECD-12 下方電鍍化學品管線洩漏',
          Truth: 'ECD-12 下方電鍍化學品管線的內管在雙套管內裂開。套管起了作用：化學品流到櫃下的托盤，托盤感測器在四公升時報警，洩漏連鎖關停了輸送泵——這正是它的用途，因為地下層地面上的電鍍液就是一起酸洩漏。樓上的鍍液整個班次都沒有補液，而每片晶圓都會從鍍液裡帶走銅，所以鍍槽只剩配方所假設銅量的三分之一在運行。其他機台都沒變：每條管線各自獨立。隔離管線、更換內管並重新認證雙套管需要五小時。',
        },
        ahuBeltSlip: {
          Label: '循環空調機組送風不足',
          Truth:
            '四台循環空調機組裡有兩台皮帶打滑，各潔淨間只拿到約 55% 的設計風量。天花板裡的每' +
            '塊過濾器都好，上面的每台風機都好——風就是沒送到。同樣的人數下房間讀數變髒，暴露它' +
            '的數字是恢復時間：潔淨間消化一次擾動要多久只由換氣次數決定，別的什麼都動不了它，' +
            '所以過濾器乾淨而恢復緩慢，問題在大樓，不在房間。在這上面換天花板過濾器要花十二小' +
            '時，什麼都換不回來。',
        },
      },
    },

    footer: {
      Built: '建置於 {{date}}。',
    },

    menu: {
      Menu: '選單',
      Settings: '設定',
      SessionNote: '你的班次——日誌、批次與設備設定——保存在本機,重新整理後仍在。',
      SessionClear: '開始新工作階段',
      Entrance: '返回入口',
      EntranceNote: '回到入口畫面。你的日誌、批次與設備設定保留。',
      Model: 'AI 模型',
      Auto: '自動',
      AutoNote: '依地區',
      LocalNote: '沒有設定託管模型，問題在本機比對。',
      Lighting: '照明',
      LightBright: '白光',
      LightBrightNote: '明亮偏冷——運轉中的工廠',
      LightBlue: '藍光',
      LightBlueNote: '下班後的自動化廠區',
      LightYellow: '黃光',
      LightYellowNote: '安全燈——不含使光阻曝光的紫外線',
      Graphics: '圖形',
      QualityAuto: '自動',
      QualityAutoNote: '預設',
      QualityHigh: '更多燈光',
      QualityHighNote: '更逼真',
      QualityLow: '更少燈光',
      QualityLowNote: '較不逼真',
      Loading: '正在載入',
      HallBayChase: '廠房 A',
      HallBayChaseNote: '工作區加維修通道佈局：機台正面嵌在隔牆內，維修通道在牆後',
      HallBallroom: '廠房 B',
      HallBallroomNote: '大開間佈局：開放式廠房，所有主機一覽無遺',
      Sound: '音效',
      SoundOn: '開啟',
      SoundOnNote: '廠房的真實環境聲',
      SoundOff: '靜音',
      SoundOffNote: '無聲 — 按 M 鍵切換',
      DesignFab: '設計一座晶圓廠',
      DesignFabNote: '用這二十五台設備排出你自己的廠房',
      YourFabs: '你蓋的廠',
      CustomFabNote: '{{n}} 台設備，{{hall}}佈局',
      Fabs: '我的廠區',
      FabsNote: '你自己的廠區：打開一個、儲存目前的，或設計一個新的',
      OpenFab: '打開…',
      OpenFabNote: '儲存在你帳戶裡的廠區',
      SaveFab: '儲存',
      SaveFabNote: '以目前名稱儲存你正站著的這個廠區',
      SaveNothing: '廠區 A 和 B 是內建的；先設計一個才有可儲存的',
      SaveFabAs: '另存新檔…',
      SaveFabAsNote: '以新名字存一份副本，並切換到副本',
      SaveAsName: '副本的名字',
      SaveAsGo: '儲存副本',
      NoSavedFabs: '這個帳戶還沒有儲存過廠區。',
      LibrarySignedOut: '登入（右上角的帳戶按鈕）後廠區會儲存到你的帳戶；訪客登入也可以。',
      LibraryDenied: '這個帳戶無權讀取那個庫。',
      LibraryOffline: '廠區庫連不上，請檢查網路後重試。',
      LibraryLoading: '正在取得你的廠區…',
      FabSaved: '已儲存 {{name}}。',
      DeleteFab: '從我的廠區中刪除',
      DeleteFabConfirm: '從你的帳戶刪除「{{name}}」？你正站著的廠區不受影響。',
      SavedOn: '儲存於 {{when}}',
    },

    routing: {
      Via: '由 {{label}}（{{model}}）作答',
      OnDevice: '由本機的模式比對作答',
      Unreachable: '由本機作答——託管模型無法連線',
      Assumed: '推定為{{region}}',
      RegionUs: '美國',
      RegionIntl: '國際',
    },

    shift: {
      Debrief: '本班總結',
      SessionTallyRuns: '本次工作階段：{{tools}} 個站點共 {{runs}} 次 · {{scrapped}} 次超出規格。',
      Performance: '本站表現',
      KpiDowntime: '機台停機',
      KpiDowntimeNote: '本班',
      KpiOutOfSpec: '超出規格',
      KpiOutOfSpecNote: '共 {{runs}} 次',
      CallsHeading: '你當時的判斷',
      CallsNote: '這些是你在設備給出結果之前說的。這裡沒有判定對錯——請自己對照著看。',
      CallsSaid: '你說',
      CallsMeasured: '實測',
      CallsExplained: '被問到原因時',
      Hours: '{{hours}} 小時',
      CostTotal: '合計',
      NothingYet: '這個站點還沒有可量測的結果。',
      CostEscalation: '上報 — {{label}}',
      CostRepair: '維修 — {{label}}',
      CostRepairBoth: '維修 — {{wrong}}，之後又修 {{actual}}',
      SessionTally:
        '本次工作階段：{{shifts}} 個班次 · {{called}} 次判定中 {{correct}} 次正確 · ' +
        '停機 {{hours}} 小時 · {{scrapped}} 次超出規格。',

      Title: '交接班報告——{{tool}}',
      AsFoundInSpec: '按現狀，這台機台在規格內——{{primary}}，{{secondary}}。把這批跑掉，是站得住腳的決定。',
      AsFoundOutOfSpec: '按現狀，這台機台已超規格——{{primary}}，{{secondary}}。你跑出來的每一片都是報廢。',
      AtTheTool: '機台上就有——免費',
      Investigate: '進一步查——要花機台時間',
      TakeIt: '去測',
      SpentSoFar:
        '到目前已花掉 {{hours}} 小時。這裡的每一個小時，都是機台不產出晶圓的一個小時——' +
        '而這正是真實排班要做的取捨。',
      InvestigateNote:
        '這裡每一項都會把機台、或一名技術員，從產線上拉走。只做那些會改變你判斷的；' +
        '全都做一遍，本身也是一種決定。',
      CallIt: '下判斷',
      CallItNote: '說出你要修的那一件事。在你提交之前答案都不會揭曉，而判斷錯了，停機代價要付兩次。',
      Correct: '正確——{{label}}。',
      Wrong: '錯了——你判的是 {{label}}。',
      RepairRight: '{{action}}。停機 {{hours}} 小時，機台修好回來。',
      RepairWrong:
        '{{action}} 花掉 {{hours}} 小時，機台回來還是壞的。接著 {{realAction}} 又要 ' +
        '{{realHours}} 小時。總計 {{total}} 小時。',
      TheRealRepair: '真正該做的修理',
      ThisShift: '這個班：排查 {{investigating}} 小時，修理 {{repairing}} 小時，' +
        '你猶豫期間報廢了 {{scrapped}} 片晶圓。',
      WhatEachRepair: '每一種修理原本能挽回多少',
      WhatEachRepairNote:
        '每一行都是把那一項單獨恢復到標稱、其餘一切保持現狀，再把機台跑一遍的結果。' +
        '這是方法，不是排行榜。',
      Recovered: '挽回 {{pct}}%——{{primary}}，{{secondary}}',
      Decidable: '最好的修理比第二名高出 {{points}} 個百分點。這一次，光靠反事實推演就能定案。',
      TooClose:
        '最好的兩種修理只差 {{points}} 個百分點，因為機台的這兩部分互相影響。' +
        '這一次靠試修是定不了案的——只有靠一次量測。',
      StartShift: '開始一個班（隨機故障）',
      RevealCause: '揭曉原因',
      HideAnswer: '隱藏答案',
      Instructor: '教師——掛載一個場景',
    },

    journal: {
      OrderComplete: '工單完成',
      ByStation: '各站點表現',
      ColTool: '機台',
      ColRuns: '次數',
      ColOutOfSpec: '超規格',
      ColDowntime: '停機',
      ColCalls: '判定',
      CallsRight: '{{calls}} 次中 {{correct}} 次正確',
      NotApplicable: '—',
      Unattributed: '（未記錄機台）',

      Title: '# SimFab — 工作階段紀錄',
      NoActivity: '_沒有記錄到任何活動。_',
      ShiftStart: '班次開始',
      TookReading: '讀取了',
      RanWafer: '跑了一片晶圓',
      InSpec: '合格',
      OutOfSpec: '**超出規格**',
      Changed: '修改了',
      Asked: '提問',
      Maintenance: '執行了維護',
      CalledIt: '判定',
      Correct: '正確',
      Incorrect: '錯誤',
      ReadingsBefore: '判定前擷取的讀數',
      WafersRun: '已跑晶圓數',
      QuestionsAsked: '提問次數',
      ActualCause: '真正的原因是',
      NoFault: '根本沒有故障',
    },

    author: {
      Title: '設計一座晶圓廠',
      Subtitle: '二十五台設備任你挑。你留下什麼不重要，你不要什麼才是決定——產品製程路線會告訴你代價。',
      Ask: '說說要改什麼……',
      Send: '送出',
      Working: '處理中……',
      NewFloor: '新廠房',
      SavedFloors: '你蓋的廠',
      NoSaved: '還沒蓋過。可以從一座現成的廠開始，或者直接說出你要的設備。',
      Build: '蓋起來，走進去',
      Rebuild: '重蓋並走進去',
      Standing: '你正站在這一座裡',
      Save: '儲存',
      Delete: '刪除',
      DeleteActive: '你正站在這一座裡。先去 Fab A 或 Fab B。',
      DeleteConfirm: '刪除「{{name}}」？忘掉的是這張廠房平面圖，設備不會丟——還是那二十五台。',
      Cancel: '留著',
      Undo: '復原',
      SortShort: '流程順序',
      allAlias: '所有設備|全部設備|所有的|全部|所有站|每一台',
      renameStop: '然後|並且|再|和',
      NotOnFloor: '不在這座廠裡：{{tags}}',
      LineNotOnFloor: '這是參考產線——Fab A 設備上的完整產品製程路線。你所在的這座廠沒有 {{tags}}，所以這裡的批次在這些製程上都得送出廠外。下面的數字屬於設計中的產線，不屬於這座廠。',
      NamePlaceholder: '給這座廠取個名',
      HallLabel: '廠房',
      OnTheFloor: '在廠房裡，按晶圓經過的順序',
      Palette: '不在這座廠裡',
      AddTool: '放進廠房',
      RemoveTool: '搬出廠房',
      MoveEarlier: '在流程中往前',
      MoveLater: '在流程中往後',
      RequiredTool: '氣閘是進門的路。每座廠都得有一個。',
      HallSize: '主通道 {{length}} m，{{bays}} 個機台區',
      Suggestions: '可以這樣問',
      Local: '在本機上比對',
      CoverageTitle: '對照產品製程路線',
      CoverageBar: '{{steps}} 道製程中的 {{covered}} 道',
      MaskCount: '{{masks}} 道光罩製程中的 {{masksCovered}} 道',
      SegmentRuns: '能從頭跑到尾',
      SegmentPart: '{{steps}} 道中的 {{covered}} 道',
      Empty: '這座廠裡除了氣閘什麼都沒有。',
      ListSeparator: '、',
      hall: {
        bayChase: '隔間式',
        ballroom: '大廳式',
      },
      hallNote: {
        bayChase: '設備正面嵌在牆裡，主機在後面的技術夾道中',
        ballroom: '一整片開放廠房，每台主機都看得見',
      },
      hallAlias: {
        bayChase: '隔間|隔間式|有牆|隔牆|封閉機台區|bay and chase',
        ballroom: '大廳|大廳式|開放廠房|開放式|沒有牆|無牆|ballroom',
      },
      zone: {
        entry: '入口',
        substrate: '基板',
        frontend: '前段',
        metrology: '量測',
        interconnect: '內連線',
        sort: '晶圓測試分選',
        assembly: '封裝與測試',
        quantum: '量子元件',
        support: '配套',
      },
      zoneAlias: {
        entry: '進廠|進門的地方',
        substrate: '晶圓供應|從晶棒到晶圓|基板線',
        frontend: 'feol|元件層|電晶體|前道',
        metrology: '線上量測',
        interconnect: 'beol|後段|金屬層|佈線|鑲嵌製程',
        sort: '針測區|晶圓測試',
        assembly: '後段封裝|封裝線|osat|組裝線',
        quantum: '量子位元|量子晶片|量子計算|量子產線',
        support: '基礎設施|廠務',
      },
      segment: {
        substrate: '基板模組',
        gate: '閘極模組',
        metal: '金屬層迴圈',
        backEnd: '封裝與測試',
      },
      archetype: {
        idm: {
          Name: '整合元件製造商（IDM）',
          Purpose: '沙子從一頭進，分好級的晶片從另一頭出。二十五台設備全在。',
        },
        foundry: {
          Name: '純晶圓代工廠',
          Purpose: '買拋光片進來，交成品晶圓出去。沒有長晶爐，也從不碰封裝。',
        },
        substrate: {
          Name: '基板供應商',
          Purpose: '晶圓廠開工用的那片晶圓是從這裡來的。它本身根本不是晶圓廠。',
        },
        osat: {
          Name: '封裝測試廠',
          Purpose: '進來成品晶圓，出去分好級的晶片。整個廠房裡一台曝光機都沒有。',
        },
        power: {
          Name: '功率分離式元件線',
          Purpose: '厚磊晶、深佈植、鋁導線——所以沒有鑲嵌迴圈，這是有意為之。',
        },
        teaching: {
          Name: '教學廠房',
          Purpose: '還能做出一層圖形的最小廠房。九台設備，一個迴圈。',
        },
      },
      archetypeAlias: {
        idm: 'idm|整合元件|全都要|完整的廠|全套',
        foundry: '代工|代工廠|純代工|foundry',
        substrate: '基板供應商|晶圓供應商|晶棒廠|做晶圓的',
        osat: 'osat|封測廠|測試廠|封裝廠',
        power: '功率線|分離式元件|mosfet|igbt|功率元件',
        teaching: '教學|課堂|訓練廠房|最小的廠|最簡單的廠',
      },
      alias: {
        gowning: '更衣|無塵衣|氣閘|更衣室|無塵室入口',
        crystal: '長晶爐|柴氏法|晶棒|矽晶棒|拉晶爐',
        waferprep: '晶圓製備|切片|研磨|拋光片|基板製備|線鋸',
        epi: '磊晶|磊晶爐|磊晶反應器|epi',
        clean: '濕式清洗台|濕式清洗|rca 清洗|清洗台|預清洗',
        implant: '離子佈植|佈植機|摻雜|摻質|佈植',
        etch: '蝕刻|蝕刻機|乾式蝕刻|icp|電漿蝕刻機',
        deposition: 'cvd|pecvd|ald|薄膜沉積|沉積設備|鍍膜',
        litho: '微影|曝光機|掃描機|步進機|光罩曝光|塗佈顯影',
        patterning: '多重圖形|多重曝光|saqp|側壁|自對準|雙重圖形|四重圖形|節距分割',
        thermal: '爐管|退火|快速熱製程|rtp|氧化|擴散|熱製程設備',
        metrology: '量測|橢偏儀|散射量測|線上量測',
        facilities: '廠務|廠務系統|公用設施盤|廠務面板|閥件盤',
        cmp: 'cmp|研磨機|平坦化|化學機械研磨|拋光機',
        plating: '電鍍|電鍍設備|ecd|銅填充|電化學沉積',
        inspection: '缺陷檢查|缺陷檢測|微粒掃描|檢查機',
        probe: '針測機|晶圓分選|針測卡|參數測試|電性分選',
        dicing: '切割|切割機|單一化|薄化切割|切割鋸|背面研磨',
        bonding: '黏晶|打線|引線鍵合|鍵合機|焊線',
        packaging: '模封|封裝|模壓|底部填充|包封',
        finaltest: '成品測試|燒機|老化|分級|測試機|ate',
        gas: '大宗氣體|氣瓶櫃|氣體站|氣體庫|特氣|氮氣供應',
        euv: 'euv|euv曝光機|極紫外光|極紫外光微影|錫光源',
        ebeam: 'cd-sem|掃描電鏡|電子束|電子束檢測|掃描式電子顯微鏡',
        quantum: '量子元件測試|量子位元測試|稀釋冷凍機|低溫恆溫器|transmon|自旋量子位元',
      },
      action: {
        add: {
          Summary: '把一台設備，或者一整段流程，放進廠房',
          Example: '加一台 CMP 研磨機',
        },
        remove: {
          Summary: '把一台設備搬出廠房',
          Example: '把長晶爐搬走',
        },
        archetype: {
          Summary: '從一座現成的廠重新開始',
          Example: '幫我蓋一座純代工廠',
        },
        hall: {
          Summary: '帶牆的隔間，還是一整片開放廠房',
          Example: '改成大廳式',
        },
        rename: {
          Summary: '給這座廠取個名字',
          Example: '叫它試產線',
        },
        sort: {
          Summary: '把通道恢復成晶圓經過設備的順序',
          Example: '按流程順序排',
        },
        clear: {
          Summary: '清空廠房，從頭再來',
          Example: '清空廠房',
        },
        assess: {
          Summary: '這座廠能做什麼，還缺什麼？',
          Example: '我還缺什麼？',
        },
        catalogue: {
          Summary: '有哪些設備可以選？',
          Example: '我能選哪些設備？',
        },
      },
      trigger: {
        add: '加一台|加上|加個|添加|放一台|放進|放個|裝一台|安裝|裝上|包括|我要|我想要|我需要|給我',
        remove: '去掉|刪掉|移除|搬走|拿走|撤掉|不要|賣掉',
        archetype: '從頭按|從一座|基於|幫我蓋|幫我做|照著|範本|預設|按照|蓋一座|做一座|改成一座',
        hall: '大廳|隔間|開放廠房|有牆|隔牆|佈局|廠房樣式',
        rename: '叫它|叫做|改名|命名|取名',
        sort: '流程順序|按順序|重新排|重排|排序|製程順序',
        clear: '清空|全部清掉|從頭再來|騰空|什麼都不留',
        assess: '能做什麼|能不能|這座廠能|還缺什麼|缺什麼|涵蓋|完整度|評估|夠不夠|行不行',
        catalogue: '有哪些設備|哪些設備|有哪些站|哪些站|列出|有什麼可選|我能選|我的選項',
      },
      renameLead: '叫它|叫做|改名為|命名為|給這座廠取名',
      reply: {
        Added: '現在廠裡有了：{{tags}}。',
        Removed: '已搬出廠房：{{tags}}。',
        Refused: '{{tags}} 留下。那是進門的路。',
        AlreadyThere: '本來就在：{{tags}}。',
        NotThere: '這座廠裡原本就沒有：{{tags}}。',
        Hall: '廠房樣式：{{hall}}。',
        Renamed: '取名為「{{name}}」。',
        Sorted: '通道現在按晶圓經過設備的順序排列了。',
        Archetype: '從這裡重新開始：{{name}}。',
        NothingToDo: '這個我會做——{{summary}}——但那句話沒告訴我對什麼做。',
        SameArchetype: '這座廠已經就是{{name}}了。',
        Unplaced: '我沒辦法把那句話變成對廠房的改動。我能做的是：',
        Complete: '產品製程路線的每一道製程在這座廠裡都有設備可用——全部 {{steps}} 道，其中 {{masks}} 道要光罩。',
        Coverage: '產品製程路線的 {{steps}} 道製程裡，有 {{covered}} 道在這座廠裡找得到設備——{{percent}}%。',
        CoverageNone: '產品製程路線的 {{steps}} 道製程，這座廠一道也找不到設備。',
        SegmentsRun: '能從頭跑到尾的是：{{segments}}。',
        SegmentsOpened: '這樣就把 {{segments}} 補齊了，它現在能從頭跑到尾。',
        SegmentsBroken: '這樣就把 {{segments}} 打斷了，它不再能從頭跑到尾。',
        BiggestGap: '最大的缺口是 {{tag}}——{{process}}——有 {{count}} 道製程沒有設備可跑。',
        BiggestGap_one: '最大的缺口是 {{tag}}——{{process}}——有 {{count}} 道製程沒有設備可跑。',
        BiggestGap_other: '最大的缺口是 {{tag}}——{{process}}——有 {{count}} 道製程沒有設備可跑。',
        CatalogueHead: '目錄裡有 {{n}} 台設備，這座廠裡放了 {{chosen}} 台。打勾的表示已經放進去了。',
        CatalogueZone: '{{zone}}：{{tools}}',
        EmptyFloor: '這座廠裡除了氣閘什麼都沒有。說一座可以照著開始的廠，或者直接說出你要的設備。',
        Floor: '{{n}} 台設備：{{tools}}。',
        NoHouse: '這座廠沒有 {{tags}}。這裡每一台設備都掛在製程真空、冰水、大宗氮氣和排氣上——把它們留在外面，就是把真正會出故障的那半棟樓留在外面。',
        Unused: '產品製程路線從來不經過 {{tags}}。這不是批評：它們在這裡，是為了這項衡量衡量不到的東西。',
      },
    },

  },
}
